import React, { useState, useEffect, useContext, Fragment, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import Select from 'react-select';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import moment from 'moment';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import DatePicker, { registerLocale } from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';
import { Form, Col } from 'react-bootstrap';
import AddButton from '../../../components/AddButton';
import Button from '../../../components/Button';
import GenericButton from '../../../components/FlowGenericButton';
import EditButton from '../../../components/EditButton';
import Fieldset from '../../../components/Fieldset';
import Modal from '../../../components/Modal';
import If from '../../../components/If';
import AlertError from '../../../components/AlertError';
import AlertSuccess from '../../../components/AlertSuccess';
import DeleteButton from '../../../components/DeleteButton';
import LoadingInForm from '../../../components/LoadingInForm';
import ConfirmationModal from '../../../components/ConfirmationModal';
import { STRINGS } from '../../../util/strings';
import { isEmptyObj } from '../../../functions/isEmptyObject';
import { Context } from '../../../context/AuthContext'
import { DecodedToken, User } from '../../../models/user';
import '../../../pages/Registers/styles.css';
import api, { apiFileDownload } from '../../../services/api';
import jwtDecode from 'jwt-decode';
import { DecimalAsComma } from '../NumberFormat';
import { _generateDate } from '../../../util/convert';
import FileExistent from '../../../components/FileExistent';
import * as Models from '../../../models/models';
import '../styles_add.scss';

import { STRINGS_CADERNOCONFORMIDADE } from '../../../util/cadernoConformidade/string';

import { isAdmin } from '../../../users/CadernoConformidade/isAdmin';
import { isRequesterReader, isRequesterWriter } from '../../../users/CadernoConformidade/isRequester';
import { isReguladorWriter, isReguladorReader } from '../../../users/CadernoConformidade/isRegulador';

import { STATUS_CADERNOCONFORMIDADE, isFinalizacaoEmAnaliseRegulatorio } from '../../../util/cadernoConformidade/status';
import {
	extrairTextoMetodoLimpezaOutros,
	formatarMetodoLimpezaOutros,
	isValorOutros,
	normalizarMetodoLimpezaParaExibicao,
} from '../../../util/cadernoConformidade/metodoLimpeza';
import { ordenarPorDataAsc } from '../../../util/cadernoConformidade/ordenacao';

import { UsuarioDto, UnityStationResult } from '../../../models/modelsAuthorizationsCIBIO';

import {
	StateType, Enum, VegetacaoSearchResult, CulturaResult,
	ResponsavelRegulatorioResult, TecnicoPrincipalResult,
	VegetacaoAnotacoes, VegetacaoPlantios, VegetacaoDataPlantios, VegetacaoPessoasEnvolvidasPlantio, VegetacaoPessoasEnvolvidasColheita,
	VegetacaoResponsaveisDescarte, VegetacaoLimpezaDestruicao, VegetacaoDataColheita, VegetacaoRegistroAmostragem, VegetacaoRegistroColheita, VegetacaoRegistroFiscalizacao, VegetacaoAtividadeManutencao,
	VegetacaoInspecaoEquipamentos, VegetacaoLimpezaInstalacoes, VegetacaoResponsaveisReporte,
	ExpectedDocumentos, ExpectedFiscalizacao, ExpectedRegistroAmostragem, ExpectedRegistroColheita, ExpectedPlanejamento,
	ExpectedPlanejamentoConducao, ExpectedReportes, ExpectedAnotacoes,
	ExpectedDestruicao, ExpectedDatasPlantio, ExpectedPessoasEnvolvidasPlantio,
	ExpectedDatasColheita, ExpectedPessoasEnvolvidasColheita,
	ExpectedAtividades, ExpectedInspecao, ExpectedLimpeza, ExpectedDestruicaoResponsaveis,
	ExpectedDestruicaoLimpeza, ExpectedPlanejamentoNotificacaoPlantio, ExpectedReportesResponsaveis,
	ExpectedLimpezaInstalacoesResponsaveis,
	DocumentosOnEditVegetacao,
	Documentos_PastaProcessoOnEditVegetacao,
	Documentos_RegistroAmostragemOnEditVegetacao,
	Planejamento_RegistroColheitaOnEditVegetacao,
	PlanejamentoOnEditVegetacao,
	Planejamento_ConducaoOnEditVegetacao,
	Planejamento_DatasPlantioOnEditVegetacao,
	Planejamento_PessoasPlantioOnEditVegetacao,
	Planejamento_DatasColheitaOnEditVegetacao,
	Planejamento_PessoasColheitaOnEditVegetacao,
	Planejamento_NotificacaoPlantioOnEditVegetacao,
	Planejamento_LimpezaOnEditVegetacao,
	Planejamento_InspecaoOnEditVegetacao,
	Planejamento_AtividadesOnEditVegetacao,
	DestruicaoOnEditVegetacao,
	Destruicao_ResponsaveisOnEditVegetacao,
	Destruicao_LimpezaOnEditVegetacao,
	ReportesOnEditVegetacao,
	ResponsaveisReportesOnEditVegetacao,
	ResponsaveisLimpezaInstalacoesOnEditVegetacao,
	AnotacoesOnEditVegetacao,
	FiscalizacaoOnEditVegetacao,
	VegetacaoByIdToEdit,
	ConducaoComunicadosEditVegetacao,
	Regulatorio,
	Responsavel,
	AtividadeManutencao,
	MetodoLimpezaInstalacoes,
	ResponsavelAtividade,
	MetodoLimpezaManutencao,
	ResponsavelEquipamentos,
	MetodoLimpezaEquipamentos,
	ResponsavelAmostragem,
	ResponsavelColheita,
	ResponsavelInstalacao,
	MetodoLimpezaInstalacao,
	ResponsavelDestruicao,
	MetodoDestruicao,
	VegetacaoDestruicao,
	ResponsavelNotificacao
} from '../../../models/modelsCadernoConformidade';

registerLocale('pt-BR', ptBR);

const getDestinoSobraIdFromPlantio = (plantio: VegetacaoPlantios | Planejamento_NotificacaoPlantioOnEditVegetacao): number => {
	const destinoSobra = plantio.destinoSobra ?? (plantio as Planejamento_NotificacaoPlantioOnEditVegetacao).destinoSobra_Id;

	if (destinoSobra !== undefined && destinoSobra !== null && destinoSobra !== '') {
		if (typeof destinoSobra === 'object' && destinoSobra.value !== undefined) {
			return Number(destinoSobra.value) || 0;
		}
		return Number(destinoSobra) || 0;
	}

	return 0;
};

export default function CadernoConformidade() {
	const history = useHistory();
	const location = useLocation<StateType>();
	const { token } = useContext(Context);
	const decoded: DecodedToken = jwtDecode(token.access_token);

	//Loading screen
	const [loading, setLoading] = useState<string[]>([]);
	const [cadernoCarregando, setCadernoCarregando] = useState(true);
	const setLoadingScreen = (tag: string, type: boolean = true) => {

		let currentLoading = loading;
		let index = currentLoading.indexOf(tag);

		if (type) {
			if (index >= 0)
				return;

			currentLoading.push(tag);
		}
		else {
			if (index <= -1)
				return;

			currentLoading.splice(index, 1);
		}

		setLoading([]);
		setLoading(currentLoading);
	}
	const isLoadingScreen = (tag: string): boolean => { return loading.indexOf(tag) >= 0; }

	const [entity, setEntity] = useState<VegetacaoSearchResult>();

	const [tipoDestruicaoValue, setTipoDestruicaoValue] = useState<any>(0);
	const [localDestruicaoValue, setLocalDestruicaoValue] = useState<any>(0);
	const [metodoDestruicaoValue, setMetodoDestruicaoValue] = useState<any>(0);
	const [tipoMaterialColheitaValue, setTipoMaterialColheitaValue] = useState<any>(0);
	const [tipoFaseLimpezaEquipamentosValue, setTipoFaseLimpezaEquipamentosValue] = useState<any>(0);
	const [tipoFaseDestruicaoValue, setTipoFaseDestruicaoValue] = useState<any>(0);
	const [destinoMaterialColheitaValue, setDestinoMaterialColheitaValue] = useState<any>(0);
	const [orgaoFiscalizadorValue, setOrgaoFiscalizadorValue] = useState<any>(0);
	const [unidadeMedidaValue, setUnidadeMedidaValue] = useState<any>(0);

	const [nomeRequerente, setNomeRequerente] = useState<string>("");

	const [contagemAnotacao, setContagemAnotacao] = useState<any>(null);
	const [anotacaoEdit, setAnotacaoEdit] = useState<VegetacaoAnotacoes>({
		id: 0,
		responsavel: '',
		dataAnotacao: undefined,
		anotacao: '',
	});
	const [selectedAnotacoes, setSelectedAnotacoes] = useState<VegetacaoAnotacoes[]>([]);
	const [modalAnotacoes, setModalAnotacoes] = useState<boolean>(false);

	const [plantioEdit, setPlantioEdit] = useState<VegetacaoPlantios>({
		id: 0,
		numeroPlantio: 0,
		casaVegetacaoModulo: '',
		material: '',
		informacoesAdicionaisMaterial: '',
		numeroAMI: '',
		sobraMaterial: '',
		numeroAmostrasRestantes: '',
		quantidadeAmostrasRestantes: '',
		destinoSobra: '',
		entradaArmazenamento: '',
		informacoesAdicionais: '',
		dataInicialPlantio: '',
		dataFinalPlantio: '',
	});

	const [selectedPlantios, setSelectedPlantios] = useState<VegetacaoPlantios[]>([]);
	const planejamentoEstadoCarregado = useRef(false);
	const destruicaoGradeHidratada = useRef(false);
	const [modalPlantios, setModalPlantios] = useState<boolean>(false);

	const [contagemRegistroAmostragem, setContagemRegistroAmostragem] = useState<any>(null);

	const [registroAmostragemEdit, setRegistroAmostragemEdit] = useState<VegetacaoRegistroAmostragem>({
		id: 0,
		contagemRegistroAmostragem: '',
		dataInicialAmostragem: '',
		dataFinalAmostragem: '',
		tipoMaterialAmostragem: '',
		responsavelAmostragem: '',
		destinoAmostras: '',
		filename: '',
		tipoMaterialAmostragemOutros: '',
		destinoAmostrasOutros: '',
	});
	const [selectedRegistroAmostragem, setSelectedRegistroAmostragem] = useState<Documentos_RegistroAmostragemOnEditVegetacao[]>([]);
	const [modalRegistroAmostragem, setModalRegistroAmostragem] = useState<boolean>(false);

	const [contagemRegistroColheita, setContagemRegistroColheita] = useState<any>(null);
	const [registroColheitaEdit, setRegistroColheitaEdit] = useState<VegetacaoRegistroColheita>({
		id: 0,
		contagemRegistroColheita: '',
		tipoColheita: '',
		dataColheita: '',
		dataInicialColheita: '',
		dataFinalColheita: '',
		tipoMaterialColheita: '',
		outrosTipoMaterialColheita: '',
		quantidadeMaterialColheita: '',
		numeroAMIColheita: '',
		destinoMaterialColheita: '',
		arquivoAMIColheita: '',
		filename: '',
	});
	const [selectedRegistroColheita, setSelectedRegistroColheita] = useState<Planejamento_RegistroColheitaOnEditVegetacao[]>([]);
	const [modalRegistroColheita, setModalRegistroColheita] = useState<boolean>(false);
	const [responsaveisColheitaModal, setResponsaveisColheitaModal] = useState<ResponsavelColheita[]>([]);
	const [arquivoRegistroColheitaPendente, setArquivoRegistroColheitaPendente] = useState<File | null>(null);
	const [lblArquivoRegistroColheita, setLblArquivoRegistroColheita] = useState('Escolher arquivo');

	const [contagemRegistroFiscalizacao, setContagemRegistroFiscalizacao] = useState<any>(null);
	const [registroFiscalizacaoEdit, setRegistroFiscalizacaoEdit] = useState<VegetacaoRegistroFiscalizacao>({
		id: 0,
		contagemRegistroFiscalizacao: '',
		orgaoFiscalizador: '',
		outrosOrgaoFiscalizador: '',
		dataFiscalizacao: '',
		observacoesTermosFiscalizacao: '',
		termosFiscalizacao: true,
		arquivoTermo: '',
		filename: '',
	});
	const [selectedRegistroFiscalizacao, setSelectedRegistroFiscalizacao] = useState<FiscalizacaoOnEditVegetacao[]>([]);
	const [modalRegistroFiscalizacao, setModalRegistroFiscalizacao] = useState<boolean>(false);
	const [arquivoRegistroFiscalizacaoPendente, setArquivoRegistroFiscalizacaoPendente] = useState<File | null>(null);
	const [lblArquivoRegistroFiscalizacao, setLblArquivoRegistroFiscalizacao] = useState('Escolher arquivo');

	const [dataPlantioEdit, setDataPlantioEdit] = useState<VegetacaoDataPlantios>({
		id: 0,
		dataInicialPlantio: '',
		dataFinalPlantio: '',
	});
	const [selectedDataPlantios, setSelectedDataPlantios] = useState<Planejamento_DatasPlantioOnEditVegetacao[]>([]);
	const [modalDataPlantios, setModalDataPlantios] = useState<boolean>(false);

	const [contagemPessoasEnvolvidasPlantio, setContagemPessoasEnvolvidasPlantio] = useState<any>(null);

	const [PessoasEnvolvidasPlantioEdit, setPessoasEnvolvidasPlantioEdit] = useState<VegetacaoPessoasEnvolvidasPlantio>({
		id: 0,
		contagemPessoasEnvolvidasPlantio: '',
		pessoaPlantio: ''
	});
	const [selectedPessoasEnvolvidasPlantio, setSelectedPessoasEnvolvidasPlantio] = useState<VegetacaoPessoasEnvolvidasPlantio[]>([]);
	const [modalPessoasEnvolvidasPlantio, setModalPessoasEnvolvidasPlantio] = useState<boolean>(false);

	const [eventMsg, setEventsMsg] = useState('');

	const [lblDocumentosGerais, setLblDocumentosGerais] = useState('Escolher arquivo');
	const [documentosGerais, setDocumentosGerais] = useState<any[]>([]);

	const [lblDadosPrincipaisAAC, setLblDadosPrincipaisAAC] = useState('Escolher arquivo');
	const [dadosPrincipaisAAC, setDadosPrincipaisAAC] = useState<any[]>([]);
	const [fileFieldDadosPrincipaisAAC, setFileFieldDadosPrincipaisAAC] = useState<Models.ModelFileRegister>();

	const [lblDadosPrincipaisListaTreinamento, setLblDadosPrincipaisListaTreinamento] = useState('Escolher arquivo');
	const [dadosPrincipaisListaTreinamento, setDadosPrincipaisListaTreinamento] = useState<any[]>([]);

	const [lblDadosPrincipaisParecerTecnico, setLblDadosPrincipaisParecerTecnico] = useState('Escolher arquivo');
	const [dadosPrincipaisParecerTecnico, setDadosPrincipaisParecerTecnico] = useState<any[]>([]);
	const [fileFieldDadosPrincipaisParecerTecnico, setFileFieldDadosPrincipaisParecerTecnico] = useState<Models.ModelFileRegister>();

	const [lblDadosPrincipaisLiberacaoQuarentena, setLblDadosPrincipaisLiberacaoQuarentena] = useState('Escolher arquivo');
	const [dadosPrincipaisLiberacaoQuarentena, setDadosPrincipaisLiberacaoQuarentena] = useState<any[]>([]);

	const [lblPlanejamentoCroqui, setLblPlanejamentoCroqui] = useState('Escolher arquivo');
	const [planejamentoCroqui, setPlanejamentoCroqui] = useState<any[]>([]);

	const [plantioArquivoMateriais, setPlantioArquivoMateriais] = useState<any[]>([]);
	const [fileFieldPlantioArquivoMateriais, setFileFieldPlantioArquivoMateriais] = useState<Models.ModelFileRegister>();
	const [plantioArquivoAMIFiles, setPlantioArquivoAMIFiles] = useState<any[]>([]);

	const mapArquivoPlantioParaGrid = (arquivo: any) => ({
		id: arquivo.id,
		filename: arquivo.filename ?? arquivo.name,
		name: arquivo.filename ?? arquivo.name,
		codigo: arquivo.codigo,
		path: arquivo.path,
		numeroPlantio: arquivo.numeroPlantio,
	});

	const obterNomeArquivoPlantio = (arquivo: any) => arquivo?.filename ?? arquivo?.Filename ?? arquivo?.name ?? '';

	const mapArquivoComunicadoParaGrid = (arquivo: any) => ({
		id: arquivo.id,
		filename: arquivo.filename ?? arquivo.name,
		name: arquivo.filename ?? arquivo.name,
		codigo: arquivo.codigo,
		path: arquivo.path,
		dataComunicado: arquivo.dataComunicado,
	});

	const mapArquivoDestruicaoAMIParaGrid = (arquivo: any) => {
		if (arquivo instanceof File) {
			return {
				file: arquivo,
				filename: arquivo.name,
				name: arquivo.name,
			};
		}

		const filename = arquivo?.filename ?? arquivo?.Filename ?? arquivo?.name ?? '';

		return {
			id: arquivo?.id ?? arquivo?.Id,
			filename,
			name: filename,
			codigo: arquivo?.codigo ?? arquivo?.Codigo,
			path: arquivo?.path ?? arquivo?.Path,
			file: arquivo?.file instanceof File ? arquivo.file : undefined,
		};
	};

	const obterDestruicaoAMIDaOrigem = (origem: any) => {
		const lista = origem?.vegetacao_Destruicao_ArquivoAMI ?? origem?.Vegetacao_Destruicao_ArquivoAMI ?? [];
		return Array.isArray(lista) ? lista : [];
	};

	const obterArquivoPendenteDestruicaoAMI = (arquivo: any): File | null => {
		if (arquivo instanceof File) {
			return arquivo;
		}

		if (arquivo?.file instanceof File) {
			return arquivo.file;
		}

		return null;
	};

	const carregarDestruicaoAMIDaEntity = (origem: any) => {
		const lista = obterDestruicaoAMIDaOrigem(origem);
		setDestruicaoAMI(lista.map(mapArquivoDestruicaoAMIParaGrid));
	};

	const obterFilenameArquivoAmostragem = (arquivo: any, filenameFallback?: any): string => {
		if (filenameFallback && typeof filenameFallback === 'string' && filenameFallback !== 'true' && filenameFallback !== 'false') {
			return filenameFallback;
		}
		if (!arquivo) return '';
		if (typeof arquivo === 'string') return arquivo;
		if (arquivo instanceof File) return arquivo.name;
		if (arquivo?.file instanceof File) return arquivo.file.name;
		if (arquivo?.length > 0 && arquivo[0] instanceof File) return arquivo[0].name;
		if (typeof arquivo?.filename === 'string') return arquivo.filename;
		return '';
	};

	const extrairFileAmostragemPendente = (arquivo: any): File | null => {
		if (arquivo?.file instanceof File) return arquivo.file;
		if (arquivo instanceof File) return arquivo;
		if (arquivo?.length > 0 && arquivo[0] instanceof File) return arquivo[0];
		return null;
	};

	const obterFilenameArquivoPlantio = obterFilenameArquivoAmostragem;
	const extrairFilePlantioPendente = extrairFileAmostragemPendente;

	const obterArquivoPlantioMaterialSalvo = (plantio: any) => {
		const filename = obterFilenameArquivoPlantio(
			plantio?.arquivoMaterialPlantado,
			plantio?.filenameMaterialPlantado ?? plantio?.filename,
		);
		let path = plantio?.pathMaterialPlantado ?? plantio?.path ?? plantio?.Path;
		let codigo = plantio?.codigoMaterialPlantado ?? plantio?.codigo ?? plantio?.Codigo;

		const arquivosEntity = entity?.vegetacao_Plantio_ArquivoMateriais as any[] | undefined;

		if (!path && arquivosEntity?.length) {
			const salvo = arquivosEntity.find((item: any) =>
				plantio?.numeroPlantio != null && item.numeroPlantio != null
				&& String(item.numeroPlantio) === String(plantio.numeroPlantio)
			) ?? arquivosEntity.find((item: any) => {
				const nomeSalvo = item.filename ?? item.Filename ?? item.name;
				return filename && nomeSalvo && String(nomeSalvo).toLowerCase() === String(filename).toLowerCase();
			});

			if (salvo) {
				path = salvo.path ?? salvo.Path;
				codigo = salvo.codigo ?? salvo.Codigo;
			}
		}

		return { path, codigo, filename };
	};

	const obterArquivoPlantioAMISalvo = (plantio: any) => {
		const filename = obterFilenameArquivoPlantio(
			plantio?.arquivoPlantioAMI,
			plantio?.filenamePlantioAMI ?? plantio?.filenameAMI,
		);
		let path = plantio?.pathPlantioAMI ?? plantio?.pathAMI;
		let codigo = plantio?.codigoPlantioAMI ?? plantio?.codigoAMI;

		const arquivosEntity = entity?.vegetacao_Plantio_ArquivoAMI as any[] | undefined;

		if (!path && arquivosEntity?.length) {
			const salvo = arquivosEntity.find((item: any) =>
				plantio?.numeroPlantio != null && item.numeroPlantio != null
				&& String(item.numeroPlantio) === String(plantio.numeroPlantio)
			) ?? arquivosEntity.find((item: any) => {
				const nomeSalvo = item.filename ?? item.Filename ?? item.name;
				return filename && nomeSalvo && String(nomeSalvo).toLowerCase() === String(filename).toLowerCase();
			});

			if (salvo) {
				path = salvo.path ?? salvo.Path;
				codigo = salvo.codigo ?? salvo.Codigo;
			}
		}

		return { path, codigo, filename };
	};

	const prepararPlantioParaEdicao = (plantio: VegetacaoPlantios): VegetacaoPlantios => {
		const arquivoMaterial = obterArquivoPlantioMaterialSalvo(plantio);
		const arquivoAMI = obterArquivoPlantioAMISalvo(plantio);

		return {
			...plantio,
			filenameMaterialPlantado: arquivoMaterial.filename || plantio?.filenameMaterialPlantado,
			pathMaterialPlantado: arquivoMaterial.path,
			codigoMaterialPlantado: arquivoMaterial.codigo,
			filenamePlantioAMI: arquivoAMI.filename || plantio?.filenamePlantioAMI,
			pathPlantioAMI: arquivoAMI.path,
			codigoPlantioAMI: arquivoAMI.codigo,
		};
	};

	const associarArquivosPlantioAosRegistros = (plantios: any[], materiais: any[], amis: any[]) => {
		if (!plantios?.length) {
			return plantios ?? [];
		}

		return plantios.map((plantio, index) => {
			const material = materiais.find((item) =>
				item?.numeroPlantio != null && String(item.numeroPlantio) === String(plantio.numeroPlantio)
			) ?? materiais[index];

			const ami = amis.find((item) =>
				item?.numeroPlantio != null && String(item.numeroPlantio) === String(plantio.numeroPlantio)
			) ?? amis[index];

			const filenameMaterial = material
				? (material.filename ?? material.name ?? '')
				: (plantio.filenameMaterialPlantado ?? '');
			const filenameAMI = ami
				? (ami.filename ?? ami.name ?? '')
				: (plantio.filenamePlantioAMI ?? '');

			return {
				...plantio,
				filenameMaterialPlantado: filenameMaterial,
				pathMaterialPlantado: material?.path ?? plantio.pathMaterialPlantado,
				codigoMaterialPlantado: material?.codigo ?? plantio.codigoMaterialPlantado,
				arquivoMaterialPlantado: filenameMaterial || plantio.arquivoMaterialPlantado,
				filenamePlantioAMI: filenameAMI,
				pathPlantioAMI: ami?.path ?? plantio.pathPlantioAMI,
				codigoPlantioAMI: ami?.codigo ?? plantio.codigoPlantioAMI,
				arquivoPlantioAMI: filenameAMI || plantio.arquivoPlantioAMI,
			};
		});
	};

	const sincronizarSelectedPlantiosArquivosComServidor = (
		plantios: any[],
		materiaisServidor: any[] | undefined,
		amisServidor: any[] | undefined,
	) => {
		if (!plantios?.length) {
			return plantios ?? [];
		}

		const materiais = (materiaisServidor ?? []).map(mapArquivoPlantioParaGrid);
		const amis = (amisServidor ?? []).map(mapArquivoPlantioParaGrid);

		const materiaisComTag = materiais.map((salvo) => {
			const pendente = plantioArquivoMateriais.find((item) =>
				!item?.id
				&& (item?.filename === salvo.filename || item?.name === salvo.filename)
			);
			return { ...salvo, numeroPlantio: pendente?.numeroPlantio ?? salvo.numeroPlantio };
		});

		const amisComTag = amis.map((salvo) => {
			const pendente = plantioArquivoAMIFiles.find((item) =>
				!item?.id
				&& (item?.filename === salvo.filename || item?.name === salvo.filename)
			);
			return { ...salvo, numeroPlantio: pendente?.numeroPlantio ?? salvo.numeroPlantio };
		});

		return associarArquivosPlantioAosRegistros(plantios, materiaisComTag, amisComTag);
	};

	const atualizarPoolArquivoPlantio = (
		poolAtual: any[],
		arquivo: any,
		numeroPlantio: any,
	) => {
		const semPlantio = poolAtual.filter((item) => String(item?.numeroPlantio) !== String(numeroPlantio));
		if (!arquivo) {
			return semPlantio;
		}
		return [...semPlantio, arquivo];
	};

	const montarArquivoPlantioPendente = (file: File, numeroPlantio: any) => ({
		file,
		filename: file.name,
		name: file.name,
		numeroPlantio,
	});

	const baixarArquivoLocal = (file: File, nomeDownload?: string) => {
		const url = URL.createObjectURL(file);
		const link = document.createElement('a');
		link.href = url;
		link.setAttribute('download', nomeDownload ?? file.name);
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(url);
	};

	const textoPreenchido = (valor: unknown) => String(valor ?? '').trim().length > 0;
	const normalizarValorSelect = (valor: any) =>
		valor === undefined || valor === null || valor === '' ? '' : String(valor);

	const obterDescricaoMetodoLimpezaFromSelect = (selectValue: any, outrosText?: string) => {
		if (!selectValue?.label) {
			return null;
		}

		if (isValorOutros(selectValue.value)) {
			if (!textoPreenchido(outrosText)) {
				return null;
			}

			return formatarMetodoLimpezaOutros(selectValue.label, outrosText);
		}

		return selectValue.label;
	};

	const metodoLimpezaJaAdicionado = (descricoes: { descricao?: string }[], descricao: string) =>
		descricoes.some((item) => item.descricao === descricao);

	const prepararLimpezaDestruicaoParaEdicao = (data: VegetacaoLimpezaDestruicao): VegetacaoLimpezaDestruicao => {
		const textoOutros = extrairTextoMetodoLimpezaOutros(
			typeof data.metodoLimpeza === 'string' ? data.metodoLimpeza : undefined,
		);

		if (textoOutros !== null) {
			const opcaoOutros = enumMetodoLimpeza.find((item) => isValorOutros(item.key));
			return {
				...data,
				metodoLimpeza: {
					value: opcaoOutros?.key ?? '99',
					label: opcaoOutros?.value ?? 'Outros',
				},
				outrosMetodoLimpeza: textoOutros,
			};
		}

		if (typeof data.metodoLimpeza === 'object' && data.metodoLimpeza !== null) {
			return data;
		}

		const metodoTexto = String(data.metodoLimpeza ?? '');
		const opcao = enumMetodoLimpeza.find((item) => item.value === metodoTexto);

		return {
			...data,
			metodoLimpeza: opcao
				? { value: opcao.key, label: opcao.value }
				: data.metodoLimpeza,
			outrosMetodoLimpeza: data.outrosMetodoLimpeza ?? '',
		};
	};

	const extrairArquivoDoModal = (formArquivosData: any): File | null => {
		const arquivosInput = formArquivosData?.arquivos;
		const arquivo = arquivosInput instanceof FileList
			? arquivosInput[0]
			: (Array.isArray(arquivosInput) ? arquivosInput[0] : arquivosInput);
		return arquivo instanceof File ? arquivo : null;
	};

	const obterArquivoRegistroAmostragemSalvo = (registro: VegetacaoRegistroAmostragem) => {
		const filename = obterFilenameArquivoAmostragem(registro.arquivoAmostragem, registro.filename);
		let path = (registro as any).path ?? (registro as any).Path;
		let codigo = (registro as any).codigo ?? (registro as any).Codigo;

		const registrosEntity = entity?.vegetacao_Documentos_RegistroAmostragem as any[] | undefined;

		if (!path && registrosEntity?.length) {
			const salvo = registrosEntity.find((item: any) =>
				registro.id && item.id === registro.id
			) ?? registrosEntity.find((item: any) => {
				const nomeSalvo = item.filename ?? item.Filename;
				return filename && nomeSalvo && String(nomeSalvo).toLowerCase() === String(filename).toLowerCase();
			});

			if (salvo) {
				path = salvo.path ?? salvo.Path;
				codigo = salvo.codigo ?? salvo.Codigo;
			}
		}

		return { path, codigo, filename };
	};

	const prepararRegistroAmostragemParaEdicao = (registro: VegetacaoRegistroAmostragem): VegetacaoRegistroAmostragem => {
		const arquivoSalvo = obterArquivoRegistroAmostragemSalvo(registro);

		return {
			...registro,
			filename: arquivoSalvo.filename || registro.filename,
			path: arquivoSalvo.path,
			codigo: arquivoSalvo.codigo,
		};
	};

	const sincronizarSelectedRegistroAmostragemComServidor = (gridItems: any[], serverItems: any[] | undefined): any[] => {
		if (!gridItems?.length) {
			return gridItems ?? [];
		}

		if (!serverItems?.length) {
			return gridItems;
		}

		return gridItems.map((item) => {
			const nomeArquivo = obterFilenameArquivoAmostragem(item.arquivoAmostragem, item.filename);
			const salvo = serverItems.find((s: any) => {
				if (item.id && item.id > 0 && s.id === item.id) {
					return true;
				}

				const nomeSalvo = s.filename ?? s.Filename ?? '';
				return nomeArquivo && String(nomeSalvo).toLowerCase() === String(nomeArquivo).toLowerCase();
			});

			if (!salvo) {
				return item;
			}

			const filename = salvo.filename ?? salvo.Filename ?? nomeArquivo;

			return {
				...item,
				id: salvo.id ?? item.id,
				filename,
				path: salvo.path ?? salvo.Path ?? item.path,
				codigo: salvo.codigo ?? salvo.Codigo ?? item.codigo,
				arquivoAmostragem: filename,
			};
		});
	};

	const obterFilenameArquivoColheita = obterFilenameArquivoAmostragem;
	const extrairFileColheitaPendente = extrairFileAmostragemPendente;

	const obterArquivoRegistroColheitaSalvo = (registro: VegetacaoRegistroColheita) => {
		const filename = obterFilenameArquivoColheita(registro.arquivoAMIColheita, registro.filename);
		let path = (registro as any).path ?? (registro as any).Path;
		let codigo = (registro as any).codigo ?? (registro as any).Codigo;

		const registrosEntity = entity?.vegetacao_Planejamento_RegistroColheita as any[] | undefined;

		if (!path && registrosEntity?.length) {
			const salvo = registrosEntity.find((item: any) =>
				registro.id && item.id === registro.id
			) ?? registrosEntity.find((item: any) => {
				const nomeSalvo = item.filename ?? item.Filename;
				return filename && nomeSalvo && String(nomeSalvo).toLowerCase() === String(filename).toLowerCase();
			});

			if (salvo) {
				path = salvo.path ?? salvo.Path;
				codigo = salvo.codigo ?? salvo.Codigo;
			}
		}

		return { path, codigo, filename };
	};

	const prepararRegistroColheitaParaEdicao = (registro: VegetacaoRegistroColheita): VegetacaoRegistroColheita => {
		const arquivoSalvo = obterArquivoRegistroColheitaSalvo(registro);

		return {
			...registro,
			filename: arquivoSalvo.filename || registro.filename,
			path: arquivoSalvo.path,
			codigo: arquivoSalvo.codigo,
		};
	};

	const sincronizarSelectedRegistroColheitaComServidor = (gridItems: any[], serverItems: any[] | undefined): any[] => {
		if (!gridItems?.length) {
			return gridItems ?? [];
		}

		if (!serverItems?.length) {
			return gridItems;
		}

		return gridItems.map((item) => {
			const nomeArquivo = obterFilenameArquivoColheita(item.arquivoAMIColheita, item.filename);
			const salvo = serverItems.find((s: any) => {
				const salvoId = s.id ?? s.Id;
				if (item.id && item.id > 0 && salvoId === item.id) {
					return true;
				}

				const nomeSalvo = s.filename ?? s.Filename ?? '';
				return nomeArquivo && String(nomeSalvo).toLowerCase() === String(nomeArquivo).toLowerCase();
			});

			if (!salvo) {
				return item;
			}

			const filename = salvo.filename ?? salvo.Filename ?? nomeArquivo;

			return {
				...item,
				id: salvo.id ?? salvo.Id ?? item.id,
				filename,
				path: salvo.path ?? salvo.Path ?? item.path,
				codigo: salvo.codigo ?? salvo.Codigo ?? item.codigo,
				arquivoAMIColheita: filename,
			};
		});
	};

	const carregarRegistroColheitaDaEntity = (origem: any) => {
		const registros = origem?.vegetacao_Planejamento_RegistroColheita ?? origem?.Vegetacao_Planejamento_RegistroColheita;

		if (!registros?.length) {
			setSelectedRegistroColheita([]);
			return;
		}

		const newRegistroColheita: Planejamento_RegistroColheitaOnEditVegetacao[] = [];

		for (let n = 0, t = registros.length; n < t; n++) {
			const registro = registros[n];
			let Responsaveis: ResponsavelColheita[] = [];
			let listaResponsaveis = '';
			const responsaveisFonte = registro.responsaveis ?? registro.Responsaveis ?? [];

			if (responsaveisFonte.length) {
				for (let i = 0, j = responsaveisFonte.length; i < j; i++) {
					const responsavel: ResponsavelColheita = {
						id: responsaveisFonte[i].id ?? responsaveisFonte[i].Id,
						responsavel: responsaveisFonte[i].responsavel ?? responsaveisFonte[i].Responsavel,
						contagem: i + 1,
					};

					listaResponsaveis += responsavel.responsavel + '; ';
					Responsaveis.push(responsavel);
				}
			}

			const tipoColheitaId = Number(registro.tipoColheita_Id ?? registro.TipoColheita_Id ?? 0);
			const tipoMaterialColheitaId = Number(registro.tipoMaterialColheita_Id ?? registro.TipoMaterialColheita_Id ?? 0);
			const destinoMaterialColheitaId = Number(registro.destinoMaterialColheita_Id ?? registro.DestinoMaterialColheita_Id ?? 0);
			const tipoColheitaEnum = enumTipoColheita.filter((e: any) => Number(e.key) === tipoColheitaId);
			const tipoMaterialColheitaEnum = enumTipoMaterialColheita.filter((e: any) => Number(e.key) === tipoMaterialColheitaId);
			const destinoEnum = locations.filter((e: any) => Number(e.id) === destinoMaterialColheitaId);

			newRegistroColheita.push({
				id: registro.id ?? registro.Id,
				tipoColheita: {
					label: tipoColheitaEnum.length > 0 ? tipoColheitaEnum[0].value : '',
					value: tipoColheitaId,
				},
				dataColheita: (registro.dataColheita ?? registro.DataColheita) !== undefined ? moment(registro.dataColheita ?? registro.DataColheita).toDate() : null,
				dataInicialColheita: (registro.dataInicialColheita ?? registro.DataInicialColheita) !== undefined ? moment(registro.dataInicialColheita ?? registro.DataInicialColheita).toDate() : null,
				dataFinalColheita: (registro.dataFinalColheita ?? registro.DataFinalColheita) !== undefined ? moment(registro.dataFinalColheita ?? registro.DataFinalColheita).toDate() : null,
				tipoMaterialColheita: {
					label: tipoMaterialColheitaEnum.length > 0 ? tipoMaterialColheitaEnum[0].value : '',
					value: tipoMaterialColheitaId,
				},
				outrosTipoMaterialColheita: registro.outrosTipoMaterialColheita ?? registro.OutrosTipoMaterialColheita ?? '',
				quantidadeMaterialColheita: registro.quantidadeMaterialColheita ?? registro.QuantidadeMaterialColheita,
				numeroAMIColheita: registro.numeroAMIColheita ?? registro.NumeroAMIColheita ?? '',
				destinoMaterialColheita: destinoEnum.length > 0 ? {
					label: destinoEnum[0].nome,
					value: destinoMaterialColheitaId,
				} : null,
				arquivoAMIColheita: registro.filename ?? registro.Filename ?? '',
				filename: registro.filename ?? registro.Filename ?? '',
				path: registro.path ?? registro.Path,
				codigo: registro.codigo ?? registro.Codigo,
				contagemRegistroColheita: n + 1,
				responsaveis: Responsaveis,
				listaResponsaveis,
			});
		}

		setSelectedRegistroColheita(ordenarPorDataAsc(newRegistroColheita, 'dataInicialColheita', 'contagemRegistroColheita'));
	};

	const obterFilenameArquivoFiscalizacao = obterFilenameArquivoAmostragem;
	const extrairFileFiscalizacaoPendente = extrairFileAmostragemPendente;

	const obterArquivoRegistroFiscalizacaoSalvo = (registro: VegetacaoRegistroFiscalizacao) => {
		const filename = obterFilenameArquivoFiscalizacao(registro.arquivoTermo, registro.filename);
		let path = (registro as any).path ?? (registro as any).Path;
		let codigo = (registro as any).codigo ?? (registro as any).Codigo;

		const registrosEntity = entity?.vegetacao_Fiscalizacao as any[] | undefined;

		if (!path && registrosEntity?.length) {
			const salvo = registrosEntity.find((item: any) =>
				registro.id && item.id === registro.id
			) ?? registrosEntity.find((item: any) => {
				const nomeSalvo = item.filename ?? item.Filename;
				return filename && nomeSalvo && String(nomeSalvo).toLowerCase() === String(filename).toLowerCase();
			});

			if (salvo) {
				path = salvo.path ?? salvo.Path;
				codigo = salvo.codigo ?? salvo.Codigo;
			}
		}

		return { path, codigo, filename };
	};

	const prepararRegistroFiscalizacaoParaEdicao = (registro: VegetacaoRegistroFiscalizacao): VegetacaoRegistroFiscalizacao => {
		const arquivoSalvo = obterArquivoRegistroFiscalizacaoSalvo(registro);

		return {
			...registro,
			filename: arquivoSalvo.filename || registro.filename,
			path: arquivoSalvo.path,
			codigo: arquivoSalvo.codigo,
		};
	};

	const sincronizarSelectedRegistroFiscalizacaoComServidor = (gridItems: any[], serverItems: any[] | undefined): any[] => {
		if (!gridItems?.length) {
			return gridItems ?? [];
		}

		if (!serverItems?.length) {
			return gridItems;
		}

		return gridItems.map((item) => {
			const nomeArquivo = obterFilenameArquivoFiscalizacao(item.arquivoTermo, item.filename);
			const salvo = serverItems.find((s: any) => {
				if (item.id && item.id > 0 && s.id === item.id) {
					return true;
				}

				const nomeSalvo = s.filename ?? s.Filename ?? '';
				return nomeArquivo && String(nomeSalvo).toLowerCase() === String(nomeArquivo).toLowerCase();
			});

			if (!salvo) {
				return item;
			}

			const filename = salvo.filename ?? salvo.Filename ?? nomeArquivo;

			return {
				...item,
				id: salvo.id ?? item.id,
				filename,
				path: salvo.path ?? salvo.Path ?? item.path,
				codigo: salvo.codigo ?? salvo.Codigo ?? item.codigo,
				arquivoTermo: filename,
			};
		});
	};

	const carregarRegistroFiscalizacaoDaEntity = (origem: any) => {
		const registros = origem?.vegetacao_Fiscalizacao;
		const termosLegados = origem?.vegetacao_Fiscalizacao_Termos ?? [];

		if (!registros?.length && !termosLegados?.length) {
			setSelectedRegistroFiscalizacao([]);
			return;
		}

		const newRegistroFiscalizacao: FiscalizacaoOnEditVegetacao[] = [];
		const fonte = registros?.length ? registros : termosLegados.map((t: any) => ({
			id: 0,
			termosFiscalizacao: true,
			filename: t.filename ?? t.Filename,
			path: t.path ?? t.Path,
			codigo: t.codigo ?? t.Codigo,
		}));

		for (let n = 0, t = fonte.length; n < t; n++) {
			const registro = fonte[n];
			const orgaoId = Number(registro.orgaoFiscalizador_Id ?? 0);
			const termoLegado = termosLegados[n];

			newRegistroFiscalizacao.push({
				id: registro.id ?? 0,
				termosFiscalizacao: registro.termosFiscalizacao ?? true,
				observacoesTermosFiscalizacao: registro.observacoesTermosFiscalizacao ?? '',
				dataFiscalizacao: registro.dataFiscalizacao !== undefined ? moment(registro.dataFiscalizacao).toDate() : null,
				orgaoFiscalizador: buildSelectValue(orgaoId, undefined, orgaoFiscalizadorOptions),
				outrosOrgaoFiscalizador: registro.outrosOrgaoFiscalizador ?? '',
				arquivoTermo: registro.filename ?? registro.Filename ?? termoLegado?.filename ?? '',
				filename: registro.filename ?? registro.Filename ?? termoLegado?.filename ?? '',
				path: registro.path ?? registro.Path ?? termoLegado?.path,
				codigo: registro.codigo ?? registro.Codigo ?? termoLegado?.codigo,
				contagemRegistroFiscalizacao: n + 1,
			});
		}

		setSelectedRegistroFiscalizacao(ordenarPorDataAsc(newRegistroFiscalizacao, 'dataFiscalizacao', 'contagemRegistroFiscalizacao'));
	};

	const [lblArquivoMaterialPlantado, setLblArquivoMaterialPlantado] = useState('Escolher arquivo');
	const [lblArquivoPlantioAMI, setLblArquivoPlantioAMI] = useState('Escolher arquivo');
	const [plantioMaterialFile, setPlantioMaterialFile] = useState<File | null>(null);
	const [plantioAMIFile, setPlantioAMIFile] = useState<File | null>(null);

	const [lblConducaoComunicados, setLblConducaoComunicados] = useState('Escolher arquivo');
	const [conducaoComunicados, setConducaoComunicados] = useState<any[]>([]);

	const [lblNumeroAMI, setLblNumeroAMI] = useState('Escolher arquivo');
	const [numeroAMI, setNumeroAMI] = useState<any[]>([]);
	const [modalAtivo, setModalAtivo] = useState<string>('');

	const [lblNumeroAAC, setLblNumeroAAC] = useState('Escolher arquivo');
	const [numeroAAC, setNumeroAAC] = useState<any[]>([]);

	const [lblArquivoRegistroAmostragem, setLblArquivoRegistroAmostragem] = useState('Escolher arquivo');
	const [arquivoRegistroAmostragemPendente, setArquivoRegistroAmostragemPendente] = useState<File | null>(null);
	const [contagemLimpezaDestruicao, setContagemLimpezaDestruicao] = useState<any>(null);

	const [expectedResponsaveisPlantio, setExpectedResponsaveisPlantio] = useState<ResponsavelNotificacao[]>([]);
	const [responsaveisPlantio, setResponsaveisPlantio] = useState<ResponsavelNotificacao[]>([]);

	const [responsaveisManutencao, setResponsaveisManutencao] = useState<ResponsavelAtividade[]>([]);
	const [metodosLimpezaManutencao, setMetodosLimpezaManutencao] = useState<MetodoLimpezaManutencao[]>([]);

	const [responsaveisEquipamentos, setResponsaveisEquipamentos] = useState<ResponsavelEquipamentos[]>([]);
	const [metodosLimpezaEquipamentos, setMetodosLimpezaEquipamentos] = useState<MetodoLimpezaEquipamentos[]>([]);

	const [responsaveisAmostragem, setResponsaveisAmostragem] = useState<ResponsavelAmostragem[]>([]);

	const [responsaveisColheita, setResponsaveisColheita] = useState<ResponsavelColheita[]>([]);

	const [responsaveisInstalacao, setResponsaveisInstalacao] = useState<ResponsavelInstalacao[]>([]);
	const [metodosLimpezaInstalacao, setMetodosLimpezaInstalacao] = useState<MetodoLimpezaInstalacao[]>([]);

	const [contagemDestruicao, setContagemDestruicao] = useState<any>(null);

	const [destruicaoEdit, setDestruicaoEdit] = useState<VegetacaoDestruicao>({
		id: 0,
		tipoDestruicao: '',
		outrosTipoDestruicao: '',
		numeroAmostras: 0,
		pesoAmostras: 0,
		unidadeMedida: '',
		localDestruicao: '',
		outrosLocalDestruicao: '',
		observacoesLocalDestruicao: '',
		metodoDestruicao: '',
		outrosMetodoDestruicao: '',
		observacoesMetodoDestruicao: '',
		dataInicialDestruicao: '',
		dataFinalDestruicao: '',
		tipoFaseDestruicao_Id: 0,
		outrosTipoFaseDestruicao: '',
	});
	const [selectedDestruicao, setSelectedDestruicao] = useState<DestruicaoOnEditVegetacao[]>([]);
	const [responsaveisDestruicao, setResponsaveisDestruicao] = useState<ResponsavelDestruicao[]>([]);
	const [metodosDestruicao, setMetodosDestruicao] = useState<MetodoDestruicao[]>([]);
	const [modalDestruicao, setModalDestruicao] = useState<boolean>(false);


	const [expectedResponsaveisPreColheita, setExpectedResponsaveisPreColheita] = useState<Responsavel[]>([]);
	const [responsaveisPreColheita, setResponsaveisPreColheita] = useState<Responsavel[]>([]);

	const [expectedResponsaveisPessoaColheita, setExpectedResponsaveisPessoaColheita] = useState<Responsavel[]>([]);
	const [responsaveisPessoaColheita, setResponsaveisPessoaColheita] = useState<Responsavel[]>([]);

	const [expectedAtividadesManutencao, setExpectedAtividadesManutencao] = useState<AtividadeManutencao[]>([]);
	const [atividadesManutencao, setAtividadesManutencao] = useState<AtividadeManutencao[]>([]);
	const [arquivoPoda, setArquivoPoda] = useState<boolean>(false);
	const [lblArquivoPodaManutencao, setLblArquivoPodaManutencao] = useState('Escolher arquivo');

	const [lblColheitaAMI, setLblColheitaAMI] = useState('Escolher arquivo');
	const [colheitaAMI, setColheitaAMI] = useState<any[]>([]);
	const [fileFieldColheitaAMI, setFileFieldColheitaAMI] = useState<Models.ModelFileRegister>();

	const normalizarArquivoColheitaAMI = (arquivo: any) => {
		if (!arquivo) {
			return arquivo;
		}

		const filename = arquivo.filename ?? arquivo.Filename ?? arquivo.name ?? '';

		return {
			...arquivo,
			id: arquivo.id ?? arquivo.Id,
			filename,
			path: arquivo.path ?? arquivo.Path,
			codigo: arquivo.codigo ?? arquivo.Codigo,
		};
	};

	const obterNomeArquivoColheitaAMI = (arquivo: any) =>
		arquivo?.filename ?? arquivo?.Filename ?? arquivo?.name ?? '';

	const obterColheitaAMIDaOrigem = (origem: any) => {
		const lista = origem?.vegetacao_Colheita_AMI ?? origem?.Vegetacao_Colheita_AMI ?? [];
		return Array.isArray(lista) ? lista : [];
	};

	const carregarColheitaAMIDaEntity = (origem: any) => {
		const lista = obterColheitaAMIDaOrigem(origem);

		if (!lista.length) {
			return;
		}

		const arquivos = lista.map(normalizarArquivoColheitaAMI);
		setColheitaAMI(arquivos);
		setFileFieldColheitaAMI(arquivos[0]);
	};

	const [lblDestruicaoAMI, setLblDestruicaoAMI] = useState('Escolher arquivo');
	const [destruicaoAMI, setDestruicaoAMI] = useState<any[]>([]);
	const [exibirAnexoDestruicaoAMI, setExibirAnexoDestruicaoAMI] = useState(false);
	const [fileFieldDestruicaoAMI, setFileFieldDestruicaoAMI] = useState<Models.ModelFileRegister>();

	const [lblFiscalizacaoTermos, setLblFiscalizacaoTermos] = useState('Escolher arquivo');
	const [fiscalizacaoTermos, setFiscalizacaoTermos] = useState<any[]>([]);
	const [fileFieldFiscalizacaoTermos, setFileFieldFiscalizacaoTermos] = useState<Models.ModelFileRegister>();

	const [limpezaDestruicaoEdit, setLimpezaDestruicaoEdit] = useState<VegetacaoLimpezaDestruicao>({
		id: 0,
		contagemLimpezaDestruicao: '',
		descricaoMaquinario: '',
		dataLimpezaAntesUso: '',
		dataLimpezaDepoisUso: '',
		metodoLimpeza: '',
		responsavelLimpeza: '',
	});
	const [selectedLimpezaDestruicao, setSelectedLimpezaDestruicao] = useState<ExpectedDestruicaoLimpeza[]>([]);
	const [modalLimpezaDestruicao, setModalLimpezaDestruicao] = useState<boolean>(false);

	const [selectedDatasColheita, setSelectedDatasColheita] = useState<VegetacaoDataColheita[]>([]);
	const [modalDatasColheita, setModalDatasColheita] = useState<boolean>(false);

	const [contagemPessoasEnvolvidasColheita, setContagemPessoasEnvolvidasColheita] = useState<any>(null);

	const [PessoasEnvolvidasColheitaEdit, setPessoasEnvolvidasColheitaEdit] = useState<VegetacaoPessoasEnvolvidasColheita>({
		id: 0,
		contagemPessoasEnvolvidasColheita: '',
		pessoaColheita: ''
	});
	const [selectedPessoasEnvolvidasColheita, setSelectedPessoasEnvolvidasColheita] = useState<VegetacaoPessoasEnvolvidasColheita[]>([]);
	const [modalPessoasEnvolvidasColheita, setModalPessoasEnvolvidasColheita] = useState<boolean>(false);

	const [contagemInspecaoEquipamento, setContagemInspecaoEquipamento] = useState<any>(null);

	const [inspecaoEquipamentosEdit, setInspecaoEquipamentosEdit] = useState<VegetacaoInspecaoEquipamentos>({
		id: 0,
		contagemInspecaoEquipamento: '',
		numeroPlantio: '',
		iD_Equipamento: '',
		dataAntesUso: '',
		dataAposUso: '',
		faseEnsaio: '',
		metodoLimpezaEquipamento_Id: '',
		faseLimpeza_Id: '',
	});
	const [selectedInspecaoEquipamentos, setSelectedInspecaoEquipamentos] = useState<VegetacaoInspecaoEquipamentos[]>([]);
	const [modalInspecaoEquipamentos, setModalInspecaoEquipamentos] = useState<boolean>(false);

	const [contagemLimpezaInstalacao, setContagemLimpezaInstalacao] = useState<any>(null);

	const [limpezaInstalacoesEdit, setLimpezaInstalacoesEdit] = useState<VegetacaoLimpezaInstalacoes>({
		id: 0,
		contagemLimpezaInstalacao: '',
		dataLimpeza: '',
		numeroCodigoCasaVegetacao: '',
		responsavel: '',
		metodoLimpeza_Id: '',
		dataInicialLimpeza: '',
		dataFinalLimpeza: '',
		tipoFaseLimpeza_Id: '',
		outrosTipoFaseLimpeza: '',
		observacoesLimpeza: ''
	});
	const [selectedLimpezaInstalacoes, setSelectedLimpezaInstalacoes] = useState<VegetacaoLimpezaInstalacoes[]>([]);
	const [modalLimpezaInstalacoes, setModalLimpezaInstalacoes] = useState<boolean>(false);

	const [contagemAtividadeManutencao, setContagemAtividadeManutencao] = useState<any>(null);

	const [atividadeManutencaoEdit, setAtividadeManutencaoEdit] = useState<VegetacaoAtividadeManutencao>({
		id: 0,
		contagemAtividadeManutencao: '',
		dataAtividade: '',
		dataInicialAtividade: '',
		dataFinalAtividade: '',
		responsavel: '',
		atividadeManutencao_Id: '',
	});
	const [selectedAtividadeManutencao, setSelectedAtividadeManutencao] = useState<VegetacaoAtividadeManutencao[]>([]);
	const [modalAtividadeManutencao, setModalAtividadeManutencao] = useState<boolean>(false);

	const [limpezaEquipamentos, setLimpezaEquipamentos] = useState<boolean>(false);

	const [ResponsavelReporteEdit, setResponsavelReporteEdit] = useState<VegetacaoResponsaveisReporte>({
		id: 0,
		nomeReporteLiberacaoNaoIntencional: '',
		cargoReporteLiberacaoNaoIntencional: '',
		dataReporteLiberacaoNaoIntencional: '',
	});
	const [responsaveisReporte, setResponsaveisReporte] = useState<ResponsaveisReportesOnEditVegetacao[]>([]);
	const [modalResponsavelReporte, setModalResponsavelReporte] = useState<boolean>(false);



	const [isConfirmation, setIsConfirmation] = useState<boolean>(false);
	const [loadingDraft, setLoadingDraft] = useState<boolean>(false);
	const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
	const [loadingGetData, setLoadingGetData] = useState<boolean>(true);
	const [successSubmit, setSuccessSubmit] = useState<boolean>(false);
	const [successDraft, setSuccessDraft] = useState<boolean>(false);
	const [errorSubmit, setErrorSubmit] = useState<any>(null);
	const [errorDraft, setErrorDraft] = useState<any>(null);
	const [errorGetData, setErrorGetData] = useState<any>(null);
	const [gridProps, setGridProps] = useState<any>(null);
	const [isRegulatory, setIsRegulatory] = useState<boolean>(false);

	const [loadingRegulatory, setLoadingRegulatory] = useState<boolean>(false);
	const [errorRegulatory, setErrorRegulatory] = useState<any>(null);
	const [successRegulatory, setSuccessRegulatory] = useState<boolean>(false);
	const [requisitanteCadernoConformidade, setRequisitanteCadernoConformidade] = useState('');
	const [statusCadernoConformidade, setStatusCadernoConformidade] = useState<number>(0);

	const [errorCorrection, setErrorCorrection] = useState<any>(null);
	const [isCorrection, setIsCorrection] = useState<boolean>(false);
	const [reasonCorrection, setReasonCorrection] = useState('');
	const [loadingCorrection, setLoadingCorrection] = useState<boolean>(false);
	const [successCorrection, setSuccessCorrection] = useState<boolean>(false);
	const [isApprove, setIsApprove] = useState<boolean>(false);
	const [loadingApprove, setLoadingApprove] = useState<boolean>(false);
	const [successApprove, setSuccessApprove] = useState<boolean>(false);
	const [errorAprove, setErrorAprove] = useState<any>(null);
	const [isComplete, setIsComplete] = useState<boolean>(false);
	const [loadingComplete, setLoadingComplete] = useState<boolean>(false);
	const [successComplete, setSuccessComplete] = useState<boolean>(false);
	const [errorComplete, setErrorComplete] = useState<any>(null);

	const [checkboxSobraMaterial, setCheckboxSobraMaterial] = useState<boolean>(false);


	const vegetacaoSchema = yup.object({
		codigoaac: yup.mixed().required(STRINGS.FORM_FIELD_REQUIRED),
		projeto: yup.string().required(STRINGS.FORM_FIELD_REQUIRED),
		municipio: yup.mixed().required(STRINGS.FORM_FIELD_REQUIRED),
		cultura_Id: yup.string().required(STRINGS.FORM_FIELD_REQUIRED),
		modoDeTransporte: yup.mixed().required(STRINGS.FORM_FIELD_REQUIRED),
		nomecientifico: yup.string().required(STRINGS.FORM_FIELD_REQUIRED),
		numeromapa: yup.string().required(STRINGS.FORM_FIELD_REQUIRED),
		responsavelRegulatorio_Id: yup.mixed().required(STRINGS.FORM_FIELD_REQUIRED),
		tecnicoPrincipal_Id: yup.mixed().required(STRINGS.FORM_FIELD_REQUIRED)
	});


	const { register, reset, setValue, getValues, errors, trigger, handleSubmit, control, watch, formState: { isDirty } } = useForm({
		defaultValues: entity,
		mode: 'onSubmit',
		resolver: yupResolver(vegetacaoSchema)
	});

	const { getValues: getValuesAnotacoes, control: controlAnotacoes, register: registerAnotacoes, errors: errorsAnotacoes, handleSubmit: handleSubmitAnotacoes, trigger: triggerAnotacoes, watch: watchAnotacoes } = useForm({
		mode: 'all',
		//resolver: yupResolver(AnotacoesSchema)
	})

	const { getValues: getValuesPlantios, control: controlPlantios, register: registerPlantios, errors: errorsPlantios, handleSubmit: handleSubmitPlantios, trigger: triggerPlantios, watch: watchEditPlantios, reset: resetPlantios } = useForm({
		mode: 'all',
		//resolver: yupResolver(PlantiosSchema)
	})

	const { getValues: getValuesRegistroAmostragem, control: controlRegistroAmostragem, register: registerRegistroAmostragem, errors: errorsRegistroAmostragem, handleSubmit: handleSubmitRegistroAmostragem, trigger: triggerRegistroAmostragem, watch: watchEditRegistroAmostragem } = useForm({
		mode: 'all',
		//resolver: yupResolver(RegistroAmostragemsSchema)
	})

	const { control: controlRegistroColheita, register: registerRegistroColheita, errors: errorsRegistroColheita, handleSubmit: handleSubmitRegistroColheita, watch: watchEditRegistroColheita } = useForm({
		mode: 'all',
	})

	const { control: controlRegistroFiscalizacao, register: registerRegistroFiscalizacao, handleSubmit: handleSubmitRegistroFiscalizacao, watch: watchEditRegistroFiscalizacao } = useForm({
		mode: 'all',
	})

	const { getValues: getValuesDataPlantios, control: controlDataPlantios, register: registerDataPlantios, errors: errorsDataPlantios, handleSubmit: handleSubmitDataPlantios, trigger: triggerDataPlantios, watch: watchDataPlantios } = useForm({
		mode: 'all',
		//resolver: yupResolver(PlantiosSchema)
	})

	const { getValues: getValuesPessoasEnvolvidasPlantio, control: controlPessoasEnvolvidasPlantio, register: registerPessoasEnvolvidasPlantio, errors: errorsPessoasEnvolvidasPlantio, handleSubmit: handleSubmitPessoasEnvolvidasPlantio, trigger: triggerPessoasEnvolvidasPlantio, watch: watchPessoasEnvolvidasPlantio } = useForm({
		mode: 'all',
		//resolver: yupResolver(PlantiosSchema)
	})

	const { getValues: getValuesLimpezaDestruicao, control: controlLimpezaDestruicao, register: registerLimpezaDestruicao, errors: errorsLimpezaDestruicao, handleSubmit: handleSubmitLimpezaDestruicao, trigger: triggerLimpezaDestruicao, watch: watchEditLimpezaDestruicao, reset: resetLimpezaDestruicao } = useForm({
		mode: 'all',
		//resolver: yupResolver(LimpezaDestruicaochema)
	})

	const { getValues: getValuesDatasColheita, control: controlDatasColheita, register: registerDatasColheita, errors: errorsDatasColheita, handleSubmit: handleSubmitDatasColheita, trigger: triggerDatasColheita, watch: watchDatasColheita } = useForm({
		mode: 'all',
		//resolver: yupResolver(DatasColheitachema)
	})

	const { getValues: getValuesPessoasEnvolvidasColheita, control: controlPessoasEnvolvidasColheita, register: registerPessoasEnvolvidasColheita, errors: errorsPessoasEnvolvidasColheita, handleSubmit: handleSubmitPessoasEnvolvidasColheita, trigger: triggerPessoasEnvolvidasColheita, watch: watchPessoasEnvolvidasColheita } = useForm({
		mode: 'all',
		//resolver: yupResolver(ColheitasSchema)
	})


	const { getValues: getValuesResponsaveisReporte, control: controlResponsaveisReporte, register: registerResponsaveisReporte, errors: errorsResponsaveisReporte, handleSubmit: handleSubmitResponsaveisReporte, trigger: triggerResponsaveisReporte, watch: watchResponsaveisReporte } = useForm({
		mode: 'all',
		//resolver: yupResolver(ColheitasSchema)
	})

	const { getValues: getValuesInspecaoEquipamentos, control: controlInspecaoEquipamentos, register: registerInspecaoEquipamentos, errors: errorsInspecaoEquipamentos, handleSubmit: handleSubmitInspecaoEquipamentos, trigger: triggerInspecaoEquipamentos, watch: watchEditInspecaoEquipamentos, reset: resetInspecaoEquipamentos, setValue: setValueInspecaoEquipamentos } = useForm({
		mode: 'all',
		//resolver: yupResolver(InspecaoEquipamentoschema)
	})

	const { getValues: getValuesLimpezaInstalacoes, control: controlLimpezaInstalacoes, register: registerLimpezaInstalacoes, errors: errorsLimpezaInstalacoes, handleSubmit: handleSubmitLimpezaInstalacoes, trigger: triggerLimpezaInstalacoes, watch: watchEditLimpezaInstalacoes, reset: resetLimpezaInstalacoes, setValue: setValueLimpezaInstalacoes } = useForm({
		mode: 'all',
		//resolver: yupResolver(LimpezaInstalacoeschema)
	})

	const { getValues: getValuesAtividadeManutencao, control: controlAtividadeManutencao, register: registerAtividadeManutencao, errors: errorsAtividadeManutencao, handleSubmit: handleSubmitAtividadeManutencao, trigger: triggerAtividadeManutencao, watch: watchEditAtividadeManutencao, reset: resetAtividadeManutencao, setValue: setValueAtividadeManutencao } = useForm({
		mode: 'all',
		//resolver: yupResolver(AtividadeManutencaosSchema)
	})

	const { getValues: getValuesDataComunicados, control: controlDataComunicados, register: registerDataComunicados, errors: errorsDataComunicados, handleSubmit: handleSubmitDataComunicados, trigger: triggerDataComunicados, watch: watchDataComunicados } = useForm({
		mode: 'all',
		//resolver: yupResolver(ComunicadosSchema)
	})

	const { getValues: getValuesDestruicao, control: controlDestruicao, register: registerDestruicao, errors: errorsDestruicao, handleSubmit: handleSubmitDestruicao, trigger: triggerDestruicao, watch: watchEditDestruicao, reset: resetDestruicao } = useForm({
		mode: 'all',
		//resolver: yupResolver(AtividadeManutencaosSchema)
	})

	const MODO_VIEW = {
		DADOS_PRINCIPAIS: 1,
		PLANEJAMENTO: 2,
		MANUTENCAO: 3,
		AMOSTRAGEM: 4,
		COLHEITA: 5,
		LIMPEZA_INSTALACOES: 6,
		DESCARTE: 7,
		NOTAS: 8,
	}

	const FASE_LIMPEZA_EQUIPAMENTOS = {
		PLANTIO: 1,
		MANUTENCAO: 2,
		AMOSTRAGEM: 3,
		COLHEITA: 4,
		DESCARTE: 5,
	}

	const [modoFluxo, setModoFluxo] = useState<Number>(MODO_VIEW.DADOS_PRINCIPAIS);
	const [usuarios, setUsuarios] = useState<UsuarioDto[]>([]);
	const [cultures, setCultures] = useState<CulturaResult[]>([]);
	const [locations, setLocations] = useState<UnityStationResult[]>([]);
	const [responsaveis, setResponsaveis] = useState<ResponsavelRegulatorioResult[]>([]);
	const [tecnicoPrincipal, setTecnicoPrincipal] = useState<TecnicoPrincipalResult[]>([]);

	const defaultForm = useForm({
		defaultValues: entity,
		mode: "onSubmit",
		shouldUnregister: false,
	});

	const [enumTipoMaterialAmostragem, setEnumTipoMaterialAmostragem] = useState<Enum[]>([]);
	const [enumDestinoAmostras, setEnumDestinoAmostras] = useState<Enum[]>([]);
	const [enumDestinoSobra, setEnumDestinoSobra] = useState<Enum[]>([]);
	const [enumLocalDescarte, setEnumLocalDescarte] = useState<Enum[]>([]);
	const [enumMetodoDescarte, setEnumMetodoDescarte] = useState<Enum[]>([]);
	const [enumTipoMaterialDescartado, setEnumTipoMaterialDescartado] = useState<Enum[]>([]);
	const [enumTipoColheita, setEnumTipoColheita] = useState<Enum[]>([]);
	const [enumTipoMaterialColheita, setEnumTipoMaterialColheita] = useState<Enum[]>([]);
	const [enumTipoFaseDestruicao, setEnumTipoFaseDestruicao] = useState<Enum[]>([]);
	const [enumTipoFaseLimpezaEquipamentos, setEnumTipoFaseLimpezaEquipamentos] = useState<Enum[]>([]);
	const [enumTipoFaseLimpezaInstalacoes, setEnumTipoFaseLimpezaInstalacoes] = useState<Enum[]>([]);
	const [enumMetodoLimpeza, setEnumMetodoLimpeza] = useState<Enum[]>([]);
	const [enumMetodoLimpezaEquipamento, setEnumMetodoLimpezaEquipamento] = useState<Enum[]>([]);
	const [enumMetodoLimpezaInstalacao, setEnumMetodoLimpezaInstalacao] = useState<Enum[]>([]);
	const [enumMunicipio, setEnumMunicipio] = useState<Enum[]>([]);
	const [enumNomeCientifico, setEnumNomeCientifico] = useState<Enum[]>([]);
	const [enumResponsavelRegulatorio, setEnumResponsavelRegulatorio] = useState<Enum[]>([]);
	const [enumAtividadesManutencao, setEnumAtividadesManutencao] = useState<Enum[]>([]);
	const [enumOrgaoFiscalizador, setEnumOrgaoFiscalizador] = useState<Enum[]>([]);
	const [enumUnidadeMedida, setEnumUnidadeMedida] = useState<Enum[]>([]);

	//#region Inicializações
	const buildSelectValue = (
		id: any,
		label: string | undefined,
		options: { label: string; value: any }[]
	): { label: string; value: any } | null => {
		const numId = id != null && id !== '' ? Number(id) : NaN;
		if (!isNaN(numId) && numId > 0) {
			const match = options.find(o => Number(o.value) === numId);
			if (match) return match;
			if (label) return { label, value: numId };
		}
		if (label) {
			const matchByLabel = options.find(o => o.label === label);
			if (matchByLabel) return matchByLabel;
		}
		return null;
	};

	const municipioOptions = enumMunicipio.map(m => ({ value: m.key, label: m.value }));
	const culturaOptions = cultures.map(c => ({ label: c.nome, value: c.id }));
	const nomeCientificoOptions = enumNomeCientifico.map(n => ({ value: n.key, label: n.value }));
	const responsavelRegulatorioOptions = enumResponsavelRegulatorio.map(r => ({ label: r.value, value: r.key }));
	const tecnicoPrincipalOptions = tecnicoPrincipal.map(t => ({ label: t.nome, value: t.id }));
	const obterValorOrgaoFiscalizador = (orgao: { key: any; value?: string }): number => {
		const n = Number(orgao.key);
		if (Number.isFinite(n) && n > 0) return n;

		const rotulo = String(orgao.value ?? orgao.key ?? '').toUpperCase();
		if (rotulo === 'MAPA') return 1;
		if (rotulo === 'IBAMA') return 2;
		if (rotulo === 'OUTROS') return 99;
		return 0;
	};
	const orgaoFiscalizadorOptions = enumOrgaoFiscalizador
		.map(orgao => ({ value: obterValorOrgaoFiscalizador(orgao), label: orgao.value }))
		.filter(opcao => opcao.value > 0);

	const lerTextoPreservado = (campoForm: string, ...valores: any[]): string => {
		const formVal = defaultForm.getValues(campoForm);
		if (formVal !== undefined && formVal !== null && String(formVal).trim() !== '') {
			return String(formVal).trim();
		}

		for (const val of valores) {
			if (val !== undefined && val !== null && String(val).trim() !== '') {
				return String(val).trim();
			}
		}

		return '';
	};

	const lerSelectPreservado = (
		campoForm: string,
		idEntity: any,
		labelEntity: string | undefined,
		options: { label: string; value: any }[]
	) => {
		const formVal = defaultForm.getValues(campoForm) as any;
		if (formVal?.value !== undefined && formVal?.value !== null && formVal?.value !== '') {
			return {
				id: Number(formVal.value) || 0,
				label: formVal.label ?? '',
				entidade: formVal,
			};
		}

		const match = buildSelectValue(idEntity, labelEntity, options);
		return {
			id: match?.value ?? (Number(idEntity) || 0),
			label: match?.label ?? labelEntity ?? '',
			entidade: match,
		};
	};

	const obterCamposDadosPrincipaisEntity = (e?: any) => {
		const fonte = e ?? entity;

		const municipio = lerSelectPreservado(
			'municipio',
			fonte?.municipio_Id ?? fonte?.municipioEntidade?.value,
			fonte?.municipioNome ?? fonte?.municipioEntidade?.label,
			municipioOptions
		);
		const cultura = lerSelectPreservado(
			'cultura',
			fonte?.cultura_Id ?? fonte?.culturaEntidade?.value,
			fonte?.culturaNome ?? fonte?.culturaEntidade?.label,
			culturaOptions
		);
		const nomeCientifico = lerSelectPreservado(
			'nomeCientifico',
			fonte?.nomecientifico_Id ?? fonte?.nomeCientifico_Id ?? fonte?.nomeCientificoEntidade?.value,
			fonte?.nomecientifico ?? fonte?.nomeCientifico ?? fonte?.nomeCientificoNome ?? fonte?.nomeCientificoEntidade?.label,
			nomeCientificoOptions
		);
		const responsavelRegulatorio = lerSelectPreservado(
			'responsavelRegulatorio',
			fonte?.responsavelRegulatorio_Id ?? fonte?.responsavelRegulatorioEntidade?.value,
			fonte?.responsavelRegulatorioNome ?? fonte?.responsavelRegulatorioEntidade?.label,
			responsavelRegulatorioOptions
		);
		const tecnicoPrincipal = lerSelectPreservado(
			'tecnicoPrincipal',
			fonte?.tecnicoPrincipal_Id ?? fonte?.tecnicoPrincipalEntidade?.value,
			fonte?.tecnicoPrincipalNome ?? fonte?.tecnicoPrincipalEntidade?.label,
			tecnicoPrincipalOptions
		);

		return {
			codigoaac: lerTextoPreservado('codigoaac', fonte?.codigoaac, fonte?.codigoAAC),
			projeto: lerTextoPreservado('projeto', fonte?.projeto),
			municipio_Id: municipio.id,
			municipioNome: municipio.label,
			municipioEntidade: {
				label: municipio.label,
				value: municipio.id,
			},
			cultura_Id: cultura.id,
			culturaNome: cultura.label,
			culturaEntidade: {
				label: cultura.label,
				value: cultura.id,
			},
			nomecientifico: nomeCientifico.label,
			nomecientifico_Id: nomeCientifico.id,
			numeromapa: lerTextoPreservado('numeroMAPA', fonte?.numeromapa, fonte?.numeroMapa),
			responsavelRegulatorio_Id: responsavelRegulatorio.id,
			responsavelRegulatorioNome: responsavelRegulatorio.label,
			responsavelRegulatorioEntidade: {
				label: responsavelRegulatorio.label,
				value: responsavelRegulatorio.id,
			},
			tecnicoPrincipal_Id: tecnicoPrincipal.id,
			tecnicoPrincipalNome: tecnicoPrincipal.label,
			tecnicoPrincipalEntidade: {
				label: tecnicoPrincipal.label,
				value: tecnicoPrincipal.id,
			},
		};
	};

	const normalizarEntityVegetacao = (data: any) => {
		if (!data) {
			return data;
		}

		return {
			...data,
			codigoaac: data.codigoaac ?? data.codigoAAC ?? '',
			numeromapa: data.numeromapa ?? data.numeroMapa ?? '',
			nomecientifico: data.nomecientifico ?? data.nomeCientifico ?? '',
			nomecientifico_Id: data.nomecientifico_Id ?? data.nomeCientifico_Id,
			vegetacao_Documentos_RegistroAmostragem: data.vegetacao_Documentos_RegistroAmostragem?.map((item: any) => ({
				...item,
				path: item.path ?? item.Path,
				filename: item.filename ?? item.Filename,
				codigo: item.codigo ?? item.Codigo,
			})),
			vegetacao_Planejamento_RegistroColheita: (data.vegetacao_Planejamento_RegistroColheita ?? data.Vegetacao_Planejamento_RegistroColheita)?.map((item: any) => ({
				...item,
				id: item.id ?? item.Id,
				tipoColheita_Id: item.tipoColheita_Id ?? item.TipoColheita_Id,
				dataColheita: item.dataColheita ?? item.DataColheita,
				dataInicialColheita: item.dataInicialColheita ?? item.DataInicialColheita,
				dataFinalColheita: item.dataFinalColheita ?? item.DataFinalColheita,
				tipoMaterialColheita_Id: item.tipoMaterialColheita_Id ?? item.TipoMaterialColheita_Id,
				outrosTipoMaterialColheita: item.outrosTipoMaterialColheita ?? item.OutrosTipoMaterialColheita,
				quantidadeMaterialColheita: item.quantidadeMaterialColheita ?? item.QuantidadeMaterialColheita,
				numeroAMIColheita: item.numeroAMIColheita ?? item.NumeroAMIColheita,
				destinoMaterialColheita_Id: item.destinoMaterialColheita_Id ?? item.DestinoMaterialColheita_Id,
				responsaveis: item.responsaveis ?? item.Responsaveis,
				path: item.path ?? item.Path,
				filename: item.filename ?? item.Filename,
				codigo: item.codigo ?? item.Codigo,
			})),
			vegetacao_Fiscalizacao: data.vegetacao_Fiscalizacao?.map((item: any) => ({
				...item,
				path: item.path ?? item.Path,
				filename: item.filename ?? item.Filename,
				codigo: item.codigo ?? item.Codigo,
			})),
			vegetacao_Colheita_AMI: (data.vegetacao_Colheita_AMI ?? data.Vegetacao_Colheita_AMI ?? [])?.map(normalizarArquivoColheitaAMI),
			vegetacao_Destruicao_ArquivoAMI: obterDestruicaoAMIDaOrigem(data).map(mapArquivoDestruicaoAMIParaGrid),
		};
	};

	const aplicarDadosPrincipaisNoForm = (data: any) => {
		if (!data) return;
		defaultForm.setValue('codigoaac', data.codigoaac ?? data.codigoAAC ?? '');
		defaultForm.setValue('projeto', data.projeto ?? '');
		defaultForm.setValue('numeroMAPA', data.numeromapa ?? data.numeroMapa ?? '');
		defaultForm.setValue(
			'municipio',
			buildSelectValue(
				data.municipio_Id ?? data.municipioEntidade?.value,
				data.municipioNome ?? data.municipioEntidade?.label,
				municipioOptions
			)
		);
		defaultForm.setValue(
			'cultura',
			buildSelectValue(
				data.cultura_Id ?? data.culturaEntidade?.value,
				data.culturaNome ?? data.culturaEntidade?.label,
				culturaOptions
			)
		);
		defaultForm.setValue(
			'nomeCientifico',
			buildSelectValue(
				data.nomecientifico_Id ?? data.nomeCientifico_Id,
				data.nomecientifico ?? data.nomeCientificoNome,
				nomeCientificoOptions
			)
		);
		defaultForm.setValue(
			'responsavelRegulatorio',
			buildSelectValue(
				data.responsavelRegulatorio_Id ?? data.responsavelRegulatorioEntidade?.value,
				data.responsavelRegulatorioNome ?? data.responsavelRegulatorioEntidade?.label,
				responsavelRegulatorioOptions
			)
		);
		defaultForm.setValue(
			'tecnicoPrincipal',
			buildSelectValue(
				data.tecnicoPrincipal_Id ?? data.tecnicoPrincipalEntidade?.value,
				data.tecnicoPrincipalNome ?? data.tecnicoPrincipalEntidade?.label,
				tecnicoPrincipalOptions
			)
		);
	};

	const carregarEstadoPlanejamentoPlantio = (origem: any) => {
		if (!origem) {
			planejamentoEstadoCarregado.current = true;
			return;
		}

		if (origem?.vegetacao_Planejamento?.length) {
			defaultForm.setValue('treinamentoBiosseguranca', origem.vegetacao_Planejamento[0].treinamentoBiosseguranca);
			defaultForm.setValue('aacAprovada', origem.vegetacao_Planejamento[0].aacAprovada);
			defaultForm.setValue('documentacaoImportacao', origem.vegetacao_Planejamento[0].documentacaoImportacao);
			defaultForm.setValue('deAcordoComPermissaoImportacao', origem.vegetacao_Planejamento[0].deAcordoComPermissaoImportacao);
			defaultForm.setValue('materialIdentificacaoDisponivel', origem.vegetacao_Planejamento[0].materialIdentificacaoDisponivel);
			defaultForm.setValue('sementesConferidas', origem.vegetacao_Planejamento[0].sementesConferidas);
			defaultForm.setValue('epIsDisponiveis', origem.vegetacao_Planejamento[0].epIsDisponiveis);
			defaultForm.setValue('lixeirasDescarte', origem.vegetacao_Planejamento[0].lixeirasDescarte);
		}

		if (origem?.vegetacao_Planejamento_Conducao?.length) {
			defaultForm.setValue('ensaioConformidadeAACAprovada', origem.vegetacao_Planejamento_Conducao[0].ensaioConformidadeAACAprovada);
			defaultForm.setValue('observacoesEnsaioConformidadeAACAprovada', origem.vegetacao_Planejamento_Conducao[0].observacoesEnsaioConformidadeAACAprovada);
			defaultForm.setValue('placaBiosseguranca', origem.vegetacao_Planejamento_Conducao[0].placaBiosseguranca);
			defaultForm.setValue('observacoesPlacaBiosseguranca', origem.vegetacao_Planejamento_Conducao[0].observacoesPlacaBiosseguranca);
			defaultForm.setValue('envelopesSementesDestruidos', origem.vegetacao_Planejamento_Conducao[0].envelopesSementesDestruidos);
			defaultForm.setValue('observacoesEnvelopesSementesDestruidos', origem.vegetacao_Planejamento_Conducao[0].observacoesEnvelopesSementesDestruidos);
			defaultForm.setValue('dispositivosBiossegurancaChecados', origem.vegetacao_Planejamento_Conducao[0].dispositivosBiossegurancaChecados);
			defaultForm.setValue('observacoesDispositivosBiossegurancaChecados', origem.vegetacao_Planejamento_Conducao[0].observacoesDispositivosBiossegurancaChecados);
			defaultForm.setValue('equipamentosAtividadePlantioLimpos', origem.vegetacao_Planejamento_Conducao[0].equipamentosAtividadePlantioLimpos);
			defaultForm.setValue('observacoesEquipamentosAtividadePlantioLimpos', origem.vegetacao_Planejamento_Conducao[0].observacoesEquipamentosAtividadePlantioLimpos);
			defaultForm.setValue('comunicacaoCoordenadasGeograficas', origem.vegetacao_Planejamento_Conducao[0].comunicacaoCoordenadasGeograficas);
			defaultForm.setValue('observacoesComunicacaoCoordenadasGeograficas', origem.vegetacao_Planejamento_Conducao[0].observacoesComunicacaoCoordenadasGeograficas);
		}

		if (origem?.vegetacao_Planejamento_NotificacaoPlantio?.length) {
			const newNotificacaoPlantio: Planejamento_NotificacaoPlantioOnEditVegetacao[] = [];

			for (let n = 0, t = origem.vegetacao_Planejamento_NotificacaoPlantio.length; n < t; n++) {
				const destinoSobraId = origem.vegetacao_Planejamento_NotificacaoPlantio[n].destinoSobra_Id;
				const destinoSobrasEnum = enumDestinoSobra.filter((e: any) => Number(e.key) === Number(destinoSobraId ?? 0));
				const destinoSobra = destinoSobraId ? {
					label: destinoSobrasEnum.length > 0 ? destinoSobrasEnum[0].value : '',
					value: destinoSobraId,
				} : null;

				newNotificacaoPlantio.push({
					id: origem.vegetacao_Planejamento_NotificacaoPlantio[n].id,
					numeroPlantio: origem.vegetacao_Planejamento_NotificacaoPlantio[n].numeroPlantio,
					casaVegetacaoModulo: origem.vegetacao_Planejamento_NotificacaoPlantio[n].casaVegetacaoModulo,
					material: origem.vegetacao_Planejamento_NotificacaoPlantio[n].material,
					informacoesAdicionaisMaterial: origem.vegetacao_Planejamento_NotificacaoPlantio[n].informacoesAdicionaisMaterial,
					numeroAMI: origem.vegetacao_Planejamento_NotificacaoPlantio[n].numeroAMI,
					sobraMaterial: origem.vegetacao_Planejamento_NotificacaoPlantio[n].sobraMaterial,
					numeroAmostrasRestantes: origem.vegetacao_Planejamento_NotificacaoPlantio[n].numeroAmostrasRestantes,
					quantidadeAmostrasRestantes: origem.vegetacao_Planejamento_NotificacaoPlantio[n].quantidadeAmostrasRestantes,
					destinoSobra_Id: destinoSobra,
					destinoSobra: destinoSobra,
					destinoSobraOutros: origem.vegetacao_Planejamento_NotificacaoPlantio[n].destinoSobraOutros,
					entradaArmazenamento: origem.vegetacao_Planejamento_NotificacaoPlantio[n].entradaArmazenamento,
					informacoesAdicionais: origem.vegetacao_Planejamento_NotificacaoPlantio[n].informacoesAdicionais,
					dataInicialPlantio: origem.vegetacao_Planejamento_NotificacaoPlantio[n].dataInicialPlantio !== undefined ? moment(origem.vegetacao_Planejamento_NotificacaoPlantio[n].dataInicialPlantio).toDate() : null,
					dataFinalPlantio: origem.vegetacao_Planejamento_NotificacaoPlantio[n].dataFinalPlantio !== undefined ? moment(origem.vegetacao_Planejamento_NotificacaoPlantio[n].dataFinalPlantio).toDate() : null,
					responsaveis: origem.vegetacao_Planejamento_NotificacaoPlantio[n].responsaveis ?? [],
				});
			}

			const materiaisPlantio = (origem?.vegetacao_Plantio_ArquivoMateriais ?? []).map(mapArquivoPlantioParaGrid);
			const amisPlantio = (origem?.vegetacao_Plantio_ArquivoAMI ?? []).map(mapArquivoPlantioParaGrid);

			setSelectedPlantios(associarArquivosPlantioAosRegistros(
				ordenarPorDataAsc(newNotificacaoPlantio, 'dataInicialPlantio'),
				materiaisPlantio,
				amisPlantio,
			));
		}

		if (origem?.vegetacao_Planejamento_DatasPlantio?.length) {
			const newDatasPlantio: Planejamento_DatasPlantioOnEditVegetacao[] = [];

			for (let n = 0, t = origem.vegetacao_Planejamento_DatasPlantio.length; n < t; n++) {
				newDatasPlantio.push({
					id: origem.vegetacao_Planejamento_DatasPlantio[n].id,
					dataInicialPlantio: origem.vegetacao_Planejamento_DatasPlantio[n].dataInicialPlantio !== undefined ? moment(origem.vegetacao_Planejamento_DatasPlantio[n].dataInicialPlantio).toDate() : null,
					dataFinalPlantio: origem.vegetacao_Planejamento_DatasPlantio[n].dataFinalPlantio !== undefined ? moment(origem.vegetacao_Planejamento_DatasPlantio[n].dataFinalPlantio).toDate() : null,
				});
			}

			setSelectedDataPlantios(newDatasPlantio);
		}

		if (origem?.vegetacao_Planejamento_PessoasPlantio?.length) {
			const newPessoasPlantio: Planejamento_PessoasPlantioOnEditVegetacao[] = [];

			for (let n = 0, t = origem.vegetacao_Planejamento_PessoasPlantio.length; n < t; n++) {
				newPessoasPlantio.push({
					id: origem.vegetacao_Planejamento_PessoasPlantio[n].id,
					pessoaPlantio: origem.vegetacao_Planejamento_PessoasPlantio[n].pessoaPlantio !== undefined ? origem.vegetacao_Planejamento_PessoasPlantio[n].pessoaPlantio : null,
					contagemPessoasEnvolvidasPlantio: n + 1,
				});
			}

			setSelectedPessoasEnvolvidasPlantio(newPessoasPlantio);
		}

		aplicarCamposColheitaConducaoNoForm(origem);

		planejamentoEstadoCarregado.current = true;
	};

	const obterConducaoPersistida = () => entity?.vegetacao_Planejamento_Conducao?.[0];

	const aplicarCamposColheitaConducaoNoForm = (origem: any) => {
		if (!origem?.vegetacao_Planejamento_Conducao?.length) {
			return;
		}

		const conducao = origem.vegetacao_Planejamento_Conducao[0];

		defaultForm.setValue('embalagemArmazenamentoMateriais', conducao.embalagemArmazenamentoMateriais);
		defaultForm.setValue('observacoesEmbalagemArmazenamentoMateriais', conducao.observacoesEmbalagemArmazenamentoMateriais ?? '');
		defaultForm.setValue('treinamentoBiossegurancaColheita', conducao.treinamentoBiossegurancaColheita);
		defaultForm.setValue('materialColhidoEmbalado', conducao.materialColhidoEmbalado);
		defaultForm.setValue('observacoesMaterialColhidoEmbalado', conducao.observacoesMaterialColhidoEmbalado ?? '');
		defaultForm.setValue('documentosDestinoMaterialColhido', conducao.documentosDestinoMaterialColhido);
		defaultForm.setValue('observacoesDocumentosDestinoMaterialColhido', conducao.observacoesDocumentosDestinoMaterialColhido ?? '');
		defaultForm.setValue('equipamentosAtividadeColheitaLimpos', conducao.equipamentosAtividadeColheitaLimpos);
		defaultForm.setValue('observacoesEquipamentosAtividadeColheitaLimpos', conducao.observacoesEquipamentosAtividadeColheitaLimpos ?? '');
		defaultForm.setValue('restosVegetaisDevidamenteDescartados', conducao.restosVegetaisDevidamenteDescartados);
		defaultForm.setValue('observacoesRestosVegetaisDevidamenteDescartados', conducao.observacoesRestosVegetaisDevidamenteDescartados ?? '');
	};

	const lerValorBooleanoForm = (nome: string, fallback = false): boolean => {
		const valor = defaultForm.getValues(nome);
		if (valor !== undefined) {
			return !!valor;
		}

		const persistido = obterConducaoPersistida();
		return persistido?.[nome] !== undefined ? !!persistido[nome] : fallback;
	};

	const lerValorTextoForm = (nome: string, fallback = ''): string => {
		const valor = defaultForm.getValues(nome);
		if (valor !== undefined && valor !== null) {
			return String(valor);
		}

		const persistido = obterConducaoPersistida();
		return persistido?.[nome] !== undefined && persistido?.[nome] !== null ? String(persistido[nome]) : fallback;
	};

	const lerValorSelectForm = (nome: string, fallback = 0): number => {
		const valor = defaultForm.getValues(nome);
		if (valor !== undefined && valor !== null) {
			if (typeof valor === 'object' && 'value' in (valor as object)) {
				return Number((valor as any).value) || fallback;
			}

			return Number(valor) || fallback;
		}

		const persistido = obterConducaoPersistida();
		return persistido?.[nome] !== undefined ? Number(persistido[nome]) || fallback : fallback;
	};

	const obterDocumentoPersistido = (): ExpectedDocumentos | undefined =>
		(entity?.vegetacao_Documentos as ExpectedDocumentos[] | undefined)?.[0];

	const lerCampoDocumentoPersistido = (nome: string): unknown => {
		const persistido = obterDocumentoPersistido();
		if (!persistido) {
			return undefined;
		}

		return (persistido as unknown as Record<string, unknown>)[nome];
	};

	const lerValorBooleanoDocumento = (nome: string, fallback = false): boolean => {
		const valor = defaultForm.getValues(nome);
		if (valor !== undefined) {
			return !!valor;
		}

		const persistido = lerCampoDocumentoPersistido(nome);
		return persistido !== undefined ? !!persistido : fallback;
	};

	const lerValorTextoDocumento = (nome: string, fallback = ''): string => {
		const valor = defaultForm.getValues(nome);
		if (valor !== undefined && valor !== null) {
			return String(valor);
		}

		const persistido = lerCampoDocumentoPersistido(nome);
		return persistido !== undefined && persistido !== null ? String(persistido) : fallback;
	};

	const aplicarDocumentosNoForm = (data: any) => {
		const documento = data?.vegetacao_Documentos?.[0];
		if (!documento) {
			return;
		}

		defaultForm.setValue('copiaAAC', documento.copiaAAC ?? false);
		defaultForm.setValue('observacoesCopiaAAC', documento.observacoesCopiaAAC ?? '');
		defaultForm.setValue('copiaListaTreinamentos', documento.copiaListaTreinamentos ?? false);
		defaultForm.setValue('observacoesCopiaListaTreinamentos', documento.observacoesCopiaListaTreinamentos ?? '');
		defaultForm.setValue('copiaParecerTecnicoCTNBio', documento.copiaParecerTecnicoCTNBio ?? false);
		defaultForm.setValue(
			'observacoesCopiaParecerTecnicoCTNBio',
			documento.observacoesCopiaParecerTecnicoCTNBio ?? documento.observacoesCopiaCTNBio ?? ''
		);
		defaultForm.setValue('copiaQuarentena', documento.copiaQuarentena ?? false);
		defaultForm.setValue('observacoesCopiaQuarentena', documento.observacoesCopiaQuarentena ?? '');
		defaultForm.setValue('croquiExperimental', documento.croquiExperimental ?? false);
		defaultForm.setValue('observacoesCroquiExperimental', documento.observacoesCroquiExperimental ?? '');
		defaultForm.setValue('cienciaInstrucoes', documento.cienciaInstrucoes ?? false);
		defaultForm.setValue('documentosDestino', documento.documentosDestino ?? false);
		defaultForm.setValue('observacoesDocumentosDestino', documento.observacoesDocumentosDestino ?? '');
		defaultForm.setValue('documentosAmostras', documento.documentosAmostras ?? false);
		defaultForm.setValue('observacoesDocumentosAmostras', documento.observacoesDocumentosAmostras ?? '');
		defaultForm.setValue('formulariosDestruicao', documento.formulariosDestruicao ?? false);
		defaultForm.setValue('observacoesFormulariosDestruicao', documento.observacoesFormulariosDestruicao ?? '');
		defaultForm.setValue('termosFiscalizacao', documento.termosFiscalizacao ?? false);
		defaultForm.setValue('observacoesTermosFiscalizacao', documento.observacoesTermosFiscalizacao ?? '');
		defaultForm.setValue(
			'dataFiscalizacao',
			documento.dataFiscalizacao != undefined ? moment(documento.dataFiscalizacao).toDate() : null
		);
	};

	const renderCheckboxField = (name: string, label: string) => (
		<Controller
			name={name}
			control={defaultForm.control}
			defaultValue={lerValorBooleanoDocumento(name)}
			render={({ onChange, value, ref }) => (
				<Form.Check
					type="checkbox"
					label={label}
					checked={!!value}
					onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.checked)}
					ref={ref}
				/>
			)}
		/>
	);

	const renderObservacoesDocumento = (name: string, placeholder: string) => (
		<Controller
			name={name}
			control={defaultForm.control}
			defaultValue={lerValorTextoDocumento(name)}
			render={({ onChange, value }) => (
				<Form.Control
					as="textarea"
					rows={4}
					placeholder={placeholder}
					value={value ?? ''}
					onChange={onChange}
				/>
			)}
		/>
	);

	const preservarColecaoNoSave = <T,>(estadoLocal: T[] | undefined, entidadeExistente: T[] | undefined): T[] | undefined => {
		if (Array.isArray(estadoLocal)) {
			return estadoLocal;
		}

		if (entidadeExistente?.length) {
			return entidadeExistente;
		}

		return estadoLocal;
	};

	const obterValorNumericoId = (valor: any): number => {
		if (valor === undefined || valor === null || valor === '') {
			return 0;
		}

		if (typeof valor === 'object') {
			return obterValorNumericoId(valor.value ?? valor.key ?? valor.Id ?? valor.id);
		}

		const n = Number(valor);
		return Number.isFinite(n) ? n : 0;
	};

	const obterFaseLimpezaIdInspecao = (item: any): number => {
		return obterValorNumericoId(item?.faseLimpeza_Id ?? item?.FaseLimpeza_Id);
	};

	const chaveInspecaoEquipamento = (item: any): string => {
		const id = obterValorNumericoId(item?.Id ?? item?.id);
		if (id > 0) {
			return `id:${id}`;
		}

		const dataAntes = item?.dataAntesUso
			? moment(item.dataAntesUso).format('YYYY-MM-DD')
			: '';

		return `tmp:${obterFaseLimpezaIdInspecao(item)}:${item?.iD_Equipamento ?? item?.ID_Equipamento ?? ''}:${dataAntes}:${item?.numeroPlantio ?? ''}`;
	};

	const deduplicarInspecaoEquipamentos = (itens: any[]): any[] => {
		const vistos = new Set<string>();
		const resultado: any[] = [];

		for (const item of itens) {
			if (!item) continue;
			const chave = chaveInspecaoEquipamento(item);
			if (vistos.has(chave)) continue;
			vistos.add(chave);
			resultado.push(item);
		}

		return resultado;
	};

	const normalizarItemInspecaoEntity = (item: any) => ({
		...item,
		id: item?.id ?? item?.Id ?? 0,
		Id: item?.Id ?? item?.id ?? 0,
		faseLimpeza_Id: obterFaseLimpezaIdInspecao(item),
		metodoLimpeza_Id: obterValorNumericoId(item?.metodoLimpeza_Id ?? item?.MetodoLimpeza_Id ?? item?.metodoLimpezaEquipamento_Id),
		responsaveis: item?.responsaveis ?? item?.Responsaveis ?? [],
		metodosLimpeza: item?.metodosLimpeza ?? item?.MetodosLimpeza ?? [],
	});

	const filtrarInspecaoEquipamentosPorFase = (inspecoes: VegetacaoInspecaoEquipamentos[], faseId: number) =>
		inspecoes.filter(item => obterFaseLimpezaIdInspecao(item) === Number(faseId));

	const abaAtualPossuiFaseLimpeza = (faseAtual: number) =>
		!!limpezaEquipamentos && Number(tipoFaseLimpezaEquipamentosValue) === Number(faseAtual);

	const mergeInspecaoEquipamentosPorFase = (
		inspecaoFaseAtual: ExpectedInspecao[],
		faseAtual: number,
		entidadeExistente: any[] | undefined
	): ExpectedInspecao[] => {
		const entidadeNormalizada = (entidadeExistente ?? []).map(normalizarItemInspecaoEntity);
		const faseAtualNumero = Number(faseAtual);

		const outrasFases = entidadeNormalizada.filter((item) => {
			const fase = obterFaseLimpezaIdInspecao(item);
			return fase > 0 && fase !== faseAtualNumero;
		});

		const faseAtualExistente = entidadeNormalizada.filter(
			item => obterFaseLimpezaIdInspecao(item) === faseAtualNumero
		);

		const inspecaoFaseNormalizada = inspecaoFaseAtual
			.map((item) => ({
				...item,
				Id: item.Id ?? (item as any).id ?? 0,
				faseLimpeza_Id: obterFaseLimpezaIdInspecao(item) || faseAtualNumero,
			}))
			.filter(item => obterFaseLimpezaIdInspecao(item) === faseAtualNumero);

		const inspecaoFaseMesclada = inspecaoFaseNormalizada.length > 0 || abaAtualPossuiFaseLimpeza(faseAtualNumero)
			? inspecaoFaseNormalizada
			: faseAtualExistente;

		return deduplicarInspecaoEquipamentos([...outrasFases, ...inspecaoFaseMesclada]);
	};

	const expectedInspecaoDeLista = (lista: VegetacaoInspecaoEquipamentos[]): ExpectedInspecao[] =>
		lista
			.filter((item) => {
				const fase = obterFaseLimpezaIdInspecao(item);
				const faseAtual = Number(tipoFaseLimpezaEquipamentosValue) || 0;
				return !fase || !faseAtual || fase === faseAtual;
			})
			.map(item => {
			const metodoLimpezaId = obterValorNumericoId(
				item.metodoLimpezaEquipamento_Id !== undefined
					? item.metodoLimpezaEquipamento_Id
					: 0
			);
			const outrosMetodoLimpeza = item.outrosMetodoLimpezaEquipamento !== undefined
				? item.outrosMetodoLimpezaEquipamento
				: '';

			return {
				Id: item.id ?? 0,
				numeroPlantio: item.numeroPlantio !== undefined ? item.numeroPlantio : '',
				iD_Equipamento: item.iD_Equipamento !== undefined ? item.iD_Equipamento : '',
				dataAntesUso: item.dataAntesUso !== undefined ? item.dataAntesUso : '',
				dataAposUso: item.dataAposUso !== undefined ? item.dataAposUso : '',
				faseEnsaio: item.faseEnsaio !== undefined ? item.faseEnsaio : '',
				metodoLimpeza_Id: metodoLimpezaId,
				outrosMetodoLimpeza,
				metodoLimpezaEquipamento_Id: metodoLimpezaId,
				outrosMetodoLimpezaEquipamento: outrosMetodoLimpeza,
				faseLimpeza_Id: obterFaseLimpezaIdInspecao(item) || Number(tipoFaseLimpezaEquipamentosValue) || 0,
				responsaveis: item.responsaveis,
				metodosLimpeza: item.metodosLimpeza,
			};
		});

	const sincronizarInspecaoEquipamentosNaEntity = (
		listaFaseAtual: VegetacaoInspecaoEquipamentos[],
		faseId: number
	) => {
		setEntity((prev: any) => {
			if (!prev) {
				return prev;
			}

			return {
				...prev,
				vegetacao_Planejamento_Inspecao: mergeInspecaoEquipamentosPorFase(
					expectedInspecaoDeLista(listaFaseAtual),
					faseId,
					prev.vegetacao_Planejamento_Inspecao
				),
			};
		});
	};

	const COLECOES_VEGETACAO = [
		'vegetacao_Planejamento',
		'vegetacao_Planejamento_Conducao',
		'vegetacao_Planejamento_DatasPlantio',
		'vegetacao_Planejamento_PessoasPlantio',
		'vegetacao_Planejamento_NotificacaoPlantio',
		'vegetacao_Planejamento_Limpeza',
		'vegetacao_Limpeza_Instalacoes_Responsaveis',
		'vegetacao_Planejamento_Inspecao',
		'vegetacao_Planejamento_Atividades',
		'vegetacao_Planejamento_DatasColheita',
		'vegetacao_Planejamento_PessoasColheita',
		'vegetacao_Documentos_RegistroAmostragem',
		'vegetacao_Destruicao',
		'vegetacao_Destruicao_Responsaveis',
		'vegetacao_Destruicao_Limpeza',
		'vegetacao_Fiscalizacao',
		'vegetacao_Reportes',
		'vegetacao_Reportes_Responsaveis',
		'vegetacao_Anotacoes',
		'vegetacao_Plantio_ArquivoMateriais',
		'vegetacao_Plantio_ArquivoAMI',
		'vegetacao_Conducao_Comunicados',
	];

	const COLECOES_ARQUIVOS_VEGETACAO = [
		'vegetacao_Plantio_ArquivoMateriais',
		'vegetacao_Plantio_ArquivoAMI',
		'vegetacao_DP_ArquivoAAC',
		'vegetacao_DP_ArquivosListaTreinamento',
		'vegetacao_DP_ArquivoUltimoParecer',
		'vegetacao_DP_ArquivoLiberacaoQuarentena',
		'vegetacao_DP_ArquivoTransferencia',
		'vegetacao_Conducao_Comunicados',
		'vegetacao_Planejamento_Croqui',
		'vegetacao_Destruicao_ArquivoAMI',
		'vegetacao_Fiscalizacao_Termos',
		'vegetacao_Colheita_AMI',
		'vegetacao_Documentos_PastaProcesso',
	];

	const obterIdsArquivosSalvos = (items: any[]): number[] =>
		items.filter((item) => item?.id > 0).map((item) => Number(item.id));

	const mapearArquivosSalvosParaEntity = (items: any[]) =>
		items
			.filter((item) => (item?.id ?? item?.Id ?? 0) > 0)
			.map((item) => {
				const codigo = item.codigo ?? item.Codigo;
				const arquivo: Record<string, any> = {
					id: item.id ?? item.Id,
					filename: item.filename ?? item.Filename ?? item.name,
					path: item.path ?? item.Path,
				};

				if (codigo) {
					arquivo.codigo = codigo;
				}

				if (item.dataComunicado) {
					arquivo.dataComunicado = item.dataComunicado;
				}

				return arquivo;
			});

	const mesclarArquivosLocaisComPayload = (locais: any[], payloadAtual: any[] | undefined): any[] => {
		const salvos = mapearArquivosSalvosParaEntity(locais);

		if (salvos.length) {
			return salvos;
		}

		return payloadAtual ?? [];
	};

	const aplicarEstadoLocalArquivosNoPayload = (payload: VegetacaoSearchResult): VegetacaoSearchResult => {
		const payloadArquivos = payload as Record<string, any[] | undefined>;
		const resultado: any = { ...payload };

		resultado.vegetacao_Conducao_Comunicados = mesclarArquivosLocaisComPayload(conducaoComunicados, payloadArquivos.vegetacao_Conducao_Comunicados);
		resultado.vegetacao_Plantio_ArquivoMateriais = mesclarArquivosLocaisComPayload(plantioArquivoMateriais, payloadArquivos.vegetacao_Plantio_ArquivoMateriais);
		resultado.vegetacao_Plantio_ArquivoAMI = mesclarArquivosLocaisComPayload(plantioArquivoAMIFiles, payloadArquivos.vegetacao_Plantio_ArquivoAMI);
		resultado.vegetacao_Planejamento_Croqui = mesclarArquivosLocaisComPayload(planejamentoCroqui, payloadArquivos.vegetacao_Planejamento_Croqui);
		resultado.vegetacao_Documentos_PastaProcesso = mesclarArquivosLocaisComPayload(documentosGerais, payloadArquivos.vegetacao_Documentos_PastaProcesso);
		resultado.vegetacao_Destruicao_ArquivoAMI = mesclarArquivosLocaisComPayload(destruicaoAMI, payloadArquivos.vegetacao_Destruicao_ArquivoAMI);
		resultado.vegetacao_Fiscalizacao_Termos = mesclarArquivosLocaisComPayload(fiscalizacaoTermos, payloadArquivos.vegetacao_Fiscalizacao_Termos);
		resultado.vegetacao_Colheita_AMI = mesclarArquivosLocaisComPayload(colheitaAMI, payloadArquivos.vegetacao_Colheita_AMI);
		resultado.vegetacao_DP_ArquivoAAC = mesclarArquivosLocaisComPayload(dadosPrincipaisAAC, payloadArquivos.vegetacao_DP_ArquivoAAC);
		resultado.vegetacao_DP_ArquivosListaTreinamento = mesclarArquivosLocaisComPayload(dadosPrincipaisListaTreinamento, payloadArquivos.vegetacao_DP_ArquivosListaTreinamento);
		resultado.vegetacao_DP_ArquivoUltimoParecer = mesclarArquivosLocaisComPayload(dadosPrincipaisParecerTecnico, payloadArquivos.vegetacao_DP_ArquivoUltimoParecer);
		resultado.vegetacao_DP_ArquivoLiberacaoQuarentena = mesclarArquivosLocaisComPayload(dadosPrincipaisLiberacaoQuarentena, payloadArquivos.vegetacao_DP_ArquivoLiberacaoQuarentena);

		return resultado;
	};

	const sincronizarArquivosRemovidos = async (cadernoConformidadeVegetacao_Id: number) => {
		const { status } = await api.post(`api/v1/caderno-conformidade/Vegetacao/${cadernoConformidadeVegetacao_Id}/SincronizarArquivosRemovidos`, {
			idsComunicados: obterIdsArquivosSalvos(conducaoComunicados),
			idsPlantioMateriais: obterIdsArquivosSalvos(plantioArquivoMateriais),
			idsPlantioAMI: obterIdsArquivosSalvos(plantioArquivoAMIFiles),
			idsCroqui: obterIdsArquivosSalvos(planejamentoCroqui),
			idsPastaProcesso: obterIdsArquivosSalvos(documentosGerais),
			idsDestruicaoAMI: obterIdsArquivosSalvos(destruicaoAMI),
			idsFiscalizacaoTermos: obterIdsArquivosSalvos(fiscalizacaoTermos),
			idsColheitaAMI: obterIdsArquivosSalvos(colheitaAMI),
			idsArquivoAAC: obterIdsArquivosSalvos(dadosPrincipaisAAC),
			idsListaTreinamento: obterIdsArquivosSalvos(dadosPrincipaisListaTreinamento),
			idsParecerTecnico: obterIdsArquivosSalvos(dadosPrincipaisParecerTecnico),
			idsLiberacaoQuarentena: obterIdsArquivosSalvos(dadosPrincipaisLiberacaoQuarentena),
		});

		return status;
	};

	const setValuesWithDataResponse = (data: any, _tipoMaterialAmostragemEnum: any, _destinoAmostrasEnum: any, _destinoSobrasEnum: any, _localDestruicaoEnum: any, _metodoDestruicaoEnum: any, _tipoMaterialDescarteEnum: any,
		_tipoColheitaEnum: any, _metodoLimpezaEnum: any, _metodoLimpezaEquipamentoEnum: any, _metodoLimpezaInstalacaoEnum: any, _atividadeManutencaoEnum: any) => {

		aplicarDadosPrincipaisNoForm(data);
		aplicarDocumentosNoForm(data);

		// vegetacao_Documentos_PastaProcesso
		
		if (data?.vegetacao_Documentos_PastaProcesso?.length) {
			setDocumentosGerais(data.vegetacao_Documentos_PastaProcesso);
		}

		// vegetacao_Documentos_RegistroAmostragem
		
		if (data?.vegetacao_Documentos_RegistroAmostragem?.length) {

			let newRegistroAmostragem: Documentos_RegistroAmostragemOnEditVegetacao[] = [];

			for (let n = 0, t = data?.vegetacao_Documentos_RegistroAmostragem?.length; n < t; n++) {

				let Responsaveis: ResponsavelAmostragem[] = [];
				let listaResponsaveisAmostragem: string = "";

				if (data.vegetacao_Documentos_RegistroAmostragem[n].responsaveis !== undefined) {
					for (let i = 0, j = data.vegetacao_Documentos_RegistroAmostragem[n].responsaveis?.length; i < j; i++) {
						let responsavel: ResponsavelAmostragem =
						{
							id: data.vegetacao_Documentos_RegistroAmostragem[n].responsaveis[i].id,
							responsavel: data.vegetacao_Documentos_RegistroAmostragem[n].responsaveis[i].responsavel,
							contagem: i + 1,
						}

						listaResponsaveisAmostragem += responsavel.responsavel + "; ";

						Responsaveis.push(responsavel);
					}
				}

				if (data.vegetacao_Documentos_RegistroAmostragem[n].filename !== null) {
					// tipoMaterialAmostragem
					let tipoMaterialAmostragemEnum = _tipoMaterialAmostragemEnum.filter((e: any) => Number(e.key) === data.vegetacao_Documentos_RegistroAmostragem[n].tipoMaterial_Id);

					// Destino Amostras
					let destinoAmostrasEnum = _destinoAmostrasEnum.filter((e: any) => Number(e.key) === data.vegetacao_Documentos_RegistroAmostragem[n].destino);

					let registroAmostragem: Documentos_RegistroAmostragemOnEditVegetacao = {
						id: data.vegetacao_Documentos_RegistroAmostragem[n].id,
						dataInicialAmostragem: data.vegetacao_Documentos_RegistroAmostragem[n].dataInicial !== undefined ? moment(data.vegetacao_Documentos_RegistroAmostragem[n].dataInicial).toDate() : null,
						dataFinalAmostragem: data.vegetacao_Documentos_RegistroAmostragem[n].dataFinal !== undefined ? moment(data.vegetacao_Documentos_RegistroAmostragem[n].dataFinal).toDate() : null,
						tipoMaterialAmostragem: {
							label: tipoMaterialAmostragemEnum.length > 0 ? tipoMaterialAmostragemEnum[0].value : '',
							value: data.vegetacao_Documentos_RegistroAmostragem[n].tipoMaterial_Id,
						},
						tipoMaterialAmostragemOutros: data.vegetacao_Documentos_RegistroAmostragem[n].outrosTipoMaterial !== undefined ? data.vegetacao_Documentos_RegistroAmostragem[n].outrosTipoMaterial : null,
						responsavelAmostragem: data.vegetacao_Documentos_RegistroAmostragem[n].responsavel,
						destinoAmostras: {
							label: destinoAmostrasEnum.length > 0 ? destinoAmostrasEnum[0].value : '',
							value: data.vegetacao_Documentos_RegistroAmostragem[n].destino,
						},

						destinoAmostrasOutros: data.vegetacao_Documentos_RegistroAmostragem[n].outrosDestino,
						arquivoAmostragem: data.vegetacao_Documentos_RegistroAmostragem[n].filename !== undefined ? data.vegetacao_Documentos_RegistroAmostragem[n].filename : '',
						filename: data.vegetacao_Documentos_RegistroAmostragem[n].filename !== undefined ? data.vegetacao_Documentos_RegistroAmostragem[n].filename : '',
						path: data.vegetacao_Documentos_RegistroAmostragem[n].path ?? data.vegetacao_Documentos_RegistroAmostragem[n].Path,
						codigo: data.vegetacao_Documentos_RegistroAmostragem[n].codigo ?? data.vegetacao_Documentos_RegistroAmostragem[n].Codigo,
						contagemRegistroAmostragem: n + 1,
					};

					newRegistroAmostragem.push(registroAmostragem);
				}
			}

			setSelectedRegistroAmostragem(ordenarPorDataAsc(newRegistroAmostragem, 'dataInicialAmostragem', 'contagemRegistroAmostragem'));
		}


		// vegetacao_Fiscalizacao
		
		if (data?.vegetacao_Fiscalizacao?.length) {
			defaultForm.setValue('documentosDestino', data.vegetacao_Fiscalizacao[0].documentosDestino);
			defaultForm.setValue('observacoesDocumentosDestino', data.vegetacao_Fiscalizacao[0].observacoesDocumentosDestino);
			defaultForm.setValue('documentosAmostras', data.vegetacao_Fiscalizacao[0].documentosAmostras);
			defaultForm.setValue('observacoesDocumentosAmostras', data.vegetacao_Fiscalizacao[0].observacoesDocumentosAmostras);
			defaultForm.setValue('formulariosDestruicao', data.vegetacao_Fiscalizacao[0].formulariosDestruicao);
			defaultForm.setValue('observacoesFormulariosDestruicao', data.vegetacao_Fiscalizacao[0].observacoesFormulariosDestruicao);
			defaultForm.setValue('termosFiscalizacao', data.vegetacao_Fiscalizacao[0].termosFiscalizacao);
			defaultForm.setValue('observacoesTermosFiscalizacao', data.vegetacao_Fiscalizacao[0].observacoesTermosFiscalizacao);
			defaultForm.setValue('dataFiscalizacao', data.vegetacao_Fiscalizacao[0].dataFiscalizacao != undefined ? moment(data.vegetacao_Fiscalizacao[0].dataFiscalizacao).toDate() : null);
		}

		// vegetacao_Dados_Principais_AAC
		
		if (data?.vegetacao_DP_ArquivoAAC?.length) {
			setFileFieldDadosPrincipaisAAC(data.vegetacao_DP_ArquivoAAC);

			let newArquivos: Documentos_PastaProcessoOnEditVegetacao[] = [];

			for (let n = 0, t = data?.vegetacao_DP_ArquivoAAC?.length; n < t; n++) {
				let arquivo: Documentos_PastaProcessoOnEditVegetacao = {
					id: data.vegetacao_DP_ArquivoAAC[n].id,
					filename: data.vegetacao_DP_ArquivoAAC[n].filename,
					name: data.vegetacao_DP_ArquivoAAC[n].filename,
					codigo: data.vegetacao_DP_ArquivoAAC[n].codigo,
					path: data.vegetacao_DP_ArquivoAAC[n].path,
				};

				newArquivos.push(arquivo);
			}

			setDadosPrincipaisAAC(newArquivos);
		}

		// vegetacao_DadosPrincipais_Lista_Treinamentos
		
		if (data?.vegetacao_DP_ArquivosListaTreinamento?.length) {

			let newArquivos: Documentos_PastaProcessoOnEditVegetacao[] = [];

			for (let n = 0, t = data?.vegetacao_DP_ArquivosListaTreinamento?.length; n < t; n++) {
				let arquivo: Documentos_PastaProcessoOnEditVegetacao = {
					id: data.vegetacao_DP_ArquivosListaTreinamento[n].id,
					filename: data.vegetacao_DP_ArquivosListaTreinamento[n].filename,
					name: data.vegetacao_DP_ArquivosListaTreinamento[n].filename,
					codigo: data.vegetacao_DP_ArquivosListaTreinamento[n].codigo,
					path: data.vegetacao_DP_ArquivosListaTreinamento[n].path,
				};

				newArquivos.push(arquivo);
			}

			setDadosPrincipaisListaTreinamento(newArquivos);
		}

		// vegetacao_Dados_Principais_ParecerTecnico
		
		if (data?.vegetacao_DP_ArquivoUltimoParecer?.length) {
			setFileFieldDadosPrincipaisParecerTecnico(data.vegetacao_DP_ArquivoUltimoParecer);

			let newArquivos: Documentos_PastaProcessoOnEditVegetacao[] = [];

			for (let n = 0, t = data?.vegetacao_DP_ArquivoUltimoParecer?.length; n < t; n++) {
				let arquivo: Documentos_PastaProcessoOnEditVegetacao = {
					id: data.vegetacao_DP_ArquivoUltimoParecer[n].id,
					filename: data.vegetacao_DP_ArquivoUltimoParecer[n].filename,
					name: data.vegetacao_DP_ArquivoUltimoParecer[n].filename,
					codigo: data.vegetacao_DP_ArquivoUltimoParecer[n].codigo,
					path: data.vegetacao_DP_ArquivoUltimoParecer[n].path,
				};

				newArquivos.push(arquivo);
			}

			setDadosPrincipaisParecerTecnico(newArquivos);
		}

		// vegetacao_DadosPrincipais_Liberacao_Quarentena
		
		if (data?.vegetacao_DP_ArquivoLiberacaoQuarentena?.length) {
			let newArquivos: Documentos_PastaProcessoOnEditVegetacao[] = [];

			for (let n = 0, t = data?.vegetacao_DP_ArquivoLiberacaoQuarentena?.length; n < t; n++) {
				let arquivo: Documentos_PastaProcessoOnEditVegetacao = {
					id: data.vegetacao_DP_ArquivoLiberacaoQuarentena[n].id,
					filename: data.vegetacao_DP_ArquivoLiberacaoQuarentena[n].filename,
					name: data.vegetacao_DP_ArquivoLiberacaoQuarentena[n].filename,
					codigo: data.vegetacao_DP_ArquivoLiberacaoQuarentena[n].codigo,
					path: data.vegetacao_DP_ArquivoLiberacaoQuarentena[n].path,
				};

				newArquivos.push(arquivo);
			}

			setDadosPrincipaisLiberacaoQuarentena(newArquivos);
		}

		// vegetacao_Conducao_Comunicados
		
		if (data?.vegetacao_Conducao_Comunicados?.length) {

			let newArquivos: ConducaoComunicadosEditVegetacao[] = [];

			for (let n = 0, t = data?.vegetacao_Conducao_Comunicados?.length; n < t; n++) {
				let arquivo: ConducaoComunicadosEditVegetacao = {
					id: data.vegetacao_Conducao_Comunicados[n].id,
					filename: data.vegetacao_Conducao_Comunicados[n].filename,
					name: data.vegetacao_Conducao_Comunicados[n].filename,
					codigo: data.vegetacao_Conducao_Comunicados[n].codigo,
					path: data.vegetacao_Conducao_Comunicados[n].path,
					dataComunicado: data.vegetacao_Conducao_Comunicados[n].dataComunicado,
				};

				newArquivos.push(arquivo);
			}

			setConducaoComunicados(newArquivos);
		}

		// vegetacao_Planejamento_Croqui
		
		if (data?.vegetacao_Planejamento_Croqui?.length) {

			let newArquivos: Documentos_PastaProcessoOnEditVegetacao[] = [];

			for (let n = 0, t = data?.vegetacao_Planejamento_Croqui?.length; n < t; n++) {
				let arquivo: Documentos_PastaProcessoOnEditVegetacao = {
					id: data.vegetacao_Planejamento_Croqui[n].id,
					filename: data.vegetacao_Planejamento_Croqui[n].filename,
					name: data.vegetacao_Planejamento_Croqui[n].filename,
					codigo: data.vegetacao_Planejamento_Croqui[n].codigo,
					path: data.vegetacao_Planejamento_Croqui[n].path,
				};

				newArquivos.push(arquivo);
			}

			setPlanejamentoCroqui(newArquivos);
		}

		// vegetacao_Planejamento_datasColheita
		
		if (data?.vegetacao_Planejamento_DatasColheita?.length) {

			let newDataColheita: VegetacaoDataColheita[] = [];

			for (let n = 0, t = data?.vegetacao_Planejamento_DatasColheita?.length; n < t; n++) {
				let dataColheita: VegetacaoDataColheita = {
					id: data.vegetacao_Planejamento_DatasColheita[n].id,
					dataColheita: data.vegetacao_Planejamento_DatasColheita[n].dataColheita,
					dataInicialColheita: data.vegetacao_Planejamento_DatasColheita[n].dataInicialColheita,
					dataFinalColheita: data.vegetacao_Planejamento_DatasColheita[n].dataFinalColheita,
				};

				newDataColheita.push(dataColheita);
			}

			setSelectedDatasColheita(newDataColheita);
		}

		// vegetacao_Destruicao_ArquivoAMI
		carregarDestruicaoAMIDaEntity(data);

		// vegetacao_Fiscalizacao_Termos
		
		if (data?.vegetacao_Fiscalizacao_Termos?.length) {
			setFileFieldDestruicaoAMI(data.vegetacao_Fiscalizacao_Termos);

			let newArquivos: Documentos_PastaProcessoOnEditVegetacao[] = [];

			for (let n = 0, t = data?.vegetacao_Fiscalizacao_Termos?.length; n < t; n++) {
				let arquivo: Documentos_PastaProcessoOnEditVegetacao = {
					id: data.vegetacao_Fiscalizacao_Termos[n].id,
					filename: data.vegetacao_Fiscalizacao_Termos[n].filename,
					name: data.vegetacao_Fiscalizacao_Termos[n].filename,
					codigo: data.vegetacao_Fiscalizacao_Termos[n].codigo,
					path: data.vegetacao_Fiscalizacao_Termos[n].path,
				};

				newArquivos.push(arquivo);
			}

			setFiscalizacaoTermos(newArquivos);
		}

		// vegetacao_Colheita_ami (legado)
		carregarColheitaAMIDaEntity(data);
		carregarRegistroColheitaDaEntity(data);
		carregarRegistroFiscalizacaoDaEntity(data);


		carregarEstadoPlanejamentoPlantio(data);

		if (data?.vegetacao_Conducao_Comunicados?.length) {
			setConducaoComunicados(data.vegetacao_Conducao_Comunicados.map(mapArquivoComunicadoParaGrid));
		} else {
			setConducaoComunicados([]);
		}

		if (data?.vegetacao_Plantio_ArquivoMateriais?.length) {
			setPlantioArquivoMateriais(data.vegetacao_Plantio_ArquivoMateriais.map(mapArquivoPlantioParaGrid));
		} else {
			setPlantioArquivoMateriais([]);
		}

		if (data?.vegetacao_Plantio_ArquivoAMI?.length) {
			setPlantioArquivoAMIFiles(data.vegetacao_Plantio_ArquivoAMI.map(mapArquivoPlantioParaGrid));
		} else {
			setPlantioArquivoAMIFiles([]);
		}

		setEntity(normalizarEntityVegetacao(data));

		setStatusCadernoConformidade(data.status);
	}

	useEffect(() => {

		const getDataToForm = async (FinishHandler: any) => {

			setLoadingScreen('get_data_form');

			try {
				const usuariosHermes = await api.get<UsuarioDto[]>(`api/v1/admin/usuarios/usuarios_obtertodos`);

				const cultures = await api.get<CulturaResult[]>('api/v1/autorizacoes-cibio/Cultura/obterporfiltro?Ativo=true');

				const responsaveis = await api.get<ResponsavelRegulatorioResult[]>('api/v1/autorizacoes-cibio/Destinatario/obterporfiltro?Ativo=true');

				const tecnicos = await api.get<ResponsavelRegulatorioResult[]>('api/v1/autorizacoes-cibio/Destinatario/obterporfiltro?Ativo=true');

				const locations = await api.get<UnityStationResult[]>('api/v1/autorizacoes-cibio/UnidadeEstacao/obterporfiltro?Ativo=true');

				const tipoMaterialAmostragem = await api.get<Enum[]>('api/v1/caderno-conformidade/Enum/tipo-material-amostragem');
				const destinoAmostras = await api.get<Enum[]>('api/v1/caderno-conformidade/Enum/destino-amostras');
				const destinoSobra = await api.get<Enum[]>('api/v1/caderno-conformidade/Enum/destino-sobra');
				const localDestruicao = await api.get<Enum[]>('api/v1/caderno-conformidade/Enum/local-descarte');
				const metodoDestruicao = await api.get<Enum[]>('api/v1/caderno-conformidade/Enum/metodo-descarte');
				const tipoMaterialDescarte = await api.get<Enum[]>('api/v1/caderno-conformidade/Enum/tipo-material-descarte');
				const tipoColheita = await api.get<Enum[]>('api/v1/caderno-conformidade/Enum/tipo-colheita');
				const tipoMaterialColheita = await api.get<Enum[]>('api/v1/caderno-conformidade/Enum/tipo-material-colheita');
				const tipoFaseLimpezaEquipamentos = await api.get<Enum[]>('api/v1/caderno-conformidade/Enum/tipo-fase-limpeza-equipamentos');
				const tipoFaseLimpezaInstalacoes = await api.get<Enum[]>('api/v1/caderno-conformidade/Enum/tipo-fase-limpeza-instalacoes');
				const tipoFaseDestruicao = await api.get<Enum[]>('api/v1/caderno-conformidade/Enum/tipo-fase-destruicao');
				const metodoLimpeza = await api.get<Enum[]>('api/v1/caderno-conformidade/Enum/metodo-limpeza');
				const metodoLimpeza_Id = await api.get<Enum[]>('api/v1/caderno-conformidade/Enum/metodo-limpeza-equipamento');
				const metodoLimpezaInstalacao = await api.get<Enum[]>('api/v1/caderno-conformidade/Enum/metodo-limpeza-instalacao');
				const municipio = await api.get<Enum[]>('api/v1/caderno-conformidade/Enum/municipio');
				const atividadeManutencao = await api.get<Enum[]>('api/v1/caderno-conformidade/Enum/atividade-manutencao');
				const orgaoFiscalizador = await api.get<Enum[]>('api/v1/caderno-conformidade/Enum/orgao-fiscalizador');

				const nomeCientifico = await api.get<Enum[]>('api/v1/caderno-conformidade/Enum/nome-cientifico');

				const responsavelRegulatorio = await api.get<Enum[]>('api/v1/caderno-conformidade/Enum/responsavel-regulatorio');

				const unidadeMedida = await api.get<Enum[]>('api/v1/caderno-conformidade/Enum/unidade-medida');

				if (municipio.status === 200) {
					setEnumMunicipio(municipio.data);
				}
				if (cultures.status === 200) {
					setCultures(cultures.data);
				}
				if (responsaveis.status === 200) {
					setResponsaveis(responsaveis.data);
				}
				if (tecnicos.status === 200) {
					setTecnicoPrincipal(tecnicos.data);
				}
				if (locations.status === 200) {
					setLocations(locations.data);
				}
				if (tipoMaterialAmostragem.status === 200) {
					setEnumTipoMaterialAmostragem(tipoMaterialAmostragem.data);
				}
				if (destinoAmostras.status === 200) {
					setEnumDestinoAmostras(destinoAmostras.data);
				}
				if (destinoSobra.status === 200) {
					setEnumDestinoSobra(destinoSobra.data);
				}
				if (localDestruicao.status === 200) {
					setEnumLocalDescarte(localDestruicao.data);
				}
				if (metodoDestruicao.status === 200) {
					setEnumMetodoDescarte(metodoDestruicao.data);
				}
				if (tipoMaterialDescarte.status === 200) {
					setEnumTipoMaterialDescartado(tipoMaterialDescarte.data);
				}
				if (tipoColheita.status === 200) {
					setEnumTipoColheita(tipoColheita.data);
				}
				if (metodoLimpeza.status === 200) {
					setEnumMetodoLimpeza(metodoLimpeza.data);
				}
				if (metodoLimpeza_Id.status === 200) {
					setEnumMetodoLimpezaEquipamento(metodoLimpeza_Id.data);
				}
				if (metodoLimpezaInstalacao.status === 200) {
					setEnumMetodoLimpezaInstalacao(metodoLimpezaInstalacao.data);
				}
				if (atividadeManutencao.status === 200) {
					setEnumAtividadesManutencao(atividadeManutencao.data);
				}
				if (tipoMaterialColheita.status === 200) {
					setEnumTipoMaterialColheita(tipoMaterialColheita.data);
				}
				if (tipoFaseLimpezaEquipamentos.status === 200) {
					setEnumTipoFaseLimpezaEquipamentos(tipoFaseLimpezaEquipamentos.data);
				}
				if (tipoFaseLimpezaInstalacoes.status === 200) {
					setEnumTipoFaseLimpezaInstalacoes(tipoFaseLimpezaInstalacoes.data);
				}
				if (tipoFaseDestruicao.status === 200) {
					setEnumTipoFaseDestruicao(tipoFaseDestruicao.data);
				}
				if (orgaoFiscalizador.status === 200) {
					setEnumOrgaoFiscalizador(orgaoFiscalizador.data);
				}
				if (nomeCientifico.status === 200) {
					setEnumNomeCientifico(nomeCientifico.data);
				}
				if (responsavelRegulatorio.status === 200) {
					setEnumResponsavelRegulatorio(responsavelRegulatorio.data);
				}
				if (unidadeMedida.status === 200) {
					setEnumUnidadeMedida(unidadeMedida.data);
				}

				let usuarioLogado = usuariosHermes.data.filter((e: any) => e.email === decoded.unique_name);
				setNomeRequerente(usuarioLogado[0].nome);

				FinishHandler(tipoMaterialAmostragem.data, destinoAmostras.data, destinoSobra.data, localDestruicao.data, metodoDestruicao.data, tipoMaterialDescarte.data,
					tipoColheita.data, metodoLimpeza.data, metodoLimpeza_Id.data, metodoLimpezaInstalacao.data, atividadeManutencao.data);

			} catch (error: any) {
				setErrorGetData(error?.response?.data);
				setCadernoCarregando(false);
			}

			setLoadingScreen('get_data_form', false);
		}

		getDataToForm((_tipoMaterialAmostragemEnum: any, _destinoAmostrasEnum: any, _destinoSobraEnum: any, _localDestruicaoEnum: any, _metodoDestruicaoEnum: any, _tipoMaterialDescarteEnum: any,
			_tipoColheitaEnum: any, _metodoLimpezaEnum: any, _metodoLimpezaEquipamentoEnum: any, _metodoLimpezaInstalacaoEnum: any, _atividadeManutencaoEnum: any) => {

			if (location.state && location.state.id) {
				getCadernoConformidade(location.state.id, _tipoMaterialAmostragemEnum, _destinoAmostrasEnum, _destinoSobraEnum, _localDestruicaoEnum, _metodoDestruicaoEnum, _tipoMaterialDescarteEnum,
					_tipoColheitaEnum, _metodoLimpezaEnum, _metodoLimpezaEquipamentoEnum, _metodoLimpezaInstalacaoEnum, _atividadeManutencaoEnum);
			}
			else {
				setStatusCadernoConformidade(1);
				setCadernoCarregando(false);
			}
		})

	}, [location.state, defaultForm.reset]);

	const getCadernoConformidade = async (entityId: any, _tipoMaterialAmostragemEnum: any, _destinoAmostrasEnum: any, _destinoSobraEnum: any, _localDestruicaoEnum: any, _metodoDestruicaoEnum: any, _tipoMaterialDescarteEnum: any,
		_tipoColheitaEnum: any, _metodoLimpezaEnum: any, _metodoLimpezaEquipamentoEnum: any, _metodoLimpezaInstalacaoEnum: any, _atividadeManutencaoEnum: any) => {

		setLoadingScreen('getCadernoConformidade');

		try {
			planejamentoEstadoCarregado.current = false;
			destruicaoGradeHidratada.current = false;
		const { data, status } = await api.get<VegetacaoSearchResult>(`api/v1/caderno-conformidade/Vegetacao/${entityId}`);
		if (status === 200) {
			setValuesWithDataResponse(data, _tipoMaterialAmostragemEnum, _destinoAmostrasEnum, _destinoSobraEnum, _localDestruicaoEnum, _metodoDestruicaoEnum, _tipoMaterialDescarteEnum,
				_tipoColheitaEnum, _metodoLimpezaEnum, _metodoLimpezaEquipamentoEnum, _metodoLimpezaInstalacaoEnum, _atividadeManutencaoEnum);
			setEntity(normalizarEntityVegetacao(data));
		}
		} catch (error: any) {
			setErrorGetData(error.response.data);
		}

		setLoadingScreen('getCadernoConformidade', false);
		setCadernoCarregando(false);
	}

	//inicio config modal upload ...
	const modalArquivo = useForm({
		mode: 'onSubmit',
		resolver: yupResolver(yup.object({
			arquivos: yup.mixed().required(STRINGS.FORM_FIELD_REQUIRED)
		})),
		shouldUnregister: false
	})
	//fim config modal upload ...

	const expectedDocumentos = (fluxo: any): ExpectedDocumentos[] => {
		let arrDocument: ExpectedDocumentos[] = [];

		const documentos = (entity?.vegetacao_Documentos as ExpectedDocumentos[]) || [];
		const documentoAtual = documentos[0] || {} as ExpectedDocumentos;

		if (fluxo === 1) {
			arrDocument.push({
				Id: documentoAtual?.Id ?? 0,
				cadernoConformidadeVegetacao_Id: entity?.id ?? 0,
				copiaAAC: lerValorBooleanoDocumento('copiaAAC'),
				observacoesCopiaAAC: lerValorTextoDocumento('observacoesCopiaAAC'),
				copiaListaTreinamentos: lerValorBooleanoDocumento('copiaListaTreinamentos'),
				observacoesCopiaListaTreinamentos: lerValorTextoDocumento('observacoesCopiaListaTreinamentos'),
				copiaParecerTecnicoCTNBio: lerValorBooleanoDocumento('copiaParecerTecnicoCTNBio'),
				observacoesCopiaCTNBio: lerValorTextoDocumento('observacoesCopiaParecerTecnicoCTNBio'),
				copiaQuarentena: lerValorBooleanoDocumento('copiaQuarentena'),
				observacoesCopiaQuarentena: lerValorTextoDocumento('observacoesCopiaQuarentena'),
				copiaAMI: documentoAtual?.copiaAMI ?? false,
				observacoesCopiaAMI: documentoAtual?.observacoesCopiaAMI ?? "",
				cienciaInstrucoes: lerValorBooleanoDocumento('cienciaInstrucoes'),
				croquiExperimental: documentoAtual?.croquiExperimental ?? false,
				observacoesCroquiExperimental: documentoAtual?.observacoesCroquiExperimental ?? "",
				documentosDestino: documentoAtual?.documentosDestino ?? false,
				observacoesDocumentosDestino: documentoAtual?.observacoesDocumentosDestino ?? "",
				documentosAmostras: documentoAtual?.documentosAmostras ?? false,
				observacoesDocumentosAmostras: documentoAtual?.observacoesDocumentosAmostras ?? "",
				formulariosDestruicao: documentoAtual?.formulariosDestruicao ?? false,
				observacoesFormulariosDestruicao: documentoAtual?.observacoesFormulariosDestruicao ?? "",
				termosFiscalizacao: documentoAtual?.termosFiscalizacao ?? false,
				observacoesTermosFiscalizacao: documentoAtual?.observacoesTermosFiscalizacao ?? "",
				dataFiscalizacao: documentoAtual?.dataFiscalizacao ?? null,
			});
		}
		else {
			documentoAtual.croquiExperimental = defaultForm.getValues('croquiExperimental') !== undefined ? defaultForm.getValues('croquiExperimental') : (documentoAtual?.croquiExperimental ?? false);
			documentoAtual.observacoesCroquiExperimental = defaultForm.getValues('observacoesCroquiExperimental') !== undefined ? defaultForm.getValues('observacoesCroquiExperimental') : (documentoAtual?.observacoesCroquiExperimental ?? "");
			arrDocument.push(documentoAtual);

		};

		return arrDocument;
	}

	const obterDocumentosParaSave = (fluxo: number): ExpectedDocumentos[] =>
		fluxo === 2 ? expectedDocumentos(2) : expectedDocumentos(1);

	const expectedFiscalizacao = (): ExpectedFiscalizacao[] => {
		const arrFiscalizacao: ExpectedFiscalizacao[] = [];

		for (let count = 0, countLen = selectedRegistroFiscalizacao.length; count < countLen; count++) {
			const registro = selectedRegistroFiscalizacao[count];
			const nomeArquivo = obterFilenameArquivoFiscalizacao(registro.arquivoTermo, registro.filename);
			const orgaoId = obterValorNumericoId(registro.orgaoFiscalizador?.value ?? registro.orgaoFiscalizador_Id);

			arrFiscalizacao.push({
				Id: registro.id ?? 0,
				documentosDestino: false,
				observacoesDocumentosDestino: '',
				documentosAmostras: false,
				observacoesDocumentosAmostras: '',
				formulariosDestruicao: false,
				observacoesFormulariosDestruicao: '',
				termosFiscalizacao: registro.termosFiscalizacao ?? true,
				observacoesTermosFiscalizacao: registro.observacoesTermosFiscalizacao ?? '',
				dataFiscalizacao: registro.dataFiscalizacao ?? '',
				orgaoFiscalizador_Id: orgaoId,
				outrosOrgaoFiscalizador: registro.outrosOrgaoFiscalizador ?? '',
				filename: nomeArquivo,
				path: registro.path,
				codigo: registro.codigo,
			});
		}

		return arrFiscalizacao;
	}

	///* *//
	const expectedRegistroAmostragem = (): ExpectedRegistroAmostragem[] => {
		let arrRegistroAmostragem: ExpectedRegistroAmostragem[] = [];

		for (let count = 0, countLen = selectedRegistroAmostragem.length; count < countLen; count++) {
			const nomeArquivo = obterFilenameArquivoAmostragem(
				selectedRegistroAmostragem[count].arquivoAmostragem,
				selectedRegistroAmostragem[count].filename,
			);

			arrRegistroAmostragem.push({
				Id: selectedRegistroAmostragem[count].id ?? 0,
				dataInicial: selectedRegistroAmostragem[count].dataInicialAmostragem !== undefined ? selectedRegistroAmostragem[count].dataInicialAmostragem : '',
				dataFinal: selectedRegistroAmostragem[count].dataFinalAmostragem !== undefined ? selectedRegistroAmostragem[count].dataFinalAmostragem : '',
				tipoMaterial_Id: selectedRegistroAmostragem[count].tipoMaterialAmostragem !== undefined ? selectedRegistroAmostragem[count].tipoMaterialAmostragem.value : 0,
				outrosTipoMaterial: selectedRegistroAmostragem[count].tipoMaterialAmostragemOutros !== undefined ? selectedRegistroAmostragem[count].tipoMaterialAmostragemOutros : '',
				responsavel: selectedRegistroAmostragem[count].responsavelAmostragem !== undefined ? selectedRegistroAmostragem[count].responsavelAmostragem : '',
				destino: selectedRegistroAmostragem[count].destinoAmostras !== undefined ? selectedRegistroAmostragem[count].destinoAmostras.value : 0,
				outrosDestino: selectedRegistroAmostragem[count].destinoAmostrasOutros !== undefined ? selectedRegistroAmostragem[count].destinoAmostrasOutros : '',
				arquivoAmostragem: nomeArquivo,
				filename: nomeArquivo,
				path: selectedRegistroAmostragem[count].path,
				codigo: selectedRegistroAmostragem[count].codigo,

				responsaveis: selectedRegistroAmostragem[count].responsaveis,

			})
		}
		return arrRegistroAmostragem;
	}

	const expectedRegistroColheita = (): ExpectedRegistroColheita[] => {
		const arrRegistroColheita: ExpectedRegistroColheita[] = [];

		for (let count = 0, countLen = selectedRegistroColheita.length; count < countLen; count++) {
			const nomeArquivo = obterFilenameArquivoColheita(
				selectedRegistroColheita[count].arquivoAMIColheita,
				selectedRegistroColheita[count].filename,
			);

			arrRegistroColheita.push({
				Id: selectedRegistroColheita[count].id ?? 0,
				tipoColheita_Id: selectedRegistroColheita[count].tipoColheita !== undefined ? selectedRegistroColheita[count].tipoColheita.value : 0,
				dataColheita: selectedRegistroColheita[count].dataInicialColheita
					?? selectedRegistroColheita[count].dataColheita
					?? '',
				dataInicialColheita: selectedRegistroColheita[count].dataInicialColheita !== undefined ? selectedRegistroColheita[count].dataInicialColheita : '',
				dataFinalColheita: selectedRegistroColheita[count].dataFinalColheita !== undefined ? selectedRegistroColheita[count].dataFinalColheita : '',
				tipoMaterialColheita_Id: selectedRegistroColheita[count].tipoMaterialColheita !== undefined ? selectedRegistroColheita[count].tipoMaterialColheita.value : 0,
				outrosTipoMaterialColheita: selectedRegistroColheita[count].outrosTipoMaterialColheita ?? '',
				quantidadeMaterialColheita: selectedRegistroColheita[count].quantidadeMaterialColheita ?? 0,
				numeroAMIColheita: selectedRegistroColheita[count].numeroAMIColheita ?? '',
				destinoMaterialColheita_Id: selectedRegistroColheita[count].destinoMaterialColheita !== undefined ? selectedRegistroColheita[count].destinoMaterialColheita.value : 0,
				filename: nomeArquivo,
				path: selectedRegistroColheita[count].path,
				codigo: selectedRegistroColheita[count].codigo,
				responsaveis: selectedRegistroColheita[count].responsaveis,
			});
		}

		return arrRegistroColheita;
	}

	const expectedPlanejamento = (): ExpectedPlanejamento[] => {
		if (!planejamentoEstadoCarregado.current && entity?.vegetacao_Planejamento?.length) {
			return entity.vegetacao_Planejamento as ExpectedPlanejamento[];
		}

		let arrPlanejamento: ExpectedPlanejamento[] = [];

		arrPlanejamento.push({
			Id: entity?.vegetacao_Planejamento?.[0]?.id ?? entity?.vegetacao_Planejamento?.[0]?.Id ?? 0,
			treinamentoBiosseguranca: defaultForm.getValues('treinamentoBiosseguranca') !== undefined ? defaultForm.getValues('treinamentoBiosseguranca') : false,
			aacAprovada: defaultForm.getValues('aacAprovada') !== undefined ? defaultForm.getValues('aacAprovada') : false,
			documentacaoImportacao: defaultForm.getValues('documentacaoImportacao') !== undefined ? defaultForm.getValues('documentacaoImportacao') : false,
			deAcordoComPermissaoImportacao: defaultForm.getValues('deAcordoComPermissaoImportacao') !== undefined ? defaultForm.getValues('deAcordoComPermissaoImportacao') : false,
			materialIdentificacaoDisponivel: defaultForm.getValues('materialIdentificacaoDisponivel') !== undefined ? defaultForm.getValues('materialIdentificacaoDisponivel') : false,
			sementesConferidas: defaultForm.getValues('sementesConferidas') !== undefined ? defaultForm.getValues('sementesConferidas') : false,
			epIsDisponiveis: defaultForm.getValues('epIsDisponiveis') !== undefined ? defaultForm.getValues('epIsDisponiveis') : false,
			lixeirasDescarte: defaultForm.getValues('lixeirasDescarte') !== undefined ? defaultForm.getValues('lixeirasDescarte') : false,
		})

		return arrPlanejamento;
	}

	const expectedPlanejamentoConducao = (): ExpectedPlanejamentoConducao[] => {
		let arrPlanejamentoConducao: ExpectedPlanejamentoConducao[] = [];

		arrPlanejamentoConducao.push({
			Id: entity?.vegetacao_Planejamento_Conducao?.[0]?.id ?? entity?.vegetacao_Planejamento_Conducao?.[0]?.Id ?? 0,
			ensaioConformidadeAACAprovada: lerValorBooleanoForm('ensaioConformidadeAACAprovada'),
			observacoesEnsaioConformidadeAACAprovada: lerValorTextoForm('observacoesEnsaioConformidadeAACAprovada'),
			placaBiosseguranca: lerValorBooleanoForm('placaBiosseguranca'),
			observacoesPlacaBiosseguranca: lerValorTextoForm('observacoesPlacaBiosseguranca'),
			envelopesSementesDestruidos: lerValorBooleanoForm('envelopesSementesDestruidos'),
			observacoesEnvelopesSementesDestruidos: lerValorTextoForm('observacoesEnvelopesSementesDestruidos'),
			dispositivosBiossegurancaChecados: lerValorBooleanoForm('dispositivosBiossegurancaChecados'),
			observacoesDispositivosBiossegurancaChecados: lerValorTextoForm('observacoesDispositivosBiossegurancaChecados'),
			equipamentosAtividadePlantioLimpos: lerValorBooleanoForm('equipamentosAtividadePlantioLimpos'),

			observacoesEquipamentosAtividadePlantioLimpos: lerValorTextoForm('observacoesEquipamentosAtividadePlantioLimpos'),
			embalagemArmazenamentoMateriais: lerValorBooleanoForm('embalagemArmazenamentoMateriais'),
			observacoesEmbalagemArmazenamentoMateriais: lerValorTextoForm('observacoesEmbalagemArmazenamentoMateriais'),
			treinamentoBiossegurancaColheita: lerValorBooleanoForm('treinamentoBiossegurancaColheita'),
			materialColhidoEmbalado: lerValorBooleanoForm('materialColhidoEmbalado'),
			observacoesMaterialColhidoEmbalado: lerValorTextoForm('observacoesMaterialColhidoEmbalado'),
			documentosDestinoMaterialColhido: lerValorBooleanoForm('documentosDestinoMaterialColhido'),
			observacoesDocumentosDestinoMaterialColhido: lerValorTextoForm('observacoesDocumentosDestinoMaterialColhido'),
			equipamentosAtividadeColheitaLimpos: lerValorBooleanoForm('equipamentosAtividadeColheitaLimpos'),
			observacoesEquipamentosAtividadeColheitaLimpos: lerValorTextoForm('observacoesEquipamentosAtividadeColheitaLimpos'),
			restosVegetaisDevidamenteDescartados: lerValorBooleanoForm('restosVegetaisDevidamenteDescartados'),
			observacoesRestosVegetaisDevidamenteDescartados: lerValorTextoForm('observacoesRestosVegetaisDevidamenteDescartados'),
			comunicacaoCoordenadasGeograficas: lerValorBooleanoForm('comunicacaoCoordenadasGeograficas'),
			observacoesComunicacaoCoordenadasGeograficas: lerValorTextoForm('observacoesComunicacaoCoordenadasGeograficas'),
		})

		return arrPlanejamentoConducao;
	}
	///* *//
	const expectedDatasPlantio = (): ExpectedDatasPlantio[] => {
		let arrDatasPlantio: ExpectedDatasPlantio[] = [];

		for (let count = 0, countLen = selectedDataPlantios.length; count < countLen; count++) {
			arrDatasPlantio.push({
				Id: 0,
				dataInicialPlantio: selectedDataPlantios[count].dataInicialPlantio !== undefined ? selectedDataPlantios[count].dataInicialPlantio : '',
				dataFinalPlantio: selectedDataPlantios[count].dataFinalPlantio !== undefined ? selectedDataPlantios[count].dataFinalPlantio : '',
			})
		}

		return arrDatasPlantio;
	}
	///* *//
	const expectedPessoasEnvolvidasPlantio = (): ExpectedPessoasEnvolvidasPlantio[] => {
		let arrPessoasEnvolvidasPlantio: ExpectedPessoasEnvolvidasPlantio[] = [];

		for (let count = 0, countLen = selectedPessoasEnvolvidasPlantio.length; count < countLen; count++) {
			arrPessoasEnvolvidasPlantio.push({
				Id: 0,
				pessoaPlantio: selectedPessoasEnvolvidasPlantio[count].pessoaPlantio !== undefined ? selectedPessoasEnvolvidasPlantio[count].pessoaPlantio : '',
			})
		}

		return arrPessoasEnvolvidasPlantio;
	}
	///* *//
	const expectedDatasColheita = (): ExpectedDatasColheita[] => {
		let arrDatasColheita: ExpectedDatasColheita[] = [];

		for (let count = 0, countLen = selectedDatasColheita.length; count < countLen; count++) {
			const dataColheitaItem = selectedDatasColheita[count];
			arrDatasColheita.push({
				Id: dataColheitaItem.id != null ? dataColheitaItem.id : 0,
				dataColheita: dataColheitaItem.dataColheita !== undefined ? dataColheitaItem.dataColheita : '',
				dataInicialColheita: dataColheitaItem.dataInicialColheita !== undefined ? dataColheitaItem.dataInicialColheita : '',
				dataFinalColheita: dataColheitaItem.dataFinalColheita !== undefined ? dataColheitaItem.dataFinalColheita : '',
			})
		}

		return arrDatasColheita;
	}
	///* *//
	const expectedPessoasEnvolvidasColheita = (): ExpectedPessoasEnvolvidasColheita[] => {
		let arrPessoasEnvolvidasColheita: ExpectedPessoasEnvolvidasColheita[] = [];

		for (let count = 0, countLen = selectedPessoasEnvolvidasColheita.length; count < countLen; count++) {
			arrPessoasEnvolvidasColheita.push({
				Id: 0,
				pessoaColheita: selectedPessoasEnvolvidasColheita[count].pessoaColheita !== undefined ? selectedPessoasEnvolvidasColheita[count].pessoaColheita : '',
			})
		}

		return arrPessoasEnvolvidasColheita;
	}
	///* *//
	const expectedLimpeza = (): ExpectedLimpeza[] => {
		let arrLimpeza: ExpectedLimpeza[] = [];

		for (let count = 0, countLen = selectedLimpezaInstalacoes.length; count < countLen; count++) {
			arrLimpeza.push({
				Id: selectedLimpezaInstalacoes[count].id ?? 0,
				dataLimpeza: selectedLimpezaInstalacoes[count].dataLimpeza !== undefined ? selectedLimpezaInstalacoes[count].dataLimpeza : selectedLimpezaInstalacoes[count].dataInicialLimpeza,
				numeroCodigoCasaVegetacao: selectedLimpezaInstalacoes[count].numeroCodigoCasaVegetacao !== undefined ? selectedLimpezaInstalacoes[count].numeroCodigoCasaVegetacao : '',
				responsavel: selectedLimpezaInstalacoes[count].responsavel !== undefined ? selectedLimpezaInstalacoes[count].responsavel : '',
				metodoLimpeza_Id: selectedLimpezaInstalacoes[count].metodoLimpeza_Id !== undefined ? selectedLimpezaInstalacoes[count].metodoLimpeza_Id.value : 0,
				outrosMetodoLimpeza: selectedLimpezaInstalacoes[count].outrosMetodoLimpeza !== undefined ? selectedLimpezaInstalacoes[count].outrosMetodoLimpeza : '',
				dataInicialLimpeza: selectedLimpezaInstalacoes[count].dataInicialLimpeza !== undefined ? selectedLimpezaInstalacoes[count].dataInicialLimpeza : '',
				dataFinalLimpeza: selectedLimpezaInstalacoes[count].dataFinalLimpeza !== undefined ? selectedLimpezaInstalacoes[count].dataFinalLimpeza : '',
				tipoFaseLimpeza_Id: selectedLimpezaInstalacoes[count].tipoFaseLimpeza_Id !== undefined ? selectedLimpezaInstalacoes[count].tipoFaseLimpeza_Id.value : 0,
				outrosTipoFaseLimpeza: selectedLimpezaInstalacoes[count].outrosTipoFaseLimpeza !== undefined ? selectedLimpezaInstalacoes[count].outrosTipoFaseLimpeza : "",
				observacoesLimpeza: selectedLimpezaInstalacoes[count].observacoesLimpeza !== undefined ? selectedLimpezaInstalacoes[count].observacoesLimpeza : "",

				responsaveis: selectedLimpezaInstalacoes[count].responsaveis,
				metodosLimpeza: selectedLimpezaInstalacoes[count].metodosLimpeza,

			})
		}
		return arrLimpeza;
	}

	const expectedLimpezaInstalacoesResponsaveis = (): ExpectedLimpezaInstalacoesResponsaveis[] => {
		let arrLimpezaInstalacoesResponsaveis: ExpectedLimpezaInstalacoesResponsaveis[] = [];

		//for (let count = 0, countLen = responsaveisLimpezaInstalacoes.length; count < countLen; count++) {
		//	arrLimpezaInstalacoesResponsaveis.push({
		//		Id: 0,
		//		nomeResponsavelLimpezaInstalacoes: responsaveisLimpezaInstalacoes[count].nome !== undefined ? responsaveisLimpezaInstalacoes[count].nome : '',
		//	})
		//}

		return arrLimpezaInstalacoesResponsaveis;
	}

	///* *//
	const expectedInspecao = (): ExpectedInspecao[] => expectedInspecaoDeLista(selectedInspecaoEquipamentos);
	///* *//
	const expectedAtividades = (): ExpectedAtividades[] => {
		let arrAtividades: ExpectedAtividades[] = [];

		for (let count = 0, countLen = selectedAtividadeManutencao.length; count < countLen; count++) {

			arrAtividades.push({
				Id: selectedAtividadeManutencao[count].id ?? 0,
				dataAtividade: selectedAtividadeManutencao[count].dataAtividade !== undefined ? selectedAtividadeManutencao[count].dataAtividade : '',
				dataInicialAtividade: selectedAtividadeManutencao[count].dataInicialAtividade !== undefined ? selectedAtividadeManutencao[count].dataInicialAtividade : '',
				dataFinalAtividade: selectedAtividadeManutencao[count].dataFinalAtividade !== undefined ? selectedAtividadeManutencao[count].dataFinalAtividade : '',
				responsavel: selectedAtividadeManutencao[count].responsavel !== undefined ? selectedAtividadeManutencao[count].responsavel : '',
				atividadeManutencao_Id: selectedAtividadeManutencao[count].atividadeManutencao_Id !== undefined ? selectedAtividadeManutencao[count].atividadeManutencao_Id.value : 0,
				outrosAtividadeManutencao: selectedAtividadeManutencao[count].outrosAtividadeManutencao !== undefined ? selectedAtividadeManutencao[count].outrosAtividadeManutencao : '',

				responsaveis: selectedAtividadeManutencao[count].responsaveis,
				metodosLimpeza: selectedAtividadeManutencao[count].metodosLimpeza,
			})
		}
		return arrAtividades;
	}

	const lerNumeroDestruicao = (valor: any, fallback = 0): number => {
		if (valor === undefined || valor === null || valor === '') {
			return fallback;
		}

		return Number(valor) || fallback;
	};

	const parseInteiroNaoNegativo = (valor: any, fallback = 0): number => {
		if (valor === undefined || valor === null || valor === '') {
			return fallback;
		}

		const n = parseInt(String(valor).replace(',', '.').replace(/[^\d.-]/g, ''), 10);
		return Number.isFinite(n) && n >= 0 ? n : fallback;
	};

	const parseDecimalNaoNegativo = (valor: any, fallback = 0): number => {
		if (valor === undefined || valor === null || valor === '') {
			return fallback;
		}

		const n = Number(String(valor).replace(',', '.').replace(/[^\d.-]/g, ''));
		return Number.isFinite(n) && n >= 0 ? n : fallback;
	};

	const mapearLimpezaDestruicaoLista = (itens: ExpectedDestruicaoLimpeza[] = []): ExpectedDestruicaoLimpeza[] =>
		itens.map((item) => ({
			...item,
			metodoLimpeza: normalizarMetodoLimpezaParaExibicao(
				item.metodoLimpeza ?? (item.metodoLimpeza_Id != null ? String(item.metodoLimpeza_Id) : ''),
				item.outrosMetodoLimpeza,
			),
		}));

	const mapearLimpezaDestruicaoParaPayload = (): ExpectedDestruicaoLimpeza[] =>
		mapearLimpezaDestruicaoLista(selectedLimpezaDestruicao);

	const expectedDestruicao = (): ExpectedDestruicao[] => {
		let arrDestruicao: ExpectedDestruicao[] = [];

		for (let count = 0, countLen = selectedDestruicao.length; count < countLen; count++) {
			const item = selectedDestruicao[count];
			arrDestruicao.push({
				Id: item.id ?? 0,
				tipoDestruicao: lerNumeroDestruicao(item.tipoDestruicao, tipoDestruicaoValue),
				outrosTipoDestruicao: item.outrosTipoDestruicao,
				numeroAmostras: parseInteiroNaoNegativo(item.numeroAmostras),
				pesoAmostras: parseDecimalNaoNegativo(item.pesoAmostras),
				unidadeMedida: lerNumeroDestruicao(item.unidadeMedida, unidadeMedidaValue),
				localDestruicao: lerNumeroDestruicao(item.localDestruicao, localDestruicaoValue),
				outrosLocalDestruicao: item.outrosLocalDestruicao,
				observacoesLocalDestruicao: item.observacoesLocalDestruicao,
				metodoDestruicao: lerNumeroDestruicao(item.metodoDestruicao, metodoDestruicaoValue),
				outrosMetodoDestruicao: item.outrosMetodoDestruicao,
				observacoesMetodoDestruicao: item.observacoesMetodoDestruicao,
				dataInicialDestruicao: item.dataInicialDestruicao,
				dataFinalDestruicao: item.dataFinalDestruicao,
				tipoFaseDestruicao_Id: lerNumeroDestruicao(item.tipoFaseDestruicao_Id, tipoFaseDestruicaoValue),
				outrosTipoFaseDestruicao: item.outrosTipoFaseDestruicao,

				responsaveisDestruicao: item.responsaveisDestruicao ?? [],
				metodosDestruicao: item.metodosDestruicao ?? [],
				limpezaDestruicao: mapearLimpezaDestruicaoLista(item.limpezaDestruicao ?? []),

			})
		}

		return arrDestruicao;
	}
	///* *//
	const expectedDestruicaoResponsaveis = (): ExpectedDestruicaoResponsaveis[] => {
		return selectedDestruicao.flatMap((item) => item.responsaveisDestruicao ?? []).map((item) => ({
			Id: item.id ?? 0,
			responsavel: item.responsavel ?? '',
		}));
	}
	///* *//
	const expectedDestruicaoLimpeza = (): ExpectedDestruicaoLimpeza[] => {
		let arrDestruicaoLimpeza: ExpectedDestruicaoLimpeza[] = [];

		//for (let count = 0, countLen = selectedLimpezaDestruicao.length; count < countLen; count++) {
		//	arrDestruicaoLimpeza.push({
		//		id: 0,
		//		descricaoMaquinario: selectedLimpezaDestruicao[count].descricaoMaquinario !== undefined ? selectedLimpezaDestruicao[count].descricaoMaquinario : '',
		//		dataLimpezaAntesUso: selectedLimpezaDestruicao[count].dataLimpezaAntesUso !== undefined ? selectedLimpezaDestruicao[count].dataLimpezaAntesUso : '',
		//		dataLimpezaDepoisUso: selectedLimpezaDestruicao[count].dataLimpezaDepoisUso !== undefined ? selectedLimpezaDestruicao[count].dataLimpezaDepoisUso : '',
		//		responsavelLimpeza: selectedLimpezaDestruicao[count].responsavelLimpeza !== undefined ? selectedLimpezaDestruicao[count].responsavelLimpeza : '',
		//		metodoLimpeza_Id: selectedLimpezaDestruicao[count].metodoLimpeza_Id !== undefined ? selectedLimpezaDestruicao[count].metodoLimpeza_Id.value : 0,
		//		outrosMetodoLimpeza: selectedLimpezaDestruicao[count].outrosMetodoLimpeza !== undefined ? selectedLimpezaDestruicao[count].outrosMetodoLimpeza : '',
		//	})
		//}

		return arrDestruicaoLimpeza;
	}

	const expectedReportes = (): ExpectedReportes[] => {
		let arrReportes: ExpectedReportes[] = [];

		if (defaultForm.getValues('liberacaoNaoIntencional') !== undefined) {
			arrReportes.push({
				Id: 0,
				liberacaoNaoIntencional: defaultForm.getValues('liberacaoNaoIntencional') !== undefined ? defaultForm.getValues('liberacaoNaoIntencional') : '',
				dataLiberacaoNaoIntencional: defaultForm.getValues('dataLiberacaoNaoIntencional') !== undefined ? defaultForm.getValues('dataLiberacaoNaoIntencional') : moment().toDate(),
				medidasCorrecaoLiberacaoNaoIntencional: defaultForm.getValues('medidasCorrecaoLiberacaoNaoIntencional') !== undefined ? defaultForm.getValues('medidasCorrecaoLiberacaoNaoIntencional') : '',
				nomeReporteLiberacaoNaoIntencional: defaultForm.getValues('nomeReporteLiberacaoNaoIntencional') !== undefined ? defaultForm.getValues('nomeReporteLiberacaoNaoIntencional') : '',
				cargoReporteLiberacaoNaoIntencional: defaultForm.getValues('cargoReporteLiberacaoNaoIntencional') !== undefined ? defaultForm.getValues('cargoReporteLiberacaoNaoIntencional') : '',
				dataReporteLiberacaoNaoIntencional: defaultForm.getValues('dataReporteLiberacaoNaoIntencional') !== undefined ? defaultForm.getValues('dataReporteLiberacaoNaoIntencional') : moment().toDate(),
			})
		}

		return arrReportes;
	}

	const expectedReportesResponsaveis = (): ExpectedReportesResponsaveis[] => {
		let arrReporteResponsaveis: ExpectedReportesResponsaveis[] = [];

		for (let count = 0, countLen = responsaveisReporte.length; count < countLen; count++) {
			arrReporteResponsaveis.push({
				Id: 0,
				nomeReporteLiberacaoNaoIntencional: responsaveisReporte[count].nomeReporteLiberacaoNaoIntencional !== undefined ? responsaveisReporte[count].nomeReporteLiberacaoNaoIntencional : '',
				cargoReporteLiberacaoNaoIntencional: responsaveisReporte[count].cargoReporteLiberacaoNaoIntencional !== undefined ? responsaveisReporte[count].cargoReporteLiberacaoNaoIntencional : '',
				dataReporteLiberacaoNaoIntencional: responsaveisReporte[count].dataReporteLiberacaoNaoIntencional !== undefined ? responsaveisReporte[count].dataReporteLiberacaoNaoIntencional : '',
			})
		}

		return arrReporteResponsaveis;
	}
	///* *//
	const expectedAnotacoes = (): ExpectedAnotacoes[] => {
		let arrAnotacoes: ExpectedAnotacoes[] = [];

		for (let count = 0, countLen = selectedAnotacoes.length; count < countLen; count++) {
			arrAnotacoes.push({
				Id: 0,
				responsavel: selectedAnotacoes[0].responsavel !== undefined ? selectedAnotacoes[0].responsavel : decoded.unique_name,
				dataAnotacao: selectedAnotacoes[0].dataAnotacao !== undefined ? selectedAnotacoes[0].dataAnotacao : moment().toDate(),
				anotacao: selectedAnotacoes[0].anotacao !== undefined ? selectedAnotacoes[0].anotacao : '',
			})
		}
		return arrAnotacoes;
	}
	///* *//
	const expectedPlanejamentoNotificacaoPlantio = (): ExpectedPlanejamentoNotificacaoPlantio[] => {
		let arrPlanejamentoNotificacaoPlantio: ExpectedPlanejamentoNotificacaoPlantio[] = [];

		for (let count = 0, countLen = selectedPlantios.length; count < countLen; count++) {
			arrPlanejamentoNotificacaoPlantio.push({
				Id: selectedPlantios[count].id ?? 0,
				numeroPlantio: selectedPlantios[count].numeroPlantio !== undefined ? selectedPlantios[count].numeroPlantio : '',
				casaVegetacaoModulo: selectedPlantios[count].casaVegetacaoModulo !== undefined ? selectedPlantios[count].casaVegetacaoModulo : '',
				material: selectedPlantios[count].material !== undefined ? selectedPlantios[count].material : '',
				informacoesAdicionaisMaterial: selectedPlantios[count].informacoesAdicionaisMaterial !== undefined ? selectedPlantios[count].informacoesAdicionaisMaterial : '',
				numeroAMI: selectedPlantios[count].numeroAMI !== undefined ? selectedPlantios[count].numeroAMI : '',
				sobraMaterial: selectedPlantios[count].sobraMaterial !== undefined ? selectedPlantios[count].sobraMaterial : false,
				numeroAmostrasRestantes: selectedPlantios[count].numeroAmostrasRestantes !== undefined ? selectedPlantios[count].numeroAmostrasRestantes : 0,
				quantidadeAmostrasRestantes: selectedPlantios[count].quantidadeAmostrasRestantes !== undefined ? selectedPlantios[count].quantidadeAmostrasRestantes : 0,
				destinoSobra_Id: getDestinoSobraIdFromPlantio(selectedPlantios[count]),
				destinoSobraOutros: selectedPlantios[count].destinoSobraOutros !== undefined ? selectedPlantios[count].destinoSobraOutros : '',
				entradaArmazenamento: selectedPlantios[count].entradaArmazenamento !== undefined ? selectedPlantios[count].entradaArmazenamento : false,
				informacoesAdicionais: selectedPlantios[count].informacoesAdicionais !== undefined ? selectedPlantios[count].informacoesAdicionais : '',
				dataInicialPlantio: selectedPlantios[count].dataInicialPlantio !== undefined ? selectedPlantios[count].dataInicialPlantio : '',
				dataFinalPlantio: selectedPlantios[count].dataFinalPlantio !== undefined ? selectedPlantios[count].dataFinalPlantio : '',

				arquivoMaterialPlantado: selectedPlantios[count].arquivoMaterialPlantado,
				arquivoPlantioAMI: selectedPlantios[count].arquivoPlantioAMI,

				responsaveis: selectedPlantios[count].responsaveis,

			})
		}

		return arrPlanejamentoNotificacaoPlantio;
	}

	const obterEntityComInspecaoSincronizada = (entityBase: any = entity) => {
		if (!entityBase || !limpezaEquipamentos || Number(modoFluxo) === MODO_VIEW.LIMPEZA_INSTALACOES) {
			return entityBase;
		}

		return {
			...entityBase,
			vegetacao_Planejamento_Inspecao: mergeInspecaoEquipamentosPorFase(
				expectedInspecaoDeLista(selectedInspecaoEquipamentos),
				Number(tipoFaseLimpezaEquipamentosValue),
				entityBase?.vegetacao_Planejamento_Inspecao
			),
		};
	};

	const obterDestruicaoParaSave = (estadoLocal: ExpectedDestruicao[]) => {
		if (!destruicaoGradeHidratada.current) {
			return entity?.vegetacao_Destruicao;
		}

		return estadoLocal;
	};

	const gravarDados = (fluxo: any, entityRef?: any) => {
		const entityAtual = obterEntityComInspecaoSincronizada(entityRef ?? entity);

		let dados: VegetacaoSearchResult =
		{

		};

		var aprovador = '';
		var dataDaAprovacao;
		var observacoes = '';

		// Dados Principais e Documentos
		if (fluxo === 1) {

			dados =
			{
				id: entity?.id,
				status: entity?.status !== undefined ? entity?.status : 0,
				requisitante: entity?.requisitante !== undefined ? entity?.requisitante : '',
				dataCriacao: entity?.dataCriacao !== undefined ? entity?.dataCriacao : '',

				...obterCamposDadosPrincipaisEntity(entity),

				cienciaInstrucoes: defaultForm.getValues('cienciaInstrucoes') !== undefined ? defaultForm.getValues('cienciaInstrucoes') : false,

				vegetacao_Documentos: expectedDocumentos(1),
				vegetacao_Documentos_RegistroAmostragem: entity?.vegetacao_Documentos_RegistroAmostragem,

				vegetacao_Planejamento: entity?.vegetacao_Planejamento,
				vegetacao_Planejamento_Conducao: entity?.vegetacao_Planejamento_Conducao,
				vegetacao_Planejamento_DatasPlantio: entity?.vegetacao_Planejamento_DatasPlantio,
				vegetacao_Planejamento_PessoasPlantio: entity?.vegetacao_Planejamento_PessoasPlantio,
				vegetacao_Planejamento_NotificacaoPlantio: entity?.vegetacao_Planejamento_NotificacaoPlantio,
				vegetacao_Planejamento_Limpeza: entity?.vegetacao_Planejamento_Limpeza,
				vegetacao_Limpeza_Instalacoes_Responsaveis: entity?.vegetacao_Limpeza_Instalacoes_Responsaveis,
				vegetacao_Planejamento_Inspecao: entity?.vegetacao_Planejamento_Inspecao,

				vegetacao_Planejamento_Atividades: entity?.vegetacao_Planejamento_Atividades,

				vegetacao_Planejamento_DatasColheita: entity?.vegetacao_Planejamento_DatasColheita,
				vegetacao_Planejamento_PessoasColheita: entity?.vegetacao_Planejamento_PessoasColheita,

				vegetacao_Destruicao: entity?.vegetacao_Destruicao,
				vegetacao_Destruicao_Responsaveis: entity?.vegetacao_Destruicao_Responsaveis,
				vegetacao_Destruicao_Limpeza: entity?.vegetacao_Destruicao_Limpeza,

				vegetacao_Fiscalizacao: entity?.vegetacao_Fiscalizacao,
				vegetacao_Reportes: entity?.vegetacao_Reportes,
				vegetacao_Reportes_Responsaveis: entity?.vegetacao_Reportes_Responsaveis,
				vegetacao_Anotacoes: entity?.vegetacao_Anotacoes,
			}
		}
		// Planejamento e Condução
		else if (fluxo === 2) {

			const notificacaoPlantio = expectedPlanejamentoNotificacaoPlantio();
			const inspecao = expectedInspecao();
			const datasPlantio = expectedDatasPlantio();
			const pessoasPlantio = expectedPessoasEnvolvidasPlantio();

			dados =
			{
				id: entity?.id,
				status: entity?.status !== undefined ? entity?.status : 0,
				requisitante: entity?.requisitante !== undefined ? entity?.requisitante : '',
				dataCriacao: entity?.dataCriacao !== undefined ? entity?.dataCriacao : '',

				...obterCamposDadosPrincipaisEntity(entity),

				vegetacao_Documentos: expectedDocumentos(2),
				vegetacao_Documentos_RegistroAmostragem: entity?.vegetacao_Documentos_RegistroAmostragem,

				vegetacao_Planejamento: preservarColecaoNoSave(expectedPlanejamento(), entity?.vegetacao_Planejamento) as any,
				vegetacao_Planejamento_Conducao: preservarColecaoNoSave(expectedPlanejamentoConducao(), entity?.vegetacao_Planejamento_Conducao) as any,
				vegetacao_Planejamento_DatasPlantio: preservarColecaoNoSave(datasPlantio, entity?.vegetacao_Planejamento_DatasPlantio) as any,
				vegetacao_Planejamento_PessoasPlantio: preservarColecaoNoSave(pessoasPlantio, entity?.vegetacao_Planejamento_PessoasPlantio) as any,
				vegetacao_Planejamento_NotificacaoPlantio: preservarColecaoNoSave(notificacaoPlantio, entity?.vegetacao_Planejamento_NotificacaoPlantio) as any,
				vegetacao_Planejamento_Limpeza: entity?.vegetacao_Planejamento_Limpeza,
				vegetacao_Limpeza_Instalacoes_Responsaveis: entity?.vegetacao_Limpeza_Instalacoes_Responsaveis,
				vegetacao_Planejamento_Inspecao: mergeInspecaoEquipamentosPorFase(
					inspecao,
					FASE_LIMPEZA_EQUIPAMENTOS.PLANTIO,
					entityAtual?.vegetacao_Planejamento_Inspecao
				) as any,

				vegetacao_Planejamento_Atividades: entity?.vegetacao_Planejamento_Atividades,

				vegetacao_Planejamento_DatasColheita: entity?.vegetacao_Planejamento_DatasColheita,
				vegetacao_Planejamento_PessoasColheita: entity?.vegetacao_Planejamento_PessoasColheita,

				vegetacao_Destruicao: entity?.vegetacao_Destruicao,
				vegetacao_Destruicao_Responsaveis: entity?.vegetacao_Destruicao_Responsaveis,
				vegetacao_Destruicao_Limpeza: entity?.vegetacao_Destruicao_Limpeza,

				vegetacao_Fiscalizacao: entity?.vegetacao_Fiscalizacao,
				vegetacao_Reportes: entity?.vegetacao_Reportes,
				vegetacao_Reportes_Responsaveis: entity?.vegetacao_Reportes_Responsaveis,
				vegetacao_Anotacoes: entity?.vegetacao_Anotacoes,
			}
		}
		// Manutençao
		else if (fluxo === 3) {

			const atividades = expectedAtividades();
			const inspecao = expectedInspecao();

			dados =
			{
				id: entity?.id,
				status: entity?.status !== undefined ? entity?.status : 0,
				requisitante: entity?.requisitante !== undefined ? entity?.requisitante : '',
				dataCriacao: entity?.dataCriacao !== undefined ? entity?.dataCriacao : '',

				...obterCamposDadosPrincipaisEntity(entity),

				vegetacao_Documentos: obterDocumentosParaSave(3),
				vegetacao_Documentos_RegistroAmostragem: entity?.vegetacao_Documentos_RegistroAmostragem,

				vegetacao_Planejamento: entity?.vegetacao_Planejamento,
				vegetacao_Planejamento_Conducao: entity?.vegetacao_Planejamento_Conducao,
				vegetacao_Planejamento_DatasPlantio: entity?.vegetacao_Planejamento_DatasPlantio,
				vegetacao_Planejamento_PessoasPlantio: entity?.vegetacao_Planejamento_PessoasPlantio,
				vegetacao_Planejamento_NotificacaoPlantio: entity?.vegetacao_Planejamento_NotificacaoPlantio,
				vegetacao_Planejamento_Limpeza: entity?.vegetacao_Planejamento_Limpeza,
				vegetacao_Limpeza_Instalacoes_Responsaveis: entity?.vegetacao_Limpeza_Instalacoes_Responsaveis,
				vegetacao_Planejamento_Inspecao: mergeInspecaoEquipamentosPorFase(
					inspecao,
					FASE_LIMPEZA_EQUIPAMENTOS.MANUTENCAO,
					entityAtual?.vegetacao_Planejamento_Inspecao
				) as any,

				vegetacao_Planejamento_Atividades: preservarColecaoNoSave(atividades, entity?.vegetacao_Planejamento_Atividades) as any,

				vegetacao_Planejamento_DatasColheita: entity?.vegetacao_Planejamento_DatasColheita,
				vegetacao_Planejamento_PessoasColheita: entity?.vegetacao_Planejamento_PessoasColheita,

				vegetacao_Destruicao: entity?.vegetacao_Destruicao,
				vegetacao_Destruicao_Responsaveis: entity?.vegetacao_Destruicao_Responsaveis,
				vegetacao_Destruicao_Limpeza: entity?.vegetacao_Destruicao_Limpeza,

				vegetacao_Fiscalizacao: entity?.vegetacao_Fiscalizacao,
				vegetacao_Reportes: entity?.vegetacao_Reportes,
				vegetacao_Reportes_Responsaveis: entity?.vegetacao_Reportes_Responsaveis,
				vegetacao_Anotacoes: entity?.vegetacao_Anotacoes,
			}
		}
		// Amostragem
		else if (fluxo === 4) {

			const registroAmostragem = expectedRegistroAmostragem();
			const inspecao = expectedInspecao();

			dados =
			{
				id: entity?.id,
				status: entity?.status !== undefined ? entity?.status : 0,
				requisitante: entity?.requisitante !== undefined ? entity?.requisitante : '',
				dataCriacao: entity?.dataCriacao !== undefined ? entity?.dataCriacao : '',

				...obterCamposDadosPrincipaisEntity(entity),

				vegetacao_Documentos: obterDocumentosParaSave(3),
				vegetacao_Documentos_RegistroAmostragem: preservarColecaoNoSave(registroAmostragem, entity?.vegetacao_Documentos_RegistroAmostragem) as any,

				vegetacao_Planejamento: entity?.vegetacao_Planejamento,
				vegetacao_Planejamento_Conducao: entity?.vegetacao_Planejamento_Conducao,
				vegetacao_Planejamento_DatasPlantio: entity?.vegetacao_Planejamento_DatasPlantio,
				vegetacao_Planejamento_PessoasPlantio: entity?.vegetacao_Planejamento_PessoasPlantio,
				vegetacao_Planejamento_NotificacaoPlantio: entity?.vegetacao_Planejamento_NotificacaoPlantio,
				vegetacao_Planejamento_Limpeza: entity?.vegetacao_Planejamento_Limpeza,
				vegetacao_Limpeza_Instalacoes_Responsaveis: entity?.vegetacao_Limpeza_Instalacoes_Responsaveis,
				vegetacao_Planejamento_Inspecao: mergeInspecaoEquipamentosPorFase(
					inspecao,
					FASE_LIMPEZA_EQUIPAMENTOS.AMOSTRAGEM,
					entityAtual?.vegetacao_Planejamento_Inspecao
				) as any,

				vegetacao_Planejamento_Atividades: entity?.vegetacao_Planejamento_Atividades,

				vegetacao_Planejamento_DatasColheita: entity?.vegetacao_Planejamento_DatasColheita,
				vegetacao_Planejamento_PessoasColheita: entity?.vegetacao_Planejamento_PessoasColheita,

				vegetacao_Destruicao: entity?.vegetacao_Destruicao,
				vegetacao_Destruicao_Responsaveis: entity?.vegetacao_Destruicao_Responsaveis,
				vegetacao_Destruicao_Limpeza: entity?.vegetacao_Destruicao_Limpeza,

				vegetacao_Fiscalizacao: entity?.vegetacao_Fiscalizacao,
				vegetacao_Reportes: entity?.vegetacao_Reportes,
				vegetacao_Reportes_Responsaveis: entity?.vegetacao_Reportes_Responsaveis,
				vegetacao_Anotacoes: entity?.vegetacao_Anotacoes,
			}
		}
		// Colheita
		else if (fluxo === 5) {

			const inspecao = expectedInspecao();

			dados =
			{
				id: entity?.id,
				status: entity?.status !== undefined ? entity?.status : 0,
				requisitante: entity?.requisitante !== undefined ? entity?.requisitante : '',
				dataCriacao: entity?.dataCriacao !== undefined ? entity?.dataCriacao : '',

				...obterCamposDadosPrincipaisEntity(entity),

				vegetacao_Documentos: obterDocumentosParaSave(3),
				vegetacao_Documentos_RegistroAmostragem: entity?.vegetacao_Documentos_RegistroAmostragem,

				vegetacao_Planejamento: entity?.vegetacao_Planejamento,
				vegetacao_Planejamento_Conducao: preservarColecaoNoSave(expectedPlanejamentoConducao(), entity?.vegetacao_Planejamento_Conducao) as any,
				vegetacao_Planejamento_DatasPlantio: entity?.vegetacao_Planejamento_DatasPlantio,
				vegetacao_Planejamento_PessoasPlantio: entity?.vegetacao_Planejamento_PessoasPlantio,
				vegetacao_Planejamento_NotificacaoPlantio: entity?.vegetacao_Planejamento_NotificacaoPlantio,
				vegetacao_Planejamento_Limpeza: entity?.vegetacao_Planejamento_Limpeza,
				vegetacao_Limpeza_Instalacoes_Responsaveis: entity?.vegetacao_Limpeza_Instalacoes_Responsaveis,
				vegetacao_Planejamento_Inspecao: mergeInspecaoEquipamentosPorFase(
					inspecao,
					FASE_LIMPEZA_EQUIPAMENTOS.COLHEITA,
					entityAtual?.vegetacao_Planejamento_Inspecao
				) as any,

				vegetacao_Planejamento_Atividades: entity?.vegetacao_Planejamento_Atividades,

				vegetacao_Planejamento_RegistroColheita: preservarColecaoNoSave(expectedRegistroColheita(), entity?.vegetacao_Planejamento_RegistroColheita) as any,

				vegetacao_Destruicao: entity?.vegetacao_Destruicao,
				vegetacao_Destruicao_Responsaveis: entity?.vegetacao_Destruicao_Responsaveis,
				vegetacao_Destruicao_Limpeza: entity?.vegetacao_Destruicao_Limpeza,

				vegetacao_Fiscalizacao: entity?.vegetacao_Fiscalizacao,
				vegetacao_Reportes: entity?.vegetacao_Reportes,
				vegetacao_Reportes_Responsaveis: entity?.vegetacao_Reportes_Responsaveis,
				vegetacao_Anotacoes: entity?.vegetacao_Anotacoes,
			}
		}
		// Limpeza Instalações
		else if (fluxo === 6) {

			const limpeza = expectedLimpeza();
			const limpezaResponsaveis = expectedLimpezaInstalacoesResponsaveis();

			dados =
			{
				id: entity?.id,
				status: entity?.status !== undefined ? entity?.status : 0,
				requisitante: entity?.requisitante !== undefined ? entity?.requisitante : '',
				dataCriacao: entity?.dataCriacao !== undefined ? entity?.dataCriacao : '',

				...obterCamposDadosPrincipaisEntity(entity),

				vegetacao_Documentos: obterDocumentosParaSave(3),
				vegetacao_Documentos_RegistroAmostragem: entity?.vegetacao_Documentos_RegistroAmostragem,

				vegetacao_Planejamento: entity?.vegetacao_Planejamento,
				vegetacao_Planejamento_Conducao: entity?.vegetacao_Planejamento_Conducao,
				vegetacao_Planejamento_DatasPlantio: entity?.vegetacao_Planejamento_DatasPlantio,
				vegetacao_Planejamento_PessoasPlantio: entity?.vegetacao_Planejamento_PessoasPlantio,
				vegetacao_Planejamento_NotificacaoPlantio: entity?.vegetacao_Planejamento_NotificacaoPlantio,
				vegetacao_Planejamento_Limpeza: preservarColecaoNoSave(limpeza, entity?.vegetacao_Planejamento_Limpeza) as any,
				vegetacao_Limpeza_Instalacoes_Responsaveis: preservarColecaoNoSave(limpezaResponsaveis, entity?.vegetacao_Limpeza_Instalacoes_Responsaveis) as any,

				vegetacao_Planejamento_Inspecao: entityAtual?.vegetacao_Planejamento_Inspecao,

				vegetacao_Planejamento_Atividades: entity?.vegetacao_Planejamento_Atividades,

				vegetacao_Planejamento_DatasColheita: entity?.vegetacao_Planejamento_DatasColheita,
				vegetacao_Planejamento_PessoasColheita: entity?.vegetacao_Planejamento_PessoasColheita,

				vegetacao_Destruicao: entity?.vegetacao_Destruicao,
				vegetacao_Destruicao_Responsaveis: entity?.vegetacao_Destruicao_Responsaveis,
				vegetacao_Destruicao_Limpeza: entity?.vegetacao_Destruicao_Limpeza,

				vegetacao_Fiscalizacao: entity?.vegetacao_Fiscalizacao,
				vegetacao_Reportes: entity?.vegetacao_Reportes,
				vegetacao_Reportes_Responsaveis: entity?.vegetacao_Reportes_Responsaveis,
				vegetacao_Anotacoes: entity?.vegetacao_Anotacoes,
			}
		}
		// Destruição e Descarte
		else if (fluxo === 7) {

			const destruicao = expectedDestruicao();
			const inspecao = expectedInspecao();

			dados =
			{
				id: entity?.id,
				status: entity?.status !== undefined ? entity?.status : 0,
				requisitante: entity?.requisitante !== undefined ? entity?.requisitante : '',
				dataCriacao: entity?.dataCriacao !== undefined ? entity?.dataCriacao : '',

				...obterCamposDadosPrincipaisEntity(entity),

				vegetacao_Documentos: obterDocumentosParaSave(3),
				vegetacao_Documentos_RegistroAmostragem: entity?.vegetacao_Documentos_RegistroAmostragem,

				vegetacao_Planejamento: entity?.vegetacao_Planejamento,
				vegetacao_Planejamento_Conducao: entity?.vegetacao_Planejamento_Conducao,
				vegetacao_Planejamento_DatasPlantio: entity?.vegetacao_Planejamento_DatasPlantio,
				vegetacao_Planejamento_PessoasPlantio: entity?.vegetacao_Planejamento_PessoasPlantio,
				vegetacao_Planejamento_NotificacaoPlantio: entity?.vegetacao_Planejamento_NotificacaoPlantio,
				vegetacao_Planejamento_Limpeza: entity?.vegetacao_Planejamento_Limpeza,
				vegetacao_Limpeza_Instalacoes_Responsaveis: entity?.vegetacao_Limpeza_Instalacoes_Responsaveis,
				vegetacao_Planejamento_Inspecao: limpezaEquipamentos
					? mergeInspecaoEquipamentosPorFase(
						inspecao,
						FASE_LIMPEZA_EQUIPAMENTOS.DESCARTE,
						entityAtual?.vegetacao_Planejamento_Inspecao
					) as any
					: entityAtual?.vegetacao_Planejamento_Inspecao,

				vegetacao_Planejamento_Atividades: entity?.vegetacao_Planejamento_Atividades,

				vegetacao_Planejamento_DatasColheita: entity?.vegetacao_Planejamento_DatasColheita,
				vegetacao_Planejamento_PessoasColheita: entity?.vegetacao_Planejamento_PessoasColheita,

				vegetacao_Destruicao: obterDestruicaoParaSave(destruicao) as any,
				vegetacao_Destruicao_Responsaveis: [],
				vegetacao_Destruicao_Limpeza: entity?.vegetacao_Destruicao_Limpeza,

				vegetacao_Fiscalizacao: entity?.vegetacao_Fiscalizacao,
				vegetacao_Reportes: entity?.vegetacao_Reportes,
				vegetacao_Reportes_Responsaveis: entity?.vegetacao_Reportes_Responsaveis,
				vegetacao_Anotacoes: entity?.vegetacao_Anotacoes,
			}
		}
		// Reportes
		else if (fluxo === 8) {

			const fiscalizacao = expectedFiscalizacao();
			const reportes = expectedReportes();
			const reportesResponsaveis = expectedReportesResponsaveis();
			const anotacoes = expectedAnotacoes();

			dados =
			{
				id: entity?.id,
				status: entity?.status !== undefined ? entity?.status : 0,
				requisitante: entity?.requisitante !== undefined ? entity?.requisitante : '',
				dataCriacao: entity?.dataCriacao !== undefined ? entity?.dataCriacao : '',

				...obterCamposDadosPrincipaisEntity(entity),

				vegetacao_Documentos: obterDocumentosParaSave(3),
				vegetacao_Documentos_RegistroAmostragem: entity?.vegetacao_Documentos_RegistroAmostragem,

				vegetacao_Planejamento: entity?.vegetacao_Planejamento,
				vegetacao_Planejamento_Conducao: entity?.vegetacao_Planejamento_Conducao,
				vegetacao_Planejamento_DatasPlantio: entity?.vegetacao_Planejamento_DatasPlantio,
				vegetacao_Planejamento_PessoasPlantio: entity?.vegetacao_Planejamento_PessoasPlantio,
				vegetacao_Planejamento_NotificacaoPlantio: entity?.vegetacao_Planejamento_NotificacaoPlantio,
				vegetacao_Planejamento_Limpeza: entity?.vegetacao_Planejamento_Limpeza,
				vegetacao_Limpeza_Instalacoes_Responsaveis: entity?.vegetacao_Limpeza_Instalacoes_Responsaveis,
				vegetacao_Planejamento_Inspecao: entityAtual?.vegetacao_Planejamento_Inspecao,

				vegetacao_Planejamento_Atividades: entity?.vegetacao_Planejamento_Atividades,

				vegetacao_Planejamento_DatasColheita: entity?.vegetacao_Planejamento_DatasColheita,
				vegetacao_Planejamento_PessoasColheita: entity?.vegetacao_Planejamento_PessoasColheita,

				vegetacao_Destruicao: entity?.vegetacao_Destruicao,
				vegetacao_Destruicao_Responsaveis: entity?.vegetacao_Destruicao_Responsaveis,
				vegetacao_Destruicao_Limpeza: entity?.vegetacao_Destruicao_Limpeza,

				vegetacao_Fiscalizacao: preservarColecaoNoSave(fiscalizacao, entity?.vegetacao_Fiscalizacao) as any,
				vegetacao_Reportes: preservarColecaoNoSave(reportes, entity?.vegetacao_Reportes) as any,
				vegetacao_Reportes_Responsaveis: preservarColecaoNoSave(reportesResponsaveis, entity?.vegetacao_Reportes_Responsaveis) as any,
				vegetacao_Anotacoes: preservarColecaoNoSave(anotacoes, entity?.vegetacao_Anotacoes) as any,
			}
		}

		if (isCorrection) {
			observacoes = reasonCorrection;
			aprovador = decoded.unique_name;
		}

		if (isApprove) {
			aprovador = decoded.unique_name;
			dataDaAprovacao = moment().toDate();
		}

		dados.dataConclusao = '';
		dados.nomeAprovador = aprovador !== undefined ? aprovador : '';
		dados.dataAprovacao = dataDaAprovacao !== undefined ? dataDaAprovacao : '';
		dados.observacoesAnaliseRegulatorio = observacoes !== undefined ? observacoes : '';

		if (fluxo === 4) {
			dados.vegetacao_Documentos_RegistroAmostragem = expectedRegistroAmostragem() as any;
		} else if (dados.vegetacao_Documentos_RegistroAmostragem === undefined) {
			dados.vegetacao_Documentos_RegistroAmostragem = entity?.vegetacao_Documentos_RegistroAmostragem;
		}

		if (fluxo === 5) {
			dados.vegetacao_Planejamento_RegistroColheita = preservarColecaoNoSave(expectedRegistroColheita(), entity?.vegetacao_Planejamento_RegistroColheita) as any;
		} else if (dados.vegetacao_Planejamento_RegistroColheita === undefined) {
			dados.vegetacao_Planejamento_RegistroColheita = entity?.vegetacao_Planejamento_RegistroColheita;
		}

		dados = {
			...dados,
			...obterCamposDadosPrincipaisEntity({ ...entity, ...dados }),
		};

		dados = aplicarEstadoLocalArquivosNoPayload(dados);

		setEntity(dados);

		return dados;

	};

	const mapearInspecaoEquipamentos = (fonte: any): Planejamento_InspecaoOnEditVegetacao[] => {
		if (!fonte?.vegetacao_Planejamento_Inspecao?.length) {
			return [];
		}

		let newPlanejamentoInspecao: Planejamento_InspecaoOnEditVegetacao[] = [];
		const inspecoes = fonte.vegetacao_Planejamento_Inspecao;

		for (let n = 0, t = inspecoes.length; n < t; n++) {
			const item = inspecoes[n];
			if (!item) continue;

			const faseId = obterFaseLimpezaIdInspecao(item);
			const metodoLimpezaId = obterValorNumericoId(item.metodoLimpeza_Id ?? item.MetodoLimpeza_Id ?? item.metodoLimpezaEquipamento_Id);

			let metodoLimpezaEquipamentoEnum = enumMetodoLimpezaEquipamento.filter((e: any) => Number(e.key) === Number(metodoLimpezaId));
			let faseLimpezaEquipamentoEnum = enumTipoFaseLimpezaEquipamentos.filter((e: any) => Number(e.key) === Number(faseId));

			let Responsaveis: ResponsavelEquipamentos[] = [];
			let listaResponsaveisEquipamentos: string = "";

			const responsaveisFonte = item.responsaveis ?? item.Responsaveis ?? [];
			if (responsaveisFonte.length) {
				for (let i = 0, j = responsaveisFonte.length; i < j; i++) {
					const resp = responsaveisFonte[i];
					let responsavel: ResponsavelEquipamentos =
					{
						id: resp.id ?? resp.Id ?? 0,
						responsavel: resp.responsavel ?? resp.Responsavel ?? '',
						contagem: i + 1,
					}

					listaResponsaveisEquipamentos += responsavel.responsavel + "; ";

					Responsaveis.push(responsavel);
				}
			}

			let MetodosLimpeza: MetodoLimpezaEquipamentos[] = [];
			let listaMetodosLimpezaEquipamentos: string = "";

			const metodosFonte = item.metodosLimpeza ?? item.MetodosLimpeza ?? [];
			if (metodosFonte.length) {
				for (let i = 0, j = metodosFonte.length; i < j; i++) {
					const met = metodosFonte[i];
					let metodoLimpeza: MetodoLimpezaEquipamentos =
					{
						id: met.id ?? met.Id ?? 0,
						descricao: met.descricao ?? met.Descricao ?? '',
						contagem: i + 1,
					}

					listaMetodosLimpezaEquipamentos += metodoLimpeza.descricao + "; ";

					MetodosLimpeza.push(metodoLimpeza);
				}
			}

			let planejamentoInspecao: Planejamento_InspecaoOnEditVegetacao = {
				id: item.id ?? item.Id ?? 0,
				numeroPlantio: item.numeroPlantio,
				iD_Equipamento: item.iD_Equipamento,
				dataAntesUso: item.dataAntesUso !== undefined ? moment(item.dataAntesUso).toDate() : null,
				dataAposUso: item.dataAposUso !== undefined ? moment(item.dataAposUso).toDate() : null,
				faseEnsaio: item.faseEnsaio,
				metodoLimpezaEquipamento_Id: {
					label: metodoLimpezaEquipamentoEnum.length > 0 ? metodoLimpezaEquipamentoEnum[0].value : '',
					value: metodoLimpezaId,
				},
				outrosMetodoLimpezaEquipamento: item.outrosMetodoLimpeza ?? item.OutrosMetodoLimpeza,
				faseLimpeza_Id: {
					label: faseLimpezaEquipamentoEnum.length > 0 ? faseLimpezaEquipamentoEnum[0].value : '',
					value: faseId,
				},
				contagemInspecaoEquipamento: n + 1,

				responsaveis: Responsaveis,
				listaResponsaveis: listaResponsaveisEquipamentos,
				metodosLimpeza: MetodosLimpeza,
				listaMetodosLimpeza: listaMetodosLimpezaEquipamentos,

			};

			newPlanejamentoInspecao.push(planejamentoInspecao);
		}

		return newPlanejamentoInspecao;
	};

	const carregarInspecaoEquipamentosPorFase = (fonte: any, faseId: number) => {
		setSelectedInspecaoEquipamentos([]);

		const filtrados = ordenarPorDataAsc(
			filtrarInspecaoEquipamentosPorFase(mapearInspecaoEquipamentos(fonte), faseId),
			'dataAntesUso',
			'contagemInspecaoEquipamento',
		);

		setSelectedInspecaoEquipamentos(filtrados);
	};

	const obterColecaoItem = (item: any, camelKey: string, pascalKey: string) =>
		item?.[camelKey] ?? item?.[pascalKey] ?? [];

	const montarResponsaveisDestruicao = (
		fonte: any[],
	): { responsaveis: ResponsavelDestruicao[]; lista: string } => {
		const responsaveis: ResponsavelDestruicao[] = [];
		let lista = '';

		for (let i = 0, j = fonte.length; i < j; i++) {
			const responsavel: ResponsavelDestruicao = {
				id: fonte[i].id ?? fonte[i].Id ?? 0,
				responsavel: fonte[i].responsavel ?? fonte[i].Responsavel ?? '',
				contagem: i + 1,
			};

			lista += responsavel.responsavel + '; ';
			responsaveis.push(responsavel);
		}

		return { responsaveis, lista };
	};

	const setarDados = (modoFluxo: any, dadosFonte?: any) => {
		const fonte = dadosFonte ?? entity;

		// Dados Principais e Documentos
		if (modoFluxo === 1) {

			setLimpezaEquipamentos(false);
			setSelectedInspecaoEquipamentos([]);

			// Dados Principais
			aplicarDadosPrincipaisNoForm(fonte);

			aplicarDocumentosNoForm(fonte);

			// vegetacao_Documentos_PastaProcesso
			
			if (entity?.vegetacao_Documentos_PastaProcesso?.length) {
				setDocumentosGerais(entity.vegetacao_Documentos_PastaProcesso);
			}
		}
		// Plantio (Planejamento e Condução)
		else if (modoFluxo === 2) {
			const origem = fonte ?? entity;

			setTipoFaseLimpezaEquipamentosValue(FASE_LIMPEZA_EQUIPAMENTOS.PLANTIO);
			setLimpezaEquipamentos(true);
			carregarInspecaoEquipamentosPorFase(fonte, FASE_LIMPEZA_EQUIPAMENTOS.PLANTIO);

			carregarEstadoPlanejamentoPlantio(origem);

			// vegetacao_Planejamento_DatasColheita
			
			if (entity?.vegetacao_Planejamento_DatasColheita?.length) {

				let newDataColheita: Planejamento_DatasColheitaOnEditVegetacao[] = [];

				for (let n = 0, t = entity?.vegetacao_Planejamento_DatasColheita?.length; n < t; n++) {

					let dataColheita: Planejamento_DatasColheitaOnEditVegetacao = {
						id: entity.vegetacao_Planejamento_DatasColheita[n].id,
						dataColheita: entity.vegetacao_Planejamento_DatasColheita[n].dataColheita !== undefined ? moment(entity.vegetacao_Planejamento_DatasColheita[n].dataColheita).toDate() : null,
						dataInicialColheita: entity.vegetacao_Planejamento_DatasColheita[n].dataInicialColheita !== undefined ? moment(entity.vegetacao_Planejamento_DatasColheita[n].dataInicialColheita).toDate() : null,
						dataFinalColheita: entity.vegetacao_Planejamento_DatasColheita[n].dataFinalColheita !== undefined ? moment(entity.vegetacao_Planejamento_DatasColheita[n].dataFinalColheita).toDate() : null,
					};

					newDataColheita.push(dataColheita);
				}

				setSelectedDatasColheita(newDataColheita);
			}


			// vegetacao_Planejamento_PessoasColheita
			
			if (entity?.vegetacao_Planejamento_PessoasColheita?.length) {

				let newPessoasColheita: Planejamento_PessoasColheitaOnEditVegetacao[] = [];

				for (let n = 0, t = entity?.vegetacao_Planejamento_PessoasColheita?.length; n < t; n++) {

					let pessoaColheita: Planejamento_PessoasColheitaOnEditVegetacao = {
						id: entity.vegetacao_Planejamento_PessoasColheita[n].id,
						pessoaColheita: entity.vegetacao_Planejamento_PessoasColheita[n].pessoaColheita !== undefined ? entity.vegetacao_Planejamento_PessoasColheita[n].pessoaColheita : null,
						contagemPessoasEnvolvidasColheita: n + 1,
					};

					newPessoasColheita.push(pessoaColheita);
				}

				setSelectedPessoasEnvolvidasColheita(newPessoasColheita);
			}


			// vegetacao_Planejamento_AMI
			
			if (entity?.vegetacao_Planejamento_AMI?.length) {
				setNumeroAMI(entity.vegetacao_Planejamento_AMI);
			}

			// vegetacao_Planejamento_AAC
			
			if (entity?.vegetacao_Planejamento_AAC?.length) {
				setNumeroAAC(entity.vegetacao_Planejamento_AAC);
			}

			// Documento Croqui
						// vegetacao_Documentos
			if (entity?.vegetacao_Documentos?.length) {
				defaultForm.setValue('croquiExperimental', entity?.vegetacao_Documentos[0].croquiExperimental);
				defaultForm.setValue('observacoesCroquiExperimental', entity?.vegetacao_Documentos[0].observacoesCroquiExperimental);
			}

		}
		// Manutençao
		else if (modoFluxo === 3) {
			setTipoFaseLimpezaEquipamentosValue(FASE_LIMPEZA_EQUIPAMENTOS.MANUTENCAO);
			setLimpezaEquipamentos(true);
			carregarInspecaoEquipamentosPorFase(fonte, FASE_LIMPEZA_EQUIPAMENTOS.MANUTENCAO);

			
			if (entity?.vegetacao_Planejamento_Atividades?.length) {

				let newPlanejamentoAtividades: Planejamento_AtividadesOnEditVegetacao[] = [];

				for (let n = 0, t = entity?.vegetacao_Planejamento_Atividades?.length; n < t; n++) {

					// Atividades
					let atividadeManutencaoEnum = enumAtividadesManutencao.filter((e: any) => Number(e.key) === (entity?.vegetacao_Planejamento_Atividades !== undefined ? entity.vegetacao_Planejamento_Atividades[n].atividadeManutencao_Id : 0));

					let Responsaveis: ResponsavelAtividade[] = [];
					let listaResponsaveisAtividade: string = "";

					if (obterColecaoItem(entity.vegetacao_Planejamento_Atividades[n], 'responsaveis', 'Responsaveis').length) {
						const responsaveisFonte = obterColecaoItem(entity.vegetacao_Planejamento_Atividades[n], 'responsaveis', 'Responsaveis');
						for (let i = 0, j = responsaveisFonte.length; i < j; i++) {
							let responsavel: ResponsavelAtividade =
							{
								id: responsaveisFonte[i].id ?? responsaveisFonte[i].Id ?? 0,
								responsavel: responsaveisFonte[i].responsavel ?? responsaveisFonte[i].Responsavel ?? '',
								contagem: i + 1,
							}

							listaResponsaveisAtividade += responsavel.responsavel + "; ";

							Responsaveis.push(responsavel);
						}
					}

					let MetodosLimpeza: MetodoLimpezaManutencao[] = [];
					let listaMetodosLimpezaAtividade: string = "";

					if (obterColecaoItem(entity.vegetacao_Planejamento_Atividades[n], 'metodosLimpeza', 'MetodosLimpeza').length) {
						const metodosFonte = obterColecaoItem(entity.vegetacao_Planejamento_Atividades[n], 'metodosLimpeza', 'MetodosLimpeza');
						for (let i = 0, j = metodosFonte.length; i < j; i++) {
							let metodoLimpeza: MetodoLimpezaManutencao =
							{
								id: metodosFonte[i].id ?? metodosFonte[i].Id ?? 0,
								descricao: metodosFonte[i].descricao ?? metodosFonte[i].Descricao ?? '',
								contagem: i + 1,
							}

							listaMetodosLimpezaAtividade += metodoLimpeza.descricao + "; ";

							MetodosLimpeza.push(metodoLimpeza);
						}
					}

					let planejamentoAtividades: Planejamento_AtividadesOnEditVegetacao = {
						id: entity.vegetacao_Planejamento_Atividades[n].id,
						dataAtividade: entity.vegetacao_Planejamento_Atividades[n].dataAtividade !== undefined ? moment(entity.vegetacao_Planejamento_Atividades[n].dataAtividade).toDate() : null,
						dataInicialAtividade: entity.vegetacao_Planejamento_Atividades[n].dataInicialAtividade !== undefined ? moment(entity.vegetacao_Planejamento_Atividades[n].dataInicialAtividade).toDate() : null,
						dataFinalAtividade: entity.vegetacao_Planejamento_Atividades[n].dataFinalAtividade !== undefined ? moment(entity.vegetacao_Planejamento_Atividades[n].dataFinalAtividade).toDate() : null,
						responsavel: entity.vegetacao_Planejamento_Atividades[n].responsavel,
						atividadeManutencao_Id: {
							label: atividadeManutencaoEnum.length > 0 ? atividadeManutencaoEnum[0].value : '',
							value: entity.vegetacao_Planejamento_Atividades[n].atividadeManutencao_Id,
						},
						outrosAtividadeManutencao: entity.vegetacao_Planejamento_Atividades[n].outrosAtividadeManutencao,
						contagemAtividadeManutencao: n + 1,

						responsaveis: Responsaveis,
						listaResponsaveis: listaResponsaveisAtividade,
						metodosLimpeza: MetodosLimpeza,
						listaMetodosLimpeza: listaMetodosLimpezaAtividade,
					};


					newPlanejamentoAtividades.push(planejamentoAtividades);
				}

				setSelectedAtividadeManutencao(ordenarPorDataAsc(newPlanejamentoAtividades, 'dataInicialAtividade', 'contagemAtividadeManutencao'));
			}

		}
		// Amostragem
		else if (modoFluxo === 4) {
			setTipoFaseLimpezaEquipamentosValue(FASE_LIMPEZA_EQUIPAMENTOS.AMOSTRAGEM);
			setLimpezaEquipamentos(true);
			carregarInspecaoEquipamentosPorFase(fonte, FASE_LIMPEZA_EQUIPAMENTOS.AMOSTRAGEM);

			
			if (entity?.vegetacao_Documentos_RegistroAmostragem?.length) {

				let newRegistroAmostragem: Documentos_RegistroAmostragemOnEditVegetacao[] = [];

				for (let n = 0, t = entity?.vegetacao_Documentos_RegistroAmostragem?.length; n < t; n++) {

					let Responsaveis: ResponsavelAmostragem[] = [];
					let listaResponsaveisAmostragem: string = "";

					if (entity.vegetacao_Documentos_RegistroAmostragem[n].responsaveis !== undefined) {
						for (let i = 0, j = entity.vegetacao_Documentos_RegistroAmostragem[n].responsaveis?.length; i < j; i++) {
							let responsavel: ResponsavelAmostragem =
							{
								id: entity.vegetacao_Documentos_RegistroAmostragem[n].responsaveis[i].id,
								responsavel: entity.vegetacao_Documentos_RegistroAmostragem[n].responsaveis[i].responsavel,
								contagem: i + 1,
							}

							listaResponsaveisAmostragem += responsavel.responsavel + "; ";

							Responsaveis.push(responsavel);
						}
					}

					if (entity.vegetacao_Documentos_RegistroAmostragem[n].filename !== null) {
						// tipoMaterialAmostragem
						let tipoMaterialAmostragemEnum = enumTipoMaterialAmostragem.filter((e: any) => Number(e.key) === (entity.vegetacao_Documentos_RegistroAmostragem !== undefined ? entity.vegetacao_Documentos_RegistroAmostragem[n].tipoMaterial_Id : 0));

						// Destino Amostras
						let destinoAmostrasEnum = enumDestinoAmostras.filter((e: any) => Number(e.key) === (entity.vegetacao_Documentos_RegistroAmostragem !== undefined ? entity.vegetacao_Documentos_RegistroAmostragem[n].destino : 0));

						let registroAmostragem: Documentos_RegistroAmostragemOnEditVegetacao = {
							id: entity.vegetacao_Documentos_RegistroAmostragem[n].id,
							dataInicialAmostragem: entity.vegetacao_Documentos_RegistroAmostragem[n].dataInicial !== undefined ? moment(entity.vegetacao_Documentos_RegistroAmostragem[n].dataInicial).toDate() : null,
							dataFinalAmostragem: entity.vegetacao_Documentos_RegistroAmostragem[n].dataFinal !== undefined ? moment(entity.vegetacao_Documentos_RegistroAmostragem[n].dataFinal).toDate() : null,
							tipoMaterialAmostragem: {
								label: tipoMaterialAmostragemEnum.length > 0 ? tipoMaterialAmostragemEnum[0].value : '',
								value: entity.vegetacao_Documentos_RegistroAmostragem[n].tipoMaterial_Id,
							},
							tipoMaterialAmostragemOutros: entity.vegetacao_Documentos_RegistroAmostragem[n].outrosTipoMaterial !== undefined ? entity.vegetacao_Documentos_RegistroAmostragem[n].outrosTipoMaterial : null,
							responsavelAmostragem: entity.vegetacao_Documentos_RegistroAmostragem[n].responsavel,
							destinoAmostras: {
								label: destinoAmostrasEnum.length > 0 ? destinoAmostrasEnum[0].value : '',
								value: entity.vegetacao_Documentos_RegistroAmostragem[n].destino,
							},

							destinoAmostrasOutros: entity.vegetacao_Documentos_RegistroAmostragem[n].outrosDestino,
							arquivoAmostragem: entity.vegetacao_Documentos_RegistroAmostragem[n].filename
								?? entity.vegetacao_Documentos_RegistroAmostragem[n].Filename
								?? entity.vegetacao_Documentos_RegistroAmostragem[n].arquivoAmostragem
								?? '',
							filename: entity.vegetacao_Documentos_RegistroAmostragem[n].filename
								?? entity.vegetacao_Documentos_RegistroAmostragem[n].Filename
								?? '',
							path: entity.vegetacao_Documentos_RegistroAmostragem[n].path ?? entity.vegetacao_Documentos_RegistroAmostragem[n].Path,
							codigo: entity.vegetacao_Documentos_RegistroAmostragem[n].codigo ?? entity.vegetacao_Documentos_RegistroAmostragem[n].Codigo,
							contagemRegistroAmostragem: n + 1,

							responsaveis: Responsaveis,
							listaResponsaveis: listaResponsaveisAmostragem,
						};

						newRegistroAmostragem.push(registroAmostragem);
					}
				}

				setSelectedRegistroAmostragem(ordenarPorDataAsc(newRegistroAmostragem, 'dataInicialAmostragem', 'contagemRegistroAmostragem'));
			}

		}
		// Colheita
		else if (modoFluxo === 5) {
			setLimpezaEquipamentos(true);
			setTipoFaseLimpezaEquipamentosValue(FASE_LIMPEZA_EQUIPAMENTOS.COLHEITA);
			carregarInspecaoEquipamentosPorFase(fonte, FASE_LIMPEZA_EQUIPAMENTOS.COLHEITA);
			aplicarCamposColheitaConducaoNoForm(fonte ?? entity);
			carregarRegistroColheitaDaEntity(fonte ?? entity);
		}
		// Limpeza Instalações
		else if (modoFluxo === 6) {
			setLimpezaEquipamentos(false);
			setSelectedInspecaoEquipamentos([]);

			// vegetacao_Planejamento_Limpeza
			
			if (entity?.vegetacao_Planejamento_Limpeza?.length) {

				let newPlanejamentoLimpeza: Planejamento_LimpezaOnEditVegetacao[] = [];

				for (let n = 0, t = entity?.vegetacao_Planejamento_Limpeza?.length; n < t; n++) {

					// Método de Limpeza
					let metodoLimpezaEnum = enumMetodoLimpeza.filter((e: any) => Number(e.key) === (entity?.vegetacao_Planejamento_Limpeza !== undefined ? entity.vegetacao_Planejamento_Limpeza[n].metodoLimpeza_Id : 0));
					// Fase de Limpeza
					let faseLimpezaEnum = enumTipoFaseLimpezaInstalacoes.filter((e: any) => Number(e.key) === (entity?.vegetacao_Planejamento_Limpeza !== undefined ? entity.vegetacao_Planejamento_Limpeza[n].tipoFaseLimpeza_Id : 0));

					let Responsaveis: ResponsavelInstalacao[] = [];
					let listaResponsaveisInstalacao: string = "";

					if (entity.vegetacao_Planejamento_Limpeza[n].responsaveis !== undefined) {
						for (let i = 0, j = entity.vegetacao_Planejamento_Limpeza[n].responsaveis?.length; i < j; i++) {
							let responsavel: ResponsavelInstalacao =
							{
								id: entity.vegetacao_Planejamento_Limpeza[n].responsaveis[i].id,
								responsavel: entity.vegetacao_Planejamento_Limpeza[n].responsaveis[i].responsavel,
								contagem: i + 1,
							}

							listaResponsaveisInstalacao += responsavel.responsavel + "; ";

							Responsaveis.push(responsavel);
						}
					}

					let MetodosLimpeza: MetodoLimpezaInstalacao[] = [];
					let listaMetodosLimpezaInstalacao: string = "";

					if (entity.vegetacao_Planejamento_Limpeza[n].metodosLimpeza !== undefined) {
						for (let i = 0, j = entity.vegetacao_Planejamento_Limpeza[n].metodosLimpeza?.length; i < j; i++) {
							let metodoLimpeza: MetodoLimpezaInstalacao =
							{
								id: entity.vegetacao_Planejamento_Limpeza[n].metodosLimpeza[i].id,
								descricao: entity.vegetacao_Planejamento_Limpeza[n].metodosLimpeza[i].descricao,
								contagem: i + 1,
							}

							listaMetodosLimpezaInstalacao += metodoLimpeza.descricao + "; ";

							MetodosLimpeza.push(metodoLimpeza);
						}
					}

					let planejamentoLimpeza: Planejamento_LimpezaOnEditVegetacao = {
						id: entity.vegetacao_Planejamento_Limpeza[n].id,
						dataLimpeza: entity.vegetacao_Planejamento_Limpeza[n].dataLimpeza !== undefined ? moment(entity.vegetacao_Planejamento_Limpeza[n].dataLimpeza).toDate() : null,
						numeroCodigoCasaVegetacao: entity.vegetacao_Planejamento_Limpeza[n].numeroCodigoCasaVegetacao,
						responsavel: entity.vegetacao_Planejamento_Limpeza[n].responsavel,
						metodoLimpeza_Id: {
							label: metodoLimpezaEnum.length > 0 ? metodoLimpezaEnum[0].value : '',
							value: entity.vegetacao_Planejamento_Limpeza[n].metodoLimpeza_Id,
						},
						outrosMetodoLimpeza: entity.vegetacao_Planejamento_Limpeza[n].outrosMetodoLimpeza,
						dataInicialLimpeza: entity.vegetacao_Planejamento_Limpeza[n].dataInicialLimpeza !== undefined ? moment(entity.vegetacao_Planejamento_Limpeza[n].dataInicialLimpeza).toDate() : null,
						dataFinalLimpeza: entity.vegetacao_Planejamento_Limpeza[n].dataFinalLimpeza !== undefined ? moment(entity.vegetacao_Planejamento_Limpeza[n].dataFinalLimpeza).toDate() : null,
						tipoFaseLimpeza_Id: {
							label: faseLimpezaEnum.length > 0 ? faseLimpezaEnum[0].value : '',
							value: entity.vegetacao_Planejamento_Limpeza[n].tipoFaseLimpeza_Id,
						},
						outrosTipoFaseLimpeza: entity.vegetacao_Planejamento_Limpeza[n].outrosTipoFaseLimpeza,
						observacoesLimpeza: entity.vegetacao_Planejamento_Limpeza[n].observacoesLimpeza,
						contagemLimpezaInstalacao: n + 1,

						responsaveis: Responsaveis,
						listaResponsaveis: listaResponsaveisInstalacao,
						metodosLimpeza: MetodosLimpeza,
						listaMetodosLimpeza: listaMetodosLimpezaInstalacao,

					};

					newPlanejamentoLimpeza.push(planejamentoLimpeza);
				}

				setSelectedLimpezaInstalacoes(ordenarPorDataAsc(newPlanejamentoLimpeza, 'dataInicialLimpeza', 'contagemLimpezaInstalacao'));
			}


			//// vegetacao_Limpeza_Instalacoes_Responsaveis
			//setTimeout(() => {

			//	if (entity?.vegetacao_Limpeza_Instalacoes_Responsaveis?.length) {

			//		let newResponsaveis: Responsavel[] = [];

			//		for (let n = 0, t = entity?.vegetacao_Limpeza_Instalacoes_Responsaveis?.length; n < t; n++) {

			//			let responsavelLimpeza: Responsavel = {
			//				id: entity.vegetacao_Limpeza_Instalacoes_Responsaveis[n].id,
			//				nome: entity.vegetacao_Limpeza_Instalacoes_Responsaveis[n].nomeResponsavelLimpezaInstalacoes,
			//				contagem: n+1,
			//			};

			//			newResponsaveis.push(responsavelLimpeza);
			//		}

			//		setResponsaveisLimpezaInstalacoes(newResponsaveis);
			//	}

			//}, 1500);

		}
		// Destruição e Descarte
		else if (modoFluxo === 7) {
			setLimpezaEquipamentos(false);

			const listaDestruicao = fonte?.vegetacao_Destruicao ?? [];

			if (listaDestruicao.length) {
				let newDestruicao: DestruicaoOnEditVegetacao[] = [];

				for (let n = 0, t = listaDestruicao.length; n < t; n++) {
					const destruicaoEntity = listaDestruicao[n];

					let responsaveisFonte = obterColecaoItem(destruicaoEntity, 'responsaveisDestruicao', 'ResponsaveisDestruicao');
					if (!responsaveisFonte.length && n === 0 && fonte?.vegetacao_Destruicao_Responsaveis?.length) {
						responsaveisFonte = fonte.vegetacao_Destruicao_Responsaveis;
					}

					const { responsaveis: Responsaveis, lista: listaResponsaveisDestruicao } = montarResponsaveisDestruicao(responsaveisFonte);

					let MetodosDestruicao: MetodoDestruicao[] = [];
					let listaMetodosDestruicao: string = "";

					const metodosFonte = obterColecaoItem(destruicaoEntity, 'metodosDestruicao', 'MetodosDestruicao');
					if (metodosFonte.length) {
						for (let i = 0, j = metodosFonte.length; i < j; i++) {
							const metodoDestruicao: MetodoDestruicao = {
								id: metodosFonte[i].id ?? metodosFonte[i].Id ?? 0,
								descricao: metodosFonte[i].descricao ?? metodosFonte[i].Descricao ?? '',
								contagem: i + 1,
							};

							listaMetodosDestruicao += metodoDestruicao.descricao + "; ";
							MetodosDestruicao.push(metodoDestruicao);
						}
					}

					let LimpezaDestruicao: ExpectedDestruicaoLimpeza[] = [];

					const limpezaFonte = obterColecaoItem(destruicaoEntity, 'limpezaDestruicao', 'LimpezaDestruicao');
					if (limpezaFonte.length) {
						for (let i = 0, j = limpezaFonte.length; i < j; i++) {
							const limpeza = limpezaFonte[i];
							LimpezaDestruicao.push({
								id: limpeza.id ?? limpeza.Id ?? 0,
								contagemLimpezaDestruicao: i + 1,
								descricaoMaquinario: limpeza.descricaoMaquinario,
								dataLimpezaAntesUso: limpeza.dataLimpezaAntesUso ? moment(limpeza.dataLimpezaAntesUso).toDate() : null,
								dataLimpezaDepoisUso: limpeza.dataLimpezaDepoisUso ? moment(limpeza.dataLimpezaDepoisUso).toDate() : null,
								responsavelLimpeza: limpeza.responsavelLimpeza,
								metodoLimpeza: limpeza.metodoLimpeza,
								metodoLimpeza_Id: limpeza.metodoLimpeza_Id,
								outrosMetodoLimpeza: limpeza.outrosMetodoLimpeza,
							});
						}
					}

					let destruicao: DestruicaoOnEditVegetacao = {
						id: destruicaoEntity.id,
						contagemDestruicao: n + 1,
						tipoDestruicao: destruicaoEntity.tipoDestruicao,
						outrosTipoDestruicao: destruicaoEntity.outrosTipoDestruicao,
						numeroAmostras: destruicaoEntity.numeroAmostras,
						pesoAmostras: destruicaoEntity.pesoAmostras,
						unidadeMedida: destruicaoEntity.unidadeMedida,
						localDestruicao: destruicaoEntity.localDestruicao,
						outrosLocalDestruicao: destruicaoEntity.outrosLocalDestruicao,
						observacoesLocalDestruicao: destruicaoEntity.observacoesLocalDestruicao,
						metodoDestruicao: destruicaoEntity.metodoDestruicao,
						outrosMetodoDestruicao: destruicaoEntity.outrosMetodoDestruicao,
						observacoesMetodoDestruicao: destruicaoEntity.observacoesMetodoDestruicao,
						dataInicialDestruicao: destruicaoEntity.dataInicialDestruicao !== undefined ? moment(destruicaoEntity.dataInicialDestruicao).toDate() : null,
						dataFinalDestruicao: destruicaoEntity.dataFinalDestruicao !== undefined ? moment(destruicaoEntity.dataFinalDestruicao).toDate() : null,
						tipoFaseDestruicao_Id: destruicaoEntity.tipoFaseDestruicao_Id,
						outrosTipoFaseDestruicao: destruicaoEntity.outrosTipoFaseDestruicao,

						responsaveisDestruicao: Responsaveis,
						listaResponsaveisDestruicao: listaResponsaveisDestruicao,
						metodosDestruicao: MetodosDestruicao,
						listaMetodosDestruicao: listaMetodosDestruicao,
						limpezaDestruicao: ordenarPorDataAsc(LimpezaDestruicao, 'dataLimpezaAntesUso', 'contagemLimpezaDestruicao'),
					}

					newDestruicao.push(destruicao);
				}

				setSelectedDestruicao(ordenarPorDataAsc(newDestruicao, 'dataInicialDestruicao', 'contagemDestruicao'));
			} else {
				setSelectedDestruicao([]);
			}

			destruicaoGradeHidratada.current = true;


			//	// vegetacao_Destruicao_Limpeza
			//	setTimeout(() => {

			//		if (entity?.vegetacao_Destruicao_Limpeza?.length) {

			//			let newDestruicaoLimpeza: Destruicao_LimpezaOnEditVegetacao[] = [];

			//			for (let n = 0, t = entity?.vegetacao_Destruicao_Limpeza?.length; n < t; n++) {

			//				// Atividades
			//				let metodoDestruicaoEnum = enumMetodoDescarte.filter((e: any) => Number(e.key) === (entity.vegetacao_Destruicao_Limpeza !== undefined ? entity.vegetacao_Destruicao_Limpeza[n].metodoLimpeza_Id : 0));

			//				let destruicaoLimpeza: Destruicao_LimpezaOnEditVegetacao = {
			//					id: entity.vegetacao_Destruicao_Limpeza[n].id,
			//					descricaoMaquinario: entity.vegetacao_Destruicao_Limpeza[n].descricaoMaquinario,
			//					dataLimpezaAntesUso: entity.vegetacao_Destruicao_Limpeza[n].dataLimpezaAntesUso !== null ? moment(entity.vegetacao_Destruicao_Limpeza[n].dataLimpezaAntesUso).toDate() : null,
			//					dataLimpezaDepoisUso: entity.vegetacao_Destruicao_Limpeza[n].dataLimpezaDepoisUso !== null ? moment(entity.vegetacao_Destruicao_Limpeza[n].dataLimpezaDepoisUso).toDate() : null,
			//					responsavelLimpeza: entity.vegetacao_Destruicao_Limpeza[n].responsavelLimpeza,
			//					metodoLimpeza: {
			//						label: metodoDestruicaoEnum.length > 0 ? metodoDestruicaoEnum[n].value : '',
			//						value: entity.vegetacao_Destruicao_Limpeza[n].metodoLimpeza_Id,
			//					},
			//					outrosMetodoLimpeza: entity.vegetacao_Destruicao_Limpeza[n].outrosMetodoLimpeza,
			//					contagemLimpezaDestruicao: n + 1,
			//				};

			//				newDestruicaoLimpeza.push(destruicaoLimpeza);
			//			}

			//			setSelectedLimpezaDestruicao(newDestruicaoLimpeza);
			//		}

			//	}, 1500);
		}
		// Fiscalização, Reportes, Anotações
		else if (modoFluxo === 8) {
			setLimpezaEquipamentos(false);
			setSelectedInspecaoEquipamentos([]);
			carregarRegistroFiscalizacaoDaEntity(fonte ?? entity);

			// vegetacao_Reportes
			
			if (entity?.vegetacao_Reportes?.length) {
				defaultForm.setValue('liberacaoNaoIntencional', entity?.vegetacao_Reportes[0].liberacaoNaoIntencional);
				defaultForm.setValue('dataLiberacaoNaoIntencional', entity.vegetacao_Reportes[0].dataLiberacaoNaoIntencional !== undefined ? moment(entity.vegetacao_Reportes[0].dataLiberacaoNaoIntencional).toDate() : null);
				defaultForm.setValue('medidasCorrecaoLiberacaoNaoIntencional', entity?.vegetacao_Reportes[0].medidasCorrecaoLiberacaoNaoIntencional);
				defaultForm.setValue('nomeReporteLiberacaoNaoIntencional', entity?.vegetacao_Reportes[0].nomeReporteLiberacaoNaoIntencional);
				defaultForm.setValue('cargoReporteLiberacaoNaoIntencional', entity?.vegetacao_Reportes[0].cargoReporteLiberacaoNaoIntencional);
				defaultForm.setValue('dataReporteLiberacaoNaoIntencional', entity?.vegetacao_Reportes[0].dataReporteLiberacaoNaoIntencional !== undefined ? moment(entity?.vegetacao_Reportes[0].dataReporteLiberacaoNaoIntencional).toDate() : null);
			}

			// vegetacao_Reportes_Responsaveis
			
			if (entity?.vegetacao_Reportes_Responsaveis?.length) {

				let newReportesResponsaveis: ResponsaveisReportesOnEditVegetacao[] = [];

				for (let n = 0, t = entity?.vegetacao_Reportes_Responsaveis?.length; n < t; n++) {
					let ReportesResponsaveis: ResponsaveisReportesOnEditVegetacao = {
						id: entity.vegetacao_Reportes_Responsaveis[n].id,
						nomeReporteLiberacaoNaoIntencional: entity.vegetacao_Reportes_Responsaveis[n].nomeReporteLiberacaoNaoIntencional,
						cargoReporteLiberacaoNaoIntencional: entity.vegetacao_Reportes_Responsaveis[n].cargoReporteLiberacaoNaoIntencional,
						dataReporteLiberacaoNaoIntencional: entity.vegetacao_Reportes_Responsaveis[n].dataReporteLiberacaoNaoIntencional,
						contagemReporteLiberacaoNaoIntencional: n + 1,
					};

					newReportesResponsaveis.push(ReportesResponsaveis);
				}

				setResponsaveisReporte(newReportesResponsaveis);
			}



			// vegetacao_Anotacoes
			
			if (entity?.vegetacao_Anotacoes?.length) {

				let newAnotacoes: AnotacoesOnEditVegetacao[] = [];

				for (let n = 0, t = entity?.vegetacao_Anotacoes?.length; n < t; n++) {
					let anotacoes: AnotacoesOnEditVegetacao = {
						id: entity?.vegetacao_Anotacoes[n].id,
						responsavel: entity?.vegetacao_Anotacoes[n].responsavel,
						dataAnotacao: entity?.vegetacao_Anotacoes[n].dataAnotacao !== undefined ? moment(entity?.vegetacao_Anotacoes[n].dataAnotacao).toDate() : null,
						anotacao: entity?.vegetacao_Anotacoes[n].anotacao,
						contagemAnotacao: n + 1,
					};

					newAnotacoes.push(anotacoes);
				}

				setSelectedAnotacoes(newAnotacoes);
			}

		}
	};

	const trocarAba = (novaAba: number) => {
		if (cadernoCarregando) {
			return;
		}

		const dadosAtualizados = gravarDados(modoFluxo);
		setModoFluxo(novaAba);
		setarDados(novaAba, dadosAtualizados);
	};

	useEffect(() => {
		if (Number(modoFluxo) === MODO_VIEW.DADOS_PRINCIPAIS && entity?.id) {
			aplicarDadosPrincipaisNoForm(entity);
			aplicarDocumentosNoForm(entity);
		}
	}, [modoFluxo, entity?.id, entity?.vegetacao_Documentos]);

	useEffect(() => {
		if (Number(modoFluxo) === MODO_VIEW.COLHEITA && entity?.id) {
			carregarColheitaAMIDaEntity(entity);
		}
	}, [modoFluxo, entity?.id, entity?.vegetacao_Colheita_AMI]);

	const getValuesToSubmitDraft = () => {

		return gravarDados(modoFluxo);
	}

	const getValuesToSubmit = () => {

		return gravarDados(modoFluxo);
	}

	const submitFilesRegistroAmostragem = async (cadernoConformidadeVegetacao_Id: number) => {

		const arquivosPendentes = selectedRegistroAmostragem
			.map((registro) => extrairFileAmostragemPendente(registro.arquivoAmostragem))
			.filter((arquivo): arquivo is File => arquivo instanceof File);

		if (arquivosPendentes.length) {
			let ultimoStatus = 200;
			let ultimosDados: any = null;

			for (let index = 0; index < arquivosPendentes.length; index++) {
				var formDataFiles = new FormData();
				formDataFiles.append('arquivos', arquivosPendentes[index]);

				const { status, data } = await api.post(`api/v1/caderno-conformidade/Vegetacao/${cadernoConformidadeVegetacao_Id}/SalvarListaArquivosRegistroAmostragem`, formDataFiles);
				ultimoStatus = status;
				ultimosDados = data;

				if (status !== 200) {
					return status;
				}
			}

			if (ultimoStatus === 200 && ultimosDados) {
				setEntity((prev: any) => ({ ...prev, vegetacao_Documentos_RegistroAmostragem: ultimosDados }));
				setSelectedRegistroAmostragem((prev) => sincronizarSelectedRegistroAmostragemComServidor(prev, ultimosDados));
			}

			return ultimoStatus;
		}

		return 200;
	}

	const submitFilesPastaProcesso = async (cadernoConformidadeVegetacao_Id: number) => {

		const arquivosPastaProcesso = documentosGerais;

		if (arquivosPastaProcesso && arquivosPastaProcesso.length) {
			var formDataFiles = new FormData();

			for (let index = 0; index < arquivosPastaProcesso.length; index++) {
				const arquivo = arquivosPastaProcesso[index];

				formDataFiles.append('arquivos', arquivo);
			}

			const { status } = await api.post(`api/v1/caderno-conformidade/Vegetacao/${cadernoConformidadeVegetacao_Id}/SalvarListaArquivosPastaProcesso`, formDataFiles);
			return status;
		}

		return 200;
	}

	const submitFilesAMI = async (cadernoConformidadeVegetacao_Id: number) => {

		const arquivosAMI = numeroAMI;

		if (arquivosAMI && arquivosAMI.length) {
			var formDataFiles = new FormData();

			for (let index = 0; index < arquivosAMI.length; index++) {
				const arquivo = arquivosAMI[index];

				formDataFiles.append('arquivos', arquivo);
			}

			const { status } = await api.post(`api/v1/caderno-conformidade/Vegetacao/${cadernoConformidadeVegetacao_Id}/SalvarListaArquivosAMI`, formDataFiles);
			return status;
		}

		return 200;
	}

	const submitFilesAAC = async (cadernoConformidadeVegetacao_Id: number) => {

		const arquivosAAC = numeroAAC;

		if (arquivosAAC && arquivosAAC.length) {
			var formDataFiles = new FormData();

			for (let index = 0; index < arquivosAAC.length; index++) {
				const arquivo = arquivosAAC[index];

				formDataFiles.append('arquivos', arquivo);
			}

			const { status } = await api.post(`api/v1/caderno-conformidade/Vegetacao/${cadernoConformidadeVegetacao_Id}/SalvarListaArquivosAAC`, formDataFiles);
			return status;
		}

		return 200;
	}

	const submitFilesDadosPrincipaisAAC = async (cadernoConformidadeVegetacao_Id: number) => {

		const arquivosAAC = dadosPrincipaisAAC;

		if (arquivosAAC && arquivosAAC.length) {
			var formDataFiles = new FormData();

			for (let index = 0; index < arquivosAAC.length; index++) {
				const arquivo = arquivosAAC[index];

				if (arquivo instanceof File) {
					formDataFiles.append('arquivos', arquivo);
				}
			}

			const { status } = await api.post(`api/v1/caderno-conformidade/Vegetacao/${cadernoConformidadeVegetacao_Id}/SalvarArquivoAACDadosPrincipais`, formDataFiles);
			return status;
		}

		return 200;
	}

	const submitFilesDadosPrincipaisListaTreinamentos = async (cadernoConformidadeVegetacao_Id: number) => {

		const arquivosListaTreinamento = dadosPrincipaisListaTreinamento;

		if (arquivosListaTreinamento && arquivosListaTreinamento.length) {
			var formDataFiles = new FormData();

			for (let index = 0; index < arquivosListaTreinamento.length; index++) {
				const arquivo = arquivosListaTreinamento[index];

				if (arquivo instanceof File) {
					formDataFiles.append('arquivos', arquivo);
				}
			}

			const { status } = await api.post(`api/v1/caderno-conformidade/Vegetacao/${cadernoConformidadeVegetacao_Id}/SalvarArquivosListaTreinamento`, formDataFiles);
			return status;
		}

		return 200;
	}

	const submitFilesDadosPrincipaisParecerTecnico = async (cadernoConformidadeVegetacao_Id: number) => {

		const arquivosParecerTecnico = dadosPrincipaisParecerTecnico;

		if (arquivosParecerTecnico && arquivosParecerTecnico.length) {
			var formDataFiles = new FormData();

			for (let index = 0; index < arquivosParecerTecnico.length; index++) {
				const arquivo = arquivosParecerTecnico[index];

				if (arquivo instanceof File) {
					formDataFiles.append('arquivos', arquivo);
				}
			}

			const { status } = await api.post(`api/v1/caderno-conformidade/Vegetacao/${cadernoConformidadeVegetacao_Id}/SalvarParecerTecnicoDadosPrincipais`, formDataFiles);
			return status;
		}

		return 200;
	}

	const submitFilesDadosPrincipaisLiberacaoQuarentenas = async (cadernoConformidadeVegetacao_Id: number) => {

		const arquivosLiberacaoQuarentena = dadosPrincipaisLiberacaoQuarentena;

		if (arquivosLiberacaoQuarentena && arquivosLiberacaoQuarentena.length) {
			var formDataFiles = new FormData();

			for (let index = 0; index < arquivosLiberacaoQuarentena.length; index++) {
				const arquivo = arquivosLiberacaoQuarentena[index];

				if (arquivo instanceof File) {
					formDataFiles.append('arquivos', arquivo);
				}
			}

			const { status } = await api.post(`api/v1/caderno-conformidade/Vegetacao/${cadernoConformidadeVegetacao_Id}/SalvarArquivosLiberacaoQuarentena`, formDataFiles);
			return status;
		}

		return 200;
	}

	const submitFilesPlanejamentoCroqui = async (cadernoConformidadeVegetacao_Id: number) => {

		const arquivosPlanejamentoCroqui = planejamentoCroqui;

		if (arquivosPlanejamentoCroqui && arquivosPlanejamentoCroqui.length) {
			var formDataFiles = new FormData();

			for (let index = 0; index < arquivosPlanejamentoCroqui.length; index++) {
				const arquivo = arquivosPlanejamentoCroqui[index];

				formDataFiles.append('arquivos', arquivo);
			}

			const { status } = await api.post(`api/v1/caderno-conformidade/Vegetacao/${cadernoConformidadeVegetacao_Id}/SalvarArquivosPlanejamentoCroqui`, formDataFiles);
			return status;
		}

		return 200;
	}

	const submitFilesConducaoComunicados = async (cadernoConformidadeVegetacao_Id: number) => {

		const arquivosNovos = conducaoComunicados.filter((arquivo: any) => arquivo?.file instanceof File);

		if (arquivosNovos.length) {
			var formDataFiles = new FormData();
			const datasComunicado = arquivosNovos.map((arquivo: any) => arquivo.dataComunicado ?? null);
			formDataFiles.append('datasComunicado', JSON.stringify(datasComunicado));

			for (let index = 0; index < arquivosNovos.length; index++) {
				formDataFiles.append('arquivos', arquivosNovos[index].file);
			}

			const { status, data } = await api.post(`api/v1/caderno-conformidade/Vegetacao/${cadernoConformidadeVegetacao_Id}/SalvarArquivosColheitaComunicados`, formDataFiles);
			if (status === 200) {
				const arquivosMapeados = data.map(mapArquivoComunicadoParaGrid);
				setEntity((prev: any) => ({ ...prev, vegetacao_Conducao_Comunicados: data }));
				setConducaoComunicados(arquivosMapeados);
			}
			return status;
		}

		return 200;
	}

	const submitFilesPlantioArquivoMateriais = async (cadernoConformidadeVegetacao_Id: number) => {
		const arquivosPendentes = plantioArquivoMateriais
			.map((arquivo) => ({
				file: extrairFilePlantioPendente(arquivo),
				numeroPlantio: arquivo?.numeroPlantio,
				filename: obterNomeArquivoPlantio(arquivo),
			}))
			.filter((item): item is { file: File; numeroPlantio: any; filename: string } => item.file !== null);

		if (!arquivosPendentes.length) {
			return 200;
		}

		const formDataFiles = new FormData();
		for (let index = 0; index < arquivosPendentes.length; index++) {
			formDataFiles.append('arquivos', arquivosPendentes[index].file);
		}

		const { status, data } = await api.post(`api/v1/caderno-conformidade/Vegetacao/${cadernoConformidadeVegetacao_Id}/SalvarArquivosPlantioMateriais`, formDataFiles);
		if (status === 200) {
			const arquivosMapeados = data.map((item: any) => {
				const mapped = mapArquivoPlantioParaGrid(item);
				const pendente = arquivosPendentes.find((p) =>
					p.filename === mapped.filename || p.file.name === mapped.filename
				);
				return { ...mapped, numeroPlantio: pendente?.numeroPlantio ?? mapped.numeroPlantio };
			});
			setEntity((prev: any) => ({ ...prev, vegetacao_Plantio_ArquivoMateriais: data }));
			setPlantioArquivoMateriais(arquivosMapeados);
			setPlantioArquivoAMIFiles((amis) => {
				setSelectedPlantios((prev) => associarArquivosPlantioAosRegistros(prev, arquivosMapeados, amis));
				return amis;
			});
		}
		return status;
	}

	const submitFilesPlantioAMI = async (cadernoConformidadeVegetacao_Id: number) => {
		const arquivosPendentes = plantioArquivoAMIFiles
			.map((arquivo) => ({
				file: extrairFilePlantioPendente(arquivo),
				numeroPlantio: arquivo?.numeroPlantio,
				filename: obterNomeArquivoPlantio(arquivo),
			}))
			.filter((item): item is { file: File; numeroPlantio: any; filename: string } => item.file !== null);

		if (!arquivosPendentes.length) {
			return 200;
		}

		const formDataFiles = new FormData();
		for (let index = 0; index < arquivosPendentes.length; index++) {
			formDataFiles.append('arquivos', arquivosPendentes[index].file);
		}

		const { status, data } = await api.post(`api/v1/caderno-conformidade/Vegetacao/${cadernoConformidadeVegetacao_Id}/SalvarArquivosPlantioAMI`, formDataFiles);
		if (status === 200) {
			const arquivosMapeados = data.map((item: any) => {
				const mapped = mapArquivoPlantioParaGrid(item);
				const pendente = arquivosPendentes.find((p) =>
					p.filename === mapped.filename || p.file.name === mapped.filename
				);
				return { ...mapped, numeroPlantio: pendente?.numeroPlantio ?? mapped.numeroPlantio };
			});
			setEntity((prev: any) => ({ ...prev, vegetacao_Plantio_ArquivoAMI: data }));
			setPlantioArquivoAMIFiles(arquivosMapeados);
			setPlantioArquivoMateriais((materiais) => {
				setSelectedPlantios((prev) => associarArquivosPlantioAosRegistros(prev, materiais, arquivosMapeados));
				return materiais;
			});
		}
		return status;
	}

	const submitFilesDestruicaoAMI = async (cadernoConformidadeVegetacao_Id: number) => {
		const arquivosPendentes = destruicaoAMI
			.map(obterArquivoPendenteDestruicaoAMI)
			.filter((arquivo): arquivo is File => arquivo !== null);

		if (!arquivosPendentes.length) {
			return 200;
		}

		const formDataFiles = new FormData();

		for (let index = 0; index < arquivosPendentes.length; index++) {
			formDataFiles.append('arquivos', arquivosPendentes[index]);
		}

		const { status, data } = await api.post(`api/v1/caderno-conformidade/Vegetacao/${cadernoConformidadeVegetacao_Id}/SalvarArquivosAMIDestruicao`, formDataFiles);

		if (status === 200 && data?.length) {
			const arquivosSalvos = data.map(mapArquivoDestruicaoAMIParaGrid);
			setDestruicaoAMI(arquivosSalvos);
			setEntity((prev: any) => ({ ...prev, vegetacao_Destruicao_ArquivoAMI: arquivosSalvos }));
		}

		return status;
	}

	const submitFilesFiscalizacaoTermos = async (cadernoConformidadeVegetacao_Id: number) => {
		const arquivosPendentes = selectedRegistroFiscalizacao
			.map((registro) => extrairFileFiscalizacaoPendente(registro.arquivoTermo))
			.filter((arquivo): arquivo is File => arquivo instanceof File);

		if (arquivosPendentes.length) {
			let ultimoStatus = 200;
			let ultimosDados: any = null;

			for (let index = 0; index < arquivosPendentes.length; index++) {
				const formDataFiles = new FormData();
				formDataFiles.append('arquivos', arquivosPendentes[index]);

				const { status, data } = await api.post(`api/v1/caderno-conformidade/Vegetacao/${cadernoConformidadeVegetacao_Id}/SalvarListaArquivosFiscalizacao`, formDataFiles);
				ultimoStatus = status;
				ultimosDados = data;

				if (status !== 200) {
					return status;
				}
			}

			if (ultimoStatus === 200 && ultimosDados) {
				setEntity((prev: any) => ({ ...prev, vegetacao_Fiscalizacao: ultimosDados }));
				setSelectedRegistroFiscalizacao((prev) => sincronizarSelectedRegistroFiscalizacaoComServidor(prev, ultimosDados));
			}

			return ultimoStatus;
		}

		return 200;
	}

	const submitFilesColheitaAMI = async (cadernoConformidadeVegetacao_Id: number) => {
		const arquivosPendentes = colheitaAMI.filter((arquivo): arquivo is File => arquivo instanceof File);

		if (!arquivosPendentes.length) {
			return 200;
		}

		const formDataFiles = new FormData();

		for (let index = 0; index < arquivosPendentes.length; index++) {
			formDataFiles.append('arquivos', arquivosPendentes[index]);
		}

		const { status, data } = await api.post(`api/v1/caderno-conformidade/Vegetacao/${cadernoConformidadeVegetacao_Id}/SalvarColheitaAMI`, formDataFiles);

		if (status === 200 && data?.length) {
			const arquivosSalvos = data.map(normalizarArquivoColheitaAMI);
			setColheitaAMI(arquivosSalvos);
			setFileFieldColheitaAMI(arquivosSalvos[0]);
			setEntity((prev: any) => ({ ...prev, vegetacao_Colheita_AMI: arquivosSalvos }));
		}

		return status;
	}

	const submitFilesRegistroColheita = async (cadernoConformidadeVegetacao_Id: number) => {
		const arquivosPendentes = selectedRegistroColheita
			.map((registro) => extrairFileColheitaPendente(registro.arquivoAMIColheita))
			.filter((arquivo): arquivo is File => arquivo instanceof File);

		if (arquivosPendentes.length) {
			let ultimoStatus = 200;
			let ultimosDados: any = null;

			for (let index = 0; index < arquivosPendentes.length; index++) {
				const formDataFiles = new FormData();
				formDataFiles.append('arquivos', arquivosPendentes[index]);

				const { status, data } = await api.post(`api/v1/caderno-conformidade/Vegetacao/${cadernoConformidadeVegetacao_Id}/SalvarListaArquivosRegistroColheita`, formDataFiles);
				ultimoStatus = status;
				ultimosDados = data;

				if (status !== 200) {
					return status;
				}
			}

			if (ultimoStatus === 200 && ultimosDados) {
				setEntity((prev: any) => ({ ...prev, vegetacao_Planejamento_RegistroColheita: ultimosDados }));
				setSelectedRegistroColheita((prev) => sincronizarSelectedRegistroColheitaComServidor(prev, ultimosDados));
			}

			return ultimoStatus;
		}

		return 200;
	}


	const verifyErrorsOnForm = (): string[] => {
		let errorsForm: any[] = [];

		if (!isEmptyObj(errors)) {
			Object.entries(errors).map(err => errorsForm.push(err[0]));
		}
		return errorsForm;
	}

	//#region Ações Plantio
	const parsePlantioDate = (value: any) => {
		if (!value) return null;
		if (value instanceof Date) return value;
		const parsed = moment(value);
		return parsed.isValid() ? parsed.toDate() : null;
	};

	const getDestinoSobraOption = (destinoSobraId: any) => {
		if (destinoSobraId && typeof destinoSobraId === 'object' && destinoSobraId.value !== undefined) {
			return destinoSobraId;
		}
		const id = Number(destinoSobraId);
		if (!id) return null;
		const destinoSobrasEnum = enumDestinoSobra.filter((e: any) => Number(e.key) === id);
		return {
			label: destinoSobrasEnum.length > 0 ? destinoSobrasEnum[0].value : '',
			value: id,
		};
	};

	const preparePlantioEditData = (data: any): VegetacaoPlantios => {
		const destinoSobra = getDestinoSobraOption(data.destinoSobra ?? data.destinoSobra_Id);
		return {
			...data,
			destinoSobra,
			dataInicialPlantio: parsePlantioDate(data.dataInicialPlantio),
			dataFinalPlantio: parsePlantioDate(data.dataFinalPlantio),
		};
	};

	const openPlantioModal = (data?: any, gridNode?: any) => {
		if (gridNode) {
			setGridProps(gridNode);
		}

		if (data) {
			const editData = prepararPlantioParaEdicao(preparePlantioEditData(data));
			setPlantioEdit(editData);
			setCheckboxSobraMaterial(!!editData.sobraMaterial);
			setResponsaveisPlantio((editData.responsaveis ?? []).map((responsavel, index) => ({
				id: responsavel.id ?? 0,
				responsavel: responsavel.responsavel,
				contagem: index + 1,
			})));
			resetPlantios({
				numeroPlantio: editData.numeroPlantio,
				casaVegetacaoModulo: editData.casaVegetacaoModulo,
				material: editData.material,
				informacoesAdicionaisMaterial: editData.informacoesAdicionaisMaterial,
				numeroAMI: editData.numeroAMI,
				sobraMaterial: editData.sobraMaterial,
				numeroAmostrasRestantes: editData.numeroAmostrasRestantes,
				quantidadeAmostrasRestantes: editData.quantidadeAmostrasRestantes,
				destinoSobra: editData.destinoSobra,
				destinoSobraOutros: editData.destinoSobraOutros,
				entradaArmazenamento: editData.entradaArmazenamento,
				informacoesAdicionais: editData.informacoesAdicionais,
				dataInicialPlantio: editData.dataInicialPlantio,
				dataFinalPlantio: editData.dataFinalPlantio,
			});
			setLblArquivoMaterialPlantado(editData.filenameMaterialPlantado || 'Escolher arquivo');
			setLblArquivoPlantioAMI(editData.filenamePlantioAMI || 'Escolher arquivo');
			setPlantioMaterialFile(extrairFilePlantioPendente(editData.arquivoMaterialPlantado));
			setPlantioAMIFile(extrairFilePlantioPendente(editData.arquivoPlantioAMI));
		} else {
			setPlantioEdit({
				id: 0,
				numeroPlantio: 0,
				casaVegetacaoModulo: '',
				material: '',
				informacoesAdicionaisMaterial: '',
				numeroAMI: '',
				sobraMaterial: '',
				numeroAmostrasRestantes: '',
				quantidadeAmostrasRestantes: '',
				destinoSobra: '',
				entradaArmazenamento: '',
				informacoesAdicionais: '',
				dataInicialPlantio: '',
				dataFinalPlantio: '',
			});
			setCheckboxSobraMaterial(false);
			setResponsaveisPlantio([]);
			resetPlantios({});
			setLblArquivoMaterialPlantado('Escolher arquivo');
			setLblArquivoPlantioAMI('Escolher arquivo');
			setPlantioMaterialFile(null);
			setPlantioAMIFile(null);
		}

		setModalPlantios(true);
	};

	const AdicionarResponsavelPlantio = () => {
		const nomeResponsavel = String(defaultForm.getValues('responsavelPlantio') ?? '').trim();
		if (!nomeResponsavel) {
			return;
		}

		setResponsaveisPlantio([...responsaveisPlantio, {
			id: 0,
			responsavel: nomeResponsavel,
			contagem: responsaveisPlantio.length + 1,
		}]);
	}
	//#endregion

	//#region Ações Inspeção Equipamentos
	const getFaseLimpezaOption = (faseLimpezaId: any) => {
		const id = obterValorNumericoId(faseLimpezaId);
		if (!id) return null;

		const faseEnum = enumTipoFaseLimpezaEquipamentos.filter((e: any) => Number(e.key) === id);
		return {
			label: faseEnum.length > 0 ? faseEnum[0].value : '',
			value: id,
		};
	};

	const prepareInspecaoEquipamentosEditData = (data: any): VegetacaoInspecaoEquipamentos => ({
		...data,
		faseLimpeza_Id: getFaseLimpezaOption(data.faseLimpeza_Id),
		dataAntesUso: parsePlantioDate(data.dataAntesUso),
		dataAposUso: parsePlantioDate(data.dataAposUso),
	});

	const openInspecaoEquipamentosModal = (data?: any, gridNode?: any) => {
		if (gridNode) {
			setGridProps(gridNode);
		}

		if (data) {
			const editData = prepareInspecaoEquipamentosEditData(data);
			setInspecaoEquipamentosEdit(editData);
			setContagemInspecaoEquipamento(editData.contagemInspecaoEquipamento * 1);
			setResponsaveisEquipamentos(editData.responsaveis ?? []);
			setMetodosLimpezaEquipamentos(editData.metodosLimpeza ?? []);
			resetInspecaoEquipamentos({
				faseLimpeza_Id: editData.faseLimpeza_Id,
				numeroPlantio: editData.numeroPlantio,
				iD_Equipamento: editData.iD_Equipamento,
				dataAntesUso: editData.dataAntesUso,
				dataAposUso: editData.dataAposUso,
				metodoLimpezaEquipamento_Id: editData.metodoLimpezaEquipamento_Id,
				outrosMetodoLimpezaEquipamento: editData.outrosMetodoLimpezaEquipamento,
				faseEnsaio: editData.faseEnsaio,
			});
		} else {
			const defaultFase = getFaseLimpezaOption(tipoFaseLimpezaEquipamentosValue);
			setInspecaoEquipamentosEdit({
				id: 0,
				contagemInspecaoEquipamento: '',
				numeroPlantio: '',
				iD_Equipamento: '',
				dataAntesUso: '',
				dataAposUso: '',
				faseEnsaio: '',
				metodoLimpezaEquipamento_Id: '',
				outrosMetodoLimpezaEquipamento: '',
				faseLimpeza_Id: defaultFase,
			});
			setContagemInspecaoEquipamento(0);
			setResponsaveisEquipamentos([]);
			setMetodosLimpezaEquipamentos([]);
			resetInspecaoEquipamentos({
				faseLimpeza_Id: defaultFase,
				numeroPlantio: '',
				iD_Equipamento: '',
				dataAntesUso: null,
				dataAposUso: null,
				metodoLimpezaEquipamento_Id: null,
				outrosMetodoLimpezaEquipamento: '',
				faseEnsaio: '',
			});
		}

		setModalInspecaoEquipamentos(true);
	};

	const limparEstadoModalAtividadeManutencao = () => {
		setResponsaveisManutencao([]);
		setMetodosLimpezaManutencao([]);
		setArquivoPoda(false);
	};

	const atualizarVisibilidadeArquivoPoda = (
		atividades: MetodoLimpezaManutencao[] = metodosLimpezaManutencao,
		atividadeSelecionada?: any
	) => {
		const podaEnum = enumAtividadesManutencao.find((e: any) => Number(e.key) === 5);
		const podaLabel = podaEnum?.value ?? '';
		const atividadeAtual = atividadeSelecionada ?? defaultForm.getValues('atividadeManutencao_Id');
		const temPodaPorSelect = Number(atividadeAtual?.value) === 5;
		const temPodaPorAtividades = atividades?.some((atividade) =>
			podaLabel !== '' && atividade.descricao === podaLabel
		);

		setArquivoPoda(temPodaPorAtividades || temPodaPorSelect);
	};

	const fecharModalAtividadeManutencao = () => {
		setModalAtividadeManutencao(false);
		limparEstadoModalAtividadeManutencao();
	};

	const openAtividadeManutencaoModal = (data?: any, gridNode?: any) => {
		if (gridNode) {
			setGridProps(gridNode);
		}

		if (data) {
			setAtividadeManutencaoEdit(data);
			setContagemAtividadeManutencao(data.contagemAtividadeManutencao * 1);
			const metodosLimpeza = data.metodosLimpeza ?? [];
			setResponsaveisManutencao(data.responsaveis ?? []);
			setMetodosLimpezaManutencao(metodosLimpeza);
			resetAtividadeManutencao({
				dataInicialAtividade: data.dataInicialAtividade ?? null,
				dataFinalAtividade: data.dataFinalAtividade ?? null,
				atividadeManutencao_Id: data.atividadeManutencao_Id,
				outrosAtividadeManutencao: data.outrosAtividadeManutencao,
			});
			atualizarVisibilidadeArquivoPoda(metodosLimpeza, data.atividadeManutencao_Id);
		} else {
			setAtividadeManutencaoEdit({
				id: 0,
				contagemAtividadeManutencao: '',
				dataAtividade: '',
				dataInicialAtividade: '',
				dataFinalAtividade: '',
				responsavel: '',
				atividadeManutencao_Id: '',
			});
			setContagemAtividadeManutencao(0);
			limparEstadoModalAtividadeManutencao();
			resetAtividadeManutencao({});
		}

		setModalAtividadeManutencao(true);
	};

	const limparEstadoModalLimpezaInstalacoes = () => {
		setResponsaveisInstalacao([]);
		setMetodosLimpezaInstalacao([]);
	};

	const fecharModalLimpezaInstalacoes = () => {
		setModalLimpezaInstalacoes(false);
		limparEstadoModalLimpezaInstalacoes();
	};

	const openLimpezaInstalacoesModal = (data?: any, gridNode?: any) => {
		if (gridNode) {
			setGridProps(gridNode);
		}

		if (data) {
			setLimpezaInstalacoesEdit(data);
			setContagemLimpezaInstalacao(data.contagemLimpezaInstalacao * 1);
			setResponsaveisInstalacao(data.responsaveis ?? []);
			setMetodosLimpezaInstalacao(data.metodosLimpeza ?? []);
			resetLimpezaInstalacoes({
				tipoFaseLimpeza_Id: data.tipoFaseLimpeza_Id,
				dataInicialLimpeza: data.dataInicialLimpeza ?? null,
				dataFinalLimpeza: data.dataFinalLimpeza ?? null,
				numeroCodigoCasaVegetacao: data.numeroCodigoCasaVegetacao,
				metodoLimpeza_Id: data.metodoLimpeza_Id,
				outrosMetodoLimpeza: data.outrosMetodoLimpeza,
				outrosTipoFaseLimpeza: data.outrosTipoFaseLimpeza,
				observacoesLimpeza: data.observacoesLimpeza,
			});
		} else {
			setLimpezaInstalacoesEdit({
				id: 0,
				contagemLimpezaInstalacao: '',
				dataLimpeza: '',
				numeroCodigoCasaVegetacao: '',
				responsavel: '',
				metodoLimpeza_Id: '',
				dataInicialLimpeza: '',
				dataFinalLimpeza: '',
				tipoFaseLimpeza_Id: '',
				outrosTipoFaseLimpeza: '',
				observacoesLimpeza: '',
			});
			setContagemLimpezaInstalacao(0);
			limparEstadoModalLimpezaInstalacoes();
			resetLimpezaInstalacoes({});
		}

		setModalLimpezaInstalacoes(true);
	};

	const limparEstadoModalDestruicao = () => {
		setResponsaveisDestruicao([]);
		setMetodosDestruicao([]);
		setSelectedLimpezaDestruicao([]);
	};

	const normalizarValorSelectDestruicao = (valor: any) => normalizarValorSelect(valor);

	const montarValoresFormDestruicao = (data: any) => ({
		tipoFaseDestruicao_Id: data?.tipoFaseDestruicao_Id ?? '',
		dataInicialDestruicao: data?.dataInicialDestruicao ? moment(data.dataInicialDestruicao).toDate() : null,
		dataFinalDestruicao: data?.dataFinalDestruicao ? moment(data.dataFinalDestruicao).toDate() : null,
		tipoDestruicao: data?.tipoDestruicao ?? '',
		outrosTipoDestruicao: data?.outrosTipoDestruicao ?? '',
		numeroAmostras: data?.numeroAmostras ?? '',
		pesoAmostras: data?.pesoAmostras ?? '',
		unidadeMedida: data?.unidadeMedida ?? '',
		localDestruicao: data?.localDestruicao ?? '',
		outrosLocalDestruicao: data?.outrosLocalDestruicao ?? '',
		observacoesLocalDestruicao: data?.observacoesLocalDestruicao ?? '',
		metodoDestruicao: data?.metodoDestruicao ?? '',
		outrosMetodoDestruicao: data?.outrosMetodoDestruicao ?? '',
		observacoesMetodoDestruicao: data?.observacoesMetodoDestruicao ?? '',
		outrosTipoFaseDestruicao: data?.outrosTipoFaseDestruicao ?? '',
	});

	const aplicarEstadoSelectsDestruicao = (data: any) => {
		setTipoFaseDestruicaoValue(normalizarValorSelectDestruicao(data?.tipoFaseDestruicao_Id));
		setTipoDestruicaoValue(normalizarValorSelectDestruicao(data?.tipoDestruicao));
		setLocalDestruicaoValue(normalizarValorSelectDestruicao(data?.localDestruicao));
		setUnidadeMedidaValue(normalizarValorSelectDestruicao(data?.unidadeMedida));
		setMetodoDestruicaoValue(normalizarValorSelectDestruicao(data?.metodoDestruicao));
	};

	const openDestruicaoModal = (data?: any, gridNode?: any) => {
		if (gridNode) {
			setGridProps(gridNode);
		}

		if (data) {
			setDestruicaoEdit(data);
			setResponsaveisDestruicao([...(data.responsaveisDestruicao ?? [])]);
			setMetodosDestruicao([...(data.metodosDestruicao ?? [])]);
			setSelectedLimpezaDestruicao(ordenarPorDataAsc([...(data.limpezaDestruicao ?? [])], 'dataLimpezaAntesUso', 'contagemLimpezaDestruicao'));
			aplicarEstadoSelectsDestruicao(data);
			setContagemDestruicao(data.contagemDestruicao * 1);
			resetDestruicao(montarValoresFormDestruicao(data));
		} else {
			setContagemDestruicao(0);
			setDestruicaoEdit({
				id: 0,
				tipoDestruicao: '',
				outrosTipoDestruicao: '',
				numeroAmostras: 0,
				pesoAmostras: 0,
				unidadeMedida: '',
				localDestruicao: '',
				outrosLocalDestruicao: '',
				observacoesLocalDestruicao: '',
				metodoDestruicao: '',
				outrosMetodoDestruicao: '',
				observacoesMetodoDestruicao: '',
				dataInicialDestruicao: '',
				dataFinalDestruicao: '',
				tipoFaseDestruicao_Id: 0,
				outrosTipoFaseDestruicao: '',
			});
			aplicarEstadoSelectsDestruicao({});
			limparEstadoModalDestruicao();
			resetDestruicao(montarValoresFormDestruicao({}));
		}

		setExibirAnexoDestruicaoAMI(false);
		setModalDestruicao(true);
	};
	//#endregion

	//#region Ações Manutenção
	const AdicionarResponsavelManutencao = () => {
		const responsavel = (defaultForm.getValues('responsavelManutencao') as string | undefined) ?? '';
		const responsavelNormalizado = responsavel.trim();
		if (!responsavelNormalizado || responsaveisManutencao.some(r => r.responsavel === responsavelNormalizado)) {
			return;
		}

		const novoResponsavel: ResponsavelAtividade = {
			id: 0,
			responsavel: responsavelNormalizado,
			contagem: responsaveisManutencao.length + 1,
		};
		setResponsaveisManutencao([...responsaveisManutencao, novoResponsavel]);
	}

	const AdicionarAtividadeManutencao = () => {

		let atividade = (defaultForm.getValues('atividadeManutencao_Id') as any);
		const outrosAtividade = getValuesAtividadeManutencao('outrosAtividadeManutencao') as string | undefined;
		const descricao = obterDescricaoMetodoLimpezaFromSelect(atividade, outrosAtividade);

		if (!descricao || metodoLimpezaJaAdicionado(metodosLimpezaManutencao, descricao)) {
			return;
		}

		const novoMetodo: MetodoLimpezaManutencao = {
			id: 0,
			descricao,
			contagem: metodosLimpezaManutencao.length + 1,
		};

		setMetodosLimpezaManutencao([...metodosLimpezaManutencao, novoMetodo]);

		atualizarVisibilidadeArquivoPoda(
			[...metodosLimpezaManutencao, novoMetodo],
			atividade
		);

		defaultForm.setValue('atividadeManutencao_Id', '');
		setValueAtividadeManutencao('outrosAtividadeManutencao', '');
		setAtividadeManutencaoEdit((state) => ({
			...state,
			atividadeManutencao_Id: '',
			outrosAtividadeManutencao: '',
		}));
	}
	//#endregion

	//#region Ações Limpeza Equipamentos
	const AdicionarResponsavelLimpezaEquipamentos = () => {
		const responsavel = (defaultForm.getValues('responsavelLimpezaEquipamentos') as string | undefined) ?? '';
		const responsavelNormalizado = responsavel.trim();
		if (!responsavelNormalizado || responsaveisEquipamentos.some(r => r.responsavel === responsavelNormalizado)) {
			return;
		}

		setResponsaveisEquipamentos([...responsaveisEquipamentos, {
			id: 0,
			responsavel: responsavelNormalizado,
			contagem: responsaveisEquipamentos.length + 1,
		}]);
	}

	const AdicionarMetodosLimpezaEquipamentos = () => {
		const metodoLimpezaEquipamento = (defaultForm.getValues('metodoLimpezaEquipamento_Id') as any);
		const outrosMetodo = getValuesInspecaoEquipamentos('outrosMetodoLimpezaEquipamento') as string | undefined;
		const descricao = obterDescricaoMetodoLimpezaFromSelect(metodoLimpezaEquipamento, outrosMetodo);

		if (!descricao || metodoLimpezaJaAdicionado(metodosLimpezaEquipamentos, descricao)) {
			return;
		}

		setMetodosLimpezaEquipamentos([...metodosLimpezaEquipamentos, {
			id: 0,
			descricao,
			contagem: metodosLimpezaEquipamentos.length + 1,
		}]);

		defaultForm.setValue('metodoLimpezaEquipamento_Id', '');
		setValueInspecaoEquipamentos('outrosMetodoLimpezaEquipamento', '');
		setInspecaoEquipamentosEdit((state) => ({
			...state,
			metodoLimpezaEquipamento_Id: '',
			outrosMetodoLimpezaEquipamento: '',
		}));
	}
	//#endregion

	//#region Ações Limpeza Instalações
	const AdicionarMetodoLimpezaInstalacoes = () => {
		const metodoLimpeza = (defaultForm.getValues('metodoLimpeza_Id') as any);
		const outrosMetodo = getValuesLimpezaInstalacoes('outrosMetodoLimpeza') as string | undefined;
		const descricao = obterDescricaoMetodoLimpezaFromSelect(metodoLimpeza, outrosMetodo);

		if (!descricao || metodoLimpezaJaAdicionado(metodosLimpezaInstalacao, descricao)) {
			return;
		}

		setMetodosLimpezaInstalacao([...metodosLimpezaInstalacao, {
			id: 0,
			descricao,
			contagem: metodosLimpezaInstalacao.length + 1,
		}]);

		defaultForm.setValue('metodoLimpeza_Id', '');
		setValueLimpezaInstalacoes('outrosMetodoLimpeza', '');
		setLimpezaInstalacoesEdit((state) => ({
			...state,
			metodoLimpeza_Id: '',
			outrosMetodoLimpeza: '',
		}));
	}

	const AdicionarResponsavelLimpezaInstalacoes = () => {
		const responsavel = (defaultForm.getValues('responsavelLimpezaInstalacoes') as string | undefined) ?? '';
		const responsavelNormalizado = responsavel.trim();
		if (!responsavelNormalizado || responsaveisInstalacao.some(r => r.responsavel === responsavelNormalizado)) {
			return;
		}

		const novoResponsavel: ResponsavelInstalacao = {
			id: 0,
			responsavel: responsavelNormalizado,
			contagem: responsaveisInstalacao.length + 1,
		};
		setResponsaveisInstalacao([...responsaveisInstalacao, novoResponsavel]);
	}
	//#endregion

	//#region Ações Destruição
	const AdicionarResponsavelDestruicao = () => {
		const responsavel = (defaultForm.getValues('responsavelDestruicao') as string | undefined) ?? '';
		const responsavelNormalizado = responsavel.trim();
		if (!responsavelNormalizado || responsaveisDestruicao.some(r => r.responsavel === responsavelNormalizado)) {
			return;
		}

		const novoResponsavel: ResponsavelDestruicao = {
			id: 0,
			responsavel: responsavelNormalizado,
			contagem: responsaveisDestruicao.length + 1,
		};
		setResponsaveisDestruicao([...responsaveisDestruicao, novoResponsavel]);
	}

	const AdicionarMetodoDestruicao = () => {

		let metodosDestruicaoEnum = enumMetodoDescarte.filter((e: any) => Number(e.key) === Number(metodoDestruicaoValue));

		if (!metodosDestruicaoEnum.length) {
			return;
		}

		const descricao = metodosDestruicaoEnum[0].value;
		if (metodosDestruicao.some(m => m.descricao === descricao)) {
			return;
		}

		setMetodosDestruicao([...metodosDestruicao, {
			id: 0,
			descricao,
			contagem: metodosDestruicao.length + 1,
		}]);
	}
	//#endregion

	const AdicionarResponsavelAmostragem = () => {
		const responsavel = (defaultForm.getValues('responsavelAmostragem') as string | undefined) ?? '';
		const responsavelNormalizado = responsavel.trim();
		if (!responsavelNormalizado || responsaveisAmostragem.some(r => r.responsavel === responsavelNormalizado)) {
			return;
		}

		setResponsaveisAmostragem([...responsaveisAmostragem, {
			id: 0,
			responsavel: responsavelNormalizado,
			contagem: expectedRegistroAmostragem.length + 1,
		}]);
	}

	const AdicionarPessoaEnvolvidaColheita = () => {
		const pessoa = (defaultForm.getValues('pessoaColheita') as string | undefined) ?? '';
		const pessoaNormalizada = pessoa.trim();
		if (!pessoaNormalizada || responsaveisColheita.some(r => r.responsavel === pessoaNormalizada)) {
			return;
		}

		setResponsaveisColheita([...responsaveisColheita, {
			id: 0,
			responsavel: pessoaNormalizada,
			contagem: responsaveisColheita.length + 1,
		}]);
	}

	const onSubmitDraft = async () => {
		setErrorDraft(null);
		setLoadingDraft(true);

		if (modoFluxo === MODO_VIEW.COLHEITA) {
			const registroOutrosInvalido = selectedRegistroColheita.some((registro) =>
				isValorOutros(registro.tipoMaterialColheita?.value) && !textoPreenchido(registro.outrosTipoMaterialColheita)
			);

			if (registroOutrosInvalido) {
				setErrorDraft(STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_FIELD_TO_SPECIFY);
				setLoadingDraft(false);
				window.scrollTo({ top: 0, behavior: 'smooth' });
				return;
			}
		}

		if (modoFluxo === MODO_VIEW.NOTAS) {
			const registroOutrosInvalido = selectedRegistroFiscalizacao.some((registro) =>
				isValorOutros(registro.orgaoFiscalizador?.value ?? registro.orgaoFiscalizador_Id) && !textoPreenchido(registro.outrosOrgaoFiscalizador)
			);

			if (registroOutrosInvalido) {
				setErrorDraft(STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_FIELD_TO_SPECIFY);
				setLoadingDraft(false);
				window.scrollTo({ top: 0, behavior: 'smooth' });
				return;
			}
		}

		try {
			const vegetacaoToSubmitDraft = getValuesToSubmitDraft();
			const { status, data } = await api.put('api/v1/caderno-conformidade/Vegetacao/atualizarrascunho', vegetacaoToSubmitDraft);

			if (status === 200) {
				await sincronizarArquivosRemovidos(data.id);
				const registroServidor = data.vegetacao_Documentos_RegistroAmostragem;
				const registroAmostragemAtualizado = registroServidor?.length
					? registroServidor
					: (modoFluxo === MODO_VIEW.AMOSTRAGEM
						? expectedRegistroAmostragem()
						: (entity?.vegetacao_Documentos_RegistroAmostragem ?? []));
				const registroColheitaServidor = data.vegetacao_Planejamento_RegistroColheita ?? data.Vegetacao_Planejamento_RegistroColheita;
				const registroColheitaAtualizado = registroColheitaServidor?.length
					? registroColheitaServidor
					: (modoFluxo === MODO_VIEW.COLHEITA
						? expectedRegistroColheita()
						: (entity?.vegetacao_Planejamento_RegistroColheita ?? []));
				const entityAtualizada = aplicarEstadoLocalArquivosNoPayload({
					...data,
					vegetacao_Documentos: data.vegetacao_Documentos ?? vegetacaoToSubmitDraft.vegetacao_Documentos,
					vegetacao_Documentos_RegistroAmostragem: registroAmostragemAtualizado as any,
					vegetacao_Planejamento_RegistroColheita: registroColheitaAtualizado as any,
				});
				setEntity(normalizarEntityVegetacao(entityAtualizada));
				carregarDestruicaoAMIDaEntity(entityAtualizada);
				if (modoFluxo === MODO_VIEW.COLHEITA) {
					carregarRegistroColheitaDaEntity(entityAtualizada);
				}
				setarDados(modoFluxo, entityAtualizada);
				setSelectedRegistroAmostragem((prev) => sincronizarSelectedRegistroAmostragemComServidor(prev, registroServidor));
				setSelectedRegistroColheita((prev) => sincronizarSelectedRegistroColheitaComServidor(prev, registroColheitaAtualizado));
				setSelectedRegistroFiscalizacao((prev) => sincronizarSelectedRegistroFiscalizacaoComServidor(prev, data.vegetacao_Fiscalizacao));
				if (modoFluxo === MODO_VIEW.PLANEJAMENTO) {
					carregarEstadoPlanejamentoPlantio(entityAtualizada);
				}
				submitFilesPastaProcesso(data.id)
					.then((fileStatus) => {
						if (fileStatus === 200) {
							submitFilesRegistroAmostragem(data.id)
								.then((fileStatus) => {
									if (fileStatus === 200) {
										submitFilesAMI(data.id)
											.then((fileStatus) => {
												if (fileStatus === 200) {
													submitFilesAAC(data.id)
														.then((fileStatus) => {
															if (fileStatus === 200) {
																submitFilesDadosPrincipaisAAC(data.id);
																submitFilesDadosPrincipaisParecerTecnico(data.id);
																submitFilesDadosPrincipaisListaTreinamentos(data.id);
																submitFilesDadosPrincipaisLiberacaoQuarentenas(data.id);
																submitFilesPlanejamentoCroqui(data.id);
																submitFilesConducaoComunicados(data.id);
																submitFilesDestruicaoAMI(data.id);
																submitFilesFiscalizacaoTermos(data.id);
																submitFilesRegistroColheita(data.id);
																submitFilesPlantioArquivoMateriais(data.id);
																submitFilesPlantioAMI(data.id);

																window.scrollTo({ top: 0, behavior: 'smooth' });
																setSuccessDraft(true);
																setTimeout(() => {
																	history.push('/cadernoconformidade/consultar/vegetacao', { id: data.id });
																}, 4900)
															}
														})
												}
											})
									}
								})
						}
					})
			}
		} catch (error: any) {
			window.scrollTo({ top: 0, behavior: 'smooth' });
			setErrorDraft(error.response?.data || error.message || "Erro ao salvar rascunho");
		} finally {
			setLoadingDraft(false);
		}
	}

	const onSubmit = async () => {
		setErrorSubmit(null);
		setLoadingSubmit(true);

		try {

			const vegetacaoToSubmit = getValuesToSubmit();
			const { status, data } = await api.post('api/v1/caderno-conformidade/Vegetacao/enviarregulatorio', vegetacaoToSubmit);

			if (status === 200) {
				await sincronizarArquivosRemovidos(data.id);
				submitFilesPastaProcesso(data.id)
					.then((fileStatus) => {
						if (fileStatus === 200) {
							submitFilesRegistroAmostragem(data.id)
								.then((fileStatus) => {
									if (fileStatus === 200) {
										submitFilesAMI(data.id)
											.then((fileStatus) => {
												if (fileStatus === 200) {
													submitFilesAAC(data.id)
														.then((fileStatus) => {
															if (fileStatus === 200) {
																submitFilesDadosPrincipaisAAC(data.id);
																submitFilesDadosPrincipaisParecerTecnico(data.id);
																submitFilesDadosPrincipaisListaTreinamentos(data.id);
																submitFilesDadosPrincipaisLiberacaoQuarentenas(data.id);
																submitFilesPlanejamentoCroqui(data.id);
																submitFilesConducaoComunicados(data.id);
																submitFilesDestruicaoAMI(data.id);
																submitFilesFiscalizacaoTermos(data.id);
																submitFilesRegistroColheita(data.id);
																submitFilesPlantioArquivoMateriais(data.id);
																submitFilesPlantioAMI(data.id);

																window.scrollTo({ top: 0, behavior: 'smooth' });
																setSuccessDraft(true);
																setTimeout(() => {
																	history.push('/cadernoconformidade/consultar/vegetacao', { id: data.id });
																}, 4900)
															}
														})
												}
											})
									}
								})
						}
					})
			}
		} catch (error: any) {
			window.scrollTo({ top: 0, behavior: 'smooth' });
			setErrorSubmit(error.response.data);
			setIsRegulatory(false);
		}

		setLoadingSubmit(false);
	}

	const requestCorrection = async () => {
		setLoadingCorrection(true);
		setErrorSubmit(null);

		try {
			const valuesToSubmit = getValuesToSubmit();
			const { status, data } = await api.post('api/v1/caderno-conformidade/Vegetacao/solicitarcorrecao', valuesToSubmit);

			if (status === 200 || status === 201) {
				//getCadernoConformidade(data.id);
				setStatusCadernoConformidade(data.status);
				setSuccessCorrection(true);
				setTimeout(() => {
					setIsCorrection(false);
					history.push('/cadernoconformidade/consultar/vegetacao', { id: data.id });
				}, 4900);
				window.scrollTo({ top: 0, behavior: 'smooth' });
			}
		} catch (error: any) {
			setErrorSubmit(error.response.data);
			setIsCorrection(false);
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}
		setLoadingCorrection(false);
	}

	const submitForm_aprove = async () => {
		setLoadingApprove(true);
		setErrorSubmit(null);
		try {
			const valuesToSubmit = getValuesToSubmit();
			const { status, data } = await api.post('api/v1/caderno-conformidade/Vegetacao/aprovar', valuesToSubmit);

			if (status === 200 || status === 201) {
				//getCadernoConformidade(data.id);
				setStatusCadernoConformidade(data.status);
				setSuccessApprove(true);
				setTimeout(() => {
					setIsApprove(false);
					history.push('/cadernoconformidade/consultar/vegetacao', { id: data.id });
				}, 4900);
				window.scrollTo({ top: 0, behavior: 'smooth' });
			}
		} catch (error: any) {
			setErrorSubmit(error.response.data);
			setIsApprove(false);
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}
		setLoadingApprove(false);
	}

	const linkDownload = (props: any) => (
		<Fragment>
			<a href='#' onClick={(e) => { downloadArquivo(e, props.node.data) }}>
				Download
			</a>
		</Fragment>
	)

	const linkArquivoRegistroAmostragem = (props: any) => {
		const registro = props.node?.data ?? {};
		const arquivo = obterArquivoRegistroAmostragemSalvo(registro);
		const arquivoLocal = extrairFileAmostragemPendente(registro.arquivoAmostragem);
		const displayName = arquivo.filename ?? registro.filename ?? '';

		if (arquivoLocal || (arquivo.path && arquivo.filename)) {
			return (
				<Fragment>
					<a href="#" onClick={(e) => downloadArquivo(e, arquivoLocal ?? { path: arquivo.path, filename: arquivo.filename })}>
						{displayName}
					</a>
				</Fragment>
			);
		}

		return <Fragment>{displayName}</Fragment>;
	}

	const linkArquivoRegistroColheita = (props: any) => {
		const registro = props.node?.data ?? {};
		const arquivo = obterArquivoRegistroColheitaSalvo(registro);
		const arquivoLocal = extrairFileColheitaPendente(registro.arquivoAMIColheita);
		const displayName = arquivo.filename ?? registro.filename ?? '';

		if (arquivoLocal || (arquivo.path && arquivo.filename)) {
			return (
				<Fragment>
					<a href="#" onClick={(e) => downloadArquivo(e, arquivoLocal ?? { path: arquivo.path, filename: arquivo.filename })}>
						{displayName}
					</a>
				</Fragment>
			);
		}

		return <Fragment>{displayName}</Fragment>;
	}

	const linkArquivoRegistroFiscalizacao = (props: any) => {
		const registro = props.node?.data ?? {};
		const arquivo = obterArquivoRegistroFiscalizacaoSalvo(registro);
		const arquivoLocal = extrairFileFiscalizacaoPendente(registro.arquivoTermo);
		const displayName = arquivo.filename ?? registro.filename ?? '';

		if (arquivoLocal || (arquivo.path && arquivo.filename)) {
			return (
				<Fragment>
					<a href="#" onClick={(e) => downloadArquivo(e, arquivoLocal ?? { path: arquivo.path, filename: arquivo.filename })}>
						{displayName}
					</a>
				</Fragment>
			);
		}

		return <Fragment>{displayName}</Fragment>;
	}

	const linkArquivoPlantioMaterial = (props: any) => {
		const plantio = props.node?.data ?? {};
		const arquivo = obterArquivoPlantioMaterialSalvo(plantio);
		const arquivoLocal = extrairFilePlantioPendente(plantio.arquivoMaterialPlantado);
		const displayName = arquivo.filename ?? plantio.filenameMaterialPlantado ?? '';

		if (arquivoLocal || (arquivo.path && arquivo.filename)) {
			return (
				<Fragment>
					<a href="#" onClick={(e) => downloadArquivo(e, arquivoLocal ?? { path: arquivo.path, filename: arquivo.filename })}>
						{displayName}
					</a>
				</Fragment>
			);
		}

		return <Fragment>{displayName}</Fragment>;
	}

	const linkArquivoPlantioAMI = (props: any) => {
		const plantio = props.node?.data ?? {};
		const arquivo = obterArquivoPlantioAMISalvo(plantio);
		const arquivoLocal = extrairFilePlantioPendente(plantio.arquivoPlantioAMI);
		const displayName = arquivo.filename ?? plantio.filenamePlantioAMI ?? '';

		if (arquivoLocal || (arquivo.path && arquivo.filename)) {
			return (
				<Fragment>
					<a href="#" onClick={(e) => downloadArquivo(e, arquivoLocal ?? { path: arquivo.path, filename: arquivo.filename })}>
						{displayName}
					</a>
				</Fragment>
			);
		}

		return <Fragment>{displayName}</Fragment>;
	}

	let linkDownloadTermos =
		<a href="../../static/media/TermosCadernoVegetacaoCAGES.pdf" target="_blank">Download dos termos</a>;

	const downloadArquivo = (e: any, arquivo: any) => {
		e.preventDefault();

		const path = arquivo?.path ?? arquivo?.Path;
		const filename = arquivo?.filename ?? arquivo?.Filename ?? arquivo?.name ?? 'download';
		const arquivoLocal = extrairFileAmostragemPendente(arquivo);

		if (arquivoLocal) {
			baixarArquivoLocal(arquivoLocal, filename !== 'download' ? filename : undefined);
			return;
		}

		if (path) {
			apiFileDownload.get(`api/v1/caderno-conformidade/Vegetacao/download?path=${encodeURIComponent(path)}`)
				.then((response) => {
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', filename);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					URL.revokeObjectURL(url);
				})
				.catch((error) => {
					console.error('Erro ao baixar arquivo:', error);
				});
		}
	}

	const downloadModelFileDadosPrincipaisAAC = async (file: Models.ModelFileRegister | undefined) => {
		if (file !== undefined) {
			try {
				apiFileDownload.get(`api/v1/caderno-conformidade/Vegetacao/download?path=${dadosPrincipaisAAC[0].path}`)
					.then((response) => {
						const url = window.URL.createObjectURL(new Blob([response.data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', dadosPrincipaisAAC[0].filename);
						document.body.appendChild(link);
						link.click();
					});

			} catch (error: any) {
				console.error(error);
			}
		}
	}

	const downloadModelFileDadosPrincipaisParecerTecnico = async (file: Models.ModelFileRegister | undefined) => {
		if (file !== undefined) {
			try {
				apiFileDownload.get(`api/v1/caderno-conformidade/Vegetacao/download?path=${dadosPrincipaisParecerTecnico[0].path}`)
					.then((response) => {
						const url = window.URL.createObjectURL(new Blob([response.data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', dadosPrincipaisParecerTecnico[0].filename);
						document.body.appendChild(link);
						link.click();
					});

			} catch (error: any) {
				console.error(error);
			}
		}
	}

	const downloadModelFileColheitaAMI = async () => {
		const arquivo = normalizarArquivoColheitaAMI(colheitaAMI[0]);

		if (arquivo?.path) {
			try {
				apiFileDownload.get(`api/v1/caderno-conformidade/Vegetacao/download?path=${arquivo.path}`)
					.then((response) => {
						const url = window.URL.createObjectURL(new Blob([response.data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', obterNomeArquivoColheitaAMI(arquivo));
						document.body.appendChild(link);
						link.click();
					});

			} catch (error: any) {
				console.error(error);
			}
		} else if (colheitaAMI[0] instanceof File) {
			const url = URL.createObjectURL(colheitaAMI[0]);
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', colheitaAMI[0].name);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			URL.revokeObjectURL(url);
		}
	}

	const downloadModelFilePlantioArquivoMateriais = async (file: Models.ModelFileRegister | undefined) => {
		if (file !== undefined) {
			try {
				apiFileDownload.get(`api/v1/caderno-conformidade/Vegetacao/download?path=${plantioArquivoMateriais[0].path}`)
					.then((response) => {
						const url = window.URL.createObjectURL(new Blob([response.data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', plantioArquivoMateriais[0].filename);
						document.body.appendChild(link);
						link.click();
					});

			} catch (error: any) {
				console.error(error);
			}
		}
	}

	const acoesDadosPrincipaisAAC = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setDadosPrincipaisAAC([...arr]);
				setEntity((prev: any) => ({ ...prev, vegetacao_DP_ArquivoAAC: [...arr] }));
			}} />
		</Fragment>
	)

	const acoesDadosPrincipaisListaTreinamento = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setDadosPrincipaisListaTreinamento([...arr]);
				setEntity((prev: any) => ({ ...prev, vegetacao_DP_ArquivosListaTreinamento: [...arr] }));
			}} />
		</Fragment>
	)

	const acoesDadosPrincipaisLiberacaoQuarentena = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setDadosPrincipaisLiberacaoQuarentena([...arr]);
				setEntity((prev: any) => ({ ...prev, vegetacao_DP_ArquivoLiberacaoQuarentena: [...arr] }));
			}} />
		</Fragment>
	)

	const acoesDadosPrincipaisParecerTecnico = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setDadosPrincipaisParecerTecnico([...arr]);
				setEntity((prev: any) => ({ ...prev, vegetacao_DP_ArquivoUltimoParecer: [...arr] }));
			}} />
		</Fragment>
	)

	const acoesPlanejamentoCroqui = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setPlanejamentoCroqui([...arr]);
				setEntity((prev: any) => ({ ...prev, vegetacao_Planejamento_Croqui: [...arr] }));
			}} />
		</Fragment>
	)

	const acoesPlantioArquivoMateriais = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setPlantioArquivoMateriais([...arr]);
				setEntity((prev: any) => ({ ...prev, vegetacao_Plantio_ArquivoMateriais: [...arr] }));
			}} />
		</Fragment>
	)

	const acoesPlantioArquivoAMI = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setPlantioArquivoAMIFiles([...arr]);
				setEntity((prev: any) => ({ ...prev, vegetacao_Plantio_ArquivoAMI: [...arr] }));
			}} />
		</Fragment>
	)

	const acoesConducaoComunicados = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setConducaoComunicados([...arr]);
				setEntity((prev: any) => ({ ...prev, vegetacao_Conducao_Comunicados: [...arr] }));
			}} />
		</Fragment>
	)

	const acoesDestruicaoAMI = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setDestruicaoAMI([...arr]);
				setEntity((prev: any) => ({ ...prev, vegetacao_Destruicao_ArquivoAMI: [...arr] }));
			}} />
		</Fragment>
	)

	const acoesFiscalizacaoTermos = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setFiscalizacaoTermos([...arr]);
				setEntity((prev: any) => ({ ...prev, vegetacao_Fiscalizacao_Termos: [...arr] }));
			}} />
		</Fragment>
	)

	const acoesDocumentosGerais = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setDocumentosGerais([...arr]);
				setEntity((prev: any) => ({ ...prev, vegetacao_Documentos_PastaProcesso: [...arr] }));
			}} />
		</Fragment>
	)

	const acoesResponsaveisPlantio = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				setResponsaveisPlantio([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setResponsaveisPlantio([...arr]);
			}} />
		</Fragment>
	)

	const acoesResponsaveisManutencao = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				setResponsaveisManutencao([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setResponsaveisManutencao([...arr]);
			}} />
		</Fragment>
	)

	const acoesAtividadesManutencao = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				setMetodosLimpezaManutencao([]);
				//setAtividadesManutencao([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setMetodosLimpezaManutencao([...arr]);
				//setAtividadesManutencao([...arr]);
			}} />
		</Fragment>
	)


	const acoesResponsaveisLimpezaInstalacoes = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				setResponsaveisInstalacao([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setResponsaveisInstalacao([...arr]);
			}} />
		</Fragment>
	)

	const acoesMetodoLimpezaInstalacoes = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				setMetodosLimpezaInstalacao([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setMetodosLimpezaInstalacao([...arr]);
			}} />
		</Fragment>
	)

	const acoesMetodoDestruicao = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				setMetodosDestruicao([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setMetodosDestruicao([...arr]);
			}} />
		</Fragment>
	)
	const acoesMetodosLimpezaEquipamentos = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				setMetodosLimpezaEquipamentos([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setMetodosLimpezaEquipamentos([...arr]);
			}} />
		</Fragment>
	)


	const acoesResponsaveisAmostragem = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				setResponsaveisAmostragem([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setResponsaveisAmostragem([...arr]);
			}} />
		</Fragment>
	)

	const acoesResponsaveisPessoaColheita = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				setResponsaveisColheita([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setResponsaveisColheita([...arr]);
			}} />
		</Fragment>
	)

	const acoesResponsaveisPreColheita = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				setResponsaveisPreColheita([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setResponsaveisPreColheita([...arr]);
			}} />
		</Fragment>
	)

	const acoesResponsaveisDestruicao = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				setResponsaveisDestruicao([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setResponsaveisDestruicao([...arr]);
			}} />
		</Fragment>
	)

	const acoesResponsaveisEquipamentos = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				setResponsaveisEquipamentos([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setResponsaveisEquipamentos([...arr]);
			}} />
		</Fragment>
	)

	const submitArquivosDocumentosGerais = async (formArquivosData: any) => {
		const arquivo = extrairArquivoDoModal(formArquivosData);
		if (!arquivo) {
			return;
		}

		setModalAtivo('');
		setDocumentosGerais([...documentosGerais, arquivo]);
		setLblDocumentosGerais('Escolher arquivo');
		modalArquivo.reset();
	}

	const submitArquivosDadosPrincipaisAAC = async (formArquivosData: any) => {
		const arquivo = extrairArquivoDoModal(formArquivosData);
		if (!arquivo) {
			return;
		}

		setModalAtivo('');
		setDadosPrincipaisAAC([...dadosPrincipaisAAC, arquivo]);
		setLblDadosPrincipaisAAC('Escolher arquivo');
		modalArquivo.reset();
	}

	const submitArquivosListaTreinamento = async (formArquivosData: any) => {
		const arquivo = extrairArquivoDoModal(formArquivosData);
		if (!arquivo) {
			return;
		}

		setModalAtivo('');
		setDadosPrincipaisListaTreinamento([...dadosPrincipaisListaTreinamento, arquivo]);
		setLblDadosPrincipaisListaTreinamento('Escolher arquivo');
		modalArquivo.reset();
	}

	const submitArquivosDadosPrincipaisParecerTecnico = async (formArquivosData: any) => {
		const arquivo = extrairArquivoDoModal(formArquivosData);
		if (!arquivo) {
			return;
		}

		setModalAtivo('');
		Object.defineProperty(arquivo, 'filename', { value: arquivo.name, writable: true });
		setDadosPrincipaisParecerTecnico([...dadosPrincipaisParecerTecnico, arquivo]);
		setLblDadosPrincipaisParecerTecnico('Escolher arquivo');
		modalArquivo.reset();
	}

	const submitArquivosLiberacaoQuarentena = async (formArquivosData: any) => {
		const arquivo = extrairArquivoDoModal(formArquivosData);
		if (!arquivo) {
			return;
		}

		setModalAtivo('');
		setDadosPrincipaisLiberacaoQuarentena([...dadosPrincipaisLiberacaoQuarentena, arquivo]);
		setLblDadosPrincipaisLiberacaoQuarentena('Escolher arquivo');
		modalArquivo.reset();
	}

	const submitArquivosPlanejamentoCroqui = async (formArquivosData: any) => {
		const arquivo = extrairArquivoDoModal(formArquivosData);
		if (!arquivo) {
			return;
		}

		setModalAtivo('');
		setPlanejamentoCroqui([...planejamentoCroqui, arquivo]);
		setLblPlanejamentoCroqui('Escolher arquivo');
		modalArquivo.reset();
	}

	const submitArquivosConducaoComunicados = async () => {
		setModalAtivo('');

		const novoArquivo = defaultForm.getValues('novoComunicado') as any;
		const dataComunicado = defaultForm.getValues('dataComunicado');

		if (novoArquivo?.[0]) {
			const file = novoArquivo[0] as File;
			const novoComunicado = {
				id: 0,
				filename: file.name,
				name: file.name,
				path: '',
				dataComunicado,
				file,
			};
			setConducaoComunicados([...conducaoComunicados, novoComunicado]);
			setLblConducaoComunicados('Escolher arquivo');
		}
	}

	const submitArquivosFiscalizacaoTermos = async (formArquivosData: any) => {
		const arquivo = extrairArquivoDoModal(formArquivosData);
		if (!arquivo) {
			return;
		}

		setModalAtivo('');
		setFiscalizacaoTermos([...fiscalizacaoTermos, arquivo]);
		setLblFiscalizacaoTermos('Escolher arquivo');
		modalArquivo.reset();
	}

	const submitArquivosColheitaAMI = async (formArquivosData: any) => {
		const arquivo = extrairArquivoDoModal(formArquivosData);
		if (!arquivo) {
			return;
		}

		setModalAtivo('');
		setColheitaAMI([arquivo]);
		setLblColheitaAMI('Escolher arquivo');
		modalArquivo.reset();
	}


	const actionsAnotacoes = (props: any) => (
		<Fragment>
			<EditButton onClick={() => {

				setAnotacaoEdit(props.data);
				setContagemAnotacao(props.data.contagemAnotacao * 1);

				setGridProps(props.node);

				setModalAnotacoes(true)
			}} />
			&nbsp;&nbsp;
			<DeleteButton onClick={() => {
				setSelectedAnotacoes([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setSelectedAnotacoes([...arr]);
			}} />
		</Fragment>
	)

	const onSubmitAnotacoes = (info: VegetacaoAnotacoes): void => {
		if (!textoPreenchido(info.anotacao)) {
			return;
		}

		setSelectedAnotacoes([]);

		let indice = 0;
		const arr = selectedAnotacoes.filter(e => e.contagemAnotacao !== contagemAnotacao);

		for (let i = 0, t = arr.length; i < t; i++) {
			indice = arr[i].contagemAnotacao * 1;
		}
		setSelectedAnotacoes([...arr, {
			id: 0,
			responsavel: decoded.unique_name,
			dataAnotacao: moment().toDate(),
			anotacao: info.anotacao,
			contagemAnotacao: contagemAnotacao === 0 ? indice + 1 : contagemAnotacao,
		}]);

		setModalAnotacoes(false);
	}

	const actionsRegistroAmostragem = (props: any) => (
		<Fragment>
			<EditButton onClick={() => {

				setRegistroAmostragemEdit(prepararRegistroAmostragemParaEdicao(props.data));
				setContagemRegistroAmostragem(props.data.contagemRegistroAmostragem * 1);
				setResponsaveisAmostragem(props.data.responsaveis ?? []);

				setGridProps(props.node);

				setArquivoRegistroAmostragemPendente(null);
				setLblArquivoRegistroAmostragem(props.data.filename || 'Escolher arquivo');
				setModalRegistroAmostragem(true)
			}} />
			&nbsp;&nbsp;
			<DeleteButton onClick={() => {
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setSelectedRegistroAmostragem([...arr]);
			}} />
		</Fragment>
	)

	const onSubmitRegistroAmostragem = (info: VegetacaoRegistroAmostragem): void => {

		let indice = 0;
		let listaResponsaveisGrid = "";

		const arr = selectedRegistroAmostragem.filter(e => e.contagemRegistroAmostragem !== contagemRegistroAmostragem);

		for (let i = 0, t = arr.length; i < t; i++) {
			indice = arr[i].contagemRegistroAmostragem * 1;
		}

		for (let j = 0, k = responsaveisAmostragem.length; j < k; j++)
			listaResponsaveisGrid += responsaveisAmostragem[j].responsavel + "; ";

		let arquivoAmostragem: any = registroAmostragemEdit.arquivoAmostragem ?? '';
		let filename = obterFilenameArquivoAmostragem(registroAmostragemEdit.arquivoAmostragem, registroAmostragemEdit.filename);
		const arquivoSalvoEdicao = obterArquivoRegistroAmostragemSalvo(registroAmostragemEdit);

		const novoArquivo = info.arquivoAmostragem;
		const filePendente = extrairFileAmostragemPendente(novoArquivo) ?? arquivoRegistroAmostragemPendente;

		if (filePendente) {
			filename = filePendente.name;
			arquivoAmostragem = {
				file: filePendente,
				filename: filePendente.name,
				name: filePendente.name,
			};
		}

		setSelectedRegistroAmostragem(ordenarPorDataAsc([...arr, {
			id: registroAmostragemEdit.id ?? 0,
			contagemRegistroAmostragem: contagemRegistroAmostragem === 0 ? indice + 1 : contagemRegistroAmostragem,
			dataInicialAmostragem: info.dataInicialAmostragem,
			dataFinalAmostragem: info.dataFinalAmostragem,
			tipoMaterialAmostragem: info.tipoMaterialAmostragem,
			destinoAmostras: info.destinoAmostras,
			arquivoAmostragem,
			filename,
			path: filePendente ? undefined : arquivoSalvoEdicao.path,
			codigo: filePendente ? undefined : arquivoSalvoEdicao.codigo,
			tipoMaterialAmostragemOutros: info.tipoMaterialAmostragemOutros,
			destinoAmostrasOutros: info.destinoAmostrasOutros,

			responsaveis: responsaveisAmostragem,
			listaResponsaveis: listaResponsaveisGrid,

		}], 'dataInicialAmostragem', 'contagemRegistroAmostragem'));

		setModalRegistroAmostragem(false);
		setLblArquivoRegistroAmostragem('Escolher arquivo');
		setArquivoRegistroAmostragemPendente(null);
		setResponsaveisAmostragem([]);
		setContagemRegistroAmostragem(0);

	}

	const actionsRegistroColheita = (props: any) => (
		<Fragment>
			<EditButton onClick={() => {
				setRegistroColheitaEdit(prepararRegistroColheitaParaEdicao(props.data));
				setContagemRegistroColheita(props.data.contagemRegistroColheita * 1);
				setResponsaveisColheitaModal(props.data.responsaveis ?? []);
				setGridProps(props.node);
				setArquivoRegistroColheitaPendente(null);
				setLblArquivoRegistroColheita(props.data.filename || 'Escolher arquivo');
				setModalRegistroColheita(true);
			}} />
			&nbsp;&nbsp;
			<DeleteButton onClick={() => {
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setSelectedRegistroColheita([...arr]);
			}} />
		</Fragment>
	)

	const AdicionarPessoaEnvolvidaColheitaModal = () => {
		const pessoa = (defaultForm.getValues('pessoaColheitaModal') as string | undefined) ?? '';
		const pessoaNormalizada = pessoa.trim();
		if (!pessoaNormalizada || responsaveisColheitaModal.some(r => r.responsavel === pessoaNormalizada)) {
			return;
		}

		setResponsaveisColheitaModal([...responsaveisColheitaModal, {
			id: 0,
			responsavel: pessoaNormalizada,
			contagem: responsaveisColheitaModal.length + 1,
		}]);
	}

	const onSubmitRegistroColheita = (info: VegetacaoRegistroColheita): void => {
		let indice = 0;
		let listaResponsaveisGrid = '';

		const arr = selectedRegistroColheita.filter(e => e.contagemRegistroColheita !== contagemRegistroColheita);

		for (let i = 0, t = arr.length; i < t; i++) {
			indice = arr[i].contagemRegistroColheita * 1;
		}

		for (let j = 0, k = responsaveisColheitaModal.length; j < k; j++)
			listaResponsaveisGrid += responsaveisColheitaModal[j].responsavel + '; ';

		let arquivoAMIColheita: any = registroColheitaEdit.arquivoAMIColheita ?? '';
		let filename = obterFilenameArquivoColheita(registroColheitaEdit.arquivoAMIColheita, registroColheitaEdit.filename);
		const arquivoSalvoEdicao = obterArquivoRegistroColheitaSalvo(registroColheitaEdit);

		const novoArquivo = info.arquivoAMIColheita;
		const filePendente = extrairFileColheitaPendente(novoArquivo) ?? arquivoRegistroColheitaPendente;

		if (filePendente) {
			filename = filePendente.name;
			arquivoAMIColheita = {
				file: filePendente,
				filename: filePendente.name,
				name: filePendente.name,
			};
		}

		if (isValorOutros(info.tipoMaterialColheita?.value) && !textoPreenchido(info.outrosTipoMaterialColheita)) {
			return;
		}

		setSelectedRegistroColheita(ordenarPorDataAsc([...arr, {
			id: registroColheitaEdit.id ?? 0,
			contagemRegistroColheita: contagemRegistroColheita === 0 ? indice + 1 : contagemRegistroColheita,
			tipoColheita: info.tipoColheita,
			dataColheita: info.dataInicialColheita ?? info.dataColheita,
			dataInicialColheita: info.dataInicialColheita,
			dataFinalColheita: info.dataFinalColheita,
			tipoMaterialColheita: info.tipoMaterialColheita,
			outrosTipoMaterialColheita: info.outrosTipoMaterialColheita,
			quantidadeMaterialColheita: info.quantidadeMaterialColheita,
			numeroAMIColheita: info.numeroAMIColheita,
			destinoMaterialColheita: info.destinoMaterialColheita,
			arquivoAMIColheita,
			filename,
			path: filePendente ? undefined : arquivoSalvoEdicao.path,
			codigo: filePendente ? undefined : arquivoSalvoEdicao.codigo,
			responsaveis: responsaveisColheitaModal,
			listaResponsaveis: listaResponsaveisGrid,
		}], 'dataInicialColheita', 'contagemRegistroColheita'));

		setModalRegistroColheita(false);
		setLblArquivoRegistroColheita('Escolher arquivo');
		setArquivoRegistroColheitaPendente(null);
		setResponsaveisColheitaModal([]);
		setContagemRegistroColheita(0);
		defaultForm.setValue('pessoaColheitaModal', '');
	}

	const actionsRegistroFiscalizacao = (props: any) => (
		<Fragment>
			<EditButton onClick={() => {
				setRegistroFiscalizacaoEdit(prepararRegistroFiscalizacaoParaEdicao(props.data));
				setContagemRegistroFiscalizacao(props.data.contagemRegistroFiscalizacao * 1);
				setArquivoRegistroFiscalizacaoPendente(null);
				setLblArquivoRegistroFiscalizacao(props.data.filename || 'Escolher arquivo');
				setModalRegistroFiscalizacao(true);
			}} />
			&nbsp;&nbsp;
			<DeleteButton onClick={() => {
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setSelectedRegistroFiscalizacao([...arr]);
			}} />
		</Fragment>
	)

	const onSubmitRegistroFiscalizacao = (info: VegetacaoRegistroFiscalizacao): void => {
		let indice = 0;
		const arr = selectedRegistroFiscalizacao.filter(e => e.contagemRegistroFiscalizacao !== contagemRegistroFiscalizacao);

		for (let i = 0, t = arr.length; i < t; i++) {
			indice = arr[i].contagemRegistroFiscalizacao * 1;
		}

		let arquivoTermo: any = registroFiscalizacaoEdit.arquivoTermo ?? '';
		let filename = obterFilenameArquivoFiscalizacao(registroFiscalizacaoEdit.arquivoTermo, registroFiscalizacaoEdit.filename);
		const arquivoSalvoEdicao = obterArquivoRegistroFiscalizacaoSalvo(registroFiscalizacaoEdit);

		const novoArquivo = info.arquivoTermo;
		const filePendente = extrairFileFiscalizacaoPendente(novoArquivo) ?? arquivoRegistroFiscalizacaoPendente;

		if (filePendente) {
			filename = filePendente.name;
			arquivoTermo = {
				file: filePendente,
				filename: filePendente.name,
				name: filePendente.name,
			};
		}

		if (isValorOutros(info.orgaoFiscalizador?.value) && !textoPreenchido(info.outrosOrgaoFiscalizador)) {
			return;
		}

		setSelectedRegistroFiscalizacao(ordenarPorDataAsc([...arr, {
			id: registroFiscalizacaoEdit.id ?? 0,
			contagemRegistroFiscalizacao: contagemRegistroFiscalizacao === 0 ? indice + 1 : contagemRegistroFiscalizacao,
			orgaoFiscalizador: info.orgaoFiscalizador
				? {
					label: info.orgaoFiscalizador.label,
					value: obterValorNumericoId(info.orgaoFiscalizador.value),
				}
				: info.orgaoFiscalizador,
			outrosOrgaoFiscalizador: info.outrosOrgaoFiscalizador,
			dataFiscalizacao: info.dataFiscalizacao,
			observacoesTermosFiscalizacao: info.observacoesTermosFiscalizacao,
			termosFiscalizacao: true,
			arquivoTermo,
			filename,
			path: filePendente ? undefined : arquivoSalvoEdicao.path,
			codigo: filePendente ? undefined : arquivoSalvoEdicao.codigo,
		}], 'dataFiscalizacao', 'contagemRegistroFiscalizacao'));

		setModalRegistroFiscalizacao(false);
		setLblArquivoRegistroFiscalizacao('Escolher arquivo');
		setArquivoRegistroFiscalizacaoPendente(null);
		setContagemRegistroFiscalizacao(0);
	}

	const actionsDataPlantios = (props: any) => (
		<Fragment>
			<EditButton onClick={() => {

				setDataPlantioEdit(props.data);

				setGridProps(props.node);

				setModalDataPlantios(true)
			}} />
			&nbsp;&nbsp;
			<DeleteButton onClick={() => {
				setSelectedDataPlantios([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setSelectedDataPlantios([...arr]);
			}} />
		</Fragment>
	)

	const onSubmitDataPlantios = (info: VegetacaoDataPlantios): void => {

		setSelectedDataPlantios([]);

		const arr = selectedDataPlantios.filter(e => e.dataInicialPlantio !== info.dataInicialPlantio);

		setSelectedDataPlantios([...arr, {
			id: 0,
			dataInicialPlantio: info.dataInicialPlantio,
			dataFinalPlantio: info.dataFinalPlantio,
		}]);

		setModalDataPlantios(false);
	}

	const actionsPessoasEnvolvidasPlantio = (props: any) => (
		<Fragment>
			<EditButton onClick={() => {

				setPessoasEnvolvidasPlantioEdit(props.data);
				setContagemPessoasEnvolvidasPlantio(props.data.contagemPessoasEnvolvidasPlantio * 1);

				setGridProps(props.node);

				setModalPessoasEnvolvidasPlantio(true)
			}} />
			&nbsp;&nbsp;
			<DeleteButton onClick={() => {
				setSelectedPessoasEnvolvidasPlantio([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setSelectedPessoasEnvolvidasPlantio([...arr]);
			}} />
		</Fragment>
	)

	const onSubmitPessoasEnvolvidasPlantio = (info: VegetacaoPessoasEnvolvidasPlantio): void => {
		if (!textoPreenchido(info.pessoaPlantio)) {
			return;
		}

		setSelectedPessoasEnvolvidasPlantio([]);

		let indice = 0;
		const arr = selectedPessoasEnvolvidasPlantio.filter(e => e.contagemPessoasEnvolvidasPlantio !== contagemPessoasEnvolvidasPlantio);

		for (let i = 0, t = arr.length; i < t; i++) {
			indice = arr[i].contagemPessoasEnvolvidasPlantio * 1;
		}
		setSelectedPessoasEnvolvidasPlantio([...arr, {
			id: 0,
			contagemPessoasEnvolvidasPlantio: contagemPessoasEnvolvidasPlantio === 0 ? indice + 1 : contagemPessoasEnvolvidasPlantio,
			pessoaPlantio: info.pessoaPlantio,
		}]);

		setModalPessoasEnvolvidasPlantio(false);
	}

	const acoesNumeroAMI = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				setNumeroAMI([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setNumeroAMI([...arr]);
			}} />
		</Fragment>
	)

	const submitArquivos = async (formArquivosData: any) => {
		const arquivo = extrairArquivoDoModal(formArquivosData);
		if (!arquivo) {
			return;
		}

		setModalAtivo('');
		setNumeroAMI([...numeroAMI, arquivo]);
		setLblNumeroAMI('Escolher arquivo');
		modalArquivo.reset();
	}

	const actionsPlantios = (props: any) => (
		<Fragment>
			<EditButton onClick={() => {
				openPlantioModal(props.data, props.node);
			}} />
			&nbsp;&nbsp;
			<DeleteButton onClick={() => {
				setSelectedPlantios([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setSelectedPlantios([...arr]);
				setPlantioArquivoMateriais((prev) => atualizarPoolArquivoPlantio(prev, null, props.data.numeroPlantio));
				setPlantioArquivoAMIFiles((prev) => atualizarPoolArquivoPlantio(prev, null, props.data.numeroPlantio));
			}} />
		</Fragment>
	)

	const onSubmitPlantios = (info: VegetacaoPlantios): void => {

		setSelectedPlantios([]);

		const arr = selectedPlantios.filter(e => e.numeroPlantio !== info.numeroPlantio);
		const arquivoMaterialSalvo = obterArquivoPlantioMaterialSalvo(plantioEdit);
		const arquivoAMISalvo = obterArquivoPlantioAMISalvo(plantioEdit);

		let filenameMaterialPlantado = arquivoMaterialSalvo.filename ?? plantioEdit.filenameMaterialPlantado ?? '';
		let pathMaterialPlantado = arquivoMaterialSalvo.path ?? plantioEdit.pathMaterialPlantado;
		let codigoMaterialPlantado = arquivoMaterialSalvo.codigo ?? plantioEdit.codigoMaterialPlantado;
		let arquivoMaterialPlantado: any = plantioEdit.arquivoMaterialPlantado;

		if (plantioMaterialFile instanceof File) {
			filenameMaterialPlantado = plantioMaterialFile.name;
			pathMaterialPlantado = undefined;
			codigoMaterialPlantado = undefined;
			arquivoMaterialPlantado = montarArquivoPlantioPendente(plantioMaterialFile, info.numeroPlantio);
			setPlantioArquivoMateriais((prev) => atualizarPoolArquivoPlantio(prev, arquivoMaterialPlantado, info.numeroPlantio));
		} else if (!filenameMaterialPlantado) {
			arquivoMaterialPlantado = null;
			setPlantioArquivoMateriais((prev) => atualizarPoolArquivoPlantio(prev, null, info.numeroPlantio));
		}

		let filenamePlantioAMI = arquivoAMISalvo.filename ?? plantioEdit.filenamePlantioAMI ?? '';
		let pathPlantioAMI = arquivoAMISalvo.path ?? plantioEdit.pathPlantioAMI;
		let codigoPlantioAMI = arquivoAMISalvo.codigo ?? plantioEdit.codigoPlantioAMI;
		let arquivoPlantioAMI: any = plantioEdit.arquivoPlantioAMI;

		if (plantioAMIFile instanceof File) {
			filenamePlantioAMI = plantioAMIFile.name;
			pathPlantioAMI = undefined;
			codigoPlantioAMI = undefined;
			arquivoPlantioAMI = montarArquivoPlantioPendente(plantioAMIFile, info.numeroPlantio);
			setPlantioArquivoAMIFiles((prev) => atualizarPoolArquivoPlantio(prev, arquivoPlantioAMI, info.numeroPlantio));
		} else if (!filenamePlantioAMI) {
			arquivoPlantioAMI = null;
			setPlantioArquivoAMIFiles((prev) => atualizarPoolArquivoPlantio(prev, null, info.numeroPlantio));
		}

		setSelectedPlantios(ordenarPorDataAsc([...arr, {
			id: plantioEdit.id ?? 0,
			numeroPlantio: info.numeroPlantio,
			casaVegetacaoModulo: info.casaVegetacaoModulo,
			material: info.material,
			informacoesAdicionaisMaterial: info.informacoesAdicionaisMaterial,
			numeroAMI: info.numeroAMI,
			sobraMaterial: info.sobraMaterial,
			numeroAmostrasRestantes: info.numeroAmostrasRestantes,
			quantidadeAmostrasRestantes: info.quantidadeAmostrasRestantes,
			destinoSobra: info.destinoSobra,
			entradaArmazenamento: info.entradaArmazenamento,
			informacoesAdicionais: info.informacoesAdicionais,
			destinoSobraOutros: info.destinoSobraOutros,
			dataInicialPlantio: info.dataInicialPlantio,
			dataFinalPlantio: info.dataFinalPlantio,

			filenameMaterialPlantado,
			pathMaterialPlantado,
			codigoMaterialPlantado,
			arquivoMaterialPlantado,
			filenamePlantioAMI,
			pathPlantioAMI,
			codigoPlantioAMI,
			arquivoPlantioAMI,

			responsaveis: responsaveisPlantio,
		}], 'dataInicialPlantio'));

		setModalPlantios(false);
		setCheckboxSobraMaterial(false);
		setResponsaveisPlantio([]);
		setPlantioMaterialFile(null);
		setPlantioAMIFile(null);
	}

	const acoesResponsaveisReporte = (props: any) => (
		<Fragment>
			<EditButton onClick={() => {

				setResponsavelReporteEdit(props.data);

				setGridProps(props.node);

				setModalResponsavelReporte(true)
			}} />
			&nbsp;&nbsp;
			<DeleteButton onClick={() => {
				setResponsaveisReporte([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setResponsaveisReporte([...arr]);
			}} />
		</Fragment>
	)

	const onSubmitResponsavelReporte = (info: VegetacaoResponsaveisReporte): void => {
		const nome = defaultForm.getValues('nomeReporteLiberacaoNaoIntencional');
		const cargo = defaultForm.getValues('cargoReporteLiberacaoNaoIntencional');
		const dataReporte = defaultForm.getValues('dataReporteLiberacaoNaoIntencional');

		if (!textoPreenchido(nome) || !textoPreenchido(cargo) || !dataReporte) {
			return;
		}

		setResponsaveisReporte([]);

		setResponsaveisReporte([...responsaveisReporte, {
			id: 0,
			nomeReporteLiberacaoNaoIntencional: defaultForm.getValues('nomeReporteLiberacaoNaoIntencional'),
			cargoReporteLiberacaoNaoIntencional: defaultForm.getValues('cargoReporteLiberacaoNaoIntencional'),
			dataReporteLiberacaoNaoIntencional: defaultForm.getValues('dataReporteLiberacaoNaoIntencional'),
			contagemReporteLiberacaoNaoIntencional: responsaveisReporte.length + 1,
		}]);

		setModalResponsavelReporte(false);

	}

	const acoesNumeroAAC = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				setNumeroAAC([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setNumeroAAC([...arr]);
			}} />
		</Fragment>
	)

	const submitArquivosAAC = async (formArquivosData: any) => {
		const arquivo = extrairArquivoDoModal(formArquivosData);
		if (!arquivo) {
			return;
		}

		setModalAtivo('');
		setNumeroAAC([...numeroAAC, arquivo]);
		setLblNumeroAAC('Escolher arquivo');
		modalArquivo.reset();
	}

	const actionsLimpezaDestruicao = (props: any) => (
		<Fragment>
			<EditButton onClick={() => {
				const editData = prepararLimpezaDestruicaoParaEdicao(props.data);
				setLimpezaDestruicaoEdit(editData);
				setContagemLimpezaDestruicao(props.data.contagemLimpezaDestruicao * 1);
				resetLimpezaDestruicao({
					descricaoMaquinario: editData.descricaoMaquinario,
					dataLimpezaAntesUso: editData.dataLimpezaAntesUso,
					dataLimpezaDepoisUso: editData.dataLimpezaDepoisUso,
					responsavelLimpeza: editData.responsavelLimpeza,
					metodoLimpeza: editData.metodoLimpeza,
					outrosMetodoLimpeza: editData.outrosMetodoLimpeza,
				});
				setGridProps(props.node);
				setModalLimpezaDestruicao(true);
			}} />
			&nbsp;&nbsp;
			<DeleteButton onClick={() => {
				setSelectedLimpezaDestruicao([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setSelectedLimpezaDestruicao([...arr]);
			}} />
		</Fragment>
	)

	const onSubmitLimpezaDestruicao = (info: VegetacaoLimpezaDestruicao): void => {
		const metodoSelecionado = info.metodoLimpeza as any;

		if (isValorOutros(metodoSelecionado?.value) && !textoPreenchido(info.outrosMetodoLimpeza)) {
			return;
		}

		const metodoLimpezaFormatado = typeof metodoSelecionado === 'object' && metodoSelecionado !== null
			? (isValorOutros(metodoSelecionado.value)
				? formatarMetodoLimpezaOutros(metodoSelecionado.label, info.outrosMetodoLimpeza)
				: metodoSelecionado.label)
			: normalizarMetodoLimpezaParaExibicao(String(info.metodoLimpeza ?? ''), info.outrosMetodoLimpeza);

		setSelectedLimpezaDestruicao([]);

		let indice = 0;
		const arr = selectedLimpezaDestruicao.filter(e => e.contagemLimpezaDestruicao !== contagemLimpezaDestruicao);

		for (let i = 0, t = arr.length; i < t; i++) {
			indice = arr.length * 1;
		}

		setSelectedLimpezaDestruicao(ordenarPorDataAsc([...arr, {
			id: limpezaDestruicaoEdit.id ?? 0,
			contagemLimpezaDestruicao: contagemLimpezaDestruicao === 0 ? indice + 1 : contagemLimpezaDestruicao,
			descricaoMaquinario: info.descricaoMaquinario,
			dataLimpezaAntesUso: moment(info.dataLimpezaAntesUso).toDate(),
			dataLimpezaDepoisUso: moment(info.dataLimpezaDepoisUso).toDate(),
			metodoLimpeza: metodoLimpezaFormatado,
			metodoLimpeza_Id: metodoSelecionado?.value,
			outrosMetodoLimpeza: info.outrosMetodoLimpeza,
			responsavelLimpeza: info.responsavelLimpeza,
		}], 'dataLimpezaAntesUso', 'contagemLimpezaDestruicao'));

		setModalLimpezaDestruicao(false);
	}

	const actionsDestruicao = (props: any) => (
		<Fragment>
			<EditButton onClick={() => {
				openDestruicaoModal(props.data, props.node);
			}} />
			&nbsp;&nbsp;
			<DeleteButton onClick={() => {
				setSelectedDestruicao([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setSelectedDestruicao([...arr]);
			}} />
		</Fragment>
	)

	const onSubmitDestruicao = (info: VegetacaoDestruicao): void => {
		destruicaoGradeHidratada.current = true;

		setSelectedDestruicao([]);

		let indice = 0;
		let listaResponsaveisGrid = "";
		const rowExistente = selectedDestruicao.find(e => e.contagemDestruicao === contagemDestruicao);

		const arr = selectedDestruicao.filter(e => e.contagemDestruicao !== contagemDestruicao);

		for (let i = 0, t = arr.length; i < t; i++) {
			indice = arr[i].contagemDestruicao * 1;
		}

		for (let j = 0, k = responsaveisDestruicao.length; j < k; j++)
			listaResponsaveisGrid += responsaveisDestruicao[j].responsavel + "; ";


		setSelectedDestruicao(ordenarPorDataAsc([...arr, {
			id: rowExistente?.id ?? destruicaoEdit.id ?? 0,
			contagemDestruicao: contagemDestruicao === 0 ? indice + 1 : contagemDestruicao,
			dataInicialDestruicao: info.dataInicialDestruicao,
			dataFinalDestruicao: info.dataFinalDestruicao,
			tipoDestruicao: tipoDestruicaoValue,
			outrosTipoDestruicao: info.outrosTipoDestruicao !== undefined ? info.outrosTipoDestruicao : '',
			numeroAmostras: parseInteiroNaoNegativo(info.numeroAmostras),
			pesoAmostras: parseDecimalNaoNegativo(info.pesoAmostras),
			unidadeMedida: unidadeMedidaValue,
			localDestruicao: localDestruicaoValue,
			outrosLocalDestruicao: info.outrosLocalDestruicao !== undefined ? info.outrosLocalDestruicao : '',
			observacoesLocalDestruicao: info.observacoesLocalDestruicao !== undefined ? info.observacoesLocalDestruicao : '',
			metodoDestruicao: metodoDestruicaoValue,
			outrosMetodoDestruicao: info.outrosMetodoDestruicao !== undefined ? info.outrosMetodoDestruicao : '',
			observacoesMetodoDestruicao: info.observacoesMetodoDestruicao,
			tipoFaseDestruicao_Id: lerNumeroDestruicao(tipoFaseDestruicaoValue, 0),
			outrosTipoFaseDestruicao: info.outrosTipoFaseDestruicao !== undefined ? info.outrosTipoFaseDestruicao : '',

			responsaveisDestruicao: responsaveisDestruicao,
			listaResponsaveisDestruicao: listaResponsaveisGrid,
			metodosDestruicao: metodosDestruicao,
			limpezaDestruicao: selectedLimpezaDestruicao,

		}], 'dataInicialDestruicao', 'contagemDestruicao'));

		setModalDestruicao(false);
		setExibirAnexoDestruicaoAMI(false);
		limparEstadoModalDestruicao();
		aplicarEstadoSelectsDestruicao({});
		resetDestruicao(montarValoresFormDestruicao({}));
	}

	const actionsDatasColheita = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				setSelectedDatasColheita([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setSelectedDatasColheita([...arr]);
			}} />
		</Fragment>
	)

	const onSubmitDatasColheita = (info: VegetacaoDataColheita): void => {

		setSelectedDatasColheita([...selectedDatasColheita, {
			id: 0,
			dataColheita: moment(info.dataColheita).toDate(),
			dataInicialColheita: moment(info.dataInicialColheita).toDate(),
			dataFinalColheita: moment(info.dataFinalColheita).toDate(),
		}]);

		setModalDatasColheita(false);
	}

	const actionsPessoasEnvolvidasColheita = (props: any) => (
		<Fragment>
			<EditButton onClick={() => {

				setPessoasEnvolvidasColheitaEdit(props.data);
				setContagemPessoasEnvolvidasColheita(props.data.contagemPessoasEnvolvidasColheita * 1);

				setGridProps(props.node);

				setModalPessoasEnvolvidasColheita(true)
			}} />
			&nbsp;&nbsp;
			<DeleteButton onClick={() => {
				setSelectedPessoasEnvolvidasColheita([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setSelectedPessoasEnvolvidasColheita([...arr]);
			}} />
		</Fragment>
	)

	const onSubmitPessoasEnvolvidasColheita = (info: VegetacaoPessoasEnvolvidasColheita): void => {
		if (!textoPreenchido(info.pessoaColheita)) {
			return;
		}

		setSelectedPessoasEnvolvidasColheita([]);

		let indice = 0;
		const arr = selectedPessoasEnvolvidasColheita.filter(e => e.contagemPessoasEnvolvidasColheita !== contagemPessoasEnvolvidasColheita);

		for (let i = 0, t = arr.length; i < t; i++) {
			indice = arr[i].contagemPessoasEnvolvidasColheita * 1;
		}
		setSelectedPessoasEnvolvidasColheita([...arr, {
			id: 0,
			contagemPessoasEnvolvidasColheita: contagemPessoasEnvolvidasColheita === 0 ? indice + 1 : contagemPessoasEnvolvidasColheita,
			pessoaColheita: info.pessoaColheita,
		}]);

		setModalPessoasEnvolvidasColheita(false);
	}

	//const actionsResponsaveisDescarte = (props: any) => (
	//	<Fragment>
	//		<EditButton onClick={() => {

	//			setResponsaveisDescarteEdit(props.data);
	//			setContagemResponsaveisDescarte(props.data.contagemResponsaveisDescarte * 1);

	//			setGridProps(props.node);

	//			setModalResponsaveisDescarte(true)
	//		}} />
	//		&nbsp;&nbsp;
	//		<DeleteButton onClick={() => {
	//			setSelectedResponsaveisDescarte([]);
	//			let arr: any = [];
	//			const { node } = props;

	//			node.gridApi.updateRowData({ remove: [node.data] })

	//			node.gridApi.forEachNode(({ data }: any) => arr.push(data));
	//			setSelectedResponsaveisDescarte([...arr]);
	//		}} />
	//	</Fragment>
	//)

	//const onSubmitResponsaveisDescarte = (info: VegetacaoResponsaveisDescarte): void => {

	//	setSelectedResponsaveisDescarte([]);

	//	let indice = 0;
	//	const arr = selectedResponsaveisDescarte.filter(e => e.contagemResponsaveisDescarte !== contagemResponsaveisDescarte);

	//	for (let i = 0, t = arr.length; i < t; i++) {
	//		indice = arr[i].contagemResponsaveisDescarte * 1;
	//	}
	//	setSelectedResponsaveisDescarte([...arr, {
	//		id: 0,
	//		contagemResponsaveisDescarte: contagemResponsaveisDescarte === 0 ? indice + 1 : contagemResponsaveisDescarte,
	//		responsaveisDescarte: info.responsaveisDescarte,
	//	}]);

	//	setModalResponsaveisDescarte(false);
	//}

	const actionsAtividadeManutencao = (props: any) => (
		<Fragment>
			<EditButton onClick={() => {
				openAtividadeManutencaoModal(props.data, props.node);
			}} />
			&nbsp;&nbsp;
			<DeleteButton onClick={() => {
				setSelectedAtividadeManutencao([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setSelectedAtividadeManutencao([...arr]);
			}} />
		</Fragment>
	)

	const onSubmitAtividadeManutencao = (info: VegetacaoAtividadeManutencao): void => {

		setSelectedAtividadeManutencao([]);

		let metodosAtualizados = [...metodosLimpezaManutencao];
		const atividadePendente = defaultForm.getValues('atividadeManutencao_Id') as any;
		const outrosPendente = info.outrosAtividadeManutencao;

		if (isValorOutros(atividadePendente?.value)) {
			if (textoPreenchido(outrosPendente)) {
				const descricaoPendente = obterDescricaoMetodoLimpezaFromSelect(atividadePendente, outrosPendente);
				if (descricaoPendente && !metodoLimpezaJaAdicionado(metodosAtualizados, descricaoPendente)) {
					metodosAtualizados = [...metodosAtualizados, {
						id: 0,
						descricao: descricaoPendente,
						contagem: metodosAtualizados.length + 1,
					}];
				}
			} else if (!metodosAtualizados.length) {
				return;
			}
		}

		let indice = 0;
		let listaResponsaveisGrid = "";
		let listaMetodosLimpezaGrid = "";

		const rowExistente = selectedAtividadeManutencao.find(e => e.contagemAtividadeManutencao === contagemAtividadeManutencao);
		const arr = selectedAtividadeManutencao.filter(e => e.contagemAtividadeManutencao !== contagemAtividadeManutencao);

		for (let i = 0, t = arr.length; i < t; i++) {
			indice = arr[i].contagemAtividadeManutencao * 1;
		}

		for (let j = 0, k = responsaveisManutencao.length; j < k; j++)
			listaResponsaveisGrid += responsaveisManutencao[j].responsavel + "; ";

		for (let j = 0, k = metodosAtualizados.length; j < k; j++)
			listaMetodosLimpezaGrid += metodosAtualizados[j].descricao + "; ";

		setSelectedAtividadeManutencao(ordenarPorDataAsc([...arr, {
			id: rowExistente?.id ?? atividadeManutencaoEdit.id ?? 0,
			contagemAtividadeManutencao: contagemAtividadeManutencao === 0 ? indice + 1 : contagemAtividadeManutencao,
			dataAtividade: info.dataAtividade,
			dataInicialAtividade: info.dataInicialAtividade,
			dataFinalAtividade: info.dataFinalAtividade,
			responsavel: info.responsavel,
			atividadeManutencao_Id: info.atividadeManutencao_Id,
			outrosAtividadeManutencao: info.outrosAtividadeManutencao,

			responsaveis: responsaveisManutencao,
			listaResponsaveis: listaResponsaveisGrid,

			metodosLimpeza: metodosAtualizados,
			listaMetodosLimpeza: listaMetodosLimpezaGrid,
		}], 'dataInicialAtividade', 'contagemAtividadeManutencao'));

		fecharModalAtividadeManutencao();
	}

	const actionsInspecaoEquipamentos = (props: any) => (
		<Fragment>
			<EditButton onClick={() => {
				openInspecaoEquipamentosModal(props.data, props.node);
			}} />
			&nbsp;&nbsp;
			<DeleteButton onClick={() => {
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setSelectedInspecaoEquipamentos([...arr]);
				sincronizarInspecaoEquipamentosNaEntity([...arr], tipoFaseLimpezaEquipamentosValue);
			}} />
		</Fragment>
	)

	const onSubmitInspecaoEquipamentos = (info: VegetacaoInspecaoEquipamentos): void => {
		let metodosAtualizados = [...metodosLimpezaEquipamentos];
		const metodoPendente = defaultForm.getValues('metodoLimpezaEquipamento_Id') as any;
		const outrosPendente = info.outrosMetodoLimpezaEquipamento;

		if (isValorOutros(metodoPendente?.value)) {
			if (textoPreenchido(outrosPendente)) {
				const descricaoPendente = obterDescricaoMetodoLimpezaFromSelect(metodoPendente, outrosPendente);
				if (descricaoPendente && !metodoLimpezaJaAdicionado(metodosAtualizados, descricaoPendente)) {
					metodosAtualizados = [...metodosAtualizados, {
						id: 0,
						descricao: descricaoPendente,
						contagem: metodosAtualizados.length + 1,
					}];
				}
			} else if (!metodosAtualizados.length) {
				return;
			}
		}

		let indice = 0;
		let listaResponsaveisGrid = "";
		let listaMetodosLimpezaGrid = "";

		const arr = selectedInspecaoEquipamentos.filter(e => e.contagemInspecaoEquipamento !== contagemInspecaoEquipamento);

		for (let i = 0, t = arr.length; i < t; i++) {
			indice = arr[i].contagemInspecaoEquipamento * 1;
		}

		for (let j = 0, k = responsaveisEquipamentos.length; j < k; j++)
			listaResponsaveisGrid += responsaveisEquipamentos[j].responsavel + "; ";

		for (let j = 0, k = metodosAtualizados.length; j < k; j++)
			listaMetodosLimpezaGrid += metodosAtualizados[j].descricao + "; ";

		const listaAtualizada = ordenarPorDataAsc([...arr, {
			id: inspecaoEquipamentosEdit.id ?? 0,
			contagemInspecaoEquipamento: contagemInspecaoEquipamento === 0 ? indice + 1 : contagemInspecaoEquipamento,
			numeroPlantio: info.numeroPlantio,
			iD_Equipamento: info.iD_Equipamento,
			dataAntesUso: moment(info.dataAntesUso).toDate(),
			dataAposUso: moment(info.dataAposUso).toDate(),
			metodoLimpezaEquipamento_Id: info.metodoLimpezaEquipamento_Id,
			faseEnsaio: info.faseEnsaio,
			outrosMetodoLimpezaEquipamento: info.outrosMetodoLimpezaEquipamento,
			faseLimpeza_Id: getFaseLimpezaOption(tipoFaseLimpezaEquipamentosValue),

			responsaveis: responsaveisEquipamentos,
			listaResponsaveis: listaResponsaveisGrid,

			metodosLimpeza: metodosAtualizados,
			listaMetodosLimpeza: listaMetodosLimpezaGrid,

		}], 'dataAntesUso', 'contagemInspecaoEquipamento');

		setSelectedInspecaoEquipamentos(listaAtualizada);
		sincronizarInspecaoEquipamentosNaEntity(listaAtualizada, tipoFaseLimpezaEquipamentosValue);

		setModalInspecaoEquipamentos(false);
	}

	const actionsLimpezaInstalacoes = (props: any) => (
		<Fragment>
			<EditButton onClick={() => {
				openLimpezaInstalacoesModal(props.data, props.node);
			}} />
			&nbsp;&nbsp;
			<DeleteButton onClick={() => {
				setSelectedLimpezaInstalacoes([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setSelectedLimpezaInstalacoes([...arr]);
			}} />
		</Fragment>
	)

	const onSubmitLimpezaInstalacoes = (info: VegetacaoLimpezaInstalacoes): void => {
		if (isValorOutros(info.tipoFaseLimpeza_Id?.value) && !textoPreenchido(info.outrosTipoFaseLimpeza)) {
			return;
		}

		let metodosAtualizados = [...metodosLimpezaInstalacao];
		const metodoPendente = defaultForm.getValues('metodoLimpeza_Id') as any;
		const outrosPendente = info.outrosMetodoLimpeza;

		if (isValorOutros(metodoPendente?.value)) {
			if (textoPreenchido(outrosPendente)) {
				const descricaoPendente = obterDescricaoMetodoLimpezaFromSelect(metodoPendente, outrosPendente);
				if (descricaoPendente && !metodoLimpezaJaAdicionado(metodosAtualizados, descricaoPendente)) {
					metodosAtualizados = [...metodosAtualizados, {
						id: 0,
						descricao: descricaoPendente,
						contagem: metodosAtualizados.length + 1,
					}];
				}
			} else if (!metodosAtualizados.length) {
				return;
			}
		}

		setSelectedLimpezaInstalacoes([]);

		let indice = 0;
		let listaResponsaveisGrid = "";
		let listaMetodosLimpezaGrid = "";

		const rowExistente = selectedLimpezaInstalacoes.find(e => e.contagemLimpezaInstalacao === contagemLimpezaInstalacao);
		const arr = selectedLimpezaInstalacoes.filter(e => e.contagemLimpezaInstalacao !== contagemLimpezaInstalacao);

		for (let i = 0, t = arr.length; i < t; i++) {
			indice = arr[i].contagemLimpezaInstalacao * 1;
		}

		for (let j = 0, k = responsaveisInstalacao.length; j < k; j++)
			listaResponsaveisGrid += responsaveisInstalacao[j].responsavel + "; ";

		for (let j = 0, k = metodosAtualizados.length; j < k; j++)
			listaMetodosLimpezaGrid += metodosAtualizados[j].descricao + "; ";


		setSelectedLimpezaInstalacoes(ordenarPorDataAsc([...arr, {
			id: rowExistente?.id ?? limpezaInstalacoesEdit.id ?? 0,
			contagemLimpezaInstalacao: contagemLimpezaInstalacao === 0 ? indice + 1 : contagemLimpezaInstalacao,
			responsavel: info.responsavel,
			dataLimpeza: info.dataLimpeza,
			metodoLimpeza_Id: info.metodoLimpeza_Id,
			numeroCodigoCasaVegetacao: info.numeroCodigoCasaVegetacao,
			outrosMetodoLimpeza: info.outrosMetodoLimpeza,
			dataInicialLimpeza: info.dataInicialLimpeza,
			dataFinalLimpeza: info.dataFinalLimpeza,
			tipoFaseLimpeza_Id: info.tipoFaseLimpeza_Id,
			outrosTipoFaseLimpeza: info.outrosTipoFaseLimpeza,
			observacoesLimpeza: info.observacoesLimpeza,

			responsaveis: responsaveisInstalacao,
			listaResponsaveis: listaResponsaveisGrid,

			metodosLimpeza: metodosAtualizados,
			listaMetodosLimpeza: listaMetodosLimpezaGrid,


		}], 'dataInicialLimpeza', 'contagemLimpezaInstalacao'));

		fecharModalLimpezaInstalacoes();
	}

	let BotoesFases =
		<div className="button-position tab-buttons-caderno">
			<Button
				title="Dados Principais e Documentos"
				contained={modoFluxo === MODO_VIEW.DADOS_PRINCIPAIS}
				className={modoFluxo === MODO_VIEW.DADOS_PRINCIPAIS ? "active" : ''}
				type="button"
				disabled={cadernoCarregando}
				onClick={() => trocarAba(MODO_VIEW.DADOS_PRINCIPAIS)}
			/>

			<Button
				title="Planejamento e Plantio"
				className={modoFluxo === MODO_VIEW.PLANEJAMENTO ? "active" : ''}
				contained={modoFluxo === MODO_VIEW.PLANEJAMENTO}
				type="button"
				disabled={cadernoCarregando}
				onClick={() => trocarAba(MODO_VIEW.PLANEJAMENTO)}
			/>

			<Button
				title="Condução e Manutenção do Ensaio"
				className={modoFluxo === MODO_VIEW.MANUTENCAO ? "active" : ''}
				contained={modoFluxo === MODO_VIEW.MANUTENCAO}
				type="button"
				disabled={cadernoCarregando}
				onClick={() => trocarAba(MODO_VIEW.MANUTENCAO)}
			/>

			<Button
				title="Amostragem"
				className={modoFluxo === MODO_VIEW.AMOSTRAGEM ? "active" : ''}
				contained={modoFluxo === MODO_VIEW.AMOSTRAGEM}
				type="button"
				disabled={cadernoCarregando}
				onClick={() => trocarAba(MODO_VIEW.AMOSTRAGEM)}
			/>

			<Button
				title="Colheita"
				className={modoFluxo === MODO_VIEW.COLHEITA ? "active" : ''}
				contained={modoFluxo === MODO_VIEW.COLHEITA}
				type="button"
				disabled={cadernoCarregando}
				onClick={() => trocarAba(MODO_VIEW.COLHEITA)}
			/>

			<Button
				title="Limpeza Instalações"
				className={modoFluxo === MODO_VIEW.LIMPEZA_INSTALACOES ? "active" : ''}
				contained={modoFluxo === MODO_VIEW.LIMPEZA_INSTALACOES}
				type="button"
				disabled={cadernoCarregando}
				onClick={() => trocarAba(MODO_VIEW.LIMPEZA_INSTALACOES)}
			/>

			<Button
				title="Destruição e Descarte"
				className={modoFluxo === MODO_VIEW.DESCARTE ? "active" : ''}
				contained={modoFluxo === MODO_VIEW.DESCARTE}
				type="button"
				disabled={cadernoCarregando}
				onClick={() => trocarAba(MODO_VIEW.DESCARTE)}
			/>

			<Button
				title="Fiscalizações, Reportes e Anotações"
				className={modoFluxo === MODO_VIEW.NOTAS ? "active" : ''}
				contained={modoFluxo === MODO_VIEW.NOTAS}
				type="button"
				disabled={cadernoCarregando}
				onClick={() => trocarAba(MODO_VIEW.NOTAS)}
			/>
		</div>;

	const fecharModalDestruicao = () => {
		setModalDestruicao(false);
		setExibirAnexoDestruicaoAMI(false);
		setLblDestruicaoAMI('Escolher arquivo');
		modalArquivo.reset();
		limparEstadoModalDestruicao();
		aplicarEstadoSelectsDestruicao({});
		resetDestruicao(montarValoresFormDestruicao({}));
	};

	const cancelarAnexoDestruicaoAMI = () => {
		setExibirAnexoDestruicaoAMI(false);
		setLblDestruicaoAMI('Escolher arquivo');
		modalArquivo.reset();
	};

	const submitArquivosDestruicaoAMI = async (formArquivosData: any) => {
		const arquivo = extrairArquivoDoModal(formArquivosData);
		if (!arquivo) {
			return;
		}

		const novoArquivo = mapArquivoDestruicaoAMIParaGrid(arquivo);
		setDestruicaoAMI([...destruicaoAMI, novoArquivo]);
		setLblDestruicaoAMI('Escolher arquivo');
		setExibirAnexoDestruicaoAMI(false);
		modalArquivo.reset();
	};

	return <div className="container-custom-search">
		<h3>{STRINGS_CADERNOCONFORMIDADE.REGISTER_CADERNO_CONFORMIDADE_VEGETACAO}</h3>
		{/*<Form onSubmit={defaultForm.handleSubmit(submitForm_salvar)}>*/}
		<Form>
			<br />
			<br />
			{BotoesFases}
			<If condition={cadernoCarregando}>
				<div style={{ marginBottom: 12, display: 'flex', alignItems: 'center', gap: 8 }}>
					<LoadingInForm />
					<span>Carregando caderno...</span>
				</div>
			</If>
			{/*Dados Principais e Documentos*/}
			<If condition={modoFluxo === MODO_VIEW.DADOS_PRINCIPAIS}>
				<Fieldset disabled={false} title={STRINGS_CADERNOCONFORMIDADE.BLOCK_ONE}>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={5}>
							<Form.Label>Projeto</Form.Label>
							<Form.Control
								ref={defaultForm.register}
								name="projeto"
								placeholder="Insira o nome do projeto"
								maxLength={100}
								defaultValue={entity?.projeto}
							/>
						</Form.Group>
						<Form.Group as={Col} md={5}>
							<Form.Label>Municipio</Form.Label>
							<Controller
								control={defaultForm.control}
								name="municipio"
								required
								render={({ onChange, value }) => (
									<Select
										value={value || null}
										onChange={onChange}
										placeholder="Selecione o município"
										options={enumMunicipio.map(municipio => Object.assign({ value: municipio.key, label: municipio.value }))}
										isClearable
									/>
								)}
							/>
							<If condition={defaultForm.errors.municipio_Id}>
								<span className="error-field">{defaultForm.errors.municipio_Id?.message}</span>
							</If>
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>
								Cultura
							</Form.Label>
							<Controller
								control={defaultForm.control}
								name="cultura"
								required
								render={({ onChange, value }) => (
									<Select
										value={value || null}
										onChange={onChange}
										options={cultures.map(culture => Object.assign({ label: culture.nome, value: culture.id }))}
										placeholder="Selecione uma cultura/organismo"
										isClearable
									/>
								)}
							/>
							<If condition={errors.cultura_Id}>
								<span className="error-field">{errors.cultura_Id?.message}</span>
							</If>
						</Form.Group>
						<Form.Group as={Col} md={6}>
							<Form.Label>Nome Científico</Form.Label>
							<Controller
								control={defaultForm.control}
								name="nomeCientifico"
								required
								render={({ onChange, value }) => (
									<Select
										value={value || null}
										onChange={onChange}
										placeholder="Selecione o Nome Científico"
										options={enumNomeCientifico.map(nomeCientifico => Object.assign({ value: nomeCientifico.key, label: nomeCientifico.value }))}
										isClearable
									/>
								)}
							/>
							{/*	<Form.Control*/}
							{/*		ref={defaultForm.register}*/}
							{/*		name="nomeCientifico"*/}
							{/*		placeholder="Insira o nome científico da cultura"*/}
							{/*		maxLength={100}*/}
							{/*		defaultValue={entity?.nomecientifico}*/}

							{/*	/>*/}
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>AAC</Form.Label>
							<Form.Control
								ref={defaultForm.register}
								name="codigoaac"
								placeholder="Insira o código da AAC"
								maxLength={100}
								defaultValue={entity?.codigoaac}

							/>
						</Form.Group>
						<Form.Group as={Col} md={6}>
							<Form.Label>Nº MAPA (IP/Autorização Importação)</Form.Label>
							<Form.Control
								ref={defaultForm.register}
								name="numeroMAPA"
								placeholder="Insira o número do MAPA (IP Autorização Importação) em caso de semente importada."
								maxLength={100}
								defaultValue={entity?.numeromapa}

							/>
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Responsável Regulatório</Form.Label>
							<Controller
								control={defaultForm.control}
								name="responsavelRegulatorio"
								required
								render={({ onChange, value }) => (
									<Select
										value={value || null}
										onChange={onChange}
										options={enumResponsavelRegulatorio.map(responsavel => Object.assign({ label: responsavel.value, value: responsavel.key }))}
										placeholder="Selecione um responsável do Regulatório"
										isClearable
									/>
								)}
							/>
						</Form.Group>
						<Form.Group as={Col} md={6}>
							<Form.Label>Técnico Principal</Form.Label>
							<Controller
								control={defaultForm.control}
								name="tecnicoPrincipal"
								required
								render={({ onChange, value }) => (
									<Select
										value={value || null}
										onChange={onChange}
										options={tecnicoPrincipal.map(tecnico => Object.assign({ label: tecnico.nome, value: tecnico.id }))}
										placeholder="Selecione um técnico principal"
										isClearable
									/>
								)}
							/>
						</Form.Group>
					</Form.Row>
				</Fieldset>
				<Fieldset disabled={false} title={STRINGS_CADERNOCONFORMIDADE.BLOCK_TWO}>

					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>
								Documentos Obrigatórios
								{/*	<br />*/}
								{/*	<br />*/}
								{/*	<AddButton type="button" onClick={() => setModalAtivo('DOCUMENTOS_GERAIS')} />*/}
							</Form.Label>
							<If condition={eventMsg}>
								<p className="error-field">{STRINGS.FORM_FIELD_REQUIRED}</p>
							</If>
						</Form.Group>
					</Form.Row>
					{/*<If condition={documentosGerais.length}>*/}
					{/*	<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>*/}
					{/*		<AgGridReact*/}
					{/*			rowData={documentosGerais}*/}
					{/*			defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}*/}
					{/*			gridOptions={{ headerHeight: 80 }}*/}
					{/*			stopEditingWhenGridLosesFocus={true}*/}
					{/*			singleClickEdit={true}*/}
					{/*			frameworkComponents={{*/}
					{/*				actions: acoesDocumentosGerais,*/}
					{/*				linkPastaProcesso: linkDownload*/}
					{/*			}}*/}
					{/*		>*/}
					{/*			<AgGridColumn*/}
					{/*				headerName='Nome'*/}
					{/*				headerClass="myfunc-default-header"*/}
					{/*				field="name"*/}
					{/*				cellStyle={{*/}
					{/*					justifyContent: 'left'*/}
					{/*				}}*/}
					{/*				autoHeight*/}
					{/*				wrapText*/}
					{/*				minWidth={250}*/}
					{/*			/>*/}
					{/*			<AgGridColumn*/}
					{/*				headerName='Link'*/}
					{/*				headerClass="myfunc-default-header"*/}
					{/*				cellRenderer="linkPastaProcesso"*/}
					{/*				field="name"*/}
					{/*				cellStyle={{*/}
					{/*					justifyContent: 'left'*/}
					{/*				}}*/}
					{/*				autoHeight*/}
					{/*				wrapText*/}
					{/*				minWidth={250}*/}
					{/*			/>*/}
					{/*			<AgGridColumn*/}
					{/*				headerName="Ações"*/}
					{/*				headerClass="myfunc-default-header"*/}
					{/*				cellRenderer="actions"*/}
					{/*				maxWidth={100}*/}
					{/*			/>*/}
					{/*		</AgGridReact>*/}
					{/*	</div>*/}
					{/*</If>*/}

					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							{renderCheckboxField('copiaAAC', 'Conferência e upload AAC/CIBio')}
						</Form.Group>
						<Form.Group as={Col}>
							<AddButton type="button" onClick={() => setModalAtivo('AAC_DADOS_PRINCIPAIS')} />
						</Form.Group>
					</Form.Row>
					<If condition={dadosPrincipaisAAC.length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={dadosPrincipaisAAC}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: acoesDadosPrincipaisAAC,
									linkPastaProcesso: linkDownload
								}}
							>
								<AgGridColumn
									headerName='Arquivo'
									headerClass="myfunc-default-header"
									field="name"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									minWidth={250}
								/>
								<AgGridColumn
									headerName='Link'
									headerClass="myfunc-default-header"
									cellRenderer="linkPastaProcesso"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									maxWidth={100}
								/>
								<AgGridColumn
									headerName="Ações"
									headerClass="myfunc-default-header"
									cellRenderer="actions"
									maxWidth={100}
								/>

							</AgGridReact>
						</div>
						{/*<Form.Row className="row-custom">*/}
						{/*	<Form.Group as={Col}>*/}
						{/*		<FileExistent text={dadosPrincipaisAAC[0]?.filename}*/}
						{/*			onDownload={(e: any) => {*/}
						{/*				e.preventDefault();*/}
						{/*				downloadModelFileDadosPrincipaisAAC(fileFieldDadosPrincipaisAAC);*/}
						{/*			}}*/}
						{/*			onClick={() => {*/}
						{/*				setFileFieldDadosPrincipaisAAC({ id: null, codigo: '', dataAtualizacao: '', nome: '', path: '', usuario: '' });*/}
						{/*			}}*/}
						{/*		/>*/}
						{/*	</Form.Group>*/}
						{/*</Form.Row>*/}
					</If>
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>Observações</Form.Label>
							{renderObservacoesDocumento('observacoesCopiaAAC', 'Informar número da AAC e data de aprovação')}
						</Form.Group>
					</Form.Row>

					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							{renderCheckboxField('copiaListaTreinamentos', 'Conferência e Upload Listas de Treinamento de Biossegurança')}
						</Form.Group>
						<Form.Group as={Col}>
							<AddButton type="button" onClick={() => setModalAtivo('LISTA_TREINAMENTO_DADOS_PRINCIPAIS')} />
						</Form.Group>

					</Form.Row>
					<If condition={dadosPrincipaisListaTreinamento.length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={dadosPrincipaisListaTreinamento}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: acoesDadosPrincipaisListaTreinamento,
									linkPastaProcesso: linkDownload
								}}
							>
								<AgGridColumn
									headerName='Arquivo'
									headerClass="myfunc-default-header"
									field="name"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									minWidth={250}
								/>
								<AgGridColumn
									headerName='Link'
									headerClass="myfunc-default-header"
									cellRenderer="linkPastaProcesso"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									maxWidth={100}
								/>
								<AgGridColumn
									headerName="Ações"
									headerClass="myfunc-default-header"
									cellRenderer="actions"
									maxWidth={100}
								/>
							</AgGridReact>
						</div>
					</If>
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>Observações</Form.Label>
							{renderObservacoesDocumento('observacoesCopiaListaTreinamentos', 'Insira observações adicionais, se pertinente')}
						</Form.Group>
					</Form.Row>

					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							{renderCheckboxField('copiaParecerTecnicoCTNBio', 'Conferência e Upload do Último Parecer Técnico CTNBio')}
						</Form.Group>
						<Form.Group as={Col}>
							<AddButton type="button" onClick={() => setModalAtivo('PARECER_TECNICO_DADOS_PRINCIPAIS')} />
						</Form.Group>

					</Form.Row>
				<If condition={dadosPrincipaisParecerTecnico.length}>
					<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
						<AgGridReact
							rowData={dadosPrincipaisParecerTecnico}
							defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
							gridOptions={{ headerHeight: 80 }}
							stopEditingWhenGridLosesFocus={true}
							singleClickEdit={true}
							frameworkComponents={{
								actions: acoesDadosPrincipaisParecerTecnico,
								linkPastaProcesso: linkDownload
							}}
						>
							<AgGridColumn
								headerName='Arquivo'
								headerClass="myfunc-default-header"
								field="name"
								cellStyle={{
									justifyContent: 'left'
								}}
								autoHeight
								wrapText
								minWidth={250}
							/>
							<AgGridColumn
								headerName='Link'
								headerClass="myfunc-default-header"
								cellRenderer="linkPastaProcesso"
								field="name"
								cellStyle={{
									justifyContent: 'left'
								}}
								autoHeight
								wrapText
								maxWidth={100}
							/>
							<AgGridColumn
								headerName="Ações"
								headerClass="myfunc-default-header"
								cellRenderer="actions"
								maxWidth={100}
							/>
						</AgGridReact>
					</div>
				</If>
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>Observações</Form.Label>
							{renderObservacoesDocumento('observacoesCopiaParecerTecnicoCTNBio', 'Insira observações adicionais, se pertinente')}
						</Form.Group>
					</Form.Row>

					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							{renderCheckboxField('copiaQuarentena', 'Origem das sementes - Permissão de Importação, Liberação da Quarentena e/ou AAC para sementes produzidas localmente')}
						</Form.Group>
						<Form.Group as={Col}>
							<AddButton type="button" onClick={() => setModalAtivo('LIBERACAO_QUARENTENA_DADOS_PRINCIPAIS')} />
						</Form.Group>
					</Form.Row>
					<If condition={dadosPrincipaisLiberacaoQuarentena.length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={dadosPrincipaisLiberacaoQuarentena}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: acoesDadosPrincipaisLiberacaoQuarentena,
									linkPastaProcesso: linkDownload
								}}
							>
								<AgGridColumn
									headerName='Arquivo'
									headerClass="myfunc-default-header"
									field="name"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									minWidth={250}
								/>
								<AgGridColumn
									headerName='Link'
									headerClass="myfunc-default-header"
									cellRenderer="linkPastaProcesso"
									field="name"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									maxWidth={100}
								/>
								<AgGridColumn
									headerName="Ações"
									headerClass="myfunc-default-header"
									cellRenderer="actions"
									maxWidth={100}
								/>
							</AgGridReact>
						</div>
					</If>
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>Observações</Form.Label>
							{renderObservacoesDocumento('observacoesCopiaQuarentena', 'Informar número do PI, Número do Ofício de Liberação e Data')}
						</Form.Group>
					</Form.Row>

					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							{renderCheckboxField('cienciaInstrucoes', 'Declaro estar ciente das instruções regulatórias sobre a legislação e normas de Biossegurança para condução de ensaios e atividades em Casa-de-Vegetação, e que no surgimento de qualquer dúvida ou problema durante a condução do ensaio/atividade  entrarei em contato imediatamente com o Departamento Regulatório e CIBio BASF')}
						</Form.Group>
						<Form.Group as={Col}>
							{linkDownloadTermos}
						</Form.Group>
					</Form.Row>
				</Fieldset>
			</If>

			{/* Plantio */}
			<If condition={modoFluxo === MODO_VIEW.PLANEJAMENTO}>
				<Fieldset disabled={false} title={STRINGS_CADERNOCONFORMIDADE.BLOCK_THREE}>
					{/* Checklist Pré-Plantio */}
					<Fieldset disabled={false} title={STRINGS_CADERNOCONFORMIDADE.BLOCK_THREE_ONE}>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Check
									type="checkbox"
									ref={defaultForm.register}
									name="treinamentoBiosseguranca"
									label="Todo pessoal envolvido nas atividades da casa de vegetação recebeu treinamento em Biossegurança?"
									defaultChecked={entity?.vegetacao_Planejamento?.[0]?.treinamentoBiosseguranca ?? false}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Check
									type="checkbox"
									ref={defaultForm.register}
									name="deAcordoComPermissaoImportacao"
									label="A Casa-de-Vegetação ou módulo dedicado ao Ensaio está de acordo como o informado na AAC aprovado pela CIBio?"
									defaultChecked={entity?.vegetacao_Planejamento?.[0]?.deAcordoComPermissaoImportacao ?? false}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Check
									type="checkbox"
									ref={defaultForm.register}
									name="materialIdentificacaoDisponivel"
									label="Todo o material para identificação e condução do ensaio visando o cumprimento dos requisitos de biossegurança estão disponíveis?"
									defaultChecked={entity?.vegetacao_Planejamento?.[0]?.materialIdentificacaoDisponivel ?? false}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Check
									type="checkbox"
									ref={defaultForm.register}
									name="epIsDisponiveis"
									label="Os EPIs necessários, conforme matriz de EPI de EHS, estão disponíveis para todos os envolvidos na condução do ensaio"
									defaultChecked={entity?.vegetacao_Planejamento?.[0]?.epIsDisponiveis ?? false}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Check
									type="checkbox"
									ref={defaultForm.register}
									name="lixeirasDescarte"
									label="Lixeiras para descarte de material/resíduos de OGM estão presentes e devidamente identificadas?"
									defaultChecked={entity?.vegetacao_Planejamento?.[0]?.lixeirasDescarte ?? false}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Check
									type="checkbox"
									ref={defaultForm.register}
									name="placaBiosseguranca"
									label="A casa de vegetação está identificada com a placa de biossegurança informando a classe de risco, símbolo de risco biológico, nome e contato do técnico principal?"
									defaultChecked={entity?.vegetacao_Planejamento_Conducao?.[0]?.placaBiosseguranca ?? false}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Label>Observações</Form.Label>
								<Form.Control
									ref={defaultForm.register}
									name="observacoesPlacaBiosseguranca"
									as="textarea"
									rows={4}
									placeholder="Insira observações adicionais, se pertinente"
									defaultValue={entity?.vegetacao_Planejamento_Conducao?.[0]?.observacoesPlacaBiosseguranca}
								/>
							</Form.Group>
						</Form.Row>
					</Fieldset>

					{/* Checklist Plantio */}
					<Fieldset disabled={false} title={STRINGS_CADERNOCONFORMIDADE.BLOCK_THREE_TWO}>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Label>
									Formulário de Registro de Plantio
									<br />
									<br />
									<AddButton
										type="button"
										onClick={() => openPlantioModal()}
									/>
								</Form.Label>
							</Form.Group>
						</Form.Row>
						<If condition={selectedPlantios.length}>
							<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
								<AgGridReact
									rowData={selectedPlantios}
									defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
									gridOptions={{ headerHeight: 80 }}
									stopEditingWhenGridLosesFocus={true}
									singleClickEdit={true}
									frameworkComponents={{
										actions: actionsPlantios,
										linkArquivoPlantioMaterial,
										linkArquivoPlantioAMI,
									}}
								>
									<AgGridColumn
										headerName='Número do Plantio'
										headerClass="myfunc-default-header"
										field="numeroPlantio"
										cellStyle={{
											justifyContent: 'left'
										}}
									/>
									<AgGridColumn
										headerName='Número da Casa-de-Vegetação'
										headerClass="myfunc-default-header"
										field="casaVegetacaoModulo"
										cellStyle={{
											justifyContent: 'left'
										}}
										autoHeight
										wrapText
									/>
									<AgGridColumn
										headerName='Data Inicial do Plantio'
										field="dataInicialPlantio"
										headerClass="myfunc-default-header"
										sort="asc"
										valueFormatter={({ data }: any) => data.dataInicialPlantio ? _generateDate(data.dataInicialPlantio, 'Pt') : ''
										}
									/>
									<AgGridColumn
										headerName='Data Final do Plantio'
										field="dataFinalPlantio"
										headerClass="myfunc-default-header"
										valueFormatter={({ data }: any) => data.dataFinalPlantio ? _generateDate(data.dataFinalPlantio, 'Pt') : ''
										}
									/>
									<AgGridColumn
										headerName='Lista de Materiais Plantados'
										field="filenameMaterialPlantado"
										headerClass="myfunc-default-header"
										cellRenderer="linkArquivoPlantioMaterial"
										cellStyle={{
											justifyContent: 'left'
										}}
										autoHeight
										wrapText
										minWidth={200}
									/>
									<AgGridColumn
										headerName='AMI de Plantio'
										field="filenamePlantioAMI"
										headerClass="myfunc-default-header"
										cellRenderer="linkArquivoPlantioAMI"
										cellStyle={{
											justifyContent: 'left'
										}}
										autoHeight
										wrapText
										minWidth={200}
									/>
									{/*<AgGridColumn*/}
									{/*	headerName='Número da AMI'*/}
									{/*	headerClass="myfunc-default-header"*/}
									{/*	field="numeroAMI"*/}
									{/*	cellStyle={{*/}
									{/*		justifyContent: 'left'*/}
									{/*	}}*/}
									{/*/>*/}
					<AgGridColumn
									headerName="Ações"
									headerClass="myfunc-default-header"
									cellRenderer="actions"
									maxWidth={100}
								/>
							</AgGridReact>
						</div>
					</If>


					{/*	<Form.Row className="row-custom">*/}
					{/*		<Form.Group as={Col}>*/}
					{/*			<Form.Label>*/}
					{/*				Datas de Plantio*/}
						{/*				<br />*/}
						{/*				<AddButton*/}
						{/*					type="button"*/}
						{/*					onClick={() => setModalDataPlantios(true)}*/}
						{/*				/>*/}
						{/*			</Form.Label>*/}
						{/*		</Form.Group>*/}
						{/*	</Form.Row>*/}
						{/*	<If condition={selectedDataPlantios.length}>*/}
						{/*		<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>*/}
						{/*			<AgGridReact*/}
						{/*				rowData={selectedDataPlantios}*/}
						{/*				defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}*/}
						{/*				gridOptions={{ headerHeight: 80 }}*/}
						{/*				stopEditingWhenGridLosesFocus={true}*/}
						{/*				singleClickEdit={true}*/}
						{/*				frameworkComponents={{*/}
						{/*					actions: actionsDataPlantios,*/}
						{/*				}}*/}
						{/*			>*/}
						{/*				<AgGridColumn*/}
						{/*					headerName='Data Inicial do Plantio'*/}
						{/*					field="dataInicialPlantio"*/}
						{/*					headerClass="myfunc-default-header"*/}
						{/*					valueFormatter={({ data }: any) => data.dataInicialPlantio ? _generateDate(data.dataInicialPlantio, 'Pt') : ''*/}
						{/*					}*/}
						{/*				/>*/}
						{/*				<AgGridColumn*/}
						{/*					headerName='Data Final do Plantio'*/}
						{/*					field="dataFinalPlantio"*/}
						{/*					headerClass="myfunc-default-header"*/}
						{/*					valueFormatter={({ data }: any) => data.dataFinalPlantio ? _generateDate(data.dataFinalPlantio, 'Pt') : ''*/}
						{/*					}*/}
						{/*				/>*/}
						{/*				<AgGridColumn*/}
						{/*					headerName="Ações"*/}
						{/*					cellRenderer="actions"*/}
						{/*					maxWidth={100}*/}
						{/*				/>*/}
						{/*			</AgGridReact>*/}
						{/*		</div>*/}
						{/*	</If>*/}

						{/*	<Form.Row className="row-custom">*/}
						{/*		<Form.Group as={Col}>*/}
						{/*			<Form.Label>*/}
						{/*				Pessoas Envolvidas no Plantio*/}
						{/*				<br />*/}
						{/*				<br />*/}
						{/*				<AddButton*/}
						{/*					type="button"*/}
						{/*					onClick={() => {*/}
						{/*						setContagemPessoasEnvolvidasPlantio(0);*/}
						{/*						setModalPessoasEnvolvidasPlantio(true);*/}
						{/*					}*/}
						{/*					}*/}
						{/*				/>*/}
						{/*			</Form.Label>*/}
						{/*		</Form.Group>*/}
						{/*	</Form.Row>*/}
						{/*	<If condition={selectedPessoasEnvolvidasPlantio.length}>*/}
						{/*		<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>*/}
						{/*			<AgGridReact*/}
						{/*				rowData={selectedPessoasEnvolvidasPlantio}*/}
						{/*				defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}*/}
						{/*				gridOptions={{ headerHeight: 80 }}*/}
						{/*				stopEditingWhenGridLosesFocus={true}*/}
						{/*				singleClickEdit={true}*/}
						{/*				frameworkComponents={{*/}
						{/*					actions: actionsPessoasEnvolvidasPlantio,*/}
						{/*				}}*/}
						{/*			>*/}
						{/*				<AgGridColumn*/}
						{/*					headerName='#'*/}
						{/*					field="contagemPessoasEnvolvidasPlantio"*/}
						{/*					headerClass="myfunc-default-header"*/}
						{/*					cellStyle={{*/}
						{/*						justifyContent: 'left'*/}
						{/*					}}*/}
						{/*				/>*/}
						{/*				<AgGridColumn*/}
						{/*					headerName='Pessoa envolvida no plantio'*/}
						{/*					headerClass="myfunc-default-header"*/}
						{/*					field="pessoaPlantio"*/}
						{/*					cellStyle={{*/}
						{/*						justifyContent: 'left'*/}
						{/*					}}*/}
						{/*				/>*/}
						{/*				<AgGridColumn*/}
						{/*					headerName="Ações"*/}
						{/*					headerClass="myfunc-default-header"*/}
						{/*					cellRenderer="actions"*/}
						{/*					maxWidth={100}*/}
						{/*				/>*/}
						{/*			</AgGridReact>*/}
						{/*		</div>*/}
						{/*	</If>*/}

						{/*	<Form.Row className="row-custom">*/}
						{/*		<Form.Group as={Col}>*/}
						{/*			<Form.Label>*/}
						{/*				Número da AMI*/}
						{/*				<br />*/}
						{/*				<AddButton type="button" onClick={() => setModalAtivo('NUMERO_AMI_PLANEJAMENTO')} />*/}
						{/*			</Form.Label>*/}
						{/*			<If condition={eventMsg}>*/}
						{/*				<p className="error-field">{STRINGS.FORM_FIELD_REQUIRED}</p>*/}
						{/*			</If>*/}
						{/*		</Form.Group>*/}
						{/*	</Form.Row>*/}
						{/*	<If condition={numeroAMI.length}>*/}
						{/*		<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>*/}
						{/*			<AgGridReact*/}
						{/*				rowData={numeroAMI}*/}
						{/*				defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}*/}
						{/*				gridOptions={{ headerHeight: 80 }}*/}
						{/*				stopEditingWhenGridLosesFocus={true}*/}
						{/*				singleClickEdit={true}*/}
						{/*				frameworkComponents={{*/}
						{/*					actions: acoesNumeroAMI,*/}
						{/*					linkAMI: linkDownload*/}
						{/*				}}*/}
						{/*			>*/}
						{/*				<AgGridColumn*/}
						{/*					headerName='Nome'*/}
						{/*					headerClass="myfunc-default-header"*/}
						{/*					field="name"*/}
						{/*					cellStyle={{*/}
						{/*						justifyContent: 'left'*/}
						{/*					}}*/}
						{/*					autoHeight*/}
						{/*					wrapText*/}
						{/*					minWidth={250}*/}
						{/*				/>*/}
						{/*				<AgGridColumn*/}
						{/*					headerName='Link'*/}
						{/*					headerClass="myfunc-default-header"*/}
						{/*					field="name"*/}
						{/*					cellStyle={{*/}
						{/*						justifyContent: 'left'*/}
						{/*					}}*/}
						{/*					autoHeight*/}
						{/*					wrapText*/}
						{/*					minWidth={250}*/}
						{/*					cellRenderer="linkAMI"*/}
						{/*				/>*/}
						{/*				<AgGridColumn*/}
						{/*					headerName="Ações"*/}
						{/*					headerClass="myfunc-default-header"*/}
						{/*					cellRenderer="actions"*/}
						{/*					maxWidth={100}*/}
						{/*				/>*/}
						{/*			</AgGridReact>*/}
						{/*		</div>*/}
						{/*	</If>*/}
					</Fieldset>

					{/* Checklist Pós-Plantio */}
					<Fieldset disabled={false} title={STRINGS_CADERNOCONFORMIDADE.BLOCK_THREE_THREE}>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Check
									type="checkbox"
									ref={defaultForm.register}
									name="croquiExperimental"
									label="O Croqui de plantio foi disponibilizado na Casa-de-Vegetação/CAGE?"
									defaultChecked={entity?.croquiExperimental ? entity?.croquiExperimental : false}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Group as={Col}>
							<AddButton type="button" onClick={() => setModalAtivo('CROQUI_PLANEJAMENTO')} />
						</Form.Group>
						<If condition={planejamentoCroqui.length}>
							<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
								<AgGridReact
									rowData={planejamentoCroqui}
									defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
									gridOptions={{ headerHeight: 80 }}
									stopEditingWhenGridLosesFocus={true}
									singleClickEdit={true}
									frameworkComponents={{
										actions: acoesPlanejamentoCroqui,
										linkPastaProcesso: linkDownload
									}}
								>
									<AgGridColumn
										headerName='Arquivo'
										headerClass="myfunc-default-header"
										field="name"
										cellStyle={{
											justifyContent: 'left'
										}}
										autoHeight
										wrapText
										minWidth={250}
									/>
									<AgGridColumn
										headerName='Link'
										headerClass="myfunc-default-header"
										cellRenderer="linkPastaProcesso"
										field="name"
										cellStyle={{
											justifyContent: 'left'
										}}
										autoHeight
										wrapText
										maxWidth={100}
									/>
									<AgGridColumn
										headerName="Ações"
										headerClass="myfunc-default-header"
										cellRenderer="actions"
										maxWidth={100}
									/>
								</AgGridReact>
							</div>
						</If>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Label>Observações</Form.Label>
								<Form.Control
									ref={defaultForm.register}
									name="observacoesCroquiExperimental"
									as="textarea"
									rows={4}
									placeholder="Insira observações adicionais, se pertinente"
									defaultValue={entity?.observacoesCroquiExperimental}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Check
									type="checkbox"
									ref={defaultForm.register}
									name="ensaioConformidadeAACAprovada"
									label="O ensaio foi instalado na casa de vegetação em conformidade com AAC aprovada pela CIBio?"
									defaultChecked={entity?.ensaioConformidadeAACAprovada ? entity?.ensaioConformidadeAACAprovada : false}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Label>Observações</Form.Label>
								<Form.Control
									ref={defaultForm.register}
									name="observacoesEnsaioConformidadeAACAprovada"
									as="textarea"
									rows={4}
									placeholder="Insira observações adicionais, se pertinente"
									defaultValue={entity?.observacoesEnsaioConformidadeAACAprovada}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Check
									type="checkbox"
									ref={defaultForm.register}
									name="envelopesSementesDestruidos"
									label="Envelopes de sementes e outros materiais remanescentes do plantio do ensaio destruídos, descartados e os registros foram realizado no campo DESTRUIÇÃO e DESCARTE?"
									defaultChecked={entity?.envelopesSementesDestruidos ? entity?.envelopesSementesDestruidos : false}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Label>Observações</Form.Label>
								<Form.Control
									ref={defaultForm.register}
									name="observacoesEnvelopesSementesDestruidos"
									as="textarea"
									rows={4}
									placeholder="Insira observações adicionais, se pertinente"
									defaultValue={entity?.observacoesEnvelopesSementesDestruidos}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Check
									type="checkbox"
									ref={defaultForm.register}
									name="dispositivosBiossegurancaChecados"
									label="Os dispositivos de biossegurança como, tela de proteção de ralos, controle de insetos e roedores, telas antiafídicas, além de outros métodos de controle da entrada de polinizadores e dispersão de pólen foram checados e estão em perfeitas condições?"
									defaultChecked={entity?.dispositivosBiossegurancaChecados ? entity?.dispositivosBiossegurancaChecados : false}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Label>Observações</Form.Label>
								<Form.Control
									ref={defaultForm.register}
									name="observacoesDispositivosBiossegurancaChecados"
									as="textarea"
									rows={4}
									placeholder="Insira observações adicionais, se pertinente"
									defaultValue={entity?.observacoesDispositivosBiossegurancaChecados}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Check
									type="checkbox"
									ref={defaultForm.register}
									name="equipamentosAtividadePlantioLimpos"
									label="Roupas, calçados, equipamentos e utensílios utilizados pela equipe na atividade de plantio foram limpos e inspecionados ANTES de ENTRAR e ANTES de SAIR das Instalações? No caso de equipamentos e utensílios o registro foi realizado no campo LIMPEZA de EQUIPAMENTOS?"
									defaultChecked={entity?.equipamentosAtividadePlantioLimpos ? entity?.equipamentosAtividadePlantioLimpos : false}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Label>Observações</Form.Label>
								<Form.Control
									ref={defaultForm.register}
									name="observacoesEquipamentosAtividadePlantioLimpos"
									as="textarea"
									rows={4}
									placeholder="Insira observações adicionais, se pertinente"
									defaultValue={entity?.observacoesEquipamentosAtividadePlantioLimpos}
								/>
							</Form.Group>
						</Form.Row>
						{/*<Form.Row className="row-custom">*/}
						{/*	<Form.Group as={Col}>*/}
						{/*		<Form.Check*/}
						{/*			type="checkbox"*/}
						{/*			ref={defaultForm.register}*/}
						{/*			name="entradaArmazenamento"*/}
						{/*			label="Foi dada entrada na Cadeia de Custódia de Armazenamento?"*/}
						{/*			defaultChecked={plantioEdit.entradaArmazenamento ? plantioEdit.entradaArmazenamento : false}*/}
						{/*		/>*/}
						{/*	</Form.Group>*/}
						{/*</Form.Row>*/}
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Check
									type="checkbox"
									ref={defaultForm.register}
									name="comunicacaoCoordenadasGeograficas"
									label="Em caso de plantio em Cages a CIBio, CNTBio e MAPA foram comunicados da data do plantio e da localização do CAGES  através das Coordenadas Geográficas?"
									defaultChecked={entity?.comunicacaoCoordenadasGeograficas ? entity?.comunicacaoCoordenadasGeograficas : false}
								/>
							</Form.Group>
							<Form.Group as={Col}>
								<AddButton type="button" onClick={() => setModalAtivo('CONDUCAO_COMUNICADOS')} />
							</Form.Group>
						</Form.Row>
						<If condition={conducaoComunicados.length}>
							<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
								<AgGridReact
									rowData={conducaoComunicados}
									defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
									gridOptions={{ headerHeight: 80 }}
									stopEditingWhenGridLosesFocus={true}
									singleClickEdit={true}
									frameworkComponents={{
										actions: acoesConducaoComunicados,
										linkPastaProcesso: linkDownload
									}}
								>
									<AgGridColumn
										headerName='Data'
										headerClass="myfunc-default-header"
										field="dataComunicado"
										cellStyle={{
											justifyContent: 'left'
										}}
										autoHeight
										wrapText
										minWidth={100}
										valueFormatter={({ data }: any) => data.dataComunicado ? _generateDate(data.dataComunicado, 'Pt') : ''}

									/>
									<AgGridColumn
										headerName='Arquivo'
										headerClass="myfunc-default-header"
										field="name"
										cellStyle={{
											justifyContent: 'left'
										}}
										autoHeight
										wrapText
										minWidth={250}
									/>
									<AgGridColumn
										headerName='Link'
										headerClass="myfunc-default-header"
										cellRenderer="linkPastaProcesso"
										cellStyle={{
											justifyContent: 'left'
										}}
										autoHeight
										wrapText
										maxWidth={100}
									/>
									<AgGridColumn
										headerName="Ações"
										headerClass="myfunc-default-header"
										cellRenderer="actions"
										maxWidth={100}
									/>
								</AgGridReact>
							</div>
						</If>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Label>Observações</Form.Label>
								<Form.Control
									ref={defaultForm.register}
									name="observacoesComunicacaoCoordenadasGeograficas"
									as="textarea"
									rows={4}
									placeholder="Insira observações adicionais, se pertinente"
									defaultValue={entity?.observacoesComunicacaoCoordenadasGeograficas}
								/>
							</Form.Group>
						</Form.Row>
					</Fieldset>
				</Fieldset>
			</If>

			{/* Manutenção */}
			<If condition={modoFluxo === MODO_VIEW.MANUTENCAO}>
				<Fieldset disabled={false} title={STRINGS_CADERNOCONFORMIDADE.BLOCK_FOUR}>
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>
								Formulário de Registro de Atividades de Manutenção
								<br />
								<AddButton
									type="button"
									onClick={() => openAtividadeManutencaoModal()}
								/>
							</Form.Label>
						</Form.Group>
					</Form.Row>
					<If condition={selectedAtividadeManutencao.length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={selectedAtividadeManutencao}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: actionsAtividadeManutencao,
								}}
							>
								<AgGridColumn
									headerName='#'
									headerClass="myfunc-default-header"
									field="contagemAtividadeManutencao"
									cellStyle={{
										justifyContent: 'left'
									}}
								/>
								{/*<AgGridColumn*/}
								{/*	headerName='Data da Atividade'*/}
								{/*	field="dataAtividade"*/}
								{/*	headerClass="myfunc-default-header"*/}
								{/*	valueFormatter={({ data }: any) => data.dataAtividade ? _generateDate(data.dataAtividade, 'Pt') : ''*/}
								{/*	}*/}
								{/*/>*/}
								<AgGridColumn
									headerName='Data Inicial da Atividade'
									field="dataInicialAtividade"
									headerClass="myfunc-default-header"
									sort="asc"
									valueFormatter={({ data }: any) => data.dataInicialAtividade ? _generateDate(data.dataInicialAtividade, 'Pt') : ''
									}
								/><AgGridColumn
									headerName='Data Final da Atividade'
									field="dataFinalAtividade"
									headerClass="myfunc-default-header"
									valueFormatter={({ data }: any) => data.dataFinalAtividade ? _generateDate(data.dataFinalAtividade, 'Pt') : ''
									}
								/>
								<AgGridColumn
									headerName='Responsável'
									field="listaResponsaveis"
									headerClass="myfunc-default-header"
								/>
								<AgGridColumn
									headerName='Tipo de Atividade'
									field="listaMetodosLimpeza"
									headerClass="myfunc-default-header"
								/>
								<AgGridColumn
									headerName="Ações"
									cellRenderer="actions"
									maxWidth={100}
								/>
							</AgGridReact>
						</div>
					</If>
				</Fieldset>
			</If>

			{/* Amostragem */}
			<If condition={modoFluxo === MODO_VIEW.AMOSTRAGEM}>
				<Fieldset disabled={false} title={STRINGS_CADERNOCONFORMIDADE.BLOCK_FIVE}>
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>
								Formulário de Registro de Amostragem
								<br />
								<br />
								<AddButton
									type="button"
									onClick={() => {
										setContagemRegistroAmostragem(0);
										setRegistroAmostragemEdit({
											id: 0,
											contagemRegistroAmostragem: '',
											dataInicialAmostragem: '',
											dataFinalAmostragem: '',
											tipoMaterialAmostragem: '',
											responsavelAmostragem: '',
											destinoAmostras: '',
											arquivoAmostragem: '',
											filename: '',
											tipoMaterialAmostragemOutros: '',
											destinoAmostrasOutros: '',
										});
										setResponsaveisAmostragem([]);
										setArquivoRegistroAmostragemPendente(null);
										setLblArquivoRegistroAmostragem('Escolher arquivo');
										setModalRegistroAmostragem(true);
									}
									}
								/>
							</Form.Label>
						</Form.Group>
					</Form.Row>
					<If condition={selectedRegistroAmostragem.length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={selectedRegistroAmostragem}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: actionsRegistroAmostragem,
									linkArquivoRegistroAmostragem,
								}}
							>
								<AgGridColumn
									headerName='#'
									headerClass="myfunc-default-header"
									field="contagemRegistroAmostragem"
									maxWidth={100}
									cellStyle={{
										justifyContent: 'left'
									}}
								/>
								<AgGridColumn
									headerName='Data Inicial'
									field="dataInicialAmostragem"
									headerClass="myfunc-default-header"
									sort="asc"
									maxWidth={100}
									valueFormatter={({ data }: any) => data.dataInicialAmostragem ? _generateDate(data.dataInicialAmostragem, 'Pt') : ''
									}
								/>
								<AgGridColumn
									headerName='Data Final'
									field="dataFinalAmostragem"
									headerClass="myfunc-default-header"
									maxWidth={100}
									valueFormatter={({ data }: any) => data.dataFinalAmostragem ? _generateDate(data.dataFinalAmostragem, 'Pt') : ''
									}
								/>
								<AgGridColumn
									headerName='Tipo de Material'
									field="tipoMaterialAmostragem"
									headerClass="myfunc-default-header"
									valueFormatter={({ data }: any) => {

										if (data?.tipoMaterialAmostragem?.label === 'Outros')
											return `Outros (${data.tipoMaterialAmostragemOutros})`;

										return data?.tipoMaterialAmostragem?.label;

									}}
								/>
								<AgGridColumn
									headerName='Destino das Amostras'
									field="destinoAmostras"
									headerClass="myfunc-default-header"
									valueFormatter={({ data }: any) => {

										if (data?.destinoAmostras?.label === 'Outros')
											return `Outros (${data.destinoAmostrasOutros})`;

										return data?.destinoAmostras?.label;

									}}
								/>
								<AgGridColumn
									headerName='Responsáveis'
									field="listaResponsaveis"
									headerClass="myfunc-default-header"
								/>
								<AgGridColumn
									headerName='Arquivo'
									field="filename"
									headerClass="myfunc-default-header"
									cellRenderer="linkArquivoRegistroAmostragem"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									minWidth={200}
								/>
								<AgGridColumn
									headerName="Ações"
									cellRenderer="actions"
									maxWidth={100}
								/>
							</AgGridReact>
						</div>
					</If>
				</Fieldset>
			</If>

			{/* Colheita */}
			<If condition={modoFluxo === MODO_VIEW.COLHEITA}>
				<Fieldset disabled={false} title={STRINGS_CADERNOCONFORMIDADE.BLOCK_SIX} className="caderno-fieldset-colheita">
					{/* Checklist Pré-Colheita */}
					<Fieldset disabled={false} title={STRINGS_CADERNOCONFORMIDADE.BLOCK_SIX_ONE}>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Controller
									control={defaultForm.control}
									name="embalagemArmazenamentoMateriais"
									defaultValue={entity?.vegetacao_Planejamento_Conducao?.[0]?.embalagemArmazenamentoMateriais ?? false}
									render={({ value, onChange }) => (
										<Form.Check
											type="checkbox"
											checked={!!value}
											onChange={(event: any) => onChange(event.target.checked)}
											label="Há embalagem disponível para o armazenamento dos materiais a serem colhidos (sacos, envelopes, etiquetas, etc.)?"
										/>
									)}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Label>Observações</Form.Label>
								<Form.Control
									ref={defaultForm.register}
									name="observacoesEmbalagemArmazenamentoMateriais"
									as="textarea"
									rows={4}
									placeholder="Insira observações adicionais, se pertinente"
									defaultValue={entity?.vegetacao_Planejamento_Conducao?.[0]?.observacoesEmbalagemArmazenamentoMateriais ?? ''}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Controller
									control={defaultForm.control}
									name="treinamentoBiossegurancaColheita"
									defaultValue={entity?.vegetacao_Planejamento_Conducao?.[0]?.treinamentoBiossegurancaColheita ?? false}
									render={({ value, onChange }) => (
										<Form.Check
											type="checkbox"
											checked={!!value}
											onChange={(event: any) => onChange(event.target.checked)}
											label="Todo pessoal envolvido nas atividades de colheita da casa de vegetação recebeu treinamento em Biossegurança?"
										/>
									)}
								/>
							</Form.Group>
						</Form.Row>
					</Fieldset>

					{/* Checklist Colheita */}
					<Fieldset disabled={false} title={STRINGS_CADERNOCONFORMIDADE.BLOCK_SIX_TWO}>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Label>
									Formulário de Registro de Colheita
									<br />
									<br />
									<AddButton
										type="button"
										onClick={() => {
											setContagemRegistroColheita(0);
											setRegistroColheitaEdit({
												id: 0,
												contagemRegistroColheita: '',
												tipoColheita: '',
												dataColheita: '',
												dataInicialColheita: '',
												dataFinalColheita: '',
												tipoMaterialColheita: '',
												outrosTipoMaterialColheita: '',
												quantidadeMaterialColheita: '',
												numeroAMIColheita: '',
												destinoMaterialColheita: '',
												arquivoAMIColheita: '',
												filename: '',
											});
											setResponsaveisColheitaModal([]);
											setArquivoRegistroColheitaPendente(null);
											setLblArquivoRegistroColheita('Escolher arquivo');
											setModalRegistroColheita(true);
										}}
									/>
								</Form.Label>
							</Form.Group>
						</Form.Row>
						<If condition={selectedRegistroColheita.length}>
							<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
								<AgGridReact
									rowData={selectedRegistroColheita}
									defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
									gridOptions={{ headerHeight: 80 }}
									stopEditingWhenGridLosesFocus={true}
									singleClickEdit={true}
									frameworkComponents={{
										actions: actionsRegistroColheita,
										linkArquivoRegistroColheita,
									}}
								>
									<AgGridColumn
										headerName='#'
										headerClass="myfunc-default-header"
										field="contagemRegistroColheita"
										maxWidth={70}
									/>
									<AgGridColumn
										headerName='Tipo de Colheita'
										field="tipoColheita"
										headerClass="myfunc-default-header"
										valueFormatter={({ data }: any) => data?.tipoColheita?.label ?? ''}
									/>
									<AgGridColumn
										headerName='Data Inicial'
										field="dataInicialColheita"
										headerClass="myfunc-default-header"
										sort="asc"
										maxWidth={110}
										valueFormatter={({ data }: any) => data.dataInicialColheita ? _generateDate(data.dataInicialColheita, 'Pt') : ''}
									/>
									<AgGridColumn
										headerName='Data Final'
										field="dataFinalColheita"
										headerClass="myfunc-default-header"
										maxWidth={110}
										valueFormatter={({ data }: any) => data.dataFinalColheita ? _generateDate(data.dataFinalColheita, 'Pt') : ''}
									/>
									<AgGridColumn
										headerName='Tipo de Material'
										field="tipoMaterialColheita"
										headerClass="myfunc-default-header"
										valueFormatter={({ data }: any) => {
											if (isValorOutros(data?.tipoMaterialColheita?.value))
												return `Outros (${data.outrosTipoMaterialColheita ?? ''})`;
											return data?.tipoMaterialColheita?.label ?? '';
										}}
									/>
									<AgGridColumn
										headerName='Responsáveis'
										field="listaResponsaveis"
										headerClass="myfunc-default-header"
									/>
									<AgGridColumn
										headerName='AMI'
										field="filename"
										headerClass="myfunc-default-header"
										cellRenderer="linkArquivoRegistroColheita"
										minWidth={150}
									/>
									<AgGridColumn
										headerName="Ações"
										cellRenderer="actions"
										maxWidth={100}
									/>
								</AgGridReact>
							</div>
						</If>
					</Fieldset>
				</Fieldset>

					{/* Checklist Pós-Colheita */}
					<Fieldset disabled={false} title={STRINGS_CADERNOCONFORMIDADE.BLOCK_SIX_THREE} className="caderno-fieldset-colheita">
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Controller
									control={defaultForm.control}
									name="materialColhidoEmbalado"
									defaultValue={entity?.vegetacao_Planejamento_Conducao?.[0]?.materialColhidoEmbalado ?? false}
									render={({ value, onChange }) => (
										<Form.Check
											type="checkbox"
											checked={!!value}
											onChange={(event: any) => onChange(event.target.checked)}
											label="O material colhido está embalado e identificado?"
										/>
									)}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Label>Observações</Form.Label>
								<Form.Control
									ref={defaultForm.register}
									name="observacoesMaterialColhidoEmbalado"
									as="textarea"
									rows={4}
									placeholder="Insira observações adicionais, se pertinente"
									defaultValue={entity?.vegetacao_Planejamento_Conducao?.[0]?.observacoesMaterialColhidoEmbalado ?? ''}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Controller
									control={defaultForm.control}
									name="documentosDestinoMaterialColhido"
									defaultValue={entity?.vegetacao_Planejamento_Conducao?.[0]?.documentosDestinoMaterialColhido ?? false}
									render={({ value, onChange }) => (
										<Form.Check
											type="checkbox"
											checked={!!value}
											onChange={(event: any) => onChange(event.target.checked)}
											label="Existem documentos que comprovam o destino do material colhido?"
										/>
									)}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Label>Observações</Form.Label>
								<Form.Control
									ref={defaultForm.register}
									name="observacoesDocumentosDestinoMaterialColhido"
									as="textarea"
									rows={4}
									placeholder="Insira observações adicionais, se pertinente"
									defaultValue={entity?.vegetacao_Planejamento_Conducao?.[0]?.observacoesDocumentosDestinoMaterialColhido ?? ''}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Controller
									control={defaultForm.control}
									name="equipamentosAtividadeColheitaLimpos"
									defaultValue={entity?.vegetacao_Planejamento_Conducao?.[0]?.equipamentosAtividadeColheitaLimpos ?? false}
									render={({ value, onChange }) => (
										<Form.Check
											type="checkbox"
											checked={!!value}
											onChange={(event: any) => onChange(event.target.checked)}
											label="Roupas, calçados, equipamentos e utensílios utilizados pela equipe na atividade de colheita foram limpos e inspecionados ANTES de ENTRAR e ANTES de SAIR das Instalações? No caso de equipamentos e utensílios o registro foi realizado no campo LIMPEZA de EQUIPAMENTOS?"
										/>
									)}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Label>Observações</Form.Label>
								<Form.Control
									ref={defaultForm.register}
									name="observacoesEquipamentosAtividadeColheitaLimpos"
									as="textarea"
									rows={4}
									placeholder="Insira observações adicionais, se pertinente"
									defaultValue={entity?.vegetacao_Planejamento_Conducao?.[0]?.observacoesEquipamentosAtividadeColheitaLimpos ?? ''}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Controller
									control={defaultForm.control}
									name="restosVegetaisDevidamenteDescartados"
									defaultValue={entity?.vegetacao_Planejamento_Conducao?.[0]?.restosVegetaisDevidamenteDescartados ?? false}
									render={({ value, onChange }) => (
										<Form.Check
											type="checkbox"
											checked={!!value}
											onChange={(event: any) => onChange(event.target.checked)}
											label="Restos vegetais proveniente da colheita e limpeza das instalações foram devidamente descartados após a atividade de colheita? Os registros foram realizados no Formulário de Destruição e Descarte?"
										/>
									)}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<Form.Label>Observações</Form.Label>
								<Form.Control
									ref={defaultForm.register}
									name="observacoesRestosVegetaisDevidamenteDescartados"
									as="textarea"
									rows={4}
									style={{ minHeight: '6rem' }}
									placeholder="Insira observações adicionais, se pertinente"
									defaultValue={entity?.vegetacao_Planejamento_Conducao?.[0]?.observacoesRestosVegetaisDevidamenteDescartados ?? ''}
								/>
							</Form.Group>
						</Form.Row>
					</Fieldset>
			</If>

			{/* Limpeza de Instalações */}
			<If condition={modoFluxo === MODO_VIEW.LIMPEZA_INSTALACOES}>
				<Fieldset disabled={false} title={STRINGS_CADERNOCONFORMIDADE.BLOCK_SEVEN}>
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>
								Formulário de registro de limpeza das Instalações
								<br />
								<AddButton
									type="button"
									onClick={() => openLimpezaInstalacoesModal()}
								/>
							</Form.Label>
						</Form.Group>
					</Form.Row>
					<If condition={selectedLimpezaInstalacoes.length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={selectedLimpezaInstalacoes}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: actionsLimpezaInstalacoes,
								}}
							>
								<AgGridColumn
									headerName='#'
									headerClass="myfunc-default-header"
									field="contagemLimpezaInstalacao"
									cellStyle={{
										justifyContent: 'left'
									}}
								/>
								<AgGridColumn
									headerName='Fase de Limpeza'
									headerClass="myfunc-default-header"
									field="tipoFaseLimpeza_Id"
									valueFormatter={({ data }: any) => {

										if (data?.tipoFaseLimpeza_Id?.label === 'Outros')
											return `Outros (${data.outrosTipoFaseLimpeza})`;

										return data?.tipoFaseLimpeza_Id?.label;

									}}
								/>
								<AgGridColumn
									headerName='Data Inicial'
									headerClass="myfunc-default-header"
									field="dataInicialLimpeza"
									sort="asc"
									cellStyle={{
										justifyContent: 'left'
									}}
									valueFormatter={({ data }: any) => data.dataInicialLimpeza ? _generateDate(data.dataInicialLimpeza, 'Pt') : ''}
								/>
								<AgGridColumn
									headerName='Data Final'
									headerClass="myfunc-default-header"
									field="dataFinalLimpeza"
									cellStyle={{
										justifyContent: 'left'
									}}
									valueFormatter={({ data }: any) => data.dataFinalLimpeza ? _generateDate(data.dataFinalLimpeza, 'Pt') : ''}
								/>
								<AgGridColumn
									headerName='Responsável'
									field="listaResponsaveis"
									headerClass="myfunc-default-header"
								/>
								<AgGridColumn
									headerName="Ações"
									headerClass="myfunc-default-header"
									cellRenderer="actions"
									maxWidth={100}
								/>
							</AgGridReact>
						</div>
					</If>

				</Fieldset>
			</If>

			{/* Destruição e Descarte */}
			<If condition={modoFluxo === MODO_VIEW.DESCARTE}>
				<Fieldset disabled={false} title={STRINGS_CADERNOCONFORMIDADE.BLOCK_EIGHT}>
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>
								Formulário de Registro de Destruição e Descarte
								<br />
								<br />
								<AddButton
									type="button"
									onClick={() => openDestruicaoModal()}
								/>
							</Form.Label>
						</Form.Group>
					</Form.Row>
					<If condition={selectedDestruicao.length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={selectedDestruicao}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: actionsDestruicao,
								}}
							>
								<AgGridColumn
									headerName='#'
									headerClass="myfunc-default-header"
									field="contagemDestruicao"
									maxWidth={100}
									cellStyle={{
										justifyContent: 'left'
									}}
								/>
								<AgGridColumn
									headerName='Data Inicial'
									field="dataInicialDestruicao"
									headerClass="myfunc-default-header"
									sort="asc"
									maxWidth={100}
									valueFormatter={({ data }: any) => data.dataInicialDestruicao ? _generateDate(data.dataInicialDestruicao, 'Pt') : ''
									}
								/>
								<AgGridColumn
									headerName='Data Final'
									field="dataFinalDestruicao"
									headerClass="myfunc-default-header"
									maxWidth={100}
									valueFormatter={({ data }: any) => data.dataFinalDestruicao ? _generateDate(data.dataFinalDestruicao, 'Pt') : ''
									}
								/>
								<AgGridColumn
									headerName='Responsáveis'
									field="listaResponsaveisDestruicao"
									headerClass="myfunc-default-header"
								/>
								<AgGridColumn
									headerName="Ações"
									cellRenderer="actions"
									maxWidth={100}
								/>
							</AgGridReact>
						</div>
					</If>
				</Fieldset>
			</If>

			{/* Fiscalizações, Reportes E Anotações */}
			<If condition={modoFluxo === MODO_VIEW.NOTAS}>
				{/*Fiscalizações*/}
				<Fieldset disabled={false} title={STRINGS_CADERNOCONFORMIDADE.BLOCK_NINE}>
					{/*<Form.Row className="row-custom">*/}
					{/*	<Form.Group as={Col}>*/}
					{/*		<Form.Check*/}
					{/*			type="checkbox"*/}
					{/*			ref={defaultForm.register}*/}
					{/*			name="documentosDestino"*/}
					{/*			label="Existem documentos que comprovam o destino do material?"*/}
					{/*			defaultChecked={entity?.documentosDestino ? entity?.documentosDestino : false}*/}
					{/*		/>*/}
					{/*	</Form.Group>*/}
					{/*</Form.Row>*/}
					{/*<Form.Row className="row-custom">*/}
					{/*	<Form.Group as={Col}>*/}
					{/*		<Form.Label>Observações</Form.Label>*/}
					{/*		<Form.Control*/}
					{/*			ref={defaultForm.register}*/}
					{/*			name="observacoesDocumentosDestino"*/}
					{/*			as="textarea"*/}
					{/*			rows={4}*/}
					{/*			placeholder="Insira observações adicionais, se pertinente"*/}
					{/*			defaultValue={entity?.observacoesDocumentosDestino}*/}
					{/*		/>*/}
					{/*	</Form.Group>*/}
					{/*</Form.Row>*/}
					{/*<Form.Row className="row-custom">*/}
					{/*	<Form.Group as={Col}>*/}
					{/*		<Form.Check*/}
					{/*			type="checkbox"*/}
					{/*			ref={defaultForm.register}*/}
					{/*			name="documentosAmostras"*/}
					{/*			label="Existem documentos que comprovam materiais amostrados?"*/}
					{/*			defaultChecked={entity?.documentosAmostras ? entity?.documentosAmostras : false}*/}
					{/*		/>*/}
					{/*	</Form.Group>*/}
					{/*</Form.Row>*/}
					{/*<Form.Row className="row-custom">*/}
					{/*	<Form.Group as={Col}>*/}
					{/*		<Form.Label>Observações</Form.Label>*/}
					{/*		<Form.Control*/}
					{/*			ref={defaultForm.register}*/}
					{/*			name="observacoesDocumentosAmostras"*/}
					{/*			as="textarea"*/}
					{/*			rows={4}*/}
					{/*			placeholder="Insira observações adicionais, se pertinente"*/}
					{/*			defaultValue={entity?.observacoesDocumentosAmostras}*/}
					{/*		/>*/}
					{/*	</Form.Group>*/}
					{/*</Form.Row>*/}
					{/*<Form.Row className="row-custom">*/}
					{/*	<Form.Group as={Col}>*/}
					{/*		<Form.Check*/}
					{/*			type="checkbox"*/}
					{/*			ref={defaultForm.register}*/}
					{/*			name="formulariosDestruicao"*/}
					{/*			label="Existem formulários de destruição e descarte?"*/}
					{/*			defaultChecked={entity?.formulariosDestruicao ? entity?.formulariosDestruicao : false}*/}
					{/*		/>*/}
					{/*	</Form.Group>*/}
					{/*</Form.Row>*/}
					{/*<Form.Row className="row-custom">*/}
					{/*	<Form.Group as={Col}>*/}
					{/*		<Form.Label>Observações</Form.Label>*/}
					{/*		<Form.Control*/}
					{/*			ref={defaultForm.register}*/}
					{/*			name="observacoesFormulariosDestruicao"*/}
					{/*			as="textarea"*/}
					{/*			rows={4}*/}
					{/*			placeholder="Insira observações adicionais, se pertinente"*/}
					{/*			defaultValue={entity?.observacoesFormulariosDestruicao}*/}
					{/*		/>*/}
					{/*	</Form.Group>*/}
					{/*</Form.Row>*/}
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>
								Formulário de Registro de Fiscalização
								<br />
								<br />
								<AddButton
									type="button"
									onClick={() => {
										setContagemRegistroFiscalizacao(0);
										setRegistroFiscalizacaoEdit({
											id: 0,
											contagemRegistroFiscalizacao: '',
											orgaoFiscalizador: '',
											outrosOrgaoFiscalizador: '',
											dataFiscalizacao: '',
											observacoesTermosFiscalizacao: '',
											termosFiscalizacao: true,
											arquivoTermo: '',
											filename: '',
										});
										setArquivoRegistroFiscalizacaoPendente(null);
										setLblArquivoRegistroFiscalizacao('Escolher arquivo');
										setModalRegistroFiscalizacao(true);
									}}
								/>
							</Form.Label>
						</Form.Group>
					</Form.Row>
					<If condition={selectedRegistroFiscalizacao.length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={selectedRegistroFiscalizacao}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: actionsRegistroFiscalizacao,
									linkArquivoRegistroFiscalizacao,
								}}
							>
								<AgGridColumn headerName='#' field="contagemRegistroFiscalizacao" maxWidth={70} />
								<AgGridColumn
									headerName='Órgão Fiscalizador'
									field="orgaoFiscalizador"
									valueFormatter={({ data }: any) => {
										if (isValorOutros(data?.orgaoFiscalizador?.value))
											return `Outros (${data.outrosOrgaoFiscalizador ?? ''})`;
										return data?.orgaoFiscalizador?.label ?? '';
									}}
								/>
								<AgGridColumn
									headerName='Data da Fiscalização'
									field="dataFiscalizacao"
									sort="asc"
									maxWidth={140}
									valueFormatter={({ data }: any) => data.dataFiscalizacao ? _generateDate(data.dataFiscalizacao, 'Pt') : ''}
								/>
								<AgGridColumn
									headerName='Termo'
									field="filename"
									cellRenderer="linkArquivoRegistroFiscalizacao"
									minWidth={150}
								/>
								<AgGridColumn headerName='Observações' field="observacoesTermosFiscalizacao" />
								<AgGridColumn headerName="Ações" cellRenderer="actions" maxWidth={100} />
							</AgGridReact>
						</div>
					</If>
				</Fieldset>

				{/*Reportes*/}
				<Fieldset disabled={false} title={STRINGS_CADERNOCONFORMIDADE.BLOCK_TEN}>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={12}>
							<Form.Label>Informações sobre o material GM liberado não intencionalmente</Form.Label>
							<Form.Control
								ref={defaultForm.register}
								name="liberacaoNaoIntencional"
								as="textarea"
								rows={4}
								placeholder="Insira as informações sobre o material GM liberado não intencionalmente, sendo o mais específico possível, descrevendo as circunstâncias da liberação"
								defaultValue={entity?.liberacaoNaoIntencional}
							/>
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={12}>
							<Form.Label>Data e hora estimada da liberação não intencional</Form.Label>
							&nbsp;&nbsp;
							<Controller
								control={defaultForm.control}
								name="dataLiberacaoNaoIntencional"
								isInvalid={defaultForm.errors.dataLiberacaoNaoIntencional !== undefined}
								render={({ onChange, value }) => (
									<DatePicker
										selected={value}
										onChange={onChange}
										className="input-custom-to-date"
										locale="pt-BR"
										dateFormat="dd/MM/yyyy HH:mm"
										placeholderText="Selecionar a data"
										showTimeSelect
										timeIntervals={1}
									/>
								)}
							/>
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={12}>
							<Form.Label>Medidas de Correção</Form.Label>
							<Form.Control
								ref={defaultForm.register}
								name="medidasCorrecaoLiberacaoNaoIntencional"
								as="textarea"
								rows={4}
								placeholder="Insira as medidas de correção (passos tomados para a mitigação da liberação não-intencional - ação corretiva)"
								defaultValue={entity?.medidasCorrecaoLiberacaoNaoIntencional}
							/>
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={12}>
							<Form.Label>Dados de quem informou a liberação</Form.Label>
							&nbsp;
							<Form.Label>
								<AddButton
									type="button"
									onClick={() => {
										setModalResponsavelReporte(true);
									}
									}
								/>
							</Form.Label>
						</Form.Group>
					</Form.Row>
					<If condition={responsaveisReporte.length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={responsaveisReporte}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: acoesResponsaveisReporte
								}}
							>
								<AgGridColumn
									headerName='Nome'
									headerClass="myfunc-default-header"
									field="nomeReporteLiberacaoNaoIntencional"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									minWidth={250}
								/>
								<AgGridColumn
									headerName='Cargo'
									headerClass="myfunc-default-header"
									field="cargoReporteLiberacaoNaoIntencional"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									minWidth={250}
								/>
								<AgGridColumn
									headerName='Data'
									headerClass="myfunc-default-header"
									field="dataReporteLiberacaoNaoIntencional"
									minWidth={200}
									valueFormatter={({ data }: any) => data.dataReporteLiberacaoNaoIntencional ? _generateDate(data.dataReporteLiberacaoNaoIntencional, 'Pt') : ''}
								/>
								<AgGridColumn
									headerName="Ações"
									headerClass="myfunc-default-header"
									cellRenderer="actions"
									maxWidth={100}
								/>
							</AgGridReact>
						</div>
					</If>
					{/*	<Form.Row className="row-custom">*/}
					{/*		<Form.Group as={Col} md={6}>*/}
					{/*			<Form.Label>Pessoa que reportou a Liberação Não-Intencional</Form.Label>*/}
					{/*			<Form.Control*/}
					{/*				ref={defaultForm.register}*/}
					{/*				name="nomeReporteLiberacaoNaoIntencional"*/}
					{/*				placeholder="Nome do responsável"*/}
					{/*				defaultValue={entity?.nomeReporteLiberacaoNaoIntencional}*/}
					{/*			/>*/}
					{/*		</Form.Group>*/}
					{/*		<Form.Group as={Col} md={3}>*/}
					{/*			<Form.Label>Cargo</Form.Label>*/}
					{/*			<Form.Control*/}
					{/*				ref={defaultForm.register}*/}
					{/*				name="cargoReporteLiberacaoNaoIntencional"*/}
					{/*				placeholder="Cargo do responsável"*/}
					{/*				defaultValue={entity?.cargoReporteLiberacaoNaoIntencional}*/}
					{/*			/>*/}
					{/*		</Form.Group>*/}
					{/*		<Form.Group as={Col} md={3}>*/}
					{/*			<Form.Label>Data de aviso</Form.Label>*/}
					{/*			*/}{/*<Form.Control*/}
					{/*			*/}{/*	ref={defaultForm.register}*/}
					{/*			*/}{/*	name="dataReporteLiberacaoNaoIntencional"*/}
					{/*			*/}{/*	placeholder="Data e hora de aviso"*/}
					{/*			*/}{/*	defaultValue={entity?.dataReporteLiberacaoNaoIntencional}*/}
					{/*			*/}{/*/>*/}
					{/*			<br />*/}
					{/*			<Controller*/}
					{/*				control={defaultForm.control}*/}
					{/*				name="dataReporteLiberacaoNaoIntencional"*/}
					{/*				isInvalid={defaultForm.errors.dataReporteLiberacaoNaoIntencional !== undefined}*/}
					{/*				render={({ onChange, value }) => (*/}
					{/*					<DatePicker*/}
					{/*						selected={value}*/}
					{/*						onChange={onChange}*/}
					{/*						className="input-custom-to-date"*/}
					{/*						locale="pt-BR"*/}
					{/*						dateFormat="dd/MM/yyyy"*/}
					{/*						placeholderText="Selecionar a data"*/}
					{/*					/>*/}
					{/*				)}*/}
					{/*			/>*/}
					{/*		</Form.Group>*/}
					{/*	</Form.Row>*/}
				</Fieldset>

				{/*Anotações*/}
				<Fieldset disabled={false} title={STRINGS_CADERNOCONFORMIDADE.BLOCK_ELEVEN}>
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>
								<AddButton
									type="button"
									onClick={() => {
										setContagemAnotacao(0);
										setModalAnotacoes(true);
									}
									}
								/>
							</Form.Label>
						</Form.Group>
					</Form.Row>
					<If condition={selectedAnotacoes.length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={selectedAnotacoes}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: actionsAnotacoes,
								}}
							>
								<AgGridColumn
									headerName='Contagem'
									headerClass="myfunc-default-header"
									field="contagemAnotacao"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									maxWidth={100}
								/>
								<AgGridColumn
									headerName='Responsavel'
									headerClass="myfunc-default-header"
									field="responsavel"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									minWidth={250}
								/>
								<AgGridColumn
									headerName='Data'
									headerClass="myfunc-default-header"
									field="dataAnotacao"
									minWidth={200}
									valueFormatter={({ data }: any) => data.dataAnotacao ? _generateDate(data.dataAnotacao, 'Pt') : ''}
								/>
								<AgGridColumn
									headerName="Ações"
									headerClass="myfunc-default-header"
									cellRenderer="actions"
									maxWidth={100}
								/>
							</AgGridReact>
						</div>
					</If>

				</Fieldset>
			</If>

			{/* Limpeza de Equipamentos */}
			<If condition={limpezaEquipamentos} >
				<Fieldset disabled={false} title={STRINGS_CADERNOCONFORMIDADE.BLOCK_LIMPEZA_EQUIPAMENTOS}>
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>
								Formulário de Inspeção de Equipamentos após a Limpeza
								<br />
								<AddButton
									type="button"
									onClick={() => openInspecaoEquipamentosModal()}
								/>
							</Form.Label>
						</Form.Group>
					</Form.Row>
					<If condition={filtrarInspecaoEquipamentosPorFase(selectedInspecaoEquipamentos, tipoFaseLimpezaEquipamentosValue).length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={filtrarInspecaoEquipamentosPorFase(selectedInspecaoEquipamentos, tipoFaseLimpezaEquipamentosValue)}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: actionsInspecaoEquipamentos,
								}}
							>
								<AgGridColumn
									headerName='#'
									headerClass="myfunc-default-header"
									field="contagemInspecaoEquipamento"
									cellStyle={{
										justifyContent: 'left'
									}}
								/>
								<AgGridColumn
									headerName='Nome Equipamento/Maquinário'
									headerClass="myfunc-default-header"
									field="numeroPlantio"
									cellStyle={{
										justifyContent: 'left'
									}}
								/>
								<AgGridColumn
									headerName='ID do Equipamento/Maquinário'
									headerClass="myfunc-default-header"
									field="iD_Equipamento"
									cellStyle={{
										justifyContent: 'left'
									}}
								/>
								<AgGridColumn
									headerName='Data Antes Uso'
									headerClass="myfunc-default-header"
									field="dataAntesUso"
									sort="asc"
									cellStyle={{
										justifyContent: 'left'
									}}
									valueFormatter={({ data }: any) => data.dataAntesUso ? _generateDate(data.dataAntesUso, 'Pt') : ''}
								/>
								<AgGridColumn
									headerName='Data Após Uso'
									headerClass="myfunc-default-header"
									field="dataAposUso"
									cellStyle={{
										justifyContent: 'left'
									}}
									valueFormatter={({ data }: any) => data.dataAposUso ? _generateDate(data.dataAposUso, 'Pt') : ''}
								/>
								{/*<AgGridColumn*/}
								{/*	headerName='Fase do Ensaio'*/}
								{/*	headerClass="myfunc-default-header"*/}
								{/*	field="faseEnsaio"*/}
								{/*	cellStyle={{*/}
								{/*		justifyContent: 'left'*/}
								{/*	}}*/}
								{/*/>*/}
								{/*<AgGridColumn*/}
								{/*	headerName='Método de Limpeza'*/}
								{/*	headerClass="myfunc-default-header"*/}
								{/*	field="metodoLimpeza_Id"*/}
								{/*	valueFormatter={({ data }: any) => {*/}

								{/*		if (data?.metodoLimpeza_Id?.label === 'Outros')*/}
								{/*			return `Outros (${data.outrosMetodoLimpezaEquipamento})`;*/}

								{/*		return data?.metodoLimpeza_Id?.label;*/}
								{/*	}}*/}
								{/*/>*/}
								<AgGridColumn
									headerName='Responsável'
									field="listaResponsaveis"
									headerClass="myfunc-default-header"
								/>
								<AgGridColumn
									headerName='Método de Limpeza'
									field="listaMetodosLimpeza"
									headerClass="myfunc-default-header"
								/>
								<AgGridColumn
									headerName="Ações"
									headerClass="myfunc-default-header"
									cellRenderer="actions"
									maxWidth={100}
								/>
							</AgGridReact>
						</div>
					</If>
				</Fieldset>

			</If>

			<div className="button-position">
				<Button
					title="Voltar"
					contained={false}
					type="button"
					onClick={() => {
						isDirty ? setIsConfirmation(true) :
							history.goBack();
					}}
				/>
				<If condition={(statusCadernoConformidade === STATUS_CADERNOCONFORMIDADE.EmPreenchimento ||
					statusCadernoConformidade === STATUS_CADERNOCONFORMIDADE.CorrecaoSolicitada ||
					statusCadernoConformidade === STATUS_CADERNOCONFORMIDADE.SolicitacaoCriacaoAprovada ||
					statusCadernoConformidade === STATUS_CADERNOCONFORMIDADE.EmCorrecao) &&
					(isRequesterWriter(decoded.roles) || isAdmin(decoded.roles))}>
					<Button
						title="Salvar Rascunho"
						contained={true}
						type="button"
						onClick={() => onSubmitDraft()}
						isLoading={loadingDraft}
					/>
				</If>
				<If condition={(statusCadernoConformidade === STATUS_CADERNOCONFORMIDADE.EmPreenchimento ||
					statusCadernoConformidade === STATUS_CADERNOCONFORMIDADE.CorrecaoSolicitada ||
					statusCadernoConformidade === STATUS_CADERNOCONFORMIDADE.SolicitacaoCriacaoAprovada ||
					statusCadernoConformidade === STATUS_CADERNOCONFORMIDADE.EmCorrecao) &&
					(isRequesterWriter(decoded.roles) || isAdmin(decoded.roles))}>
					<GenericButton
						title="Salvar e Finalizar Caderno Digital"
						variant="btn-danger"
						type="button"
						onClick={() => setIsRegulatory(true)}
						loading={false}
					/>
				</If>
				<If condition={isFinalizacaoEmAnaliseRegulatorio(statusCadernoConformidade ?? 0) && (isReguladorWriter(decoded.roles) || isAdmin(decoded.roles))}>
					<GenericButton
						title="Solicitar Correção do Caderno Digital"
						variant="btn-danger"
						type="button"
						loading={false}
						onClick={() => setIsCorrection(true)}
					/>
					<GenericButton
						title="Aprovar Finalização do Caderno Digital"
						variant="btn-success"
						type="button"
						loading={false}
						onClick={() => setIsApprove(true)}
					/>
				</If>
			</div>
		</Form>

		{/*Modal Envio ao regulatório */}
		<If condition={isRegulatory}>
			<ConfirmationModal
				show={isRegulatory}
				onHide={() => {
					setIsRegulatory(false);
				}}
				title={STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_ENVIO_CIBIO_TITLE}
				confirmationMsg={STRINGS.REGULATORY_ACTION}
				onConfirm={() => {
					onSubmit();
				}}
				loading={loadingSubmit}
				variant="success"
				color="white"
			>
				<p>{STRINGS.REGULATORY_MESSAGE}</p>
			</ConfirmationModal>
		</If>

		{/*Modal Correção */}
		<If condition={isCorrection}>
			<ConfirmationModal
				show={isCorrection}
				onHide={() => setIsCorrection(false)}
				title={STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_CORRECTION_TITLE}
				confirmationMsg={STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_CORRECTION_CONFIRMATION_MSG}
				onConfirm={() => requestCorrection()}
				loading={loadingCorrection}
				variant="success"
				color="white"
				hideFooter={successCorrection}
			>
				<If condition={successCorrection}>
					<AlertSuccess
						message={STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_CORRECTION_SUCCESS}
					/>
				</If>
				<p>{STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_CORRECTION_BODY_MSG}</p>
				<Form.Label>
					Motivo da Correção:<em>*</em>
				</Form.Label>
				<Form.Control
					onChange={({ target }: any) =>
						setReasonCorrection(target.value)
					}
					value={reasonCorrection}
					as="textarea"
					maxLength={200}
				/>
			</ConfirmationModal>
		</If>

		{/*Modal Aprovação */}
		<If condition={isApprove}>
			<ConfirmationModal
				show={isApprove}
				onHide={() => setIsApprove(false)}
				title={isFinalizacaoEmAnaliseRegulatorio(statusCadernoConformidade ?? 0)
					? STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_APROVE_REGULATORIO_TITLE
					: STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_APROVE_TITLE}
				confirmationMsg={STRINGS.APROVE_CONFIRMATION}
				onConfirm={() => submitForm_aprove()}
				loading={loadingApprove}
				variant="success"
				color="white"
				hideFooter={successApprove}
			>
				<If condition={successApprove}>
					<AlertSuccess
						message={isFinalizacaoEmAnaliseRegulatorio(statusCadernoConformidade ?? 0)
							? STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_APROVE_REGULATORIO_SUCCESS
							: STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_APROVE_SUCCESS}
					/>
				</If>
				<p>{isFinalizacaoEmAnaliseRegulatorio(statusCadernoConformidade ?? 0)
					? STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_APROVE_REGULATORIO_BODY_MSG
					: STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_APROVE_BODY_MSG}</p>
			</ConfirmationModal>
		</If>

		{/*Modal Arquivo AAC*/}
		<If condition={modalAtivo === 'AAC_DADOS_PRINCIPAIS'}>
			<Modal show={true} onHide={() => setModalAtivo('')} title={'Adicionar arquivo de AAC'}>
				<Form onSubmit={modalArquivo.handleSubmit(submitArquivosDadosPrincipaisAAC)} autoComplete="off">
					<Form.Group as={Col} md={6}>
						<Form.Label>
							Anexar Documento<em>*</em>
						</Form.Label>
						<Form.File
							ref={modalArquivo.register}
							name="arquivos"
							label={lblDadosPrincipaisAAC}
							data-browse="upload"
							custom
							onChange={({ target }: any) => {
								if (!target.value) {
									return
								}
								setLblDadosPrincipaisAAC(`${target.files[0].name}`);
							}}
						/>
					</Form.Group>
					<div className="button-position">
						<Button title="Cancelar" contained={false} type="button" onClick={() => setModalAtivo('')} />
						<Button title="Inserir" contained={true} type="submit" />
					</div>
				</Form>
			</Modal>
		</If>

		{/*Modal Arquivo Lista Treinamento*/}
		<If condition={modalAtivo === 'LISTA_TREINAMENTO_DADOS_PRINCIPAIS'}>
			<Modal show={true} onHide={() => setModalAtivo('')} title={'Adicionar arquivo de Lista de Treinamento'}>
				<Form onSubmit={modalArquivo.handleSubmit(submitArquivosListaTreinamento)} autoComplete="off">
					<Form.Group as={Col} md={6}>
						<Form.Label>
							Anexar Documento<em>*</em>
						</Form.Label>
						<Form.File
							ref={modalArquivo.register}
							name="arquivos"
							label={lblDadosPrincipaisListaTreinamento}
							data-browse="upload"
							custom
							onChange={({ target }: any) => {
								if (!target.value) {
									return
								}
								setLblDadosPrincipaisListaTreinamento(`${target.files[0].name}`);
							}}
						/>
					</Form.Group>
					<div className="button-position">
						<Button title="Cancelar" contained={false} type="button" onClick={() => setModalAtivo('')} />
						<Button title="Inserir" contained={true} type="submit" />
					</div>
				</Form>
			</Modal>
		</If>

		{/*Modal Arquivo Parecer Técnico*/}
		<If condition={modalAtivo === 'PARECER_TECNICO_DADOS_PRINCIPAIS'}>
			<Modal show={true} onHide={() => setModalAtivo('')} title={'Adicionar arquivo de Parecer Técnico'}>
				<Form onSubmit={modalArquivo.handleSubmit(submitArquivosDadosPrincipaisParecerTecnico)} autoComplete="off">
					<Form.Group as={Col} md={6}>
						<Form.Label>
							Anexar Documento<em>*</em>
						</Form.Label>
						<Form.File
							ref={modalArquivo.register}
							name="arquivos"
							label={lblDadosPrincipaisParecerTecnico}
							data-browse="upload"
							custom
							onChange={({ target }: any) => {
								if (!target.value) {
									return
								}
								setLblDadosPrincipaisParecerTecnico(`${target.files[0].name}`);
							}}
						/>
					</Form.Group>
					<div className="button-position">
						<Button title="Cancelar" contained={false} type="button" onClick={() => setModalAtivo('')} />
						<Button title="Inserir" contained={true} type="submit" />
					</div>
				</Form>
			</Modal>
		</If>

		{/*Modal Arquivo Liberação Quarentena*/}
		<If condition={modalAtivo === 'LIBERACAO_QUARENTENA_DADOS_PRINCIPAIS'}>
			<Modal show={true} onHide={() => setModalAtivo('')} title={'Adicionar arquivo de Liberação de Quarentena'}>
				<Form onSubmit={modalArquivo.handleSubmit(submitArquivosLiberacaoQuarentena)} autoComplete="off">
					<Form.Group as={Col} md={6}>
						<Form.Label>
							Anexar Documento<em>*</em>
						</Form.Label>
						<Form.File
							ref={modalArquivo.register}
							name="arquivos"
							label={lblDadosPrincipaisLiberacaoQuarentena}
							data-browse="upload"
							custom
							onChange={({ target }: any) => {
								if (!target.value) {
									return
								}
								setLblDadosPrincipaisLiberacaoQuarentena(`${target.files[0].name}`);
							}}
						/>
					</Form.Group>
					<div className="button-position">
						<Button title="Cancelar" contained={false} type="button" onClick={() => setModalAtivo('')} />
						<Button title="Inserir" contained={true} type="submit" />
					</div>
				</Form>
			</Modal>
		</If>

		{/*Modal Arquivo Croqui*/}
		<If condition={modalAtivo === 'CROQUI_PLANEJAMENTO'}>
			<Modal show={true} onHide={() => setModalAtivo('')} title={'Adicionar arquivo de croqui'}>
				<Form onSubmit={modalArquivo.handleSubmit(submitArquivosPlanejamentoCroqui)} autoComplete="off">
					<Form.Group as={Col} md={6}>
						<Form.Label>
							Anexar Documento<em>*</em>
						</Form.Label>
						<Form.File
							ref={modalArquivo.register}
							name="arquivos"
							label={lblPlanejamentoCroqui}
							data-browse="upload"
							custom
							onChange={({ target }: any) => {
								if (!target.value) {
									return
								}
								setLblPlanejamentoCroqui(`${target.files[0].name}`);
							}}
						/>
					</Form.Group>
					<div className="button-position">
						<Button title="Cancelar" contained={false} type="button" onClick={() => setModalAtivo('')} />
						<Button title="Inserir" contained={true} type="submit" />
					</div>
				</Form>
			</Modal>
		</If>

		{/*Modal Documentos Gerais */}
		<If condition={modalAtivo === 'DOCUMENTOS_GERAIS'}>
			<Modal show={true} onHide={() => setModalAtivo('')} title={'Adicionar arquivo de Documentos'}>
				<Form onSubmit={modalArquivo.handleSubmit(submitArquivosDocumentosGerais)} autoComplete="off">
					<Form.Group as={Col} md={6}>
						<Form.Label>
							Anexar Documento<em>*</em>
						</Form.Label>
						<Form.File
							ref={modalArquivo.register}
							name="arquivos"
							label={lblDocumentosGerais}
							data-browse="upload"
							custom
							onChange={({ target }: any) => {
								if (!target.value) {
									return
								}
								setLblDocumentosGerais(`${target.files[0].name}`);
							}}
						/>
					</Form.Group>
					<div className="button-position">
						<Button title="Cancelar" contained={false} type="button" onClick={() => setModalAtivo('')} />
						<Button title="Inserir" contained={true} type="submit" />
					</div>
				</Form>
			</Modal>
		</If>

		{/*Modal Arquivo Colheita AMI*/}
		<If condition={modalAtivo === 'ARQUIVO_COLHEITA_AMI'}>
			<Modal show={true} onHide={() => setModalAtivo('')} title={'Adicionar arquivo de AMI'}>
				<Form onSubmit={modalArquivo.handleSubmit(submitArquivosColheitaAMI)} autoComplete="off">
					<Form.Group as={Col} md={6}>
						<Form.Label>
							Anexar Documento<em>*</em>
						</Form.Label>
						<Form.File
							ref={modalArquivo.register}
							name="arquivos"
							label={lblColheitaAMI}
							data-browse="upload"
							custom
							onChange={({ target }: any) => {
								if (!target.value) {
									return
								}
								setLblColheitaAMI(`${target.files[0].name}`);
							}}
						/>
					</Form.Group>
					<div className="button-position">
						<Button title="Cancelar" contained={false} type="button" onClick={() => setModalAtivo('')} />
						<Button title="Inserir" contained={true} type="submit" />
					</div>
				</Form>
			</Modal>
		</If>

		{/*Modal Comunicados */}
		<If condition={modalAtivo === 'CONDUCAO_COMUNICADOS'}>
			<Modal
				show={true}
				onHide={() => setModalAtivo('')}
				title="Adicionar comunicado"
			>
				<Form autoComplete="off">
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.File
								ref={defaultForm.register}
								type="file"
								name="novoComunicado"
								label={lblConducaoComunicados}
								data-browse="upload"
								custom
								style={{ zIndex: 0 }}
								onChange={({ target }: any) => {
									if (!target.value) return;
									setLblConducaoComunicados(`${target.files[0].name}`);
								}}
							/>
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>Data do Comunicado</Form.Label>
							<br />
							<Controller
								control={defaultForm.control}
								name="dataComunicado"
								isInvalid={errorsDataPlantios.dataComunicado !== undefined}
								render={({ onChange, value }) => (
									<DatePicker
										selected={value}
										onChange={onChange}
										className="input-custom-to-date"
										locale="pt-BR"
										dateFormat="dd/MM/yyyy"
										placeholderText="Selecionar a data"
										maxDate={new Date()}
									/>
								)}
							/>
						</Form.Group>
					</Form.Row>
					<div className="button-position">
						<Button
							title="Cancelar"
							contained={false}
							type="button"
							onClick={() => setModalAtivo('')}
						/>
						<Button
							title="Inserir"
							contained={true}
							type="button"
							onClick={() => { submitArquivosConducaoComunicados(); }}
						/>
					</div>
				</Form>
			</Modal>

		</If>

		{/*Modal Data Plantios */}
		<If condition={modalDataPlantios}>
			<Modal
				show={true}
				onHide={() => setModalDataPlantios(false)}
				title={STRINGS_CADERNOCONFORMIDADE.DATA_PLANTIO_MODAL_TITLE}
			>
				<Form onSubmit={handleSubmitDataPlantios(onSubmitDataPlantios)} autoComplete="off">
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Data Inicial do Plantio</Form.Label>
							<br />
							<Controller
								control={controlDataPlantios}
								name="dataInicialPlantio"
								defaultValue={dataPlantioEdit.dataInicialPlantio}
								isInvalid={errorsDataPlantios.dataInicialPlantio !== undefined}
								render={({ onChange, value }) => (
									<DatePicker
										selected={value}
										onChange={onChange}
										className="input-custom-to-date"
										locale="pt-BR"
										dateFormat="dd/MM/yyyy"
										placeholderText="Selecionar a data"
									/>
								)}
							/>
						</Form.Group>
						<Form.Group as={Col} md={6}>
							<Form.Label>Data Final do Plantio</Form.Label>
							<br />
							<Controller
								control={controlDataPlantios}
								name="dataFinalPlantio"
								defaultValue={dataPlantioEdit.dataFinalPlantio}
								isInvalid={errorsDataPlantios.dataFinalPlantio !== undefined}
								render={({ onChange, value }) => (
									<DatePicker
										selected={value}
										onChange={onChange}
										className="input-custom-to-date"
										locale="pt-BR"
										dateFormat="dd/MM/yyyy"
										placeholderText="Selecionar a data"
									/>
								)}
							/>
						</Form.Group>
					</Form.Row>

					<div className="button-position">
						<Button
							title="Cancelar"
							contained={false}
							type="button"
							onClick={() => setModalDataPlantios(false)}
						/>
						<Button
							title="Inserir"
							contained={true}
							type="submit"
						/>
					</div>
				</Form>
			</Modal>
		</If>

		{/*Modal Pessoas Envolvidas Plantio */}
		<If condition={modalPessoasEnvolvidasPlantio}>
			<Modal
				show={true}
				onHide={() => setModalPessoasEnvolvidasPlantio(false)}
				title={STRINGS_CADERNOCONFORMIDADE.PESSOAS_ENVOLVIDAS_PLANTIO_MODAL_TITLE}
			>
				<Form onSubmit={handleSubmitPessoasEnvolvidasPlantio(onSubmitPessoasEnvolvidasPlantio)} autoComplete="off">
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Pessoas envolvidas no plantio</Form.Label>
							<br />
							<Form.Control
								ref={registerPessoasEnvolvidasPlantio}
								name="pessoaPlantio"
								placeholder="Informe o(s) Responsável(is) pela atividade"
								maxLength={100}
								defaultValue={PessoasEnvolvidasPlantioEdit.pessoaPlantio}
							/>
						</Form.Group>
					</Form.Row>

					<div className="button-position">
						<Button
							title="Cancelar"
							contained={false}
							type="button"
							onClick={() => setModalPessoasEnvolvidasPlantio(false)}
						/>
						<Button
							title="Inserir"
							contained={true}
							type="submit"
						/>
					</div>
				</Form>
			</Modal>
		</If>

		{/*Modal Arquivo AMI Planejamento */}
		<If condition={modalAtivo === 'NUMERO_AMI_PLANEJAMEMTO'}>
			<Modal show={true} onHide={() => setModalAtivo('')} title={'Adicionar arquivo de AMI'}>
				<Form onSubmit={modalArquivo.handleSubmit(submitArquivos)} autoComplete="off">
					<Form.Group as={Col} md={6}>
						<Form.Label>
							Anexar Número da AMI<em>*</em>
						</Form.Label>
						<Form.File
							ref={modalArquivo.register}
							name="arquivos"
							label={lblNumeroAMI}
							data-browse="upload"
							custom
							onChange={({ target }: any) => {
								if (!target.value) {
									return
								}
								setLblNumeroAMI(`${target.files[0].name}`);
							}}
						/>
					</Form.Group>
					<div className="button-position">
						<Button title="Cancelar" contained={false} type="button" onClick={() => setModalAtivo('')} />
						<Button title="Inserir" contained={true} type="submit" />
					</div>
				</Form>
			</Modal>
		</If>

		{/*Modal Plantios */}
		<If condition={modalPlantios}>
			<Modal
				key={`plantio-modal-${plantioEdit.id ?? 'new'}-${plantioEdit.numeroPlantio ?? ''}`}
				show={true}
				onHide={() => setModalPlantios(false)}
				title={STRINGS_CADERNOCONFORMIDADE.PLANTIOS_MODAL_TITLE}
			>
				<Form onSubmit={handleSubmitPlantios(onSubmitPlantios)} autoComplete="off">
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Número do Plantio</Form.Label>
							<Form.Control
								ref={registerPlantios}
								name="numeroPlantio"
								placeholder="Insira o número do plantio"
								maxLength={100}
								defaultValue={plantioEdit.numeroPlantio}
							/>
						</Form.Group>
						<Form.Group as={Col} md={6}>
							<Form.Label>Número da Casa-de-Vegetação/CAGE</Form.Label>
							<Form.Control
								ref={registerPlantios}
								name="casaVegetacaoModulo"
								placeholder="Insira o Número da Casa-de-Vegetação"
								defaultValue={plantioEdit.casaVegetacaoModulo}
							/>
						</Form.Group>
					</Form.Row>
					{/*<Form.Row className="row-custom">*/}
					{/*	<Form.Group as={Col} >*/}
					{/*		<Form.Label>Material(is) Plantado(s)</Form.Label>*/}
					{/*		<Form.Control*/}
					{/*			ref={registerPlantios}*/}
					{/*			name="material"*/}
					{/*			placeholder="Informar material(is) plantado(s) ou anexar lista de plantio"*/}
					{/*			defaultValue={plantioEdit.material}*/}
					{/*		/>*/}
					{/*	</Form.Group>*/}
					{/*</Form.Row>*/}
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>
								Anexar Lista de Materiais Plantados
							</Form.Label>
							<Form.File
								ref={registerPlantios}
								name="arquivoMaterialPlantado"
								label={lblArquivoMaterialPlantado}
								data-browse="upload"
								custom
								onChange={({ target }: any) => {
									if (!target.files?.[0]) {
										return
									}
									setLblArquivoMaterialPlantado(target.files[0].name);
									setPlantioMaterialFile(target.files[0]);
								}}
							/>
							<If condition={plantioMaterialFile !== null}>
								<FileExistent
									text={obterNomeArquivoPlantio(plantioMaterialFile)}
									onDownload={(e: any) => {
										e.preventDefault();
										if (plantioMaterialFile) {
											downloadArquivo(e, plantioMaterialFile);
										}
									}}
									onClick={() => {
										setPlantioMaterialFile(null);
										setLblArquivoMaterialPlantado('Escolher arquivo');
									}}
								/>
							</If>
							<If condition={!plantioMaterialFile && obterArquivoPlantioMaterialSalvo(plantioEdit).path}>
								<FileExistent
									text={obterArquivoPlantioMaterialSalvo(plantioEdit).filename}
									onDownload={(e: any) => {
										e.preventDefault();
										const arquivoSalvo = obterArquivoPlantioMaterialSalvo(plantioEdit);
										downloadArquivo(e, { path: arquivoSalvo.path, filename: arquivoSalvo.filename });
									}}
									onClick={() => {
										setPlantioEdit((state: any) => ({
											...state,
											filenameMaterialPlantado: '',
											pathMaterialPlantado: undefined,
											codigoMaterialPlantado: undefined,
											arquivoMaterialPlantado: null,
										}));
										setLblArquivoMaterialPlantado('Escolher arquivo');
									}}
								/>
							</If>
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>
								Anexar AMI de plantio
							</Form.Label>
							<Form.File
								ref={registerPlantios}
								name="arquivoPlantioAMI"
								label={lblArquivoPlantioAMI}
								data-browse="upload"
								custom
								onChange={({ target }: any) => {
									if (!target.files?.[0]) {
										return
									}
									setLblArquivoPlantioAMI(target.files[0].name);
									setPlantioAMIFile(target.files[0]);
								}}
							/>
							<If condition={plantioAMIFile !== null}>
								<FileExistent
									text={obterNomeArquivoPlantio(plantioAMIFile)}
									onDownload={(e: any) => {
										e.preventDefault();
										if (plantioAMIFile) {
											downloadArquivo(e, plantioAMIFile);
										}
									}}
									onClick={() => {
										setPlantioAMIFile(null);
										setLblArquivoPlantioAMI('Escolher arquivo');
									}}
								/>
							</If>
							<If condition={!plantioAMIFile && obterArquivoPlantioAMISalvo(plantioEdit).path}>
								<FileExistent
									text={obterArquivoPlantioAMISalvo(plantioEdit).filename}
									onDownload={(e: any) => {
										e.preventDefault();
										const arquivoSalvo = obterArquivoPlantioAMISalvo(plantioEdit);
										downloadArquivo(e, { path: arquivoSalvo.path, filename: arquivoSalvo.filename });
									}}
									onClick={() => {
										setPlantioEdit((state: any) => ({
											...state,
											filenamePlantioAMI: '',
											pathPlantioAMI: undefined,
											codigoPlantioAMI: undefined,
											arquivoPlantioAMI: null,
										}));
										setLblArquivoPlantioAMI('Escolher arquivo');
									}}
								/>
							</If>
						</Form.Group>
					</Form.Row>
					{/*<Form.Row className="row-custom">*/}
					{/*	<Form.Group as={Col} >*/}
					{/*		<Form.Label>Material(is) Plantado(s)</Form.Label>*/}
					{/*		<Form.Control*/}
					{/*			ref={registerPlantios}*/}
					{/*			name="material"*/}
					{/*			placeholder="Informar material(is) plantado(s) ou anexar lista de plantio"*/}
					{/*			defaultValue={plantioEdit.material}*/}
					{/*		/>*/}
					{/*	</Form.Group>*/}
					{/*</Form.Row>*/}
					{/*<If condition={plantioEdit.arquivoMateriaisPlantados?.length}>*/}
					{/*	<Form.Row className="row-custom">*/}
					{/*		<Form.Group as={Col}>*/}
					{/*			<FileExistent text={plantioEdit.arquivoMateriaisPlantados ? plantioEdit.arquivoMateriaisPlantados[0].filename : ''}*/}
					{/*				onDownload={(e: any) => {*/}
					{/*					e.preventDefault();*/}
					{/*					downloadModelFilePlantioArquivoMateriais(fileFieldPlantioArquivoMateriais);*/}
					{/*				}}*/}
					{/*				onClick={() => {*/}
					{/*					setFileFieldPlantioArquivoMateriais({ id: null, codigo: '', dataAtualizacao: '', nome: '', path: '', usuario: '' });*/}
					{/*				}}*/}
					{/*			/>*/}
					{/*		</Form.Group>*/}
					{/*	</Form.Row>*/}
					{/*</If>*/}
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Data Inicial do Plantio</Form.Label>
							<br />
							<Controller
								control={controlPlantios}
								name="dataInicialPlantio"
								defaultValue={plantioEdit.dataInicialPlantio}
								isInvalid={errorsDataPlantios.dataInicialPlantio !== undefined}
								render={({ onChange, value }) => (
									<DatePicker
										selected={value}
										onChange={onChange}
										className="input-custom-to-date"
										locale="pt-BR"
										dateFormat="dd/MM/yyyy"
										placeholderText="Selecionar a data"
									/>
								)}
							/>
						</Form.Group>
						<Form.Group as={Col} md={6}>
							<Form.Label>Data Final do Plantio</Form.Label>
							<br />
							<Controller
								control={controlPlantios}
								name="dataFinalPlantio"
								defaultValue={plantioEdit.dataFinalPlantio}
								isInvalid={errorsDataPlantios.dataFinalPlantio !== undefined}
								render={({ onChange, value }) => (
									<DatePicker
										selected={value}
										onChange={onChange}
										className="input-custom-to-date"
										locale="pt-BR"
										dateFormat="dd/MM/yyyy"
										placeholderText="Selecionar a data"
									/>
								)}
							/>
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Colaboradores envolvidos no Plantio</Form.Label>
							<br />
							<Form.Control
								ref={defaultForm.register}
								name="responsavelPlantio"
								placeholder="Insira o responsável"
							/>
							&nbsp;
							<AddButton
								type="button"
								onClick={() => {
									AdicionarResponsavelPlantio();

									defaultForm.setValue('responsavelPlantio', '');

								}}
							/>
						</Form.Group>
					</Form.Row>
					<If condition={responsaveisPlantio.length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={responsaveisPlantio}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: acoesResponsaveisPlantio,
									linkPastaProcesso: linkDownload
								}}
							>
								<AgGridColumn
									headerName='Responsavel'
									headerClass="myfunc-default-header"
									field="responsavel"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									minWidth={250}
								/>
								<AgGridColumn
									headerName="Ações"
									headerClass="myfunc-default-header"
									cellRenderer="actions"
									maxWidth={100}
								/>
							</AgGridReact>
						</div>
					</If>

					<Form.Row className="row-custom">
						<Form.Group as={Col} md={12}>
							<Form.Label>Informações Adicionais do Plantio</Form.Label>
							<Form.Control
								ref={registerPlantios}
								name="informacoesAdicionais"
								as="textarea"
								rows={4}
								placeholder="Insira a anotação"
								defaultValue={plantioEdit.informacoesAdicionais}
							/>
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Check
								type="checkbox"
								ref={registerPlantios}
								name="sobraMaterial"
								label="Houve sobra de material após o plantio?"
								defaultChecked={plantioEdit.sobraMaterial ? plantioEdit.sobraMaterial : false}
								onClick={() => {
									checkboxSobraMaterial == false ? setCheckboxSobraMaterial(true) : setCheckboxSobraMaterial(false);
								}}
							/>
						</Form.Group>
					</Form.Row>
					<If condition={checkboxSobraMaterial}>
						<Form.Row className="row-custom">
							<Form.Group as={Col} md={6}>
								<Form.Label>Número de Amostras Restantes</Form.Label>
								<Form.Control
									ref={registerPlantios}
									name="numeroAmostrasRestantes"
									placeholder="Insira o número de amostras restantes"
									defaultValue={plantioEdit.numeroAmostrasRestantes}
								/>
							</Form.Group>
							<Form.Group as={Col} md={6}>
								<Form.Label>Quantidade de amostras restantes (gramas)</Form.Label>
								<Form.Control
									ref={registerPlantios}
									name="quantidadeAmostrasRestantes"
									placeholder="Insira a quantidade de material que sobrou (gramas)"
									defaultValue={plantioEdit.quantidadeAmostrasRestantes}
									type="number"
									onChange={({ target }: any) => {
										if (target.value.split(".")[1]?.length > 2)
											target.value = Number(target.value).toFixed(2);
									}}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row className="row-custom">
							<Form.Group as={Col} md={6}>
								<Form.Label>Destino da Sobra</Form.Label>
								<Controller
									control={controlPlantios}
									name="destinoSobra"
									defaultValue={plantioEdit.destinoSobra}
									required
									as={<Select
										placeholder="Selecione um método de descarte"
										options={enumDestinoSobra.map(destinoSobra => Object.assign({ value: destinoSobra.key, label: destinoSobra.value }))}
										isClearable
									/>}
								/>
							</Form.Group>
						</Form.Row>
						<If condition={!isEmptyObj(watchEditPlantios()) || plantioEdit.destinoSobra}>
							<If condition={watchEditPlantios().destinoSobra?.value === 99 || plantioEdit.destinoSobraOutros}>
								<Form.Row className="row-custom">
									<Form.Group as={Col} md={6}>
										<Form.Label>
											Especifique o destino da sobra<em>*</em>
										</Form.Label>
										<Form.Control
											ref={registerPlantios}
											defaultValue={plantioEdit.destinoSobraOutros}
											required
											name="destinoSobraOutros"
											placeholder="Insira o destino da sobra"
										/>
										<span className="error-field">
											{STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_FIELD_TO_SPECIFY}
										</span>
									</Form.Group>
								</Form.Row>
							</If>
						</If>
						<Form.Row className="row-custom">
							<Form.Group as={Col} md={12}>
								<Form.Label>Informações Adicionais da Sobra</Form.Label>
								<Form.Control
									ref={registerPlantios}
									name="informacoesAdicionaisMaterial"
									as="textarea"
									rows={4}
									placeholder="Insira a anotação"
									defaultValue={plantioEdit.informacoesAdicionaisMaterial}
								/>
							</Form.Group>
						</Form.Row>
					</If>

					<div className="button-position">
						<Button
							title="Cancelar"
							contained={false}
							type="button"
							onClick={() => setModalPlantios(false)}
						/>
						<Button
							title="Inserir"
							contained={true}
							type="submit"
						/>
					</div>
				</Form>
			</Modal>
		</If>

		{/*Modal Amostragem */}
		<If condition={modalRegistroAmostragem}>
			<Modal
				show={true}
				onHide={() => setModalRegistroAmostragem(false)}
				title={STRINGS_CADERNOCONFORMIDADE.REGISTRO_AMOSTRAGEM_MODAL_TITLE}
			>
				<Form onSubmit={handleSubmitRegistroAmostragem(onSubmitRegistroAmostragem)} autoComplete="off">
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Data Inicial da Amostragem</Form.Label>
							<br />
							<Controller
								control={controlRegistroAmostragem}
								name="dataInicialAmostragem"
								defaultValue={registroAmostragemEdit.dataInicialAmostragem}
								isInvalid={errorsRegistroAmostragem.dataInicialAmostragem !== undefined}
								render={({ onChange, value }) => (
									<DatePicker
										selected={value}
										onChange={onChange}
										className="input-custom-to-date"
										locale="pt-BR"
										dateFormat="dd/MM/yyyy"
										placeholderText="Selecionar a data"
									/>
								)}
							/>
						</Form.Group>
						<Form.Group as={Col} md={6}>
							<Form.Label>Data Final da Amostragem</Form.Label>
							<br />
							<Controller
								control={controlRegistroAmostragem}
								name="dataFinalAmostragem"
								defaultValue={registroAmostragemEdit.dataFinalAmostragem}
								isInvalid={errorsRegistroAmostragem.dataFinalAmostragem !== undefined}
								render={({ onChange, value }) => (
									<DatePicker
										selected={value}
										onChange={onChange}
										className="input-custom-to-date"
										locale="pt-BR"
										dateFormat="dd/MM/yyyy"
										placeholderText="Selecionar a data"
									/>
								)}
							/>
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Tipo de Material Amostragem</Form.Label>
							<br />
							<Controller
								control={controlRegistroAmostragem}
								name="tipoMaterialAmostragem"
								required
								defaultValue={registroAmostragemEdit.tipoMaterialAmostragem}
								isInvalid={errorsRegistroAmostragem.tipoMaterialAmostragem !== undefined}
								as={<Select
									placeholder="Selecione um tipo de material"
									options={enumTipoMaterialAmostragem.map(tipoMaterialAmostragem => Object.assign({ value: tipoMaterialAmostragem.key, label: tipoMaterialAmostragem.value }))}
									isClearable
									onInputChange={() =>
										setRegistroAmostragemEdit(state => ({
											id: state.id,
											contagemRegistroAmostragem: state.contagemRegistroAmostragem,
											dataInicialAmostragem: state.dataInicialAmostragem,
											dataFinalAmostragem: state.dataFinalAmostragem,
											tipoMaterialAmostragem: state.tipoMaterialAmostragem,
											responsavelAmostragem: state.responsavelAmostragem,
											destinoAmostras: state.destinoAmostras,
											arquivoAmostragem: state.arquivoAmostragem,
											filename: state.filename,
											tipoMaterialAmostragemOutros: state.tipoMaterialAmostragemOutros,
											destinoAmostrasOutros: state.destinoAmostrasOutros,
										}))
									}
								/>}
							/>
						</Form.Group>
					</Form.Row>
					<If condition={!isEmptyObj(watchEditRegistroAmostragem()) || registroAmostragemEdit.tipoMaterialAmostragem}>
						<If condition={watchEditRegistroAmostragem().tipoMaterialAmostragem?.value === 99 || registroAmostragemEdit.tipoMaterialAmostragemOutros}>
							<Form.Row className="row-custom">
								<Form.Group as={Col} md={6}>
									<Form.Label>
										Especifique o tipo de material<em>*</em>
									</Form.Label>
									<Form.Control
										ref={registerRegistroAmostragem}
										defaultValue={registroAmostragemEdit.tipoMaterialAmostragemOutros}
										required
										name="tipoMaterialAmostragemOutros"
										placeholder="Insira o tipo de material"
									/>
									<span className="error-field">
										{STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_FIELD_TO_SPECIFY}
									</span>
								</Form.Group>
							</Form.Row>
						</If>
					</If>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Destino da Amostra</Form.Label>
							<Controller
								control={controlRegistroAmostragem}
								name="destinoAmostras"
								required
								defaultValue={registroAmostragemEdit.destinoAmostras}
								isInvalid={errorsRegistroAmostragem.destinoAmostras !== undefined}
								as={<Select
									placeholder="Selecione o destino das amostras"
									options={enumDestinoAmostras.map(destinoAmostras => Object.assign({ value: destinoAmostras.key, label: destinoAmostras.value }))}
									isClearable
								/>}
							/>
						</Form.Group>
					</Form.Row>
					<If condition={!isEmptyObj(watchEditRegistroAmostragem()) || registroAmostragemEdit.destinoAmostras}>
						<If condition={watchEditRegistroAmostragem().destinoAmostras?.value === 99 || registroAmostragemEdit.destinoAmostrasOutros}>
							<Form.Row className="row-custom">
								<Form.Group as={Col} md={6}>
									<Form.Label>
										Especifique o destino da amostra<em>*</em>
									</Form.Label>
									<Form.Control
										ref={registerRegistroAmostragem}
										defaultValue={registroAmostragemEdit.destinoAmostrasOutros}
										required
										name="destinoAmostrasOutros"
										placeholder="Insira o destino da amostra"
									/>
									<span className="error-field">
										{STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_FIELD_TO_SPECIFY}
									</span>
								</Form.Group>
							</Form.Row>
						</If>
					</If>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Responsáveis</Form.Label>
							<br />
							<Form.Control
								ref={defaultForm.register}
								name="responsavelAmostragem"
								placeholder="Insira o responsável"
							/>
							&nbsp;
							<AddButton
								type="button"
								onClick={() => {
									AdicionarResponsavelAmostragem();

									defaultForm.setValue('responsavelAmostragem', '');

								}}
							/>
						</Form.Group>
					</Form.Row>
					<If condition={responsaveisAmostragem.length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={responsaveisAmostragem}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: acoesResponsaveisAmostragem,
									linkPastaProcesso: linkDownload
								}}
							>
								<AgGridColumn
									headerName='Responsavel'
									headerClass="myfunc-default-header"
									field="responsavel"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									minWidth={250}
								/>
								<AgGridColumn
									headerName="Ações"
									headerClass="myfunc-default-header"
									cellRenderer="actions"
									maxWidth={100}
								/>
							</AgGridReact>
						</div>
					</If>

					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>
								Anexar AMI ou Carta de Transferência<em>*</em>
							</Form.Label>
							<Form.File
								ref={registerRegistroAmostragem}
								name="arquivoAmostragem"
								label={lblArquivoRegistroAmostragem}
								data-browse="upload"
								custom
								onChange={({ target }: any) => {
									if (!target.files?.[0]) {
										return
									}
									setLblArquivoRegistroAmostragem(`${target.files[0].name}`);
									setArquivoRegistroAmostragemPendente(target.files[0]);
									setRegistroAmostragemEdit((state: VegetacaoRegistroAmostragem) => ({
										...state,
										path: undefined,
										codigo: undefined,
									}));
								}}
							/>
						</Form.Group>
					</Form.Row>
					<If condition={arquivoRegistroAmostragemPendente !== null}>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<FileExistent
									text={arquivoRegistroAmostragemPendente?.name}
									onDownload={(e: any) => {
										e.preventDefault();
										if (arquivoRegistroAmostragemPendente) {
											const url = URL.createObjectURL(arquivoRegistroAmostragemPendente);
											const link = document.createElement('a');
											link.href = url;
											link.setAttribute('download', arquivoRegistroAmostragemPendente.name);
											document.body.appendChild(link);
											link.click();
											document.body.removeChild(link);
											URL.revokeObjectURL(url);
										}
									}}
									onClick={() => {
										setArquivoRegistroAmostragemPendente(null);
										setLblArquivoRegistroAmostragem('Escolher arquivo');
									}}
								/>
							</Form.Group>
						</Form.Row>
					</If>
					<If condition={!arquivoRegistroAmostragemPendente && obterArquivoRegistroAmostragemSalvo(registroAmostragemEdit).path}>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<FileExistent
									text={obterArquivoRegistroAmostragemSalvo(registroAmostragemEdit).filename}
									onDownload={(e: any) => {
										e.preventDefault();
										const arquivoSalvo = obterArquivoRegistroAmostragemSalvo(registroAmostragemEdit);
										downloadArquivo(e, {
											path: arquivoSalvo.path,
											filename: arquivoSalvo.filename,
										});
									}}
									onClick={() => {
										setRegistroAmostragemEdit((state: VegetacaoRegistroAmostragem) => ({
											...state,
											path: undefined,
											codigo: undefined,
											filename: '',
											arquivoAmostragem: '',
										}));
										setLblArquivoRegistroAmostragem('Escolher arquivo');
									}}
								/>
							</Form.Group>
						</Form.Row>
					</If>
					<div className="button-position">
						<Button
							title="Cancelar"
							contained={false}
							type="button"
							onClick={() => setModalRegistroAmostragem(false)}
						/>
						<Button
							title="Inserir"
							contained={true}
							type="submit"
						/>
					</div>
				</Form>
			</Modal>
		</If>

		{/*Modal Registro Fiscalização */}
		<If condition={modalRegistroFiscalizacao}>
			<Modal
				show={true}
				onHide={() => setModalRegistroFiscalizacao(false)}
				title={STRINGS_CADERNOCONFORMIDADE.REGISTRO_FISCALIZACAO_MODAL_TITLE}
			>
				<Form onSubmit={handleSubmitRegistroFiscalizacao(onSubmitRegistroFiscalizacao)} autoComplete="off">
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Órgão Fiscalizador</Form.Label>
							<Controller
								control={controlRegistroFiscalizacao}
								name="orgaoFiscalizador"
								defaultValue={registroFiscalizacaoEdit.orgaoFiscalizador}
								render={({ onChange, value }) => (
									<Select
										value={value || null}
										onChange={(selected: any) => {
											onChange(selected);
											if (!isValorOutros(selected?.value)) {
												defaultForm.setValue('outrosOrgaoFiscalizadorModal', '');
											}
										}}
										options={orgaoFiscalizadorOptions}
										placeholder="Selecione um órgão fiscalizador"
										isClearable
									/>
								)}
							/>
						</Form.Group>
						<Form.Group as={Col} md={6}>
							<Form.Label>Data da Fiscalização</Form.Label>
							<br />
							<Controller
								control={controlRegistroFiscalizacao}
								name="dataFiscalizacao"
								defaultValue={registroFiscalizacaoEdit.dataFiscalizacao}
								render={({ onChange, value }) => (
									<DatePicker
										selected={value}
										onChange={onChange}
										className="input-custom-to-date"
										locale="pt-BR"
										dateFormat="dd/MM/yyyy"
										placeholderText="Selecionar a data"
										maxDate={new Date()}
									/>
								)}
							/>
						</Form.Group>
					</Form.Row>
					<If condition={isValorOutros(watchEditRegistroFiscalizacao().orgaoFiscalizador?.value) || isValorOutros(registroFiscalizacaoEdit.orgaoFiscalizador?.value)}>
						<Form.Row className="row-custom">
							<Form.Group as={Col} md={6}>
								<Form.Label>Especifique o órgão fiscalizador<em>*</em></Form.Label>
								<Form.Control
									ref={registerRegistroFiscalizacao}
									name="outrosOrgaoFiscalizador"
									defaultValue={registroFiscalizacaoEdit.outrosOrgaoFiscalizador}
									placeholder="Insira o órgão fiscalizador"
								/>
							</Form.Group>
						</Form.Row>
					</If>
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>Observações</Form.Label>
							<Form.Control
								ref={registerRegistroFiscalizacao}
								name="observacoesTermosFiscalizacao"
								as="textarea"
								rows={3}
								defaultValue={registroFiscalizacaoEdit.observacoesTermosFiscalizacao}
								placeholder="Insira observações adicionais, se pertinente"
							/>
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Anexar Termo de Fiscalização<em>*</em></Form.Label>
							<Form.File
								ref={registerRegistroFiscalizacao}
								name="arquivoTermo"
								label={lblArquivoRegistroFiscalizacao}
								data-browse="upload"
								custom
								onChange={({ target }: any) => {
									if (!target.files?.[0]) return;
									setLblArquivoRegistroFiscalizacao(target.files[0].name);
									setArquivoRegistroFiscalizacaoPendente(target.files[0]);
									setRegistroFiscalizacaoEdit((state) => ({ ...state, path: undefined, codigo: undefined }));
								}}
							/>
						</Form.Group>
					</Form.Row>
					<If condition={arquivoRegistroFiscalizacaoPendente !== null}>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<FileExistent
									text={arquivoRegistroFiscalizacaoPendente?.name}
									onDownload={(e: any) => {
										e.preventDefault();
										if (arquivoRegistroFiscalizacaoPendente) baixarArquivoLocal(arquivoRegistroFiscalizacaoPendente);
									}}
									onClick={() => {
										setArquivoRegistroFiscalizacaoPendente(null);
										setLblArquivoRegistroFiscalizacao('Escolher arquivo');
									}}
								/>
							</Form.Group>
						</Form.Row>
					</If>
					<If condition={!arquivoRegistroFiscalizacaoPendente && obterArquivoRegistroFiscalizacaoSalvo(registroFiscalizacaoEdit).path}>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<FileExistent
									text={obterArquivoRegistroFiscalizacaoSalvo(registroFiscalizacaoEdit).filename}
									onDownload={(e: any) => {
										e.preventDefault();
										const arquivoSalvo = obterArquivoRegistroFiscalizacaoSalvo(registroFiscalizacaoEdit);
										downloadArquivo(e, { path: arquivoSalvo.path, filename: arquivoSalvo.filename });
									}}
									onClick={() => {
										setRegistroFiscalizacaoEdit((state) => ({ ...state, path: undefined, codigo: undefined, filename: '', arquivoTermo: '' }));
										setLblArquivoRegistroFiscalizacao('Escolher arquivo');
									}}
								/>
							</Form.Group>
						</Form.Row>
					</If>
					<div className="button-position">
						<Button title="Cancelar" contained={false} type="button" onClick={() => setModalRegistroFiscalizacao(false)} />
						<Button title="Inserir" contained={true} type="submit" />
					</div>
				</Form>
			</Modal>
		</If>

		{/*Modal Registro Colheita */}
		<If condition={modalRegistroColheita}>
			<Modal
				show={true}
				onHide={() => setModalRegistroColheita(false)}
				title={STRINGS_CADERNOCONFORMIDADE.REGISTRO_COLHEITA_MODAL_TITLE}
			>
				<Form onSubmit={handleSubmitRegistroColheita(onSubmitRegistroColheita)} autoComplete="off">
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Tipo de colheita</Form.Label>
							<Controller
								control={controlRegistroColheita}
								name="tipoColheita"
								defaultValue={registroColheitaEdit.tipoColheita}
								render={({ onChange, value }) => (
									<Select
										value={value || null}
										onChange={onChange}
										options={enumTipoColheita.map(tipoColheita => Object.assign({ value: tipoColheita.key, label: tipoColheita.value }))}
										placeholder="Selecione um tipo de colheita"
										isClearable
									/>
								)}
							/>
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Data Inicial da colheita</Form.Label>
							<br />
							<Controller
								control={controlRegistroColheita}
								name="dataInicialColheita"
								defaultValue={registroColheitaEdit.dataInicialColheita}
								render={({ onChange, value }) => (
									<DatePicker
										selected={value}
										onChange={onChange}
										className="input-custom-to-date"
										locale="pt-BR"
										dateFormat="dd/MM/yyyy"
										placeholderText="Selecionar a data"
									/>
								)}
							/>
						</Form.Group>
						<Form.Group as={Col} md={6}>
							<Form.Label>Data Final da colheita</Form.Label>
							<br />
							<Controller
								control={controlRegistroColheita}
								name="dataFinalColheita"
								defaultValue={registroColheitaEdit.dataFinalColheita}
								render={({ onChange, value }) => (
									<DatePicker
										selected={value}
										onChange={onChange}
										className="input-custom-to-date"
										locale="pt-BR"
										dateFormat="dd/MM/yyyy"
										placeholderText="Selecionar a data"
									/>
								)}
							/>
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Tipo de Material Colhido</Form.Label>
							<Controller
								control={controlRegistroColheita}
								name="tipoMaterialColheita"
								defaultValue={registroColheitaEdit.tipoMaterialColheita}
								render={({ onChange, value }) => (
									<Select
										value={value || null}
										onChange={(selected: any) => {
											onChange(selected);
											if (!isValorOutros(selected?.value)) {
												defaultForm.setValue('outrosTipoMaterialColheitaModal', '');
											}
										}}
										options={enumTipoMaterialColheita.map(tipo => Object.assign({ value: tipo.key, label: tipo.value }))}
										placeholder="Selecione um tipo de material colhido"
										isClearable
									/>
								)}
							/>
						</Form.Group>
						<Form.Group as={Col} md={6}>
							<Form.Label>Quantidade de Material Colhido (gramas)</Form.Label>
							<Form.Control
								ref={registerRegistroColheita}
								name="quantidadeMaterialColheita"
								type="number"
								step="any"
								defaultValue={registroColheitaEdit.quantidadeMaterialColheita}
								placeholder="Insira a quantidade"
							/>
						</Form.Group>
					</Form.Row>
					<If condition={isValorOutros(watchEditRegistroColheita().tipoMaterialColheita?.value) || isValorOutros(registroColheitaEdit.tipoMaterialColheita?.value)}>
						<Form.Row className="row-custom">
							<Form.Group as={Col} md={6}>
								<Form.Label>Especifique o tipo de material colhido<em>*</em></Form.Label>
								<Form.Control
									ref={registerRegistroColheita}
									name="outrosTipoMaterialColheita"
									defaultValue={registroColheitaEdit.outrosTipoMaterialColheita}
									placeholder="Insira o tipo de material colhido"
								/>
							</Form.Group>
						</Form.Row>
					</If>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Número da AMI</Form.Label>
							<Form.Control
								ref={registerRegistroColheita}
								name="numeroAMIColheita"
								defaultValue={registroColheitaEdit.numeroAMIColheita}
								placeholder="Insira o número da AMI"
							/>
						</Form.Group>
						<Form.Group as={Col} md={6}>
							<Form.Label>Destino do Material Colhido</Form.Label>
							<Controller
								control={controlRegistroColheita}
								name="destinoMaterialColheita"
								defaultValue={registroColheitaEdit.destinoMaterialColheita}
								render={({ onChange, value }) => (
									<Select
										value={value || null}
										onChange={onChange}
										placeholder="Selecione um local"
										options={locations.map(local => Object.assign({ value: local.id, label: local.nome }))}
										isClearable
									/>
								)}
							/>
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={12}>
							<Form.Label>Pessoas Envolvidas na Colheita</Form.Label>
							<Form.Control
								ref={defaultForm.register}
								name="pessoaColheitaModal"
								placeholder="Insira a pessoa envolvida na colheita"
							/>
							&nbsp;
							<AddButton type="button" onClick={() => {
								AdicionarPessoaEnvolvidaColheitaModal();
								defaultForm.setValue('pessoaColheitaModal', '');
							}} />
						</Form.Group>
					</Form.Row>
					<If condition={responsaveisColheitaModal.length}>
						<div className="ag-theme-alpine" style={{ height: '150px', width: '100%' }}>
							<AgGridReact
								rowData={responsaveisColheitaModal}
								defaultColDef={{ flex: 1, sortable: true, resizable: true }}
							>
								<AgGridColumn headerName='#' field="contagem" maxWidth={50} />
								<AgGridColumn headerName='Pessoa' field="responsavel" />
							</AgGridReact>
						</div>
					</If>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Anexar AMI<em>*</em></Form.Label>
							<Form.File
								ref={registerRegistroColheita}
								name="arquivoAMIColheita"
								label={lblArquivoRegistroColheita}
								data-browse="upload"
								custom
								onChange={({ target }: any) => {
									if (!target.files?.[0]) return;
									setLblArquivoRegistroColheita(target.files[0].name);
									setArquivoRegistroColheitaPendente(target.files[0]);
									setRegistroColheitaEdit((state) => ({ ...state, path: undefined, codigo: undefined }));
								}}
							/>
						</Form.Group>
					</Form.Row>
					<If condition={arquivoRegistroColheitaPendente !== null}>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<FileExistent
									text={arquivoRegistroColheitaPendente?.name}
									onDownload={(e: any) => {
										e.preventDefault();
										if (arquivoRegistroColheitaPendente) baixarArquivoLocal(arquivoRegistroColheitaPendente);
									}}
									onClick={() => {
										setArquivoRegistroColheitaPendente(null);
										setLblArquivoRegistroColheita('Escolher arquivo');
									}}
								/>
							</Form.Group>
						</Form.Row>
					</If>
					<If condition={!arquivoRegistroColheitaPendente && obterArquivoRegistroColheitaSalvo(registroColheitaEdit).path}>
						<Form.Row className="row-custom">
							<Form.Group as={Col}>
								<FileExistent
									text={obterArquivoRegistroColheitaSalvo(registroColheitaEdit).filename}
									onDownload={(e: any) => {
										e.preventDefault();
										const arquivoSalvo = obterArquivoRegistroColheitaSalvo(registroColheitaEdit);
										downloadArquivo(e, { path: arquivoSalvo.path, filename: arquivoSalvo.filename });
									}}
									onClick={() => {
										setRegistroColheitaEdit((state) => ({ ...state, path: undefined, codigo: undefined, filename: '', arquivoAMIColheita: '' }));
										setLblArquivoRegistroColheita('Escolher arquivo');
									}}
								/>
							</Form.Group>
						</Form.Row>
					</If>
					<div className="button-position">
						<Button title="Cancelar" contained={false} type="button" onClick={() => setModalRegistroColheita(false)} />
						<Button title="Inserir" contained={true} type="submit" />
					</div>
				</Form>
			</Modal>
		</If>

		{/*Modal Datas Colheita */}
		<If condition={modalDatasColheita}>
			<Modal
				show={true}
				onHide={() => setModalDatasColheita(false)}
				title={STRINGS_CADERNOCONFORMIDADE.DATACOLHEITA_MODAL_TITLE}
			>
				<Form onSubmit={handleSubmitDatasColheita(onSubmitDatasColheita)} autoComplete="off">
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>Data Inicial da colheita</Form.Label>
							<br />
							<Controller
								control={controlDatasColheita}
								name="dataInicialColheita"
								isInvalid={errorsDatasColheita.dataInicialColheita !== undefined}
								render={({ onChange, value }) => (
									<DatePicker
										selected={value}
										onChange={onChange}
										className="input-custom-to-date"
										locale="pt-BR"
										dateFormat="dd/MM/yyyy"
										placeholderText="Selecionar a data"
									/>
								)}
							/>
						</Form.Group>
						<Form.Group as={Col}>
							<Form.Label>Data Final da colheita</Form.Label>
							<br />
							<Controller
								control={controlDatasColheita}
								name="dataFinalColheita"
								isInvalid={errorsDatasColheita.dataFinalColheita !== undefined}
								render={({ onChange, value }) => (
									<DatePicker
										selected={value}
										onChange={onChange}
										className="input-custom-to-date"
										locale="pt-BR"
										dateFormat="dd/MM/yyyy"
										placeholderText="Selecionar a data"
									/>
								)}
							/>
						</Form.Group>
					</Form.Row>
					<div className="button-position">
						<Button
							title="Cancelar"
							contained={false}
							type="button"
							onClick={() => setModalDatasColheita(false)}
						/>
						<Button
							title="Inserir"
							contained={true}
							type="submit"
						/>
					</div>
				</Form>
			</Modal>
		</If>

		{/*Modal Arquivo AAC Colheita */}
		<If condition={modalAtivo === 'NUMERO_AAC'}>
			<Modal show={true} onHide={() => setModalAtivo('')} title={'Adicionar arquivo de AAC'}>
				<Form onSubmit={modalArquivo.handleSubmit(submitArquivosAAC)} autoComplete="off">
					<Form.Group as={Col} md={6}>
						<Form.Label>
							Anexar Número da AAC<em>*</em>
						</Form.Label>
						<Form.File
							ref={modalArquivo.register}
							name="arquivos"
							label={lblNumeroAAC}
							data-browse="upload"
							custom
							onChange={({ target }: any) => {
								if (!target.value) {
									return
								}
								setLblNumeroAAC(`${target.files[0].name}`);
							}}
						/>
					</Form.Group>
					<div className="button-position">
						<Button title="Cancelar" contained={false} type="button" onClick={() => setModalAtivo('')} />
						<Button title="Inserir" contained={true} type="submit" />
					</div>
				</Form>
			</Modal>
		</If>

		{/*Modal Responsaveis Reporte */}
		<If condition={modalResponsavelReporte}>
			<Modal
				show={true}
				onHide={() => setModalResponsavelReporte(false)}
				title={STRINGS_CADERNOCONFORMIDADE.RESPONSAVEIS_REPORTE_MODAL_TITLE}
			>
				<Form onSubmit={handleSubmitResponsaveisReporte(onSubmitResponsavelReporte)} autoComplete="off">
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Pessoa que reportou a Liberação Não-Intencional</Form.Label>
							<Form.Control
								ref={defaultForm.register}
								name="nomeReporteLiberacaoNaoIntencional"
								placeholder="Nome do responsável"
								defaultValue={entity?.nomeReporteLiberacaoNaoIntencional}
							/>
						</Form.Group>
						<Form.Group as={Col} md={3}>
							<Form.Label>Cargo</Form.Label>
							<Form.Control
								ref={defaultForm.register}
								name="cargoReporteLiberacaoNaoIntencional"
								placeholder="Cargo do responsável"
								defaultValue={entity?.cargoReporteLiberacaoNaoIntencional}
							/>
						</Form.Group>
						<Form.Group as={Col} md={3}>
							<Form.Label>Data de aviso</Form.Label>
							<br />
							<Controller
								control={defaultForm.control}
								name="dataReporteLiberacaoNaoIntencional"
								isInvalid={defaultForm.errors.dataReporteLiberacaoNaoIntencional !== undefined}
								render={({ onChange, value }) => (
									<DatePicker
										selected={value}
										onChange={onChange}
										className="input-custom-to-date"
										locale="pt-BR"
										dateFormat="dd/MM/yyyy"
										placeholderText="Selecionar a data"
									/>
								)}
							/>
						</Form.Group>
					</Form.Row>

					<div className="button-position">
						<Button
							title="Cancelar"
							contained={false}
							type="button"
							onClick={() => setModalResponsavelReporte(false)}
						/>
						<Button
							title="Inserir"
							contained={true}
							type="submit"
						/>
					</div>
				</Form>
			</Modal>
		</If>

		{/*Modal Limpeza Destruição */}
		<If condition={modalLimpezaDestruicao}>
			<Modal
				show={true}
				onHide={() => setModalLimpezaDestruicao(false)}
				title={STRINGS_CADERNOCONFORMIDADE.LIMPEZADESTRUICAO_MODAL_TITLE}
			>
				<Form onSubmit={handleSubmitLimpezaDestruicao(onSubmitLimpezaDestruicao)} autoComplete="off">
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Maquinário/Equipamento</Form.Label>
							<Form.Control
								ref={registerLimpezaDestruicao}
								name="descricaoMaquinario"
								placeholder="Insira a identificação Maquinário/Equipamento"
								maxLength={100}
								defaultValue={limpezaDestruicaoEdit.descricaoMaquinario}
							/>
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Data ANTES do Uso</Form.Label>
							<br />
							<Controller
								control={controlLimpezaDestruicao}
								name="dataLimpezaAntesUso"
								defaultValue={limpezaDestruicaoEdit.dataLimpezaAntesUso}
								isInvalid={errorsLimpezaDestruicao.dataLimpezaAntesUso !== undefined}
								render={({ onChange, value }) => (
									<DatePicker
										selected={value}
										onChange={onChange}
										className="input-custom-to-date"
										locale="pt-BR"
										dateFormat="dd/MM/yyyy"
										placeholderText="Selecionar a data"
									/>
								)}
							/>

						</Form.Group>
						<Form.Group as={Col} md={6}>
							<Form.Label>Data APÓS do Uso</Form.Label>
							<br />
							<Controller
								control={controlLimpezaDestruicao}
								name="dataLimpezaDepoisUso"
								defaultValue={limpezaDestruicaoEdit.dataLimpezaDepoisUso}
								isInvalid={errorsLimpezaDestruicao.dataLimpezaDepoisUso !== undefined}
								render={({ onChange, value }) => (
									<DatePicker
										selected={value}
										onChange={onChange}
										className="input-custom-to-date"
										locale="pt-BR"
										dateFormat="dd/MM/yyyy"
										placeholderText="Selecionar a data"
									/>
								)}
							/>
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Responsável(is) pela limpeza</Form.Label>
							<Form.Control
								ref={registerLimpezaDestruicao}
								name="responsavelLimpeza"
								placeholder="Insira o responsável pela limpeza"
								defaultValue={limpezaDestruicaoEdit.responsavelLimpeza}
							/>
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Método de limpeza</Form.Label>
							<Controller
								control={controlLimpezaDestruicao}
								name="metodoLimpeza"
								required
								defaultValue={limpezaDestruicaoEdit.metodoLimpeza}
								isInvalid={errorsLimpezaDestruicao.metodoLimpeza !== undefined}
								render={({ onChange, value }) => (
									<Select
										placeholder="Selecione um método de limpeza"
										options={enumMetodoLimpeza.map(metodoLimpeza => Object.assign({ value: metodoLimpeza.key, label: metodoLimpeza.value }))}
										isClearable
										value={value}
										onChange={(option: any) => {
											onChange(option);
											setLimpezaDestruicaoEdit((state) => ({
												...state,
												metodoLimpeza: option,
												outrosMetodoLimpeza: isValorOutros(option?.value) ? state.outrosMetodoLimpeza : '',
											}));
										}}
									/>
								)}
							/>
						</Form.Group>
					</Form.Row>
					<If condition={!isEmptyObj(watchEditLimpezaDestruicao()) || limpezaDestruicaoEdit.metodoLimpeza}>
						<If condition={isValorOutros(watchEditLimpezaDestruicao().metodoLimpeza?.value) || limpezaDestruicaoEdit.outrosMetodoLimpeza}>
							<Form.Row className="row-custom">
								<Form.Group as={Col} md={6}>
									<Form.Label>
										Especifique o método de limpeza<em>*</em>
									</Form.Label>
									<Form.Control
										ref={registerLimpezaDestruicao}
										defaultValue={limpezaDestruicaoEdit.outrosMetodoLimpeza}
										required
										name="outrosMetodoLimpeza"
										placeholder="Insira o método de limpeza"
									/>
									<span className="error-field">
										{STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_FIELD_TO_SPECIFY}
									</span>
								</Form.Group>
							</Form.Row>
						</If>
					</If>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={12}>
							<Form.Label>Eu, {nomeRequerente}, certifico que o material GM acima informado foi destruído e descartado de forma a impedir sua dispersão ou propragação no meio ambiente e seu consumo com alimento por animais e pelo homem</Form.Label>
						</Form.Group>
					</Form.Row>

					<div className="button-position">
						<Button
							title="Cancelar"
							contained={false}
							type="button"
							onClick={() => setModalLimpezaDestruicao(false)}
						/>
						<Button
							title="Inserir"
							contained={true}
							type="submit"
						/>
					</div>
				</Form>
			</Modal>
		</If>

		{/*Modal Arquivo Termos Fiscalizacao*/}
		<If condition={modalAtivo === 'TERMOS_FISCALIZACAO'}>
			<Modal show={true} onHide={() => setModalAtivo('')} title={'Adicionar arquivo de Termos de Fiscalização'}>
				<Form onSubmit={modalArquivo.handleSubmit(submitArquivosFiscalizacaoTermos)} autoComplete="off">
					<Form.Group as={Col} md={6}>
						<Form.Label>
							Anexar Documento<em>*</em>
						</Form.Label>
						<Form.File
							ref={modalArquivo.register}
							name="arquivos"
							label={lblFiscalizacaoTermos}
							data-browse="upload"
							custom
							onChange={({ target }: any) => {
								if (!target.value) {
									return
								}
								setLblFiscalizacaoTermos(`${target.files[0].name}`);
							}}
						/>
					</Form.Group>
					<div className="button-position">
						<Button title="Cancelar" contained={false} type="button" onClick={() => setModalAtivo('')} />
						<Button title="Inserir" contained={true} type="submit" />
					</div>
				</Form>
			</Modal>
		</If>

		{/*Modal Anotações */}
		<If condition={modalAnotacoes}>
			<Modal
				show={true}
				onHide={() => setModalAnotacoes(false)}
				title={STRINGS_CADERNOCONFORMIDADE.ANOTACOES_MODAL_TITLE}
			>
				<Form onSubmit={handleSubmitAnotacoes(onSubmitAnotacoes)} autoComplete="off">
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={12}>
							<Form.Label>Anotação</Form.Label>
							<Form.Control
								ref={registerAnotacoes}
								name="anotacao"
								as="textarea"
								rows={4}
								placeholder="Insira a anotação"
								defaultValue={anotacaoEdit.anotacao}
							/>
						</Form.Group>
					</Form.Row>
					<div className="button-position">
						<Button
							title="Cancelar"
							contained={false}
							type="button"
							onClick={() => setModalAnotacoes(false)}
						/>
						<Button
							title="Inserir"
							contained={true}
							type="submit"
						/>
					</div>
				</Form>
			</Modal>
		</If>

		{/*Modal Limpeza Equipamentos */}
		<If condition={modalInspecaoEquipamentos}>
			<Modal
				key={`inspecao-equipamentos-modal-${inspecaoEquipamentosEdit.id ?? 'new'}-${inspecaoEquipamentosEdit.contagemInspecaoEquipamento ?? ''}`}
				show={true}
				onHide={() => setModalInspecaoEquipamentos(false)}
				title={STRINGS_CADERNOCONFORMIDADE.INSPECAOEQUIPAMENTOS_MODAL_TITLE}
			>
				<Form onSubmit={handleSubmitInspecaoEquipamentos(onSubmitInspecaoEquipamentos)} autoComplete="off">
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>Fase de Limpeza</Form.Label>
							<br />
							<Controller
								control={controlInspecaoEquipamentos}
								name="faseLimpeza_Id"
								required
								defaultValue={inspecaoEquipamentosEdit.faseLimpeza_Id}
								isInvalid={errorsInspecaoEquipamentos.faseLimpeza_Id !== undefined}
								as={<Select
									placeholder="Selecione a fase de limpeza"
									options={enumTipoFaseLimpezaEquipamentos.map(tipoFaseLimpezaEquipamentos => Object.assign({ value: tipoFaseLimpezaEquipamentos.key, label: tipoFaseLimpezaEquipamentos.value }))}
									isClearable
								/>}
							/>
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Nome do Maquinário/Equipamento</Form.Label>
							<Form.Control
								ref={registerInspecaoEquipamentos}
								name="numeroPlantio"
								placeholder="Insira o nome do maquinário"
								defaultValue={inspecaoEquipamentosEdit.numeroPlantio}
							/>
						</Form.Group>
						<Form.Group as={Col} md={6}>
							<Form.Label>ID do Maquinário/Equipamento</Form.Label>
							<Form.Control
								ref={registerInspecaoEquipamentos}
								name="iD_Equipamento"
								placeholder="Insira o ID do equipamento"
								defaultValue={inspecaoEquipamentosEdit.iD_Equipamento}
							/>
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Data ANTES do Uso</Form.Label>
							<br />
							<Controller
								control={controlInspecaoEquipamentos}
								name="dataAntesUso"
								defaultValue={inspecaoEquipamentosEdit.dataAntesUso}
								isInvalid={errorsInspecaoEquipamentos.dataAntesUso !== undefined}
								render={({ onChange, value }) => (
									<DatePicker
										selected={value}
										onChange={onChange}
										className="input-custom-to-date"
										locale="pt-BR"
										dateFormat="dd/MM/yyyy"
										placeholderText="Selecionar a data"
									/>
								)}
							/>
						</Form.Group>
						<Form.Group as={Col} md={6}>
							<Form.Label>Data APÓS do Uso</Form.Label>
							<br />
							<Controller
								control={controlInspecaoEquipamentos}
								name="dataAposUso"
								defaultValue={inspecaoEquipamentosEdit.dataAposUso}
								isInvalid={errorsInspecaoEquipamentos.dataAposUso !== undefined}
								render={({ onChange, value }) => (
									<DatePicker
										selected={value}
										onChange={onChange}
										className="input-custom-to-date"
										locale="pt-BR"
										dateFormat="dd/MM/yyyy"
										placeholderText="Selecionar a data"
									/>
								)}
							/>
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={12}>
							<Form.Label>Responsável(is) pela limpeza</Form.Label>
							<Form.Control
								ref={defaultForm.register}
								name="responsavelLimpezaEquipamentos"
								placeholder="Insira o responsável pela limpeza do equipamento"
							/>
							&nbsp;
							<AddButton
								type="button"
								onClick={() => {
									AdicionarResponsavelLimpezaEquipamentos();

									defaultForm.setValue('responsavelLimpezaEquipamentos', '');

								}}
							/>
						</Form.Group>
					</Form.Row>
					<If condition={responsaveisEquipamentos.length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={responsaveisEquipamentos}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: acoesResponsaveisEquipamentos
								}}
							>
								<AgGridColumn
									headerName='Responsavel'
									headerClass="myfunc-default-header"
									field="responsavel"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									minWidth={250}
								/>
								<AgGridColumn
									headerName="Ações"
									headerClass="myfunc-default-header"
									cellRenderer="actions"
									maxWidth={100}
								/>
							</AgGridReact>
						</div>
					</If>
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>Método de Limpeza</Form.Label>
							<br />
							<Controller
								control={defaultForm.control}
								name="metodoLimpezaEquipamento_Id"
								required
								defaultValue={inspecaoEquipamentosEdit.metodoLimpezaEquipamento_Id}
								isInvalid={errorsInspecaoEquipamentos.metodoLimpezaEquipamento_Id !== undefined}
								render={({ onChange, value }) => (
									<Select
										placeholder="Selecione o método de limpeza do equipamento"
										options={enumMetodoLimpezaEquipamento.map(metodoLimpeza_Id => Object.assign({ value: metodoLimpeza_Id.key, label: metodoLimpeza_Id.value }))}
										isClearable
										value={value}
										onChange={(option: any) => {
											onChange(option);
											setInspecaoEquipamentosEdit((state) => ({
												...state,
												metodoLimpezaEquipamento_Id: option,
												outrosMetodoLimpezaEquipamento: isValorOutros(option?.value) ? state.outrosMetodoLimpezaEquipamento : '',
											}));
										}}
									/>
								)}
							/>
							&nbsp;
							<AddButton
								type="button"
								onClick={() => {
									AdicionarMetodosLimpezaEquipamentos();

									defaultForm.setValue('metodoLimpezaEquipamento_Id', '');

								}}
							/>
						</Form.Group>
					</Form.Row>
					<If condition={inspecaoEquipamentosEdit.metodoLimpezaEquipamento_Id}>
						<If condition={isValorOutros((inspecaoEquipamentosEdit.metodoLimpezaEquipamento_Id as any)?.value) || inspecaoEquipamentosEdit.outrosMetodoLimpezaEquipamento}>
							<Form.Row className="row-custom">
								<Form.Group as={Col} md={6}>
									<Form.Label>
										Especifique o método de limpeza<em>*</em>
									</Form.Label>
									<Form.Control
										ref={registerInspecaoEquipamentos}
										defaultValue={inspecaoEquipamentosEdit.outrosMetodoLimpezaEquipamento}
										required={metodosLimpezaEquipamentos.length === 0}
										name="outrosMetodoLimpezaEquipamento"
										placeholder="Insira o método de limpeza do equipamento"
									/>
									<If condition={metodosLimpezaEquipamentos.length === 0}>
										<span className="error-field">
											{STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_FIELD_TO_SPECIFY}
										</span>
									</If>
								</Form.Group>
							</Form.Row>
						</If>
					</If>
					<If condition={metodosLimpezaEquipamentos.length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={metodosLimpezaEquipamentos}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: acoesMetodosLimpezaEquipamentos
								}}
							>
								<AgGridColumn
									headerName='Método'
									headerClass="myfunc-default-header"
									field="descricao"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									minWidth={250}
								/>
								<AgGridColumn
									headerName="Ações"
									headerClass="myfunc-default-header"
									cellRenderer="actions"
									maxWidth={100}
								/>
							</AgGridReact>
						</div>
					</If>

					{/*<Form.Row className="row-custom">*/}
					{/*	<Form.Group as={Col}>*/}
					{/*		<Form.Label>Método de Limpeza</Form.Label>*/}
					{/*		<br />*/}
					{/*		<Controller*/}
					{/*			control={controlInspecaoEquipamentos}*/}
					{/*			name="metodoLimpeza_Id"*/}
					{/*			required*/}
					{/*			defaultValue={inspecaoEquipamentosEdit.metodoLimpeza_Id}*/}
					{/*			isInvalid={errorsInspecaoEquipamentos.metodoLimpeza_Id !== undefined}*/}
					{/*			as={<Select*/}
					{/*				placeholder="Selecione o método de limpeza do equipamento"*/}
					{/*				options={enumMetodoLimpezaEquipamento.map(metodoLimpeza_Id => Object.assign({ value: metodoLimpeza_Id.key, label: metodoLimpeza_Id.value }))}*/}
					{/*				isClearable*/}
					{/*				onInputChange={() =>*/}
					{/*					setInspecaoEquipamentosEdit(state => ({*/}
					{/*						id: state.id,*/}
					{/*						numeroPlantio: state.numeroPlantio,*/}
					{/*						iD_Equipamento: state.iD_Equipamento,*/}
					{/*						dataAntesUso: state.dataAntesUso,*/}
					{/*						dataAposUso: state.dataAposUso,*/}
					{/*						metodoLimpeza_Id: state.metodoLimpeza_Id,*/}
					{/*						faseEnsaio: state.faseEnsaio,*/}
					{/*						outrosMetodoLimpeza: '',*/}
					{/*					}))*/}
					{/*				}*/}
					{/*			/>}*/}
					{/*		/>*/}
					{/*	</Form.Group>*/}
					{/*</Form.Row>*/}
					{/*<If condition={!isEmptyObj(watchEditInspecaoEquipamentos()) || inspecaoEquipamentosEdit.metodoLimpeza_Id}>*/}
					{/*	<If condition={watchEditInspecaoEquipamentos().metodoLimpeza_Id?.value === 99 || inspecaoEquipamentosEdit.outrosMetodoLimpeza}>*/}
					{/*		<Form.Row className="row-custom">*/}
					{/*			<Form.Group as={Col} md={6}>*/}
					{/*				<Form.Label>*/}
					{/*					Especifique o método<em>*</em>*/}
					{/*				</Form.Label>*/}
					{/*				<Form.Control*/}
					{/*					ref={registerInspecaoEquipamentos}*/}
					{/*					defaultValue={inspecaoEquipamentosEdit.outrosMetodoLimpeza}*/}
					{/*					required*/}
					{/*					name="outrosMetodoLimpeza"*/}
					{/*					placeholder="Insira o método"*/}
					{/*				/>*/}
					{/*				<span className="error-field">*/}
					{/*					{STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_FIELD_TO_SPECIFY}*/}
					{/*				</span>*/}
					{/*			</Form.Group>*/}
					{/*		</Form.Row>*/}
					{/*	</If>*/}
					{/*</If>*/}
					<div className="button-position">
						<Button
							title="Cancelar"
							contained={false}
							type="button"
							onClick={() => setModalInspecaoEquipamentos(false)}
						/>
						<Button
							title="Inserir"
							contained={true}
							type="submit"
						/>
					</div>
				</Form>
			</Modal>
		</If>

		{/*Modal Limpeza Instalações */}
		<If condition={modalLimpezaInstalacoes}>
			<Modal
				show={true}
				onHide={fecharModalLimpezaInstalacoes}
				title={STRINGS_CADERNOCONFORMIDADE.LIMPEZAINSTALACOES_MODAL_TITLE}
			>
				<Form onSubmit={handleSubmitLimpezaInstalacoes(onSubmitLimpezaInstalacoes)} autoComplete="off">
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>Fase de Limpeza</Form.Label>
							<br />
							<Controller
								control={controlLimpezaInstalacoes}
								name="tipoFaseLimpeza_Id"
								required
								defaultValue={limpezaInstalacoesEdit.tipoFaseLimpeza_Id}
								isInvalid={errorsLimpezaInstalacoes.tipoFaseLimpeza_Id !== undefined}
								render={({ onChange, value }) => (
									<Select
										placeholder="Selecione a fase de limpeza"
										options={enumTipoFaseLimpezaInstalacoes.map(tipoFaseLimpezaInstalacoes => Object.assign({ value: tipoFaseLimpezaInstalacoes.key, label: tipoFaseLimpezaInstalacoes.value }))}
										isClearable
										value={value}
										onChange={(option: any) => {
											onChange(option);
											setLimpezaInstalacoesEdit((state) => ({
												...state,
												tipoFaseLimpeza_Id: option,
												outrosTipoFaseLimpeza: isValorOutros(option?.value) ? state.outrosTipoFaseLimpeza : '',
											}));
										}}
									/>
								)}
							/>
						</Form.Group>
					</Form.Row>
					<If condition={!isEmptyObj(watchEditLimpezaInstalacoes()) || limpezaInstalacoesEdit.tipoFaseLimpeza_Id}>
						<If condition={isValorOutros(watchEditLimpezaInstalacoes().tipoFaseLimpeza_Id?.value) || limpezaInstalacoesEdit.outrosTipoFaseLimpeza}>
							<Form.Row className="row-custom">
								<Form.Group as={Col} md={6}>
									<Form.Label>
										Especifique a fase de limpeza<em>*</em>
									</Form.Label>
									<Form.Control
										ref={registerLimpezaInstalacoes}
										defaultValue={limpezaInstalacoesEdit.outrosTipoFaseLimpeza}
										required
										name="outrosTipoFaseLimpeza"
										placeholder="Insira a fase de limpeza"
									/>
									<span className="error-field">
										{STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_FIELD_TO_SPECIFY}
									</span>
								</Form.Group>
							</Form.Row>
						</If>
					</If>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={4}>
							<Form.Label>Data Inicial da Limpeza</Form.Label>
							<br />
							<Controller
								control={controlLimpezaInstalacoes}
								name="dataInicialLimpeza"
								defaultValue={limpezaInstalacoesEdit.dataInicialLimpeza}
								isInvalid={errorsLimpezaInstalacoes.dataInicialLimpeza !== undefined}
								render={({ onChange, value }) => (
									<DatePicker
										selected={value}
										onChange={onChange}
										className="input-custom-to-date"
										locale="pt-BR"
										dateFormat="dd/MM/yyyy"
										placeholderText="Selecionar a data"
									/>
								)}
							/>
						</Form.Group>
						<Form.Group as={Col} md={4}>
							<Form.Label>Data Final da Limpeza</Form.Label>
							<br />
							<Controller
								control={controlLimpezaInstalacoes}
								name="dataFinalLimpeza"
								defaultValue={limpezaInstalacoesEdit.dataFinalLimpeza}
								isInvalid={errorsLimpezaInstalacoes.dataFinalLimpeza !== undefined}
								render={({ onChange, value }) => (
									<DatePicker
										selected={value}
										onChange={onChange}
										className="input-custom-to-date"
										locale="pt-BR"
										dateFormat="dd/MM/yyyy"
										placeholderText="Selecionar a data"
									/>
								)}
							/>
						</Form.Group>
						<Form.Group as={Col} md={4}>
							<Form.Label>Número da Casa-de-Vegetação</Form.Label>
							<Form.Control
								ref={registerLimpezaInstalacoes}
								name="numeroCodigoCasaVegetacao"
								placeholder="Insira o número da Casa-de-Vegetação"
								defaultValue={limpezaInstalacoesEdit.numeroCodigoCasaVegetacao}
							/>
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={12}>
							<Form.Label>Responsável(is) pela limpeza</Form.Label>
							<Form.Control
								ref={defaultForm.register}
								name="responsavelLimpezaInstalacoes"
								placeholder="Insira o responsável pela limpeza da instalação"
							/>
							&nbsp;
							<AddButton
								type="button"
								onClick={() => {
									AdicionarResponsavelLimpezaInstalacoes();

									defaultForm.setValue('responsavelLimpezaInstalacoes', '');

								}}
							/>
						</Form.Group>
					</Form.Row>
					<If condition={responsaveisInstalacao.length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={responsaveisInstalacao}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: acoesResponsaveisLimpezaInstalacoes
								}}
							>
								<AgGridColumn
									headerName='Responsavel'
									headerClass="myfunc-default-header"
									field="responsavel"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									minWidth={250}
								/>
								<AgGridColumn
									headerName="Ações"
									headerClass="myfunc-default-header"
									cellRenderer="actions"
									maxWidth={100}
								/>
							</AgGridReact>
						</div>
					</If>
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>Método de Limpeza</Form.Label>
							<br />
							<Controller
								control={defaultForm.control}
								name="metodoLimpeza_Id"
								required
								defaultValue={limpezaInstalacoesEdit.metodoLimpeza_Id}
								isInvalid={defaultForm.errors.metodoLimpezaInstalacao !== undefined}
								render={({ onChange, value }) => (
									<Select
										placeholder="Selecione um método de limpeza"
										options={enumMetodoLimpezaInstalacao.map(metodoLimpezaInstalacao => Object.assign({ value: metodoLimpezaInstalacao.key, label: metodoLimpezaInstalacao.value }))}
										isClearable
										value={value}
										onChange={(option: any) => {
											onChange(option);
											setLimpezaInstalacoesEdit((state) => ({
												...state,
												metodoLimpeza_Id: option,
												outrosMetodoLimpeza: isValorOutros(option?.value) ? state.outrosMetodoLimpeza : '',
											}));
										}}
									/>
								)}
							/>
							&nbsp;
							<AddButton
								type="button"
								onClick={() => {
									AdicionarMetodoLimpezaInstalacoes();

									defaultForm.setValue('metodoLimpeza_Id', '');

								}}
							/>
						</Form.Group>
					</Form.Row>
					<If condition={limpezaInstalacoesEdit.metodoLimpeza_Id}>
						<If condition={isValorOutros((limpezaInstalacoesEdit.metodoLimpeza_Id as any)?.value) || limpezaInstalacoesEdit.outrosMetodoLimpeza}>
							<Form.Row className="row-custom">
								<Form.Group as={Col} md={6}>
									<Form.Label>
										Especifique o método de limpeza<em>*</em>
									</Form.Label>
									<Form.Control
										ref={registerLimpezaInstalacoes}
										defaultValue={limpezaInstalacoesEdit.outrosMetodoLimpeza}
										required={metodosLimpezaInstalacao.length === 0}
										name="outrosMetodoLimpeza"
										placeholder="Insira o método de limpeza"
									/>
									<If condition={metodosLimpezaInstalacao.length === 0}>
										<span className="error-field">
											{STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_FIELD_TO_SPECIFY}
										</span>
									</If>
								</Form.Group>
							</Form.Row>
						</If>
					</If>
					<If condition={metodosLimpezaInstalacao.length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={metodosLimpezaInstalacao}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: acoesMetodoLimpezaInstalacoes
								}}
							>
								<AgGridColumn
									headerName='Método'
									headerClass="myfunc-default-header"
									field="descricao"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									minWidth={250}
								/>
								<AgGridColumn
									headerName="Ações"
									headerClass="myfunc-default-header"
									cellRenderer="actions"
									maxWidth={100}
								/>
							</AgGridReact>
						</div>
					</If>
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>Observações</Form.Label>
							<Form.Control
								ref={registerLimpezaInstalacoes}
								name="observacoesLimpeza"
								defaultValue={limpezaInstalacoesEdit.observacoesLimpeza}
								as="textarea"
								rows={4}
								placeholder="Insira observações adicionais, se pertinente."
							/>
						</Form.Group>
					</Form.Row>
					<div className="button-position">
						<Button
							title="Cancelar"
							contained={false}
							type="button"
							onClick={fecharModalLimpezaInstalacoes}
						/>
						<Button
							title="Inserir"
							contained={true}
							type="submit"
						/>
					</div>
				</Form>
			</Modal>
		</If>

		{/*Modal Atividades de Manutenção */}
		<If condition={modalAtividadeManutencao}>
			<Modal
				show={true}
				onHide={fecharModalAtividadeManutencao}
				title={STRINGS_CADERNOCONFORMIDADE.ATIVIDADE_MANUTENCAO_MODAL_TITLE}
			>
				<Form onSubmit={handleSubmitAtividadeManutencao(onSubmitAtividadeManutencao)} autoComplete="off">
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Data Inicial da Atividade</Form.Label>
							<br />
							<Controller
								control={controlAtividadeManutencao}
								name="dataInicialAtividade"
								defaultValue={atividadeManutencaoEdit.dataInicialAtividade}
								isInvalid={errorsAtividadeManutencao.dataInicialAtividade !== undefined}
								render={({ onChange, value }) => (
									<DatePicker
										selected={value}
										onChange={onChange}
										className="input-custom-to-date"
										locale="pt-BR"
										dateFormat="dd/MM/yyyy"
										placeholderText="Selecionar a data"
									/>
								)}
							/>
						</Form.Group>
						<Form.Group as={Col} md={6}>
							<Form.Label>Data Final da Atividade</Form.Label>
							<br />
							<Controller
								control={controlAtividadeManutencao}
								name="dataFinalAtividade"
								defaultValue={atividadeManutencaoEdit.dataFinalAtividade}
								isInvalid={errorsAtividadeManutencao.dataFinalAtividade !== undefined}
								render={({ onChange, value }) => (
									<DatePicker
										selected={value}
										onChange={onChange}
										className="input-custom-to-date"
										locale="pt-BR"
										dateFormat="dd/MM/yyyy"
										placeholderText="Selecionar a data"
									/>
								)}
							/>
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Responsáveis</Form.Label>
							<br />
							<Form.Control
								ref={defaultForm.register}
								name="responsavelManutencao"
								placeholder="Insira o responsável"
							/>
							&nbsp;
							<AddButton
								type="button"
								onClick={() => {
									AdicionarResponsavelManutencao();

									defaultForm.setValue('responsavelManutencao', '');

								}}
							/>
						</Form.Group>
					</Form.Row>
					<If condition={responsaveisManutencao.length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={responsaveisManutencao}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: acoesResponsaveisManutencao,
									linkPastaProcesso: linkDownload
								}}
							>
								<AgGridColumn
									headerName='Responsavel'
									headerClass="myfunc-default-header"
									field="responsavel"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									minWidth={250}
								/>
								<AgGridColumn
									headerName="Ações"
									headerClass="myfunc-default-header"
									cellRenderer="actions"
									maxWidth={100}
								/>
							</AgGridReact>
						</div>
					</If>

					{/*<Form.Row className="row-custom">*/}
					{/*	<Form.Group as={Col} md={6}>*/}
					{/*		<Form.Label>Responsável pela Atividade</Form.Label>*/}
					{/*		<br />*/}
					{/*		<Form.Control*/}
					{/*			ref={registerAtividadeManutencao}*/}
					{/*			name="responsavel"*/}
					{/*			placeholder="Digite o nome do responsável"*/}
					{/*			maxLength={100}*/}
					{/*			defaultValue={atividadeManutencaoEdit.responsavel}*/}
					{/*		/>*/}
					{/*	</Form.Group>*/}
					{/*</Form.Row>*/}
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Atividade de Manutenção</Form.Label>
							<br />
							<Controller
								control={defaultForm.control}
								name="atividadeManutencao_Id"
								required
								defaultValue={atividadeManutencaoEdit.atividadeManutencao_Id}
								isInvalid={errorsAtividadeManutencao.atividadeManutencao_Id !== undefined}
								render={({ onChange, value }) => (
									<Select
										placeholder="Selecione a atividade"
										options={enumAtividadesManutencao.map(atividadeManutencao => Object.assign({ value: atividadeManutencao.key, label: atividadeManutencao.value }))}
										isClearable
										value={value}
										onChange={(option: any) => {
											onChange(option);
											setAtividadeManutencaoEdit((state) => ({
												...state,
												atividadeManutencao_Id: option,
												outrosAtividadeManutencao: isValorOutros(option?.value) ? state.outrosAtividadeManutencao : '',
											}));
											atualizarVisibilidadeArquivoPoda(metodosLimpezaManutencao, option);
										}}
									/>
								)}
							/>
							&nbsp;
							<AddButton
								type="button"
								onClick={() => {
									AdicionarAtividadeManutencao();

									defaultForm.setValue('atividadeManutencao_Id', '');

								}}
							/>
						</Form.Group>
					</Form.Row>
					<If condition={atividadeManutencaoEdit.atividadeManutencao_Id}>
						<If condition={isValorOutros((atividadeManutencaoEdit.atividadeManutencao_Id as any)?.value) || atividadeManutencaoEdit.outrosAtividadeManutencao}>
							<Form.Row className="row-custom">
								<Form.Group as={Col} md={6}>
									<Form.Label>
										Especifique a atividade<em>*</em>
									</Form.Label>
									<Form.Control
										ref={registerAtividadeManutencao}
										defaultValue={atividadeManutencaoEdit.outrosAtividadeManutencao}
										required={metodosLimpezaManutencao.length === 0}
										name="outrosAtividadeManutencao"
										placeholder="Insira a atividade"
									/>
									<If condition={metodosLimpezaManutencao.length === 0}>
										<span className="error-field">
											{STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_FIELD_TO_SPECIFY}
										</span>
									</If>
								</Form.Group>
							</Form.Row>
						</If>
					</If>
					<If condition={arquivoPoda}>
						<Form.File
							ref={modalArquivo.register}
							name="arquivoPodaManutencao"
							label={lblArquivoPodaManutencao}
							data-browse="upload"
							custom
							onChange={({ target }: any) => {
								if (!target.value) {
									return
								}
								setLblArquivoPodaManutencao(`${target.files[0].name}`);
							}}
						/>
						<br />
					</If>
					<If condition={metodosLimpezaManutencao.length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={metodosLimpezaManutencao}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: acoesAtividadesManutencao
								}}
							>
								<AgGridColumn
									headerName='Atividade'
									headerClass="myfunc-default-header"
									field="descricao"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									minWidth={250}
								/>
								<AgGridColumn
									headerName="Ações"
									headerClass="myfunc-default-header"
									cellRenderer="actions"
									maxWidth={100}
								/>
							</AgGridReact>
						</div>
					</If>

					<div className="button-position">
						<Button
							title="Cancelar"
							contained={false}
							type="button"
							onClick={fecharModalAtividadeManutencao}
						/>
						<Button
							title="Inserir"
							contained={true}
							type="submit"
						/>
					</div>

				</Form>
			</Modal>
		</If>

		{/*Modal Destruicao*/}
		<If condition={modalDestruicao}>
			<Modal
				key={`destruicao-modal-${contagemDestruicao}`}
				show={true}
				onHide={fecharModalDestruicao}
				title={STRINGS_CADERNOCONFORMIDADE.DESCARTE_MODAL_TITLE}
			>
				<Form onSubmit={handleSubmitDestruicao(onSubmitDestruicao)} autoComplete="off">
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>Fase de Destruição</Form.Label>
							<br />
							<Controller
								control={controlDestruicao}
								name="tipoFaseDestruicao_Id"
								required
								defaultValue={destruicaoEdit.tipoFaseDestruicao_Id}
								isInvalid={defaultForm.errors.tipoFaseDestruicao_Id !== undefined}

								render={() =>
									<Form.Control
										as="select"
										value={tipoFaseDestruicaoValue}
										onChange={({ target }: any) => {
											let index = target.selectedIndex;
											defaultForm.setValue('tipoFaseDestruicao_Id', target.value)
											setTipoFaseDestruicaoValue(target.options[index].value);
										}}
									>
										<Form.Control
											as="option"
											label="Selecione a fase de destruição"
											value=""
										/>
										{enumTipoFaseDestruicao.map((tipoFaseDestruicao) => (<Form.Control
											key={tipoFaseDestruicao.key}
											as="option"
											label={tipoFaseDestruicao.value}
											value={tipoFaseDestruicao.key}
										/>))}
									</Form.Control>}
							/>

						</Form.Group>
					</Form.Row>
					<If condition={tipoFaseDestruicaoValue === '99'}>
						<Form.Row className="row-custom">
							<Form.Group as={Col} md={6}>
								<Form.Label>
									Especifique a fase de destruição
								</Form.Label>
								<Form.Control
									ref={registerDestruicao}
									defaultValue={destruicaoEdit.outrosTipoFaseDestruicao}
									required
									name="outrosTipoFaseDestruicao"
									placeholder="Insira a fase de destruição"
								/>
								<span className="error-field">
									{STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_FIELD_TO_SPECIFY}
								</span>
							</Form.Group>
						</Form.Row>
					</If>


					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Data Inicial da Destruicao</Form.Label>
							<br />
							<Controller
								control={controlDestruicao}
								name="dataInicialDestruicao"
								defaultValue={destruicaoEdit.dataInicialDestruicao}
								isInvalid={errorsDestruicao.dataInicialDestruicao !== undefined}
								render={({ onChange, value }) => (
									<DatePicker
										selected={value}
										onChange={onChange}
										className="input-custom-to-date"
										locale="pt-BR"
										dateFormat="dd/MM/yyyy"
										placeholderText="Selecionar a data"
									/>
								)}
							/>
						</Form.Group>
						<Form.Group as={Col} md={6}>
							<Form.Label>Data Final da Destruicao</Form.Label>
							<br />
							<Controller
								control={controlDestruicao}
								name="dataFinalDestruicao"
								defaultValue={destruicaoEdit.dataFinalDestruicao}
								isInvalid={errorsDestruicao.dataFinalDestruicao !== undefined}
								render={({ onChange, value }) => (
									<DatePicker
										selected={value}
										onChange={onChange}
										className="input-custom-to-date"
										locale="pt-BR"
										dateFormat="dd/MM/yyyy"
										placeholderText="Selecionar a data"
									/>
								)}
							/>
						</Form.Group>
					</Form.Row>

					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Tipo de material destruído/descartado</Form.Label>
							<Controller
								control={controlDestruicao}
								name="tipoDestruicao"
								required
								defaultValue={destruicaoEdit.tipoDestruicao}
								isInvalid={defaultForm.errors.tipoDestruicao !== undefined}

								render={() =>
									<Form.Control
										as="select"
										value={tipoDestruicaoValue}
										onChange={({ target }: any) => {
											let index = target.selectedIndex;
											defaultForm.setValue('tipoDestruicaoValue', target.value)
											setTipoDestruicaoValue(target.options[index].value);
										}}
									>
										<Form.Control
											as="option"
											label="Selecione um tipo de material de descarte"
											value=""
										/>
										{enumTipoMaterialDescartado.map((tipoMaterialDescartado) => (<Form.Control
											key={tipoMaterialDescartado.key}
											as="option"
											label={tipoMaterialDescartado.value}
											value={tipoMaterialDescartado.key}
										/>))}
									</Form.Control>}
							/>
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={3}>
							<Form.Label>Número de Amostras</Form.Label>
							<Form.Control
								ref={registerDestruicao}
								name="numeroAmostras"
								type="number"
								min={0}
								step={1}
								inputMode="numeric"
								placeholder="Insira o total de amostras"
								defaultValue={destruicaoEdit.numeroAmostras}
								onKeyDown={(event: any) => {
									if (['e', 'E', '+', '-'].includes(event.key)) {
										event.preventDefault();
									}
								}}
							/>
						</Form.Group>
						<Form.Group as={Col} md={3}>
							<Form.Label>Quantidade de amostras</Form.Label>
							<Form.Control
								ref={registerDestruicao}
								name="pesoAmostras"
								placeholder="Insira o peso total de amostras"
								type="number"
								min={0}
								step="0.01"
								inputMode="decimal"
								defaultValue={destruicaoEdit.pesoAmostras}
								onKeyDown={(event: any) => {
									if (['e', 'E', '+', '-'].includes(event.key)) {
										event.preventDefault();
									}
								}}
								onChange={({ target }: any) => {
									if (target.value.split(".")[1]?.length > 2)
										target.value = Number(target.value).toFixed(2);
								}}

							/>
						</Form.Group>
						<Form.Group as={Col} md={6}>
							<Form.Label>Unidade de Medida</Form.Label>
							<Controller
								control={controlDestruicao}
								name="unidadeMedida"
								required
								defaultValue={destruicaoEdit.unidadeMedida}
								isInvalid={defaultForm.errors.unidadeMedida !== undefined}

								render={() =>
									<Form.Control
										as="select"
										value={unidadeMedidaValue}
										onChange={({ target }: any) => {
											let index = target.selectedIndex;
											defaultForm.setValue('unidadeMedidaValue', target.value)
											setUnidadeMedidaValue(target.options[index].value);
										}}
									>
										<Form.Control
											as="option"
											label="Selecione uma unidade de medida"
											value=""
										/>
										{enumUnidadeMedida.map((unidadeMedida) => (<Form.Control
											key={unidadeMedida.key}
											as="option"
											label={unidadeMedida.value}
											value={unidadeMedida.key}
										/>))}
									</Form.Control>}
							/>
						</Form.Group>
					</Form.Row>
					<If condition={tipoDestruicaoValue === '99'}>
						<Form.Row className="row-custom">
							<Form.Group as={Col} md={6}>
								<Form.Label>
									Especifique o tipo de descarte
								</Form.Label>
								<Form.Control
									ref={registerDestruicao}
									required
									name="outrosTipoDestruicao"
									defaultValue={destruicaoEdit.outrosTipoDestruicao}
									placeholder="Insira o tipo de descarte"
								/>
								<span className="error-field">
									{STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_FIELD_TO_SPECIFY}
								</span>
							</Form.Group>
						</Form.Row>
					</If>

					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Local da destruição/descarte:</Form.Label>
							<Controller
								control={controlDestruicao}
								name="localDestruicao"
								required
								isInvalid={defaultForm.errors.localDestruicao !== undefined}

								render={() =>
									<Form.Control
										as="select"
										value={localDestruicaoValue}
										onChange={({ target }: any) => {
											let index = target.selectedIndex;
											defaultForm.setValue('localDestruicaoValue', target.value)
											setLocalDestruicaoValue(target.options[index].value);
										}}
									>
										<Form.Control
											as="option"
											label="Selecione um local de descarte"
											value=""
										/>
										{enumLocalDescarte.map((localDestruicao) => (<Form.Control
											key={localDestruicao.key}
											as="option"
											label={localDestruicao.value}
											value={localDestruicao.key}
										/>))}
									</Form.Control>}
							/>
						</Form.Group>
						<Form.Group as={Col} md={6}>
							<Form.Label>Observações</Form.Label>
							<Form.Control
								ref={registerDestruicao}
								name="observacoesLocalDestruicao"
								as="textarea"
								rows={4}
								placeholder="Insira observações adicionais, se pertinente"
								defaultValue={destruicaoEdit.observacoesLocalDestruicao}
							/>
						</Form.Group>
					</Form.Row>
					<If condition={localDestruicaoValue === '99'}>
						<Form.Row className="row-custom">
							<Form.Group as={Col} md={6}>
								<Form.Label>
									Especifique o local de descarte
								</Form.Label>
								<Form.Control
									ref={registerDestruicao}
									required
									name="outrosLocalDestruicao"
									defaultValue={destruicaoEdit.outrosLocalDestruicao}
									placeholder="Insira o local de descarte"
								/>
								<span className="error-field">
									{STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_FIELD_TO_SPECIFY}
								</span>
							</Form.Group>
						</Form.Row>
					</If>

					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Método de destruição</Form.Label>
							<Controller
								control={controlDestruicao}
								name="metodoDestruicao_Id"
								required
								defaultValue={destruicaoEdit.metodoDestruicao}
								isInvalid={defaultForm.errors.metodoDestruicao !== undefined}

								render={() =>
									<Form.Control
										as="select"
										value={metodoDestruicaoValue}
										onChange={({ target }: any) => {
											let index = target.selectedIndex;
											defaultForm.setValue('metodoDestruicaoValue', target.value)
											setMetodoDestruicaoValue(target.options[index].value);
										}}
									>
										<Form.Control
											as="option"
											label="Selecione um método de descarte"
											value=""
										/>
										{enumMetodoDescarte.map((metodoDestruicao) => (<Form.Control
											key={metodoDestruicao.key}
											as="option"
											label={metodoDestruicao.value}
											value={metodoDestruicao.key}
										/>))}
									</Form.Control>}
							/>
							&nbsp;
							<AddButton
								type="button"
								onClick={() => {
									AdicionarMetodoDestruicao();

									defaultForm.setValue('metodoDestruicao_Id', '');

								}}
							/>
						</Form.Group>
						<Form.Group as={Col} md={6}>
							<Form.Label>Observações</Form.Label>
							<Form.Control
								ref={registerDestruicao}
								name="observacoesMetodoDestruicao"
								as="textarea"
								rows={4}
								placeholder="Insira observações adicionais, se pertinente"
								defaultValue={destruicaoEdit.observacoesMetodoDestruicao}
							/>
						</Form.Group>
					</Form.Row>
					<If condition={metodoDestruicaoValue === '99'}>
						<Form.Row className="row-custom">
							<Form.Group as={Col} md={6}>
								<Form.Label>
									Especifique o método de descarte
								</Form.Label>
								<Form.Control
									ref={registerDestruicao}
									required
									name="outrosMetodoDestruicao"
									defaultValue={destruicaoEdit.outrosMetodoDestruicao}
									placeholder="Insira o método de descarte"
								/>
								<span className="error-field">
									{STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_FIELD_TO_SPECIFY}
								</span>
							</Form.Group>
						</Form.Row>
					</If>
					<If condition={metodosDestruicao.length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={metodosDestruicao}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: acoesMetodoDestruicao
								}}
							>
								<AgGridColumn
									headerName='Método de Destruição'
									headerClass="myfunc-default-header"
									field="descricao"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									minWidth={250}
								/>
								<AgGridColumn
									headerName="Ações"
									headerClass="myfunc-default-header"
									cellRenderer="actions"
									maxWidth={100}
								/>
							</AgGridReact>
						</div>
					</If>

					<Form.Row className="row-custom">
						<Form.Group as={Col} md={12}>
							<Form.Label>Responsável(is) pelo Descarte</Form.Label>
							<Form.Control
								ref={defaultForm.register}
								name="responsavelDestruicao"
								placeholder="Informe o(s) Responsável(is) pela atividade"
							/>
							&nbsp;
							<AddButton
								type="button"
								onClick={() => {
									AdicionarResponsavelDestruicao();

									defaultForm.setValue('responsavelDestruicao', '');

								}}
							/>
						</Form.Group>
					</Form.Row>
					<If condition={responsaveisDestruicao.length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={responsaveisDestruicao}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: acoesResponsaveisDestruicao
								}}
							>
								<AgGridColumn
									headerName='Responsavel'
									headerClass="myfunc-default-header"
									field="responsavel"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									minWidth={250}
								/>
								<AgGridColumn
									headerName="Ações"
									headerClass="myfunc-default-header"
									cellRenderer="actions"
									maxWidth={100}
								/>
							</AgGridReact>
						</div>
					</If>

					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>
								Formulário de limpeza de maquinários/equipamentos utilizados na destruição e descarte
								<br />
								<br />
								<AddButton
									type="button"
									onClick={() => {
										setContagemLimpezaDestruicao(0);
										setModalLimpezaDestruicao(true);
									}
									}
								/>
							</Form.Label>
						</Form.Group>
					</Form.Row>
					<If condition={selectedLimpezaDestruicao.length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={selectedLimpezaDestruicao}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: actionsLimpezaDestruicao,
								}}
							>
								<AgGridColumn
									headerName='#'
									headerClass="myfunc-default-header"
									field="contagemLimpezaDestruicao"
									cellStyle={{
										justifyContent: 'left'
									}}
								/>
								<AgGridColumn
									headerName='Maquinário'
									headerClass="myfunc-default-header"
									field="descricaoMaquinario"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
								/>
								<AgGridColumn
									headerName='Responsáveis pela destruição'
									headerClass="myfunc-default-header"
									field="responsavelLimpeza"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									minWidth={250}
								/>
								<AgGridColumn
									headerName='Data Antes do Uso'
									field="dataLimpezaAntesUso"
									headerClass="myfunc-default-header"
									sort="asc"
									valueFormatter={({ data }: any) => data.dataLimpezaAntesUso ? _generateDate(data.dataLimpezaAntesUso, 'Pt') : ''
									}
								/>
								<AgGridColumn
									headerName='Data Após do Uso'
									field="dataLimpezaDepoisUso"
									headerClass="myfunc-default-header"
									valueFormatter={({ data }: any) => data.dataLimpezaDepoisUso ? _generateDate(data.dataLimpezaDepoisUso, 'Pt') : ''}
								/>
								<AgGridColumn
									headerName="Ações"
									headerClass="myfunc-default-header"
									cellRenderer="actions"
									maxWidth={100}
								/>
							</AgGridReact>
						</div>
					</If>

					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>
								Número da AMI
								<br />
								<If condition={!exibirAnexoDestruicaoAMI}>
									<AddButton type="button" onClick={() => setExibirAnexoDestruicaoAMI(true)} />
								</If>
							</Form.Label>
							<If condition={eventMsg}>
								<p className="error-field">{STRINGS.FORM_FIELD_REQUIRED}</p>
							</If>
						</Form.Group>
					</Form.Row>
					<If condition={exibirAnexoDestruicaoAMI}>
						<Form.Row className="row-custom">
							<Form.Group as={Col} md={12}>
								<div style={{ border: '1px solid #dee2e6', borderRadius: '4px', padding: '16px', marginBottom: '16px', backgroundColor: '#f8f9fa' }}>
									<Form.Label>
										Anexar Documento<em>*</em>
									</Form.Label>
									<Form.File
										ref={modalArquivo.register}
										name="arquivos"
										label={lblDestruicaoAMI}
										data-browse="upload"
										custom
										onChange={({ target }: any) => {
											if (!target.value) {
												return;
											}
											setLblDestruicaoAMI(`${target.files[0].name}`);
										}}
									/>
									<div className="button-position" style={{ marginTop: '12px', justifyContent: 'flex-end' }}>
										<Button title="Cancelar" contained={false} type="button" onClick={cancelarAnexoDestruicaoAMI} />
										<Button
											title="Inserir"
											contained={true}
											type="button"
											onClick={modalArquivo.handleSubmit(submitArquivosDestruicaoAMI)}
										/>
									</div>
								</div>
							</Form.Group>
						</Form.Row>
					</If>
					<If condition={destruicaoAMI.length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={destruicaoAMI}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: acoesDestruicaoAMI,
									linkAMI: linkDownload
								}}
							>
								<AgGridColumn
									headerName='Nome'
									headerClass="myfunc-default-header"
									field="name"
									valueGetter={({ data }: any) => data?.name ?? data?.filename ?? data?.Filename ?? ''}
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									minWidth={250}
								/>
								<AgGridColumn
									headerName='Link'
									headerClass="myfunc-default-header"
									field="name"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									minWidth={250}
									cellRenderer="linkAMI"
								/>
								<AgGridColumn
									headerName="Ações"
									headerClass="myfunc-default-header"
									cellRenderer="actions"
									maxWidth={100}
								/>
							</AgGridReact>
						</div>
					</If>

					<div className="button-position">
						<Button
							title="Cancelar"
							contained={false}
							type="button"
							onClick={fecharModalDestruicao}
						/>
						<Button
							title="Inserir"
							contained={true}
							type="submit"
						/>
					</div>
				</Form>
			</Modal>
		</If>


	</div>



}